export const userLanguage = [
  {
    Login: {
      LI1: {
        En: 'logo',
        Et: 'logo',
        Ar: 'شعار',
        Ml: 'ലോഗോ',
        Ma: 'लोगो',
        Fr: 'logo',
        Hi: 'प्रतीक चिन्ह',
        Ta: 'சின்னம்',
        Ja: 'ロゴ',
        Ge: 'Logo',
      },
      LL1: {
        En: 'Welcome to HoneyComb Manager',
        Et: 'Tere tulemast HoneyComb Manageri',
        Ar: 'مرحبًا بك في HoneyComb Manager',
        Ml: 'ഹണികോംബ് മാനേജരിലേക്ക് സ്വാഗതം',
        Ma: 'हनीकॉम्ब मॅनेजरमध्ये आपले स्वागत आहे',
        Fr: 'Bienvenue dans HoneyComb Manager',
        Hi: 'हनीकॉम्ब मैनेजर में आपका स्वागत है',
        Ta: 'தேன்கூடு மேலாளருக்கு வரவேற்கிறோம்',
        Ja: 'ハニカム マネージャーへようこそ',
        Ge: 'Willkommen beim HoneyComb-Manager',
      },
      LL2: {
        En: "Archives, museums, and production houses deal with physical assets worth millions. Managing media archives and physical assets has never been this easy. The complex process and technology to store, protect, track, and manage these assets have made management solutions difficult and expensive up until now. Honeycomb's modern approach and architecture make it the ultimate product to manage assets of all types. Honeycomb enables advanced search and cataloguing of your assets, opening new possibilitites to control, access, and monetize assets.",
        // En: 'Video has become a hugely dominant form of content, with more companies than ever applying video as part of their marketing, training and business strategies. Among these companies we do not only see traditional broadcasters extending their business model into internet distributed film and tv, but also a more generic usage of video in internal and external daily communication by many different companies and organizations in all sectors.',
        Et: 'Videost on saanud tohutult domineeriv sisuvorm ning rohkem ettevõtteid kui kunagi varem kasutab videot oma turundus-, koolitus- ja äristrateegiate osana. Nende ettevõtete hulgas ei näe me mitte ainult traditsioonilisi ringhäälinguorganisatsioone, kes laiendavad oma ärimudelit Internetis levitatavatele filmidele ja televisioonile, vaid ka video üldisemat kasutamist igapäevases sise- ja välissuhtluses paljude erinevate ettevõtete ja organisatsioonide poolt kõigis sektorites.',
        Ar: 'أصبح الفيديو شكلاً مهيمنًا بشكل كبير على المحتوى ، مع قيام شركات أكثر من أي وقت مضى بتطبيق الفيديو كجزء من استراتيجيات التسويق والتدريب والأعمال. من بين هذه الشركات ، لا نرى فقط المذيعين التقليديين يوسعون نموذج أعمالهم ليشمل الأفلام والتلفزيون الموزعة على الإنترنت ، ولكن أيضًا استخدام أكثر عمومية للفيديو في الاتصالات اليومية الداخلية والخارجية من قبل العديد من الشركات والمؤسسات المختلفة في جميع القطاعات.',
        Ml: 'വിപണനം, പരിശീലനം, ബിസിനസ്സ് തന്ത്രങ്ങൾ എന്നിവയുടെ ഭാഗമായി എന്നത്തേക്കാളും കൂടുതൽ കമ്പനികൾ വീഡിയോ പ്രയോഗിക്കുന്നതിനാൽ വീഡിയോ ഉള്ളടക്കത്തിന്റെ വലിയൊരു പ്രബലമായ രൂപമായി മാറിയിരിക്കുന്നു. ഈ കമ്പനികളിൽ പരമ്പരാഗത പ്രക്ഷേപകർ അവരുടെ ബിസിനസ്സ് മോഡൽ ഇന്റർനെറ്റ് ഡിസ്‌ട്രിബ്യൂഡ് ഫിലിം, ടിവി എന്നിവയിലേക്ക് വ്യാപിപ്പിക്കുന്നത് മാത്രമല്ല, എല്ലാ മേഖലകളിലെയും വിവിധ കമ്പനികളും ഓർഗനൈസേഷനുകളും ആന്തരികവും ബാഹ്യവുമായ ദൈനംദിന ആശയവിനിമയത്തിൽ വീഡിയോയുടെ കൂടുതൽ പൊതുവായ ഉപയോഗവും ഞങ്ങൾ കാണുന്നില്ല.',
        Ma: 'व्हिडिओ हा सामग्रीचा एक प्रचंड प्रभावशाली प्रकार बनला आहे, ज्यापेक्षा जास्त कंपन्या त्यांच्या विपणन, प्रशिक्षण आणि व्यवसाय धोरणांचा भाग म्हणून व्हिडिओ लागू करतात. या कंपन्यांमध्ये आम्ही केवळ पारंपारिक प्रसारक त्यांच्या व्यवसाय मॉडेलचा इंटरनेट वितरीत चित्रपट आणि टीव्हीमध्ये विस्तार करताना पाहत नाही, तर सर्व क्षेत्रातील विविध कंपन्या आणि संस्थांद्वारे अंतर्गत आणि बाह्य दैनंदिन संप्रेषणामध्ये व्हिडिओचा अधिक सामान्य वापर देखील करतो.',
        Fr: "La vidéo est devenue une forme de contenu extrêmement dominante, avec plus d'entreprises que jamais qui appliquent la vidéo dans le cadre de leurs stratégies de marketing, de formation et commerciales. Parmi ces entreprises, nous voyons non seulement les diffuseurs traditionnels étendre leur modèle commercial au cinéma et à la télévision distribués sur Internet, mais aussi une utilisation plus générique de la vidéo dans la communication quotidienne interne et externe par de nombreuses entreprises et organisations différentes dans tous les secteurs.",
        Hi: 'वीडियो सामग्री का एक बेहद प्रभावशाली रूप बन गया है, जिसमें पहले से कहीं अधिक कंपनियां अपनी मार्केटिंग, प्रशिक्षण और व्यावसायिक रणनीतियों के हिस्से के रूप में वीडियो लागू कर रही हैं। इन कंपनियों में हम न केवल पारंपरिक प्रसारकों को इंटरनेट वितरित फिल्म और टीवी में अपने व्यवसाय मॉडल का विस्तार करते हुए देखते हैं, बल्कि सभी क्षेत्रों में कई अलग-अलग कंपनियों और संगठनों द्वारा आंतरिक और बाहरी दैनिक संचार में वीडियो का अधिक सामान्य उपयोग भी करते हैं।',
        Ta: 'வீடியோ ஒரு பெரிய மேலாதிக்க வடிவமாக மாறியுள்ளது, முன்பை விட அதிகமான நிறுவனங்கள் தங்கள் மார்க்கெட்டிங், பயிற்சி மற்றும் வணிக உத்திகளின் ஒரு பகுதியாக வீடியோவைப் பயன்படுத்துகின்றன. இந்த நிறுவனங்களில் பாரம்பரிய ஒளிபரப்பாளர்கள் தங்கள் வணிக மாதிரியை இணைய விநியோகிக்கப்பட்ட திரைப்படம் மற்றும் தொலைக்காட்சிக்கு விரிவுபடுத்துவது மட்டுமல்லாமல், அனைத்துத் துறைகளிலும் உள்ள பல்வேறு நிறுவனங்கள் மற்றும் நிறுவனங்களால் உள் மற்றும் வெளிப்புற தினசரி தகவல்தொடர்புகளில் வீடியோவின் பொதுவான பயன்பாட்டையும் நாங்கள் பார்க்கிறோம்.',
        Ja: 'ビデオは、マーケティング、トレーニング、およびビジネス戦略の一部としてビデオを利用する企業がこれまで以上に多く、コンテンツの非常に支配的な形式になっています。これらの企業の中には、従来の放送局がビジネス モデルをインターネット配信の映画やテレビに拡張しているだけでなく、あらゆる分野のさまざまな企業や組織が社内外の日常的なコミュニケーションでビデオをより一般的に使用しているのが見られます。',
        Ge: 'Videos sind zu einer äußerst dominierenden Form von Inhalten geworden, und mehr Unternehmen als je zuvor setzen Videos als Teil ihrer Marketing-, Schulungs- und Geschäftsstrategien ein. Unter diesen Unternehmen sehen wir nicht nur traditionelle Sender, die ihr Geschäftsmodell auf über das Internet verbreitete Filme und Fernsehsendungen ausdehnen, sondern auch eine allgemeinere Verwendung von Video in der internen und externen täglichen Kommunikation durch viele verschiedene Unternehmen und Organisationen in allen Sektoren.',
      },
      LL3: {
        En: 'Honeycomb can be implemented as a standalone Vault and physical asset management system. You can get the basics done and start seeing the results in days or weeks instead of months. From there, you can scale to millions of assets. You can extend the capabilities of Honeycomb with optional IOT based movement tracking using GPS, RFID and NFC. Dashboards, metadata management, cataloguing, configurable workflows, cloud storage options and various levels and layers of tracking makes Honeycomb complling for every archivist.',

        // En: 'The value of the media files themselves are closely related to what we know about these media files – the data about the data – more commonly referred to as metadata. The more we know about our media files the more valuable they are. The most simplistic form of managing files in the early days was to create folders and subfolders, name these folders and name the media files using naming conventions that maybe only a very small number of people could navigate by.',
        Et: 'Meediumifailide endi väärtus on tihedalt seotud sellega, mida me nende meediumifailide kohta teame – andmeid andmete kohta – mida sagedamini nimetatakse metaandmeteks. Mida rohkem me oma meediumifailidest teame, seda väärtuslikumad need on. Failide haldamise kõige lihtsam viis esimestel päevadel oli kaustade ja alamkaustade loomine, nendele kaustadele nimede andmine ja meediumifailide nimetamine, kasutades nimetavasid, mille järgi suutsid liikuda vaid väga vähesed inimesed.',
        Ar: 'ترتبط قيمة ملفات الوسائط نفسها ارتباطًا وثيقًا بما نعرفه عن ملفات الوسائط هذه - البيانات حول البيانات - التي يشار إليها بشكل أكثر شيوعًا باسم البيانات الوصفية. كلما عرفنا المزيد عن ملفات الوسائط الخاصة بنا ، زادت قيمتها. كان الشكل الأكثر بساطة لإدارة الملفات في الأيام الأولى هو إنشاء مجلدات ومجلدات فرعية ، وتسمية هذه المجلدات وتسمية ملفات الوسائط باستخدام اصطلاحات التسمية التي ربما يمكن لعدد قليل جدًا من الأشخاص التنقل من خلالها.',
        Ml: 'മീഡിയ ഫയലുകളുടെ മൂല്യം ഈ മീഡിയ ഫയലുകളെക്കുറിച്ച് നമുക്കറിയാവുന്ന കാര്യങ്ങളുമായി അടുത്ത ബന്ധപ്പെട്ടിരിക്കുന്നു - ഡാറ്റയെക്കുറിച്ചുള്ള ഡാറ്റ - സാധാരണയായി മെറ്റാഡാറ്റ എന്ന് വിളിക്കുന്നു. നമ്മുടെ മീഡിയ ഫയലുകളെക്കുറിച്ച് നമ്മൾ എത്രത്തോളം അറിയുന്നുവോ അത്രയും മൂല്യമുണ്ട്. ആദ്യകാലങ്ങളിൽ ഫയലുകൾ കൈകാര്യം ചെയ്യുന്നതിനുള്ള ഏറ്റവും ലളിതമായ രീതി ഫോൾഡറുകളും സബ്ഫോൾഡറുകളും സൃഷ്‌ടിക്കുകയും ഈ ഫോൾഡറുകൾക്ക് പേരിടുകയും മീഡിയ ഫയലുകൾക്ക് പേരിടൽ കൺവെൻഷനുകൾ ഉപയോഗിച്ച് പേരിടുകയും ചെയ്യുക എന്നതായിരുന്നു.',
        Ma: 'मीडिया फाइल्सचे मूल्य या मीडिया फायलींबद्दल आपल्याला काय माहित आहे - डेटाबद्दलचा डेटा - अधिक सामान्यपणे मेटाडेटा म्हणून संदर्भित असलेल्या गोष्टींशी संबंधित आहे. आमच्या मीडिया फाइल्सबद्दल आम्हाला जितके अधिक माहिती असेल तितकी त्या अधिक मौल्यवान आहेत. सुरुवातीच्या काळात फायली व्यवस्थापित करण्याचा सर्वात सोपा प्रकार म्हणजे फोल्डर्स आणि सबफोल्डर्स तयार करणे, या फोल्डर्सना नाव देणे आणि नामकरण पद्धती वापरून मीडिया फाइल्सना नाव देणे ज्याद्वारे कदाचित फारच कमी लोक नेव्हिगेट करू शकतील.',
        Fr: 'La valeur des fichiers multimédias eux-mêmes est étroitement liée à ce que nous savons de ces fichiers multimédias - les données sur les données - plus communément appelées métadonnées. Plus nous en savons sur nos fichiers multimédias, plus ils sont précieux. La forme la plus simple de gestion des fichiers au début consistait à créer des dossiers et des sous-dossiers, à nommer ces dossiers et à nommer les fichiers multimédias en utilisant des conventions de dénomination que seul un très petit nombre de personnes pouvaient parcourir.',
        Hi: 'मीडिया फ़ाइलों का मूल्य स्वयं इन मीडिया फ़ाइलों के बारे में हम जो जानते हैं उससे निकटता से संबंधित हैं - डेटा के बारे में डेटा - जिसे आमतौर पर मेटाडेटा के रूप में संदर्भित किया जाता है। हम अपनी मीडिया फ़ाइलों के बारे में जितना अधिक जानते हैं, वे उतनी ही अधिक मूल्यवान होती हैं। शुरुआती दिनों में फाइलों को प्रबंधित करने का सबसे सरल रूप था फ़ोल्डर्स और सबफ़ोल्डर्स बनाना, इन फ़ोल्डर्स को नाम देना और नामकरण सम्मेलनों का उपयोग करके मीडिया फ़ाइलों को नाम देना, जिन्हें शायद बहुत कम संख्या में लोग नेविगेट कर सकते थे।',
        Ta: 'மீடியா கோப்புகளின் மதிப்பு இந்த மீடியா கோப்புகளைப் பற்றி நமக்குத் தெரிந்தவற்றுடன் நெருக்கமாக தொடர்புடையது - தரவு பற்றிய தரவு - பொதுவாக மெட்டாடேட்டா என குறிப்பிடப்படுகிறது. எங்கள் மீடியா கோப்புகளைப் பற்றி நாம் எவ்வளவு அதிகமாக அறிந்திருக்கிறோமோ அவ்வளவு மதிப்புமிக்கதாக இருக்கும். ஆரம்ப நாட்களில் கோப்புகளை நிர்வகிப்பதற்கான மிகவும் எளிமையான வடிவம், கோப்புறைகள் மற்றும் துணை கோப்புறைகளை உருவாக்குதல், இந்த கோப்புறைகளுக்கு பெயரிடுதல் மற்றும் பெயரிடும் மரபுகளைப் பயன்படுத்தி மீடியா கோப்புகளுக்கு பெயரிடுதல் ஆகியவை மிகக் குறைந்த எண்ணிக்கையிலான நபர்களால் மட்டுமே செல்ல முடியும்.',
        Ja: 'メディア ファイル自体の価値は、これらのメディア ファイルについて私たちが知っていること (データに関するデータ) と密接に関連しており、より一般的にはメタデータと呼ばれます。メディア ファイルについて知れば知るほど、その価値は高まります。初期のファイル管理の最も単純な形式は、フォルダーとサブフォルダーを作成し、これらのフォルダーに名前を付け、ごく少数の人しかナビゲートできない命名規則を使用してメディア ファイルに名前を付けることでした。',
        Ge: 'Der Wert der Mediendateien selbst hängt eng mit dem zusammen, was wir über diese Mediendateien wissen – die Daten über die Daten – allgemein als Metadaten bezeichnet. Je mehr wir über unsere Mediendateien wissen, desto wertvoller sind sie. Die einfachste Form der Dateiverwaltung in den frühen Tagen bestand darin, Ordner und Unterordner zu erstellen, diese Ordner zu benennen und die Mediendateien unter Verwendung von Namenskonventionen zu benennen, an denen sich möglicherweise nur eine sehr kleine Anzahl von Personen orientieren konnte.',
      },
      LL4: {
        En: 'Sign In',
        Et: 'Logi sisse',
        Ar: 'تسجيل الدخول',
        Ml: 'സൈൻ ഇൻ',
        Ma: 'साइन इन करा',
        Fr: "S'identifier",
        Hi: 'साइन इन करें',
        Ta: 'உள்நுழையவும்',
        Ja: 'ログイン',
        Ge: 'Einloggen',
      },
      LTB1: {
        En: 'Email',
        Et: 'Meil',
        Ar: 'البريد الإلكتروني',
        Ml: 'ഇമെയിൽ',
        Ma: 'ईमेल',
        Fr: 'E-mail',
        Hi: 'ईमेल',
        Ta: 'மின்னஞ்சல்',
        Ja: 'Eメール',
        Ge: 'Email',
      },
      LTB2: {
        En: 'Password',
        Et: 'Parool',
        Ar: 'كلمة المرور',
        Ml: 'Password',
        Ma: 'पासवर्ड',
        Fr: 'Mot de passe',
        Hi: 'पासवर्ड',
        Ta: 'கடவுச்சொல்',
        Ja: 'パスワード',
        Ge: 'Passwort',
      },
      LB1: {
        En: 'Login',
        Et: 'Logi sisse',
        Ar: 'تسجيل الدخول',
        Ml: 'ലോഗിൻ',
        Ma: 'लॉगिन करा',
        Fr: 'Connexion',
        Hi: 'लॉग इन करें',
        Ta: 'உள்நுழைய',
        Ja: 'ログイン',
        Ge: 'Anmeldung',
      },
      LL5: {
        En: 'OR',
        Et: 'VÕI',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'OU',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'また',
        Ge: 'ODER',
      },
      LB2: {
        En: 'Register',
        Et: 'Registreeri',
        Ar: 'يسجل',
        Ml: 'രജിസ്റ്റർ ചെയ്യുക',
        Ma: 'नोंदणी करा',
        Fr: "S'inscrire",
        Hi: 'पंजीकरण करें',
        Ta: 'பதிவு',
        Ja: '登録',
        Ge: 'Registrieren',
      },
    },

    Sidebar: {
      M01: {
        En: 'Home',
        Et: 'Kodu',
        Ar: 'مسكن',
        Ml: 'വീട്',
        Ma: 'मुख्यपृष्ठ',
        Fr: 'Maison',
        Hi: 'मुख्यपृष्ठ',
        Ta: 'வீடு',
        Ja: '家',
        Ge: 'Heim',
      },
      M02: {
        En: 'Board',
        Ar: 'مجلس',
        Ml: 'ബോർഡ്',
        Ma: 'बोर्ड',
        Fr: 'Planche',
        Hi: 'पटल',
        Ta: 'பலகை',
        Ja: 'ボード',
        Ge: 'Tafel',
      },
      M02I01: {
        En: 'Dynamic Dashboard',
        Ar: 'لوحة تحكم ديناميكية',
        Ml: 'ചലനാത്മകം ഡാഷ്ബോർഡ്',
        Ma: 'डायनॅमिक डॅशबोर्ड',
        Fr: 'Tableau de bord dynamique',
        Hi: 'गतिशील डैशबोर्ड',
        Ta: 'டைனமிக் டாஷ்போர்டு',
        Ja: 'ダイナミックダッシュボード',
        Ge: 'Dynamisches Dashboard'
      },
      M02I02: {
        En: 'Smart Flow',
        Ar: 'تدفق ذكي',
        Ml: 'സ്മാർട്ട് ഫ്ലോ',
        Ma: 'स्मार्ट प्रवाह',
        Fr: 'Flux intelligent',
        Hi: 'स्मार्ट फ्लो',
        Ta: 'ஸ்மார்ட் ஓட்டம்',
        Ja: 'スマートフロー',
        Ge: 'Intelligenter Fluss'
      },
      M03: {
        En: 'Vault Master',
        Et: 'Vault Master',
        Ar: 'مدير الخزنة',
        Ml: 'വോൾട്ട് മാസ്റ്റർ',
        Ma: 'वॉल्ट मास्टर',
        Fr: 'Maître du coffre-fort',
        Hi: 'तिजोरी मास्टर',
        Ta: 'வால்ட் மாஸ்டர்',
        Ja: 'ヴォルトマスター',
        Ge: 'Tresormeister',
      },
      M03I01: {
        En: 'Register Vault',
        Et: 'Registreeri Vault',
        Ar: 'تسجيل  خزنة',
        Ml: 'വോൾട്ട് രജിസ്റ്റർ ചെയ്യുക',
        Ma: 'वॉल्टची नोंदणी करा',
        Fr: 'Enregistrer le coffre-fort',
        Hi: 'तिजोरी पंजीकरण',
        Ta: 'பதிவு வால்ட்',
        Ja: 'ボールトの登録',
        Ge: 'Tresor registrieren',
      },
      M03I02: {
        En: 'View Vault',
        Et: 'Vaata Vault',
        Ar: 'مشاهدة ملف  خزنة',
        Ml: 'വോൾട്ട് കാണുക',
        Ma: 'व्हॉल्ट पहा',
        Fr: 'Voir le coffre-fort',
        Hi: 'तिजोरी देखें',
        Ta: 'வால்ட் பார்க்கவும்',
        Ja: 'ボールトを表示',
        Ge: 'Tresor anzeigen',
      },
      M04: {
        En: 'Device Master',
        Et: 'Seadmemeister',
        Ar: 'سيد الجهاز',
        Ml: 'ഉപകരണ മാസ്റ്റർ',
        Ma: 'डिव्हाइस मास्टर',
        Fr: "Maître de l'appareil",
        Hi: 'उपकरण मास्टर',
        Ta: 'சாதன மாஸ்டர்',
        Ja: 'デバイスマスター',
        Ge: 'Gerätemaster',
      },
      M04I01: {
        En: 'Register Device',
        Et: 'Registreerige seade',
        Ar: 'تسجيل الجهاز',
        Ml: 'ഉപകരണം രജിസ്റ്റർ ചെയ്യുക',
        Ma: 'डिव्हाइस नोंदणी करा',
        Fr: "Enregistrer l'appareil",
        Hi: 'उपकरण पंजीकरण',
        Ta: 'பதிவு சாதனம்',
        Ja: 'デバイスの登録',
        Ge: 'Gerät registrieren',
      },
      M04I02: {
        En: 'View Device',
        Et: 'Kuva seade',
        Ar: 'عرض الجهاز',
        Ml: 'ഉപകരണം കാണുക',
        Ma: 'डिव्हाइस पहा',
        Fr: "Afficher l'appareil",
        Hi: 'उपकरण देखें',
        Ta: 'சாதனத்தைப் பார்க்கவும்',
        Ja: 'デバイスを表示',
        Ge: 'Gerät anzeigen',
      },
      M05: {
        En: 'Shelf/Rack Master',
        Et: 'Riiul/riiulimeister',
        Ar: 'الرف / الرف الرئيسي',
        Ml: 'ഷെൽഫ്/റാക്ക് മാസ്റ്റർ',
        Ma: 'शेल्फ/रॅक मास्टर',
        Fr: 'Étagère/Rack Master',
        Hi: 'शेल्फ / रैक मास्टर',
        Ta: 'ஷெல்ஃப்/ரேக் மாஸ்டர்',
        Ja: '棚・ラックマスター',
        Ge: 'Shelf/Rack-Master',
      },
      M05I01: {
        En: 'Register Shelf/Rack',
        Et: 'Registreeri riiul/riiul',
        Ar: 'سجل الرف / الرف',
        Ml: 'ഷെൽഫ്/റാക്ക് രജിസ്റ്റർ ചെയ്യുക',
        Ma: 'शेल्फ/रॅकची नोंदणी करा',
        Fr: 'Registre étagère/rack',
        Hi: 'शेल्फ / रैक पंजीकरण',
        Ta: 'பதிவு அலமாரி/ரேக்',
        Ja: '登録棚・ラック',
        Ge: 'Regal/Rack registrieren',
      },
      M05I02: {
        En: 'View Shelf/Rack',
        Et: 'Vaata riiulit/riiulit',
        Ar: 'عرض الرف / الرف',
        Ml: 'ഷെൽഫ്/റാക്ക് കാണുക',
        Ma: 'शेल्फ/रॅक पहा',
        Fr: 'Voir Étagère/Râtelier',
        Hi: 'शेल्फ / रैक देखें',
        Ta: 'ஷெல்ஃப்/ரேக் பார்க்கவும்',
        Ja: 'シェルフ/ラックを見る',
        Ge: 'Regal/Rack anzeigen',
      },
      M06: {
        En: 'Department Master',
        Et: 'Osakonna kapten',
        Ar: 'ماجستير قسم',
        Ml: 'ഡിപ്പാർട്ട്മെന്റ് മാസ്റ്റർ',
        Ma: 'विभाग मास्टर',
        Fr: 'Maître de département',
        Hi: 'विभाग मास्टर',
        Ta: 'துறை மாஸ்டர்',
        Ja: '部門長',
        Ge: 'Abteilungsmeister',
      },
      M06I01: {
        En: 'Register Department ',
        Et: 'Registriosakond',
        Ar: 'قسم التسجيل',
        Ml: 'രജിസ്റ്റർ വകുപ്പ്',
        Ma: 'नोंदणी विभाग',
        Fr: 'Département du registre',
        Hi: 'विभाग पंजीकरण',
        Ta: 'பதிவு துறை',
        Ja: '登録部門',
        Ge: 'Registerabteilung',
      },
      M06I02: {
        En: 'View Department',
        Et: 'Vaata osakonda',
        Ar: 'مشاهدة القسم',
        Ml: 'വകുപ്പ് കാണുക',
        Ma: 'विभाग पहा',
        Fr: 'Afficher le département',
        Hi: 'विभाग देखें',
        Ta: 'துறையைப் பார்க்கவும்',
        Ja: '部署を見る',
        Ge: 'Abteilung ansehen',
      },
      M07: {
        En: 'Customer Master',
        Et: 'Kliendimeister',
        Ar: 'سيد العميل',
        Ml: 'കസ്റ്റമർ മാസ്റ്റർ',
        Ma: 'ग्राहक मास्टर',
        Fr: 'Maître client',
        Hi: 'ग्राहक मास्टर',
        Ta: 'வாடிக்கையாளர் மாஸ்டர்',
        Ja: '顧客マスター',
        Ge: 'Kundenstamm',
      },
      M07I01: {
        En: 'Register Customer',
        Et: 'Registreeri klient',
        Ar: 'تسجيل الزبون',
        Ml: 'കസ്റ്റമർ രജിസ്റ്റർ ചെയ്യുക',
        Ma: 'ग्राहक नोंदणी करा',
        Fr: 'Enregistrer le client',
        Hi: 'ग्राहक पंजीकरण',
        Ta: 'வாடிக்கையாளர் பதிவு',
        Ja: '顧客登録',
        Ge: 'Kunde registrieren',
      },
      M07I02: {
        En: 'View Customer',
        Et: 'Vaata klienti',
        Ar: 'عرض العملاء',
        Ml: 'ഉപഭോക്താവിനെ കാണുക',
        Ma: 'ग्राहक पहा',
        Fr: 'Afficher le client',
        Hi: 'ग्राहक देखें',
        Ta: 'வாடிக்கையாளரைப் பார்க்கவும்',
        Ja: '顧客を見る',
        Ge: 'Kunde anzeigen',
      },
      M08: {
        En: 'Assets',
        Et: 'Varad',
        Ar: 'أصول',
        Ml: 'ആസ്തികൾ',
        Ma: 'मालमत्ता',
        Fr: 'Les atouts',
        Hi: 'संपत्ति',
        Ta: 'சொத்துக்கள்',
        Ja: '資産',
        Ge: 'Vermögenswerte',
      },
      M08I01: {
        En: 'Register Item Group',
        Et: 'Registreeri kaubagrupp',
        Ar: 'تسجيل مجموعة العناصر',
        Ml: 'ഇനം ഗ്രൂപ്പ് രജിസ്റ്റർ ചെയ്യുക',
        Ma: 'आयटम गट नोंदणी करा',
        Fr: "Enregistrer un groupe d'articles",
        Hi: 'वस्तु समूह पंजीकरण',
        Ta: 'உருப்படி குழுவை பதிவு செய்யவும்',
        Ja: 'アイテムグループ登録',
        Ge: 'Artikelgruppe registrieren',
      },
      M08I02: {
        En: 'View Item Group',
        Et: 'Kuva kaubagrupp',
        Ar: 'عرض مجموعة العناصر',
        Ml: 'ഇനം ഗ്രൂപ്പ് കാണുക',
        Ma: 'आयटम गट पहा',
        Fr: "Afficher le groupe d'articles",
        Hi: 'वस्तु समूह देखें',
        Ta: 'உருப்படி குழுவைப் பார்க்கவும்',
        Ja: 'アイテム グループを表示',
        Ge: 'Artikelgruppe anzeigen',
      },
      M08I03: {
        En: 'View Item Level',
        Et: 'Kuva üksuse tase',
        Ar: 'عرض مستوى العنصر',
        Ml: 'ഇനം ലെവൽ കാണുക',
        Ma: 'आयटम पातळी पहा',
        Fr: "Afficher le niveau de l'objet",
        Hi: 'वस्तु स्तर देखें',
        Ta: 'உருப்படியின் அளவைக் காண்க',
        Ja: 'アイテムレベルを見る',
        Ge: 'Artikelebene anzeigen',
      },
      M08I04: {
        En: 'Assign User',
        Et: 'Määra kasutaja',
        Ar: 'تعيين المستخدم',
        Ml: 'ഉപയോക്താവിനെ നിയോഗിക്കുക',
        Ma: 'वापरकर्ता नियुक्त करा',
        Fr: 'Attribuer un utilisateur',
        Hi: 'उपयोगकर्ता निर्दिष्ट करें',
        Ta: 'பயனரை ஒதுக்கவும்',
        Ja: 'ユーザーの割り当て',
        Ge: 'Benutzer zuweisen',
      },
      M08I05: {
        En: 'Import Assets from CSV',
        Et: 'Importige varad CSV-st',
        Ar: 'استيراد الأصول من CSV',
        Ml: 'CSV-യിൽ നിന്ന് അസറ്റുകൾ ഇറക്കുമതി ചെയ്യുക',
        Ma: 'CSV वरून मालमत्ता आयात करा',
        Fr: 'Importer des actifs à partir de CSV',
        Hi: 'CSV से संपत्ति आयात करें',
        Ta: 'CSV இலிருந்து சொத்துக்களை இறக்குமதி செய்யவும்',
        Ja: 'CSV からアセットをインポートする',
        Ge: 'Importieren Sie Assets aus CSV',
      },
      M09: {
        En: 'Allocate User',
        Et: 'Määra kasutaja',
        Ar: 'تخصيص المستخدم',
        Ml: 'ഉപയോക്താവിനെ അനുവദിക്കുക',
        Ma: 'वापरकर्ता वाटप',
        Fr: 'Attribuer un utilisateur',
        Hi: 'उपयोगकर्ता आवंटित करें',
        Ta: 'பயனரை ஒதுக்குங்கள்',
        Ja: 'ユーザーの割り当て',
        Ge: 'Benutzer zuweisen',
      },
      M10: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      M10I01: {
        En: 'Meta Data Report',
        Et: 'Metaandmete aruanne',
        Ar: 'تقرير بيانات التعريف',
        Ml: 'മെറ്റാ ഡാറ്റ റിപ്പോർട്ട്',
        Ma: 'मेटा डेटा अहवाल',
        Fr: 'Rapport de métadonnées',
        Hi: 'मेटा डेटा रिपोर्ट',
        Ta: 'மெட்டா டேட்டா அறிக்கை',
        Ja: 'メタデータ レポート',
        Ge: 'Metadatenbericht',
      },
      M10I02: {
        En: 'Pivot Table',
        Et: 'Pivot tabel',
        Ar: 'جدول محوري',
        Ml: 'പിവറ്റ് പട്ടിക',
        Ma: 'मुख्य सारणी',
        Fr: 'Tableau croisé dynamique',
        Hi: 'मुख्य सारणी',
        Ta: 'பிவோட் அட்டவணை',
        Ja: 'ピボットテーブル',
        Ge: 'Pivot-Tabelle',
      },
      M10I03: {
        En: 'Film Festival Report',
        Et: 'Filmifestivali aruanne',
        Ar: 'تقرير مهرجان الفيلم',
        Ml: 'ഫിലിം ഫെസ്റ്റിവൽ റിപ്പോർട്ട്',
        Ma: 'चित्रपट महोत्सव अहवाल',
        Fr: 'Rapport du festival du film',
        Hi: 'फिल्म महोत्सव रिपोर्ट',
        Ta: 'திரைப்பட விழா அறிக்கை',
        Ja: '映画祭レポート',
        Ge: 'Filmfestbericht',
      },
      M11: {
        En: 'Dynamic Report',
        Et: 'Dünaamiline aruanne',
        Ar: 'تقرير ديناميكي',
        Ml: 'ഡൈനാമിക് റിപ്പോർട്ട്',
        Ma: 'डायनॅमिक अहवाल',
        Fr: 'Rapport dynamique',
        Hi: 'गतिशील रिपोर्ट',
        Ta: 'டைனமிக் அறிக்கை',
        Ja: '動的レポート',
        Ge: 'Dynamischer Bericht',
      },
      M12: {
        En: 'User',
        Et: 'Kasutaja',
        Ar: 'المستعمل',
        Ml: 'ഉപയോക്താവ്',
        Ma: 'वापरकर्ता',
        Fr: 'Utilisateur',
        Hi: 'उपयोगकर्ता',
        Ta: 'பயனர்',
        Ja: 'ユーザー',
        Ge: 'Benutzer',
      },
      M12I01: {
        En: 'View User',
        Et: 'Kuva kasutaja',
        Ar: 'عرض المستخدم',
        Ml: 'ഉപയോക്താവിനെ കാണുക',
        Ma: 'वापरकर्ता पहा',
        Fr: "Afficher l'utilisateur",
        Hi: 'उपयोगकर्ता देखें',
        Ta: 'பயனரைக் காண்க',
        Ja: 'ユーザーを表示',
        Ge: 'Benutzer anzeigen',
      },
      M12I02: {
        En: 'Create User',
        Et: 'Loo kasutaja',
        Ar: 'إنشاء مستخدم',
        Ml: 'ഉപയോക്താവിനെ സൃഷ്ടിക്കുക',
        Ma: 'वापरकर्ता तयार करा',
        Fr: 'Créer un utilisateur',
        Hi: 'उपयोगकर्ता बनाइये',
        Ta: 'பயனரை உருவாக்கவும்',
        Ja: 'ユーザーを作成',
        Ge: 'Benutzer erstellen',
      },
      M13: {
        En: 'Settings',
        Et: 'Seaded',
        Ar: 'إعدادات',
        Ml: 'ക്രമീകരണങ്ങൾ',
        Ma: 'सेटिंग्ज',
        Fr: 'Réglages',
        Hi: 'समायोजन',
        Ta: 'அமைப்புகள்',
        Ja: '設定',
        Ge: 'Einstellungen',
      },
      M13I01: {
        En: 'Roles and Permissions',
        Et: 'Rollid ja load',
        Ar: 'الأدوار والتصاريح',
        Ml: 'റോളുകളും അനുമതികളും',
        Ma: 'भूमिका आणि परवानग्या',
        Fr: 'Rôles et autorisations',
        Hi: 'भूमिकाएं और अनुमतियां',
        Ta: 'பாத்திரங்கள் மற்றும் அனுமதிகள்',
        Ja: '役割と権限',
        Ge: 'Rollen und Berechtigungen',
      },
      M13I02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      M13I03: {
        En: 'Metadata',
        Et: 'Metaandmete konfiguratsioon',
        Ar: 'تكوين البيانات الوصفية',
        Ml: 'മെറ്റാഡാറ്റ കോൺഫിഗറേഷൻ',
        Ma: 'मेटाडेटा कॉन्फिगरेशन',
        Fr: 'Configuration des métadonnées',
        Hi: 'मेटाडेटा विन्यास',
        Ta: 'மெட்டாடேட்டா கட்டமைப்பு',
        Ja: 'メタデータ構成',
        Ge: 'Metadatenkonfiguration',
      },
      M14: {
        En: 'Create Master',
        Et: 'Määra kasutaja',
        Ar: 'تخصيص المستخدم',
        Ml: 'ഉപയോക്താവിനെ അനുവദിക്കുക',
        Ma: 'वापरकर्ता वाटप',
        Fr: 'Attribuer un utilisateur',
        Hi: 'उपयोगकर्ता आवंटित करें',
        Ta: 'பயனரை ஒதுக்குங்கள்',
        Ja: 'ユーザーの割り当て',
        Ge: 'Benutzer zuweisen',
      },
      M15: {
        En: 'ADL Maintenance',
        Et: 'ADL Maintenance',
        Ar: 'صيانة ADL',
        Ml: 'ADL പരിപാലനം',
        Ma: 'एडीएल मेंटेनन्स',
        Fr: 'ADL Maintenance',
        Hi: 'एडीएल रखरखाव',
        Ta: 'ADL பராமரிப்பு',
        Ja: 'ADL メンテナンス',
        Ge: 'ADL-Wartung',
      },
      M16: {
        En: 'Quick Scan',
        Ar: 'مسح سريع',
        Ml: ' ത്വരിത സ്കാൻ',
        Ma: 'जलद स्कॅन',
        Fr: 'Scan rapide',
        Hi: 'त्वरित स्कैन',
        Ta: 'விரைவு ஸ்கேன்',
        Ja: 'クイックスキャン',
        Ge: 'Schneller Scan'
      },
      M17: {
        En: 'Dashboard',
        Ar: 'لوحة التحكم',
        Ml: ' ഡാഷ്ബോർഡ് ',
        Ma: 'डॅशबोर्ड ',
        Fr: 'Tableau de bord',
        Hi: 'डैशबोर्ड',
        Ta: 'கட்டுப்பாட்டு திரை',
        Ja: 'ダッシュボード',
        Ge: 'Armaturenbrett'
      },
      M18:{
        En: 'Metadata Configuration',
        Et: 'Metaandmete konfigureerimine',
        Ar: 'تكوين البيانات الوصفية',
        Ml: 'മെറ്റാഡാറ്റാ കോൺഫിഗറേഷൻ',
        Ma: 'मेटाडेटा कॉन्फिगरेशन',
        Fr: 'configuration des métadonnées',
        Hi: 'मेटाडेटा कॉन्फ़िगरेशन',
        Ta: 'மெட்டா தரவு கட்டமைப்பு',
        Ja: 'メタデータ構成',
        Ge: 'Metadatenkonfiguration'
      }
    },

    Dashboard: {
      DB01: {
        En: 'List Button',
        Et: 'Loendi nupp',
        Ar: 'زر القائمة',
        Ml: 'ലിസ്റ്റ് ബട്ടൺ',
        Ma: 'सूची बटण',
        Fr: 'Bouton Liste',
        Hi: 'सूची बटन',
        Ta: 'பட்டியல் பொத்தான்',
        Ja: 'リストボタン',
        Ge: 'Listen-Schaltfläche',
      },
      DI01: {
        En: 'Logo',
        Et: 'Logo',
        Ar: 'شعار',
        Ml: 'ലോഗോ',
        Ma: 'लोगो',
        Fr: 'Logo',
        Hi: 'प्रतीक चिन्ह',
        Ta: 'சின்னம்',
        Ja: 'ロゴ',
        Ge: 'Logo',
      },
      DB02: {
        En: 'Home Icon',
        Et: 'Avalehe ikoon',
        Ar: 'أيقونة المنزل',
        Ml: 'ഹോം ഐക്കൺ',
        Ma: 'होम आयकॉन',
        Fr: 'Icône de la maison',
        Hi: 'होम आइकन',
        Ta: 'முகப்பு ஐகான்',
        Ja: 'ホーム アイコン',
        Ge: 'Home-Symbol',
      },
      DB03: {
        En: 'Mail Icon',
        Et: 'Maili ikoon',
        Ar: 'رمز البريد',
        Ml: 'മെയിൽ ഐക്കൺ',
        Ma: 'मेल आयकॉन',
        Fr: 'Icône Courrier',
        Hi: 'मेल चिह्न',
        Ta: 'அஞ்சல் ஐகான்',
        Ja: 'メールアイコン',
        Ge: 'Mail-Symbol',
      },
      DB04: {
        En: 'User Icon',
        Et: 'Kasutaja ikoon',
        Ar: 'رمز المستخدم',
        Ml: 'ഉപയോക്തൃ ഐക്കൺ',
        Ma: 'वापरकर्ता चिन्ह',
        Fr: "Icône de l'utilisateur",
        Hi: 'उपयोगकर्ता चिह्न',
        Ta: 'பயனர் ஐகான்',
        Ja: 'ユーザーアイコン',
        Ge: 'Benutzersymbol',
      },
      DB05: {
        En: 'Level 1',
        Et: '1. tase',
        Ar: 'المستوى 1',
        Ml: 'ലെവൽ 1',
        Ma: 'पातळी 1',
        Fr: 'Niveau 1',
        Hi: 'स्तर 1',
        Ta: 'நிலை 1',
        Ja: 'レベル1',
        Ge: 'Level 1',
      },
      DB06: {
        En: 'Level 2',
        Et: '2. tase',
        Ar: 'المستوي 2',
        Ml: 'ലെവൽ 2',
        Ma: 'स्तर 2',
        Fr: 'Niveau 2',
        Hi: 'लेवल 2',
        Ta: 'நிலை 2',
        Ja: 'レベル2',
        Ge: 'Level 2',
      },
      DB07: {
        En: 'Level 3',
        Et: '3. tase',
        Ar: 'مستوى 3',
        Ml: 'ലെവൽ 3',
        Ma: 'स्तर 3',
        Fr: 'Niveau 3',
        Hi: 'स्तर 3',
        Ta: 'நிலை 3',
        Ja: 'レベル3',
        Ge: 'Stufe 3',
      },
      DST01: {
        En: 'Search...',
        Et: 'Otsing...',
        Ar: 'يبحث...',
        Ml: 'തിരയുക...',
        Ma: 'शोधा...',
        Fr: 'Chercher...',
        Hi: 'खोज...',
        Ta: 'தேடு...',
        Ja: '探す...',
        Ge: 'Suche...',
      },
      DTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      DTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      DTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      DTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      DTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      DTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      DTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      DTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      DTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      DTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      DTH11: {
        En: 'Film',
        Ar: 'فيلم',
        Ml: 'ചിത്രം',
        Ma: 'चित्रपट',
        Fr: 'Film',
        Hi: 'फिल्म',
        Ta: 'திரைப்படம்',
        Ja: '映画',
        Ge: 'Film'
      },
      DB08: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      DB09: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      DL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      DCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      DB10: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      DB11: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      DC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      DC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      DC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      DC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    User: {
      UDDB1: {
        En: 'My Profile',
        Et: 'Minu profiil',
        Ar: 'ملفي',
        Ml: 'എന്റെ പ്രൊഫൈൽ',
        Ma: 'माझे प्रोफाइल',
        Fr: 'Mon profil',
        Hi: 'मेरी प्रोफाइल',
        Ta: 'என் சுயவிவரம்',
        Ja: '私のプロフィール',
        Ge: 'Mein Profil',
      },
      UDDB2: {
        En: 'Logout',
        Et: 'Logi välja',
        Ar: 'تسجيل خروج',
        Ml: 'പുറത്തുകടക്കുക',
        Ma: 'बाहेर पडणे',
        Fr: 'Se déconnecter',
        Hi: 'लॉग आउट',
        Ta: 'வெளியேறு',
        Ja: 'ログアウト',
        Ge: 'Ausloggen',
      },
    },

    MyProfile: {
      MPPHL1: {
        En: 'Profile',
        Et: 'Profiil',
        Ar: 'الملف الشخصي',
        Ml: 'പ്രൊഫൈൽ',
        Ma: 'प्रोफाइल',
        Fr: 'Profil',
        Hi: 'प्रोफ़ाइल',
        Ta: 'சுயவிவரம்',
        Ja: 'プロフィール',
        Ge: 'Profil',
      },
      MPPB01: {
        En: 'Update Profile',
        Et: 'Uuenda profiili',
        Ar: 'تحديث الملف',
        Ml: 'പ്രൊഫൈൽ അപ്ഡേറ്റ് ചെയ്യുക',
        Fr: 'Mettre à jour le profil',
        Hi: 'प्रोफ़ाइल को नवीनतम बनाओ',
        Ta: 'சுயவிவரத்தைப் புதுப்பிக்கவும்',
        Ja: 'プロフィールを更新',
        Ge: 'Profil aktualisieren',
      },
      MPHL01: {
        En: 'Personal',
        Et: 'Isiklik',
        Ar: 'شخصي',
        Ml: 'വ്യക്തിപരം',
        Ma: 'वैयक्तिक',
        Fr: 'Personnel',
        Hi: 'निजी',
        Ta: 'தனிப்பட்ட',
        Ja: '個人的',
        Ge: 'persönlich',
      },
      MPL01: {
        En: 'Display Name',
        Et: 'Kuvatav nimi',
        Ar: 'اسم العرض',
        Ml: 'പ്രദർശന നാമം',
        Ma: 'डिस्प्ले नाव',
        Fr: 'Afficher un nom',
        Hi: 'प्रदर्शित होने वाला नाम',
        Ta: 'காட்சி பெயர்',
        Ja: '表示名',
        Ge: 'Anzeigename',
      },
      MPL02: {
        En: 'Username',
        Et: 'Kasutajanimi',
        Ar: 'اسم المستخدم',
        Ml: 'ഉപയോക്തൃനാമം',
        Ma: 'वापरकर्तानाव',
        Fr: "Nom d'utilisateur",
        Hi: 'उपयोगकर्ता नाम',
        Ta: 'பயனர் பெயர்',
        Ja: 'ユーザー名',
        Ge: 'Nutzername',
      },
      MPL03: {
        En: 'Email',
        Et: 'Meil',
        Ar: 'البريد الإلكتروني',
        Ml: 'ഇമെയിൽ',
        Ma: 'ईमेल',
        Fr: 'E-mail',
        Hi: 'ईमेल',
        Ta: 'மின்னஞ்சல்',
        Ja: 'Eメール',
        Ge: 'Email',
      },
      MPHL02: {
        En: 'Contact Information',
        Et: 'Kontaktinfo',
        Ar: 'معلومات التواصل',
        Ml: 'ബന്ധപ്പെടാനുള്ള വിവരങ്ങൾ',
        Ma: 'संपर्क माहिती',
        Fr: 'Coordonnées',
        Hi: 'संपर्क जानकारी',
        Ta: 'தொடர்பு தகவல்',
        Ja: '連絡先',
        Ge: 'Kontaktinformationen',
      },
      MPL04: {
        En: 'Phone Number',
        Et: 'Telefoninumber',
        Ar: 'رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ',
        Ma: 'फोन नंबर',
        Fr: 'Numéro de téléphone',
        Hi: 'फ़ोन नंबर',
        Ta: 'தொலைபேசி எண்',
        Ja: '電話番号',
        Ge: 'Telefonnummer',
      },
      MPL05: {
        En: 'Alternate Phone Number',
        Et: 'Alternatiivne telefoninumber',
        Ar: 'رقم هاتف بديل',
        Ml: 'ഇതര ഫോൺ നമ്പർ',
        Ma: 'पर्यायी फोन नंबर',
        Fr: 'Autre numéro de téléphone',
        Hi: 'वैकल्पिक फ़ोन नंबर',
        Ta: 'மாற்று தொலைபேசி எண்',
        Ja: '代替電話番号',
        Ge: 'Alternative Telefonnummer',
      },
      MPHL03: {
        En: 'Employeer Information',
        Et: 'Tööandja teave',
        Ar: 'معلومات صاحب العمل',
        Ml: 'തൊഴിലുടമയുടെ വിവരങ്ങൾ',
        Ma: 'नियोक्ता माहिती',
        Fr: "Renseignements sur l'employeur",
        Hi: 'नियोक्ता सूचना',
        Ta: 'முதலாளி தகவல்',
        Ja: '雇用者情報',
        Ge: 'Arbeitgeberinformationen',
      },
      MPL06: {
        En: 'Customer Name',
        Et: 'Kliendi nimi',
        Ar: 'اسم الزبون',
        Ml: 'ഉപഭോക്താവിന്റെ പേര്',
        Ma: 'ग्राहकाचे नाव',
        Fr: 'Nom du client',
        Hi: 'ग्राहक का नाम',
        Ta: 'வாடிக்கையாளர் பெயர்',
        Ja: '顧客名',
        Ge: 'Kundenname',
      },
      MPL07: {
        En: 'Department Name',
        Et: 'Osakonna nimi',
        Ar: 'اسم القسم',
        Ml: 'വകുപ്പിന്റെ പേര്',
        Ma: 'विभागाचे नाव',
        Fr: 'Nom du département',
        Hi: 'विभाग का नाम',
        Ta: 'துறை பெயர்',
        Ja: '部署名',
        Ge: 'Abteilungsname',
      },
      MPHL04: {
        En: 'Address',
        Et: 'Aadress',
        Ar: 'تبوك',
        Ml: 'വിലാസം',
        Ma: 'पत्ता',
        Fr: 'Adresse',
        Hi: 'पता',
        Ta: 'முகவரி',
        Ja: '住所',
        Ge: 'Adresse',
      },
      MPL08: {
        En: 'Address Line 1',
        Et: '1. aadressirida',
        Ar: 'العنوان الأول',
        Ml: 'വിലാസ ലൈൻ 1',
        Ma: 'पत्ता ओळ 1',
        Fr: 'Adresse 1',
        Hi: 'पता पंक्ति 1',
        Ta: 'முகவரி வரி 1',
        Ja: '住所1',
        Ge: 'Anschrift Zeile 1',
      },
      MPL09: {
        En: 'Address Line 2',
        Et: 'aadressi rida 2',
        Ar: 'سطر العنوان 2',
        Ml: 'വിലാസം വരി 2',
        Ma: 'पत्ता ओळ 2',
        Fr: 'Adresse Ligne 2',
        Hi: 'पता पंक्ति नं। 2',
        Ta: 'முகவரி வரி 2',
        Ja: '住所2',
        Ge: 'Adresszeile 2',
      },
    },

    ProfileEditModal: {
      PEMHL01: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      PEML01: {
        En: 'Display Name',
        Et: 'Kuvatav nimi',
        Ar: 'اسم العرض',
        Ml: 'പ്രദർശന നാമം',
        Ma: 'डिस्प्ले नाव',
        Fr: 'Afficher un nom',
        Hi: 'प्रदर्शित होने वाला नाम',
        Ta: 'காட்சி பெயர்',
        Ja: '表示名',
        Ge: 'Anzeigename',
      },
      PEMTB01: {
        En: 'Display Name',
        Et: 'Kuvatav nimi',
        Ar: 'اسم العرض',
        Ml: 'പ്രദർശന നാമം',
        Ma: 'डिस्प्ले नाव',
        Fr: 'Afficher un nom',
        Hi: 'प्रदर्शित होने वाला नाम',
        Ta: 'காட்சி பெயர்',
        Ja: '表示名',
        Ge: 'Anzeigename',
      },
      PEML02: {
        En: 'User Name',
        Et: 'Kasutajanimi',
        Ar: 'اسم االمستخدم',
        Ml: 'ഉപയോക്തൃ നാമം',
        Ma: 'वापरकर्ता नाव',
        Fr: "Nom d'utilisateur",
        Hi: 'उपयोगकर्ता नाम',
        Ta: 'பயனர் பெயர்',
        Ja: 'ユーザー名',
        Ge: 'Nutzername',
      },
      PEMTB02: {
        En: 'User Name',
        Et: 'Kasutajanimi',
        Ar: 'اسم االمستخدم',
        Ml: 'ഉപയോക്തൃ നാമം',
        Ma: 'वापरकर्ता नाव',
        Fr: "Nom d'utilisateur",
        Hi: 'उपयोगकर्ता नाम',
        Ta: 'பயனர் பெயர்',
        Ja: 'ユーザー名',
        Ge: 'Nutzername',
      },
      PEML03: {
        En: 'Department Name',
        Et: 'Osakonna nimi',
        Ar: 'اسم القسم',
        Ml: 'വകുപ്പിന്റെ പേര്',
        Ma: 'विभागाचे नाव',
        Fr: 'Nom du département',
        Hi: 'विभाग का नाम',
        Ta: 'துறை பெயர்',
        Ja: '部署名',
        Ge: 'Abteilungsname',
      },
      PEMTB03: {
        En: 'Department Name',
        Et: 'Osakonna nimi',
        Ar: 'اسم القسم',
        Ml: 'വകുപ്പിന്റെ പേര്',
        Ma: 'विभागाचे नाव',
        Fr: 'Nom du département',
        Hi: 'विभाग का नाम',
        Ta: 'துறை பெயர்',
        Ja: '部署名',
        Ge: 'Abteilungsname',
      },
      PEML04: {
        En: 'Customer Name',
        Et: 'Kliendi nimi',
        Ar: 'اسم الزبون',
        Ml: 'ഉപഭോക്താവിന്റെ പേര്',
        Ma: 'ग्राहकाचे नाव',
        Fr: 'Nom du client',
        Hi: 'ग्राहक का नाम',
        Ta: 'வாடிக்கையாளர் பெயர்',
        Ja: '顧客名',
        Ge: 'Kundenname',
      },
      PEMTB04: {
        En: 'Customer Name',
        Et: 'Kliendi nimi',
        Ar: 'اسم الزبون',
        Ml: 'ഉപഭോക്താവിന്റെ പേര്',
        Ma: 'ग्राहकाचे नाव',
        Fr: 'Nom du client',
        Hi: 'ग्राहक का नाम',
        Ta: 'வாடிக்கையாளர் பெயர்',
        Ja: '顧客名',
        Ge: 'Kundenname',
      },
      PEML05: {
        En: 'Address Line 1',
        Et: '1. aadressirida',
        Ar: 'العنوان الأول',
        Ml: 'വിലാസ ലൈൻ 1',
        Ma: 'पत्ता ओळ 1',
        Fr: 'Adresse 1',
        Hi: 'पता पंक्ति 1',
        Ta: 'முகவரி வரி 1',
        Ja: '住所1',
        Ge: 'Anschrift Zeile 1',
      },
      PEMTB05: {
        En: 'Address Line 1',
        Et: '1. aadressirida',
        Ar: 'العنوان الأول',
        Ml: 'വിലാസ ലൈൻ 1',
        Ma: 'पत्ता ओळ 1',
        Fr: 'Adresse 1',
        Hi: 'पता पंक्ति 1',
        Ta: 'முகவரி வரி 1',
        Ja: '住所1',
        Ge: 'Anschrift Zeile 1',
      },
      PEML06: {
        En: 'Address Line 2',
        Et: 'aadressi rida 2',
        Ar: 'سطر العنوان 2',
        Ml: 'വിലാസം വരി 2',
        Ma: 'पत्ता ओळ 2',
        Fr: 'Adresse Ligne 2',
        Hi: 'पता पंक्ति नं। 2',
        Ta: 'முகவரி வரி 2',
        Ja: '住所2',
        Ge: 'Adresszeile 2',
      },
      PEMTB06: {
        En: 'Address Line 2',
        Et: 'aadressi rida 2',
        Ar: 'سطر العنوان 2',
        Ml: 'വിലാസം വരി 2',
        Ma: 'पत्ता ओळ 2',
        Fr: 'Adresse Ligne 2',
        Hi: 'पता पंक्ति नं। 2',
        Ta: 'முகவரி வரி 2',
        Ja: '住所2',
        Ge: 'Adresszeile 2',
      },
      PEML07: {
        En: 'Phone Number',
        Et: 'Telefoninumber',
        Ar: 'رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ',
        Ma: 'फोन नंबर',
        Fr: 'Numéro de téléphone',
        Hi: 'फ़ोन नंबर',
        Ta: 'தொலைபேசி எண்',
        Ja: '電話番号',
        Ge: 'Telefonnummer',
      },
      PEMTB07: {
        En: 'Phone Number',
        Et: 'Telefoninumber',
        Ar: 'رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ',
        Ma: 'फोन नंबर',
        Fr: 'Numéro de téléphone',
        Hi: 'फ़ोन नंबर',
        Ta: 'தொலைபேசி எண்',
        Ja: '電話番号',
        Ge: 'Telefonnummer',
      },
      PEML08: {
        En: 'Alternate Phone Number',
        Et: 'Alternatiivne telefoninumber',
        Ar: 'رقم هاتف بديل',
        Ml: 'ഇതര ഫോൺ നമ്പർ',
        Ma: 'पर्यायी फोन नंबर',
        Fr: 'Autre numéro de téléphone',
        Hi: 'वैकल्पिक फ़ोन नंबर',
        Ta: 'மாற்று தொலைபேசி எண்',
        Ja: '代替電話番号',
        Ge: 'Alternative Telefonnummer',
      },
      PEMTB08: {
        En: 'Alternate Phone Number',
        Et: 'Alternatiivne telefoninumber',
        Ar: 'رقم هاتف بديل',
        Ml: 'ഇതര ഫോൺ നമ്പർ',
        Ma: 'पर्यायी फोन नंबर',
        Fr: 'Autre numéro de téléphone',
        Hi: 'वैकल्पिक फ़ोन नंबर',
        Ta: 'மாற்று தொலைபேசி எண்',
        Ja: '代替電話番号',
        Ge: 'Alternative Telefonnummer',
      },
      PEML09: {
        En: 'Role',
        Et: 'Roll',
        Ar: 'دور',
        Ml: 'പങ്ക്',
        Ma: 'भूमिका',
        Fr: 'Rôle',
        Hi: 'भूमिका',
        Ta: 'பங்கு',
        Ja: '役割',
        Ge: 'Rolle',
      },
      PEMTB09: {
        En: 'Select Role',
        Et: 'Valige Roll',
        Ar: 'حدد الدور',
        Ml: 'റോൾ തിരഞ്ഞെടുക്കുക',
        Ma: 'भूमिका निवडा',
        Fr: 'Sélectionnez un rôle',
        Hi: 'भूमिका चुनें',
        Ta: 'பாத்திரத்தைத் தேர்ந்தெடுக்கவும்',
        Ja: '役割を選択',
        Ge: 'Rolle auswählen',
      },
      PEMB01: {
        En: 'Change Password',
        Et: 'Muuda salasõna',
        Ar: 'غير كلمة السر',
        Ml: 'പാസ്വേഡ് മാറ്റുക',
        Ma: 'पासवर्ड बदला',
        Fr: 'Changer le mot de passe',
        Hi: 'पासवर्ड बदलें',
        Ta: 'கடவுச்சொல்லை மாற்று',
        Ja: 'パスワードを変更する',
        Ge: 'Passwort ändern',
      },
      PEMB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PEMB03: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      PEMB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
    },

    EditProfileChangePassword: {
      EPCPMHL01: {
        En: 'Change Password',
        Et: 'Muuda salasõna',
        Ar: 'غير كلمة السر',
        Ml: 'പാസ്വേഡ് മാറ്റുക',
        Ma: 'पासवर्ड बदला',
        Fr: 'Changer le mot de passe',
        Hi: 'पासवर्ड बदलें',
        Ta: 'கடவுச்சொல்லை மாற்று',
        Ja: 'パスワードを変更する',
        Ge: 'Passwort ändern',
      },
      EPCPML01: {
        En: 'Current Password',
        Et: 'Praegune salasõna',
        Ar: 'كلمة المرور الحالية',
        Ml: 'ഇപ്പോഴത്തെ പാസ്സ്വേർഡ്',
        Ma: 'सध्याचा गुप्त शब्द',
        Fr: 'Mot de passe actuel',
        Hi: 'वर्तमान पासवर्ड',
        Ta: 'தற்போதைய கடவுச்சொல்',
        Ja: '現在のパスワード',
        Ge: 'Jetziges Passwort',
      },
      EPCPMTB01: {
        En: 'Current Password',
        Et: 'Praegune salasõna',
        Ar: 'كلمة المرور الحالية',
        Ml: 'ഇപ്പോഴത്തെ പാസ്സ്വേർഡ്',
        Ma: 'सध्याचा गुप्त शब्द',
        Fr: 'Mot de passe actuel',
        Hi: 'वर्तमान पासवर्ड',
        Ta: 'தற்போதைய கடவுச்சொல்',
        Ja: '現在のパスワード',
        Ge: 'Jetziges Passwort',
      },
      EPCPML02: {
        En: 'New Password',
        Et: 'uus salasõna',
        Ar: 'كلمة السر الجديدة',
        Ml: 'പുതിയ പാസ്വേഡ്',
        Ma: 'नवीन पासवर्ड',
        Fr: 'nouveau mot de passe',
        Hi: 'नया पासवर्ड',
        Ta: 'புதிய கடவுச்சொல்',
        Ja: '新しいパスワード',
        Ge: 'Neues Passwort',
      },
      EPCPMTB02: {
        En: 'New Password',
        Et: 'uus salasõna',
        Ar: 'كلمة السر الجديدة',
        Ml: 'പുതിയ പാസ്വേഡ്',
        Ma: 'नवीन पासवर्ड',
        Fr: 'nouveau mot de passe',
        Hi: 'नया पासवर्ड',
        Ta: 'புதிய கடவுச்சொல்',
        Ja: '新しいパスワード',
        Ge: 'Neues Passwort',
      },
      EPCPML03: {
        En: 'Confirm  New Password',
        Et: 'Kinnita Uus salasõna',
        Ar: 'تأكيد كلمة المرور الجديدة',
        Ml: 'പുതിയ പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക',
        Ma: 'नवीन परवलीच्या शब्दाची खात्री करा',
        Fr: 'Confirmer le nouveau mot de passe',
        Hi: 'नए पासवर्ड की पुष्टि करें',
        Ta: 'புதிய கடவு சொல்லை உறுதி செய்',
        Ja: '新しいパスワードを確認',
        Ge: 'Bestätige neues Passwort',
      },
      EPCPMTB03: {
        En: 'Confirm  New Password',
        Et: 'Kinnita Uus salasõna',
        Ar: 'تأكيد كلمة المرور الجديدة',
        Ml: 'പുതിയ പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക',
        Ma: 'नवीन परवलीच्या शब्दाची खात्री करा',
        Fr: 'Confirmer le nouveau mot de passe',
        Hi: 'नए पासवर्ड की पुष्टि करें',
        Ta: 'புதிய கடவு சொல்லை உறுதி செய்',
        Ja: '新しいパスワードを確認',
        Ge: 'Bestätige neues Passwort',
      },
      EPCPMB01: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      EPCPMB02: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      EPCPMB03: {
        En: 'Change Password',
        Et: 'Muuda salasõna',
        Ar: 'غير كلمة السر',
        Ml: 'പാസ്വേഡ് മാറ്റുക',
        Ma: 'पासवर्ड बदला',
        Fr: 'Changer le mot de passe',
        Hi: 'पासवर्ड बदलें',
        Ta: 'கடவுச்சொல்லை மாற்று',
        Ja: 'パスワードを変更する',
        Ge: 'Passwort ändern',
      },
    },

    UploadProfilePhoto: {
      UPPPH01: {
        En: 'Photos',
        Et: 'Fotod',
        Ar: 'الصور',
        Ml: 'ഫോട്ടോകൾ',
        Ma: 'फोटो',
        Fr: 'Photos',
        Hi: 'तस्वीरें',
        Ta: 'புகைப்படங்கள்',
        Ja: '写真',
        Ge: 'Fotos',
      },
      UPPB01: {
        En: 'Add Photo',
        Et: 'Lisa foto',
        Ar: 'إضافة صورة',
        Ml: 'ഫോട്ടോ ചേർക്കുക',
        Ma: 'फोटो जोडा',
        Fr: 'Ajouter une photo',
        Hi: 'फ़ोटो जोड़ें',
        Ta: 'புகைப்படம் சேர்க்க',
        Ja: '写真を追加',
        Ge: 'Foto hinzufügen',
      },
      UPPB02: {
        En: 'Make Profile Picture',
        Et: 'Tee profiilipilt',
        Ar: 'جعل صورة الملف الشخصي',
        Ml: 'മുഖചിത്രം നിര്മിക്കല്',
        Ma: 'प्रोफाइल पिक्चर बनवा',
        Fr: 'Créer une photo de profil',
        Hi: 'प्रोफ़ाइल चित्र बनाएं',
        Ta: 'சுயவிவரப் படத்தை உருவாக்கவும்',
        Ja: 'プロフィール画像を作ります',
        Ge: 'Erstelle ein Profilbild',
      },
      UPPB03: {
        En: 'Delete',
        Et: 'Kustuta',
        Ar: 'حذف',
        Ml: 'ഇല്ലാതാക്കുക',
        Ma: 'हटवा',
        Fr: 'Effacer',
        Hi: 'मिटाना',
        Ta: 'அழி',
        Ja: '消去',
        Ge: 'Löschen',
      },
      UPPSL01: {
        En: 'Upload Photo',
        Et: 'Lae pilt üles',
        Ar: 'حمل الصورة',
        Ml: 'ഫോട്ടോ അപ്‌ലോഡ് ചെയ്യുക',
        Ma: 'फोटो अपलोड करा',
        Fr: 'Envoyer la photo',
        Hi: 'फोटो अपलोड करें',
        Ta: 'புகைப்படத்தைப் பதிவேற்றவும்',
        Ja: '写真をアップする',
        Ge: 'Foto hochladen',
      },
      UPPSL02: {
        En: 'Resize Image',
        Et: 'Muuda pildi suurust',
        Ar: 'تغيير حجم الصورة',
        Ml: 'ചിത്രത്തിന്റെ വലുപ്പം മാറ്റുക',
        Ma: 'प्रतिमेचा आकार बदला',
        Fr: "Redimensionner l'image",
        Hi: 'चित्र को पुनर्कार करें',
        Ta: 'படத்தை மறுஅளவாக்கு',
        Ja: '画像のサイズ変更',
        Ge: 'Bildgröße anpassen',
      },
      UPPSL03: {
        En: 'Preview & Upload',
        Et: 'Eelvaade ja üleslaadimine',
        Ar: 'معاينة وتحميل',
        Ml: 'പ്രിവ്യൂ & അപ്‌ലോഡ്',
        Ma: 'पूर्वावलोकन आणि अपलोड करा',
        Fr: 'Aperçu et téléchargement',
        Hi: 'पूर्वावलोकन और अपलोड',
        Ta: 'முன்னோட்டம் & பதிவேற்றம்',
        Ja: 'プレビューとアップロード',
        Ge: 'Vorschau & Hochladen',
      },
      UPPL01: {
        En: 'Drop image here',
        Et: 'Pukseeri pilt siia',
        Ar: 'أفلت الصورة هنا',
        Ml: 'ചിത്രം ഇവിടെ ഇടുക',
        Ma: 'येथे प्रतिमा टाका',
        Fr: "Déposez l'image ici",
        Hi: 'छवि यहाँ छोड़ें',
        Ta: 'படத்தை இங்கே விடவும்',
        Ja: 'ここに画像をドロップ',
        Ge: 'Bild hier ablegen',
      },
      UPPB04: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
    },

    DashboardLevel1: {
      DL1B1: {
        En: 'Inventory',
        Et: 'Inventuur',
        Ar: 'جرد',
        Ml: 'ഇൻവെന്ററി',
        Ma: 'इन्व्हेंटरी',
        Fr: 'Inventaire',
        Hi: 'भंडार',
        Ta: 'சரக்கு',
        Ja: '在庫',
        Ge: 'Inventar',
      },
      DL1L1: {
        En: 'Number of assets in inventory ',
        Et: 'Varade arv laos',
        Ar: 'عدد الأصول في المخزون',
        Ml: 'ഇൻവെന്ററിയിലുള്ള അസറ്റുകളുടെ എണ്ണം',
        Ma: 'इन्व्हेंटरीमधील मालमत्तेची संख्या',
        Fr: "Nombre d'actifs en inventaire",
        Hi: 'इन्वेंट्री में संपत्तियों की संख्या',
        Ta: 'சரக்குகளில் உள்ள சொத்துக்களின் எண்ணிக்கை',
        Ja: '在庫の資産数',
        Ge: 'Anzahl der Assets im Inventar',
      },
      //Total number of assets
      DL1B2: {
        En: 'Logistics',
        Et: 'Tellimused',
        Ar: 'الطلب',
        Ml: 'ഉത്തരവുകൾ',
        Ma: 'आदेश',
        Fr: 'Ordres',
        Hi: 'आदेश',
        Ta: 'ஆர்டர்கள்',
        Ja: '注文',
        Ge: 'Aufträge',
      },
      DL1L2: {
        En: 'Number of orders',
        Et: 'Tellimuste arv',
        Ar: 'عدد الطلبات',
        Ml: 'ഓർഡറുകളുടെ എണ്ണം',
        Ma: 'ऑर्डरची संख्या',
        Fr: 'Nombre de commandes',
        Hi: 'आदेशों की संख्या',
        Ta: 'ஆர்டர்களின் எண்ணிக்கை',
        Ja: '注文数',
        Ge: 'Anzahl der Bestellungen',
      },
      DL1B3: {
        En: 'Production Planning',
        Et: 'Tootmise planeerimine',
        Ar: 'تخطيط الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ പ്ലാനിംഗ്',
        Ma: 'उत्पादन नियोजन',
        Fr: 'La planification de la production',
        Hi: 'उत्पादन योजना',
        Ta: 'உற்பத்தி திட்டமிடல்',
        Ja: '生産計画',
        Ge: 'Produktionsplanung',
      },
      DL1L3A: {
        En: 'Completed ',
        Et: 'Lõpetatud',
        Ar: ' مكتمل',
        Ml: 'പൂർത്തിയാക്കി ',
        Ma: 'पूर्ण झाले ',
        Fr: 'Complété ',
        Hi: 'संपन्न ',
        Ta: 'நிறைவு ',
        Ja: '完了 ',
        Ge: 'Abgeschlossen ',
      },
      DL1L3B: {
        En: 'out of',
        Et: 'otsas',
        Ar: 'بعيدا عن المكان',
        Ml: 'പുറത്ത്',
        Ma: 'बाहेर',
        Fr: 'hors de',
        Hi: 'अंतर्गत',
        Ta: 'வெளியே',
        Ja: 'のうち',
        Ge: 'aus',
      },
      DL1L3C: {
        En: 'Tasks',
        Et: 'Ülesanded',
        Ar: 'مهام',
        Ml: 'ചുമതലകൾ',
        Ma: 'कार्ये',
        Fr: 'Tâches',
        Hi: 'कार्य',
        Ta: 'பணிகள்',
        Ja: 'タスク',
        Ge: 'Aufgaben',
      },
      DL1L4A: {
        En: 'Pinned Feature',
        Ar: 'الميزة المثبتة',
        Ml: 'പിൻ ചെയ്‌ത സവിശേഷത',
        Fr: 'Fonction épinglée',
        Hi: 'पिन किया गया फ़ीचर',
        Ta: 'பின் செய்யப்பட்ட அம்சம்',
        Ja: 'ピン留めされた機能',
        Ge: 'Angeheftete Funktion',
      },
      DL1L4B: {
        En: 'Total Number of Tasks',
        Ar: 'العدد الإجمالي للمهام',
        Ml: 'ആകെ ജോലികളുടെ എണ്ണം',
        Ma: ' एकूण कार्ये संख्या',
        Fr: 'Nombre total de tâches',
        Hi: 'कुल कार्य संख्या',
        Ta: 'மொத்த பணிகளின் எண்ணிக்கை',
        Ja: '総タスク数',
        Ge: 'Gesamtzahl der Aufgaben'
      }
    },

    Level1Inventory: [
      {
        id: 'IB1',
        value: 'Receiving',
        text: {
          En: 'New Acquisition',
          Et: 'Vastuvõtmine',
          Ar: 'يستلم',
          Ml: 'സ്വീകരിക്കുന്നത്',
          Ma: 'प्राप्त करत आहे',
          Fr: 'Recevoir',
          Hi: 'प्राप्त',
          Ta: 'பெறுதல்',
          Ja: '受信',
          Ge: 'Empfang',
        },
        number: '(28)',
        Icon: 'sign in alternate',
        gradientvalue: 80,
        disable: false,
      },
      {
        id: 'IB2',
        value: 'Delivery',
        text: {
          En: 'Delivery',
          Et: 'Kohaletoimetamine',
          Ar: 'توصيل',
          Ml: 'ഡെലിവറി',
          Ma: 'डिलिव्हरी',
          Fr: 'Livraison',
          Hi: 'वितरण',
          Ta: 'டெலிவரி',
          Ja: '配達',
          Ge: 'Lieferung',
        },
        number: '(5)',
        Icon: 'shipping',
        gradientvalue: 20,
        disable: false,
      },
      {
        id: 'IB3',
        value: 'Reports',
        text: {
          En: 'Reports',
          Et: 'Aruanded',
          Ar: 'التقارير',
          Ml: 'റിപ്പോർട്ടുകൾ',
          Ma: 'अहवाल',
          Fr: 'Rapports',
          Hi: 'रिपोर्टों',
          Ta: 'அறிக்கைகள்',
          Ja: 'レポート',
          Ge: 'Berichte',
        },
        number: '(7)',
        Icon: 'file alternate outline',
        gradientvalue: -10,
        disable: false,
      },
    ],

    // for HFC
    Level1InventoryHFC: [
      {
        id: 'IB1',
        value: 'Receiving',
        text: {
          En: 'New Asset',
          Et: 'Vastuvõtmine',
          Ar: 'يستلم',
          Ml: 'സ്വീകരിക്കുന്നത്',
          Ma: 'प्राप्त करत आहे',
          Fr: 'Recevoir',
          Hi: 'प्राप्त',
          Ta: 'பெறுதல்',
          Ja: '受信',
          Ge: 'Empfang',
        },
        number: '(28)',
        Icon: 'sign in alternate',
        gradientvalue: 80,
        disable: false,
      },
      {
        id: 'IB2',
        value: 'Delivery',
        text: {
          En: 'Move To Vault',
          Et: 'Kohaletoimetamine',
          Ar: 'توصيل',
          Ml: 'ഡെലിവറി',
          Ma: 'डिलिव्हरी',
          Fr: 'Livraison',
          Hi: 'वितरण',
          Ta: 'டெலிவரி',
          Ja: '配達',
          Ge: 'Lieferung',
        },
        number: '(5)',
        Icon: 'shipping',
        gradientvalue: 20,
        disable: false,
      },
      {
        id: 'IB3',
        value: 'Reports',
        text: {
          En: 'Reports',
          Et: 'Aruanded',
          Ar: 'التقارير',
          Ml: 'റിപ്പോർട്ടുകൾ',
          Ma: 'अहवाल',
          Fr: 'Rapports',
          Hi: 'रिपोर्टों',
          Ta: 'அறிக்கைகள்',
          Ja: 'レポート',
          Ge: 'Berichte',
        },
        number: '(7)',
        Icon: 'file alternate outline',
        gradientvalue: -10,
        disable: false,
      },
    ],



    // for lok sabha
    Level1InventoryLokSabha: [
      {
        id: 'IB1',
        value: 'Receiving',
        text: {
          En: 'Register & Inspection',
          Et: 'Vastuvõtmine',
          Ar: 'يستلم',
          Ml: 'സ്വീകരിക്കുന്നത്',
          Ma: 'प्राप्त करत आहे',
          Fr: 'Recevoir',
          Hi: 'प्राप्त',
          Ta: 'பெறுதல்',
          Ja: '受信',
          Ge: 'Empfang',
        },
        number: '(28)',
        Icon: 'sign in alternate',
        gradientvalue: 80,
        disable: false,
      },
      {
        id: 'IB2',
        value: 'Delivery',
        text: {
          En: 'Delivery',
          Et: 'Kohaletoimetamine',
          Ar: 'توصيل',
          Ml: 'ഡെലിവറി',
          Ma: 'डिलिव्हरी',
          Fr: 'Livraison',
          Hi: 'वितरण',
          Ta: 'டெலிவரி',
          Ja: '配達',
          Ge: 'Lieferung',
        },
        number: '(5)',
        Icon: 'shipping',
        gradientvalue: 20,
        disable: false,
      },
      {
        id: 'IB3',
        value: 'Reports',
        text: {
          En: 'Reports',
          Et: 'Aruanded',
          Ar: 'التقارير',
          Ml: 'റിപ്പോർട്ടുകൾ',
          Ma: 'अहवाल',
          Fr: 'Rapports',
          Hi: 'रिपोर्टों',
          Ta: 'அறிக்கைகள்',
          Ja: 'レポート',
          Ge: 'Berichte',
        },
        number: '(7)',
        Icon: 'file alternate outline',
        gradientvalue: -10,
        disable: false,
      },
    ],

    Level1Orders: [
      {
        id: 'OB1',
        text: {
          En: 'Outward',
          Et: 'Väljapoole',
          Ar: 'الخارج',
          Ml: 'വെളിയിലേക്കുള്ള',
          Ma: 'जावक',
          Fr: "Vers l'extérieur",
          Hi: 'बाहर',
          Ta: 'வெளிப்புறமாக',
          Ja: '外向き',
          Ge: 'Nach außen',
        },
        disable: false,
      },
      {
        id: 'OB2',
        text: {
          En: 'Inward',
          Et: 'Sissepoole',
          Ar: 'إلى الداخل',
          Ml: 'ഉള്ളിലേക്ക്',
          Ma: 'आवक',
          Fr: "Vers l'intérieur",
          Hi: 'आंतरिक',
          Ta: 'உள்நோக்கி',
          Ja: '内向き',
          Ge: 'Innere',
        },
        disable: false,
      },
      {
        id: 'OB3',
        text: {
          En: 'Reports',
          Et: 'Aruanded',
          Ar: 'التقارير',
          Ml: 'റിപ്പോർട്ടുകൾ',
          Ma: 'अहवाल',
          Fr: 'Rapports',
          Hi: 'रिपोर्टों',
          Ta: 'அறிக்கைகள்',
          Ja: 'レポート',
          Ge: 'Berichte',
        },
        disable: false,
      },
    ],

    Level1ProductionPlanning: [
      {
        id: 'PPB1',
        text: {
          En: 'Film/Picture',
          Et: 'Film/Pilt',
          Ar: 'فيلم / صورة',
          Ml: 'സിനിമ/ചിത്രം',
          Ma: 'चित्रपट/चित्र',
          Fr: 'Film/Image',
          Hi: 'फिल्म/चित्र',
          Ta: 'திரைப்படம்/படம்',
          Ja: '映画・写真',
          Ge: 'Film/Bild',
        },
        disable: false,
      },
      {
        id: 'PPB2',
        text: {
          En: 'Tape',
          Et: 'Lint',
          Ar: 'الشريط',
          Ml: 'ടേപ്പ്',
          Ma: 'टेप',
          Fr: 'Ruban',
          Hi: 'फीता',
          Ta: 'டேப்',
          Ja: 'テープ',
          Ge: 'Band',
        },
        disable: false,
      },
      {
        id: 'PPB3',
        text: {
          En: 'Film/Audio',
          Et: 'Film/Audio',
          Ar: 'فيلم / صوت',
          Ml: 'ഫിലിം/ഓഡിയോ',
          Ma: 'चित्रपट/ऑडिओ',
          Fr: 'Film/Audio',
          Hi: 'फिल्म/ऑडियो',
          Ta: 'திரைப்படம்/ஆடியோ',
          Ja: '映画/オーディオ',
          Ge: 'Film/Audio',
        },
        disable: false,
      },
      {
        id: 'PPB4',
        text: {
          En: 'Photograph',
          Et: 'Fotograaf',
          Ar: 'تصوير',
          Ml: 'ഫോട്ടോ',
          Ma: 'फोटो',
          Fr: 'Photographier',
          Hi: 'फोटो',
          Ta: 'புகைப்படம்',
          Ja: '写真',
          Ge: 'Foto',
        },
        disable: false,
      },
      {
        id: 'PPB5',
        text: {
          En: 'Document',
          Et: 'Dokument',
          Ar: 'وثيقة',
          Ml: 'പ്രമാണം',
          Ma: 'दस्तऐवज',
          Fr: 'Document',
          Hi: 'दस्तावेज़',
          Ta: 'ஆவணம்',
          Ja: '書類',
          Ge: 'Dokumentieren',
        },
        disable: false,
      },
    ],

    Level2InventoryRecieving: [
      {
        id: 'IRB1',
        value: 'Register',
        Icon: 'registered',
        gradientvalue: 80,
        text: {
          En: 'Register',
          Et: 'Registreeri',
          Ar: 'يسجل',
          Ml: 'രജിസ്റ്റർ ചെയ്യുക',
          Ma: 'नोंदणी करा',
          Fr: "S'inscrire",
          Hi: 'पंजीकरण',
          Ta: 'பதிவு',
          Ja: '登録',
          Ge: 'Registrieren',
        },
        disable: false,
      },
      {
        id: 'IRB2',
        value: 'Verify',
        Icon: 'check',
        gradientvalue: 20,
        text: {
          En: 'Incoming Asset',
          Et: 'Kinnitage',
          Ar: 'يؤكد',
          Ml: 'സ്ഥിരീകരിക്കുക',
          Ma: 'सत्यापित करा',
          Fr: 'Vérifier',
          Hi: 'सत्यापित करना',
          Ta: 'சரிபார்க்கவும்',
          Ja: '確認',
          Ge: 'Verifizieren',
        },
        disable: false,
      },
      {
        id: 'IRB3',
        value: 'Tag',
        Icon: 'tag',
        gradientvalue: 90,
        text: {
          En: 'Tag & Verify',
          Et: 'Tag',
          Ar: 'بطاقة شعار',
          Ml: 'ടാഗ് ചെയ്യുക',
          Ma: 'टॅग करा',
          Fr: 'Étiquette',
          Hi: 'उपनाम',
          Ta: 'குறிச்சொல்',
          Ja: '鬼ごっこ',
          Ge: 'Tag',
        },
        disable: false,
      },
      {
        id: 'IRB4',
        value: 'Create Order Receiving',
        Icon: 'check square outline',
        gradientvalue: 90,
        text: {
          En: 'Create Order',
          Et: 'Loo tellimus',
          Ar: 'إنشاء النظام',
          Ml: 'ഓർഡർ സൃഷ്ടിക്കുക',
          Ma: 'ऑर्डर तयार करा',
          Fr: 'Créer une commande',
          Hi: 'आदेश बनाएं',
          Ta: 'ஆர்டரை உருவாக்கவும்',
          Ja: '注文を作成',
          Ge: 'Bestellung anlegen',
        },
        disable: false,
      },
    ],
    Level2InventoryRecievingHFC: [
      {
        id: 'IRB1',
        value: 'Register',
        Icon: 'registered',
        gradientvalue: 80,
        text: {
          En: 'Register',
          Et: 'Registreeri',
          Ar: 'يسجل',
          Ml: 'രജിസ്റ്റർ ചെയ്യുക',
          Ma: 'नोंदणी करा',
          Fr: "S'inscrire",
          Hi: 'पंजीकरण',
          Ta: 'பதிவு',
          Ja: '登録',
          Ge: 'Registrieren',
        },
        disable: false,
      },
      {
        id: 'IRB2',
        value: 'Move To Vault',
        Icon: 'check',
        gradientvalue: 20,
        text: {
          En: 'Move To Vault',
          Et: 'Kinnitage',
          Ar: 'يؤكد',
          Ml: 'സ്ഥിരീകരിക്കുക',
          Ma: 'सत्यापित करा',
          Fr: 'Vérifier',
          Hi: 'सत्यापित करना',
          Ta: 'சரிபார்க்கவும்',
          Ja: '確認',
          Ge: 'Verifizieren',
        },
        disable: false,
      },
      {
        id: 'IRB3',
        value: 'Tag',
        Icon: 'tag',
        gradientvalue: 90,
        text: {
          En: 'Tag & Verify',
          Et: 'Tag',
          Ar: 'بطاقة شعار',
          Ml: 'ടാഗ് ചെയ്യുക',
          Ma: 'टॅग करा',
          Fr: 'Étiquette',
          Hi: 'उपनाम',
          Ta: 'குறிச்சொல்',
          Ja: '鬼ごっこ',
          Ge: 'Tag',
        },
        disable: false,
      },
      {
        id: 'IRB4',
        value: 'Create Order Receiving',
        Icon: 'check square outline',
        gradientvalue: 90,
        text: {
          En: 'Create Order',
          Et: 'Loo tellimus',
          Ar: 'إنشاء النظام',
          Ml: 'ഓർഡർ സൃഷ്ടിക്കുക',
          Ma: 'ऑर्डर तयार करा',
          Fr: 'Créer une commande',
          Hi: 'आदेश बनाएं',
          Ta: 'ஆர்டரை உருவாக்கவும்',
          Ja: '注文を作成',
          Ge: 'Bestellung anlegen',
        },
        disable: false,
      },
    ],
    Level2InventoryReceivingRestoration: [
      {
        id: 'IRB1',
        value: 'Register',
        Icon: 'registered',
        gradientvalue: 80,
        text: {
          En: 'Register',
          Et: 'Registreeri',
          Ar: 'يسجل',
          Ml: 'രജിസ്റ്റർ ചെയ്യുക',
          Ma: 'नोंदणी करा',
          Fr: "S'inscrire",
          Hi: 'पंजीकरण',
          Ta: 'பதிவு',
          Ja: '登録',
          Ge: 'Registrieren',
        },
        disable: false,
      },
      {
        id: 'IRB2',
        value: 'Verify',
        Icon: 'check',
        gradientvalue: 20,
        text: {
          En: 'Incoming Asset',
          Et: 'Kinnitage',
          Ar: 'يؤكد',
          Ml: 'സ്ഥിരീകരിക്കുക',
          Ma: 'सत्यापित करा',
          Fr: 'Vérifier',
          Hi: 'सत्यापित करना',
          Ta: 'சரிபார்க்கவும்',
          Ja: '確認',
          Ge: 'Verifizieren',
        },
        disable: false,
      },
      {
        id: 'IRB4',
        value: 'Create Order Receiving',
        Icon: 'check square outline',
        gradientvalue: 90,
        text: {
          En: 'Create Order',
          Et: 'Loo tellimus',
          Ar: 'إنشاء النظام',
          Ml: 'ഓർഡർ സൃഷ്ടിക്കുക',
          Ma: 'ऑर्डर तयार करा',
          Fr: 'Créer une commande',
          Hi: 'आदेश बनाएं',
          Ta: 'ஆர்டரை உருவாக்கவும்',
          Ja: '注文を作成',
          Ge: 'Bestellung anlegen',
        },
        disable: false,
      },
    ],

    // lok sabha
    Level2InventoryRecievingLokSabha: [
      {
        id: 'IRB1',
        value: 'Register',
        Icon: 'registered',
        gradientvalue: 80,
        text: {
          En: 'Register',
          Et: 'Registreeri',
          Ar: 'يسجل',
          Ml: 'രജിസ്റ്റർ ചെയ്യുക',
          Ma: 'नोंदणी करा',
          Fr: "S'inscrire",
          Hi: 'पंजीकरण',
          Ta: 'பதிவு',
          Ja: '登録',
          Ge: 'Registrieren',
        },
        disable: false,
      },
      {
        id: 'IRB2',
        value: 'Verify',
        Icon: 'check',
        gradientvalue: 20,
        text: {
          En: 'Inspection',
          Et: 'Kinnitage',
          Ar: 'يؤكد',
          Ml: 'സ്ഥിരീകരിക്കുക',
          Ma: 'सत्यापित करा',
          Fr: 'Vérifier',
          Hi: 'सत्यापित करना',
          Ta: 'சரிபார்க்கவும்',
          Ja: '確認',
          Ge: 'Verifizieren',
        },
        disable: false,
      },
      {
        id: 'IRB3',
        value: 'Tag',
        Icon: 'tag',
        gradientvalue: 90,
        text: {
          En: 'Tag & Verify',
          Et: 'Tag',
          Ar: 'بطاقة شعار',
          Ml: 'ടാഗ് ചെയ്യുക',
          Ma: 'टॅग करा',
          Fr: 'Étiquette',
          Hi: 'उपनाम',
          Ta: 'குறிச்சொல்',
          Ja: '鬼ごっこ',
          Ge: 'Tag',
        },
        disable: false,
      },
      {
        id: 'IRB4',
        value: 'Create Order Receiving',
        Icon: 'check square outline',
        gradientvalue: 90,
        text: {
          En: 'Work Allocation',
          Et: 'Loo tellimus',
          Ar: 'إنشاء النظام',
          Ml: 'ഓർഡർ സൃഷ്ടിക്കുക',
          Ma: 'ऑर्डर तयार करा',
          Fr: 'Créer une commande',
          Hi: 'आदेश बनाएं',
          Ta: 'ஆர்டரை உருவாக்கவும்',
          Ja: '注文を作成',
          Ge: 'Bestellung anlegen',
        },
        disable: false,
      },
    ],

    Level2InventoryDelivery: [
      {
        id: 'IDB1',
        value: 'Order Request',
        Icon: 'sign-out',
        gradientvalue: 20,
        text: {
          En: 'Outward Request',
          Et: 'Tellimuse taotlus',
          Ar: 'طلب',
          Ml: 'ഓർഡർ അഭ്യർത്ഥന',
          Ma: 'ऑर्डर विनंती',
          Fr: 'Demande de commande',
          Hi: 'ऑर्डर अनुरोध',
          Ta: 'ஆர்டர் கோரிக்கை',
          Ja: 'オーダーリクエスト',
          Ge: 'Bestellanfrage',
        },
        disable: false,
      },
      {
        id: 'IDB2',
        value: 'Order Register',
        Icon: 'registered outline',
        gradientvalue: 20,
        text: {
          En: 'Outward Register',
          Et: 'Tellimuste register',
          Ar: 'طلب تسجيل',
          Ml: 'ഓർഡർ രജിസ്റ്റർ',
          Ma: 'ऑर्डर रजिस्टर',
          Fr: 'Registre des commandes',
          Hi: 'आदेश पंजीकरण',
          Ta: 'ஆர்டர் பதிவு',
          Ja: '注文登録',
          Ge: 'Bestellregister',
        },
        disable: false,
      },
      {
        id: 'IDB3',
        value: 'Approve',
        Icon: 'check circle outline',
        gradientvalue: 20,
        text: {
          En: 'Approve',
          Et: 'Kinnita',
          Ar: 'يوافق',
          Ml: 'അംഗീകരിക്കുക',
          Ma: 'मंजूर',
          Fr: 'Approuver',
          Hi: 'मंज़ूरी देना',
          Ta: 'ஒப்புதல்',
          Ja: '承認',
          Ge: 'Genehmigen',
        },
        disable: false,
      },
      {
        id: 'IDB4',
        value: 'Assign Picker Delivery',
        Icon: 'hand lizard outline',
        gradientvalue: 20,
        text: {
          En: 'Authorized Personnal',
          Et: 'Määra valija',
          Ar: 'منتقي التعيين',
          Ml: 'പിക്കർ അസൈൻ ചെയ്യുക',
          Ma: 'पिकर नियुक्त करा',
          Fr: 'Attribuer un sélecteur',
          Hi: 'पिकर असाइन करें',
          Ta: 'பிக்கரை ஒதுக்கவும்',
          Ja: 'ピッカーの割り当て',
          Ge: 'Picker zuweisen',
        },
        disable: false,
      },
      {
        id: 'IDB5',
        value: 'Create Order',
        Icon: 'chevron circle right',
        gradientvalue: 20,
        text: {
          En: 'Outward Process Instructions',
          Et: 'Loo tellimus',
          Ar: 'إنشاء النظام',
          Ml: 'ഓർഡർ സൃഷ്ടിക്കുക',
          Ma: 'ऑर्डर तयार करा',
          Fr: 'Créer une commande',
          Hi: 'आदेश बनाएं',
          Ta: 'ஆர்டரை உருவாக்கவும்',
          Ja: '注文を作成',
          Ge: 'Bestellung anlegen',
        },
        disable: false,
      },
      {
        id: 'IDB6',
        value: 'Delivery',
        Icon: 'clipboard check',
        gradientvalue: 20,
        text: {
          En: 'Delivery',
          Et: 'Kohaletoimetamine',
          Ar: 'توصيل',
          Ml: 'ഡെലിവറി',
          Ma: 'डिलिव्हरी',
          Fr: 'Livraison',
          Hi: 'वितरण',
          Ta: 'டெலிவரி',
          Ja: '配達',
          Ge: 'Lieferung',
        },
        disable: false,
      },
    ],

    Level2InventoryReports: [
      {
        id: 'IRR1',
        value: 'New Asset Added',
        Icon: 'ticket',
        gradientvalue: 80,
        text: {
          En: 'New Asset Added',
          Et: 'Sellel kuul on lisatud uusi varade pealkirju',
          Ar: 'تمت إضافة عناوين الأصول الجديدة في هذا الشهر',
          Ml: 'ഈ മാസം പുതിയ അസറ്റ് ശീർഷകങ്ങൾ ചേർത്തു',
          Ma: 'या महिन्यात नवीन मालमत्ता शीर्षके जोडली',
          Fr: "Nouveaux titres d'actifs ajoutés ce mois-ci",
          Hi: 'इस महीने में जोड़े गए नए एसेट टाइटल',
          Ta: 'இந்த மாதத்தில் புதிய சொத்து தலைப்புகள் சேர்க்கப்பட்டன',
          Ja: '今月追加された新しいアセット タイトル',
          Ge: 'Neue Asset-Titel in diesem Monat hinzugefügt',
        },
        disable: false,
      },
      {
        id: 'IRR2',
        value: 'Current Month Asset CAN Movement',
        Icon: 'chevron circle right',
        gradientvalue: 20,
        text: {
          En: 'Current Month Asset CAN Movement',
          Et: 'Jooksev kuu vara CAN liikumine',
          Ar: 'يمكن تحريك أصول الشهر الحالي',
          Ml: 'നിലവിലെ മാസ ആസ്തി പ്രസ്ഥാനത്തിന് കഴിയും',
          Ma: 'चालू महिन्याची मालमत्ता कॅन चळवळ',
          Fr: 'Mouvement CAN des actifs du mois en cours',
          Hi: 'वर्तमान माह संपत्ति आंदोलन कर सकती है',
          Ta: 'நடப்பு மாத சொத்து இயக்கம் முடியும்',
          Ja: '当月の資産のCAN移動',
          Ge: 'Asset-CAN-Bewegung des aktuellen Monats',
        },
        disable: false,
      },
      {
        id: 'IRR3',
        value: 'Pending Returns From Borrowers',
        Icon: 'wait',
        gradientvalue: 10,
        text: {
          En: 'Pending Returns From Borrowers',
          Et: 'Ootel laenuvõtjate tagasimaksed',
          Ar: 'عوائد معلقة من المقترضين',
          Ml: 'കടം വാങ്ങുന്നവരിൽ നിന്ന് തീർപ്പാക്കാത്ത റിട്ടേണുകൾ',
          Ma: 'कर्जदारांकडून प्रलंबित परतावे',
          Fr: 'Retours en attente des emprunteurs',
          Hi: 'उधारकर्ताओं से लंबित रिटर्न',
          Ta: 'கடன் வாங்கியவர்களிடமிருந்து நிலுவையில் உள்ள வருமானம்',
          Ja: '借り手からの保留中の返品',
          Ge: 'Ausstehende Rückgaben von Kreditnehmern',
        },
        disable: false,
      },
      {
        id: 'IRR4',
        value: 'Assets Cleaned',
        Icon: 'calendar check outline',
        gradientvalue: 90,
        text: {
          En: 'Assets Cleaned',
          Et: 'Selle kuu jooksul puhastatud varad',
          Ar: 'الأصول التي تم تنظيفها في هذا الشهر',
          Ml: 'ഈ മാസത്തിൽ സ്വത്തുക്കൾ വൃത്തിയാക്കി',
          Ma: 'या महिन्यात मालमत्ता साफ केल्या',
          Fr: 'Actifs nettoyés ce mois-ci',
          Hi: 'इस महीने में साफ की गई संपत्ति',
          Ta: 'இந்த மாதத்தில் சுத்தம் செய்யப்பட்ட சொத்துகள்',
          Ja: '今月クリーニングされたアセット',
          Ge: 'Assets, die in diesem Monat gereinigt wurden',
        },
        disable: false,
      },
      {
        id: 'IRR5',
        value: 'Assets Scheduled For Cleaning',
        Icon: 'calendar check outline',
        gradientvalue: 90,
        text: {
          En: 'Assets Scheduled For Cleaning',
          Et: 'Varad on plaanitud puhastada',
          Ar: 'الأصول المجدولة للتنظيف',
          Ml: 'ശുചീകരണത്തിനായി ഷെഡ്യൂൾ ചെയ്ത അസറ്റുകൾ',
          Ma: 'साफसफाईसाठी शेड्यूल केलेली मालमत्ता',
          Fr: 'Actifs programmés pour le nettoyage',
          Hi: 'सफाई के लिए अनुसूचित संपत्ति',
          Ta: 'சுத்தம் செய்ய திட்டமிடப்பட்ட சொத்துகள்',
          Ja: 'クリーニング予定のアセット',
          Ge: 'Für die Reinigung geplante Assets',
        },
        disable: false,
      },
      {
        id: 'IRR6',
        value: 'Digitalization Priority',
        Icon: 'ordered list',
        gradientvalue: 90,
        text: {
          En: 'Digitalization Priority',
          Ar: 'أولوية الرقمنة',
          Ml: 'ഡിജിറ്റലൈസേഷൻ മുൻഗണന',
          Ma: 'डिजिटलायझेशनला प्राधान्य',
          Fr: 'Priorité à la numérisation',
          Hi: 'डिजिटलीकरण प्राथमिकता',
          Ta: 'டிஜிட்டல் மயமாக்கல் முன்னுரிமை',
          Ja: 'デジタル化の優先事項',
          Ge: 'Priorität Digitalisierung',
        },
        disable: false,
      },
    ],

    Level3InventoryRecievingRegister: {
      IRRL01: {
        En: 'PACKAGE DETAILS OF NEW ACQUISITION',
        Et: 'VASTU SAADUD/TAATUD VARA PAKENDI ANDMED',
        Ar: 'تفاصيل حزمة الأصول المستلمة / المسلمة',
        Ml: 'ലഭിച്ച/ഡെലിവർ ചെയ്ത അസറ്റിന്റെ പാക്കേജ് വിശദാംശങ്ങൾ',
        Ma: 'प्राप्त/वितरित मालमत्तेचे पॅकेज तपशील',
        Fr: "DÉTAILS DE L'EMBALLAGE DE L'ACTIF REÇU/LIVRÉ",
        Hi: 'प्राप्त/वितरित संपत्ति का पैकेज विवरण',
        Ta: 'பெறப்பட்ட/வழங்கப்பட்ட சொத்தின் தொகுப்பு விவரங்கள்',
        Ja: '受領/納品されたアセットのパッケージの詳細',
        Ge: 'PAKETDETAILS DES ERHALTENEN/GELIEFERTEN WERTS',
      },
      IRRL02: {
        En: 'PACKAGE DETAILS',
        Et: 'PAKENDI ANDMED',
        Ar: 'حزمة من التفاصيل',
        Ml: 'പാക്കേജ് വിശദാംശങ്ങൾ',
        Ma: 'पॅकेज तपशील',
        Fr: 'DÉTAILS DU FORFAIT',
        Hi: 'पैकेज विवरण',
        Ta: 'பேக்கேஜ் விவரங்கள்',
        Ja: 'パッケージの詳細',
        Ge: 'PAKETDETAILS',
      },
      IRRL03: {
        En: 'Title',
        Et: 'Pealkiri',
        Ar: 'عنوان',
        Ml: 'തലക്കെട്ട്',
        Ma: 'शीर्षक',
        Fr: 'Titre',
        Hi: 'शीर्षक',
        Ta: 'தலைப்பு',
        Ja: '題名',
        Ge: 'Titel',
      },
      IRRL04:{
        En: 'Assign Activities',
        Et: 'Määra tegevused',
        Ar: 'تعيين الأنشطة',
        Ml: 'പ്രവർത്തനങ്ങൾ നിയോഗിക്കുക',
        Ma: 'क्रियाकलापांचे नियोजन करा',
        Fr: 'Attribuer des activités',
        Hi: 'गतिविधियाँ असाइन करें ',
        Ta: 'செயல்களைக் ஒதுக்கு',
        Ja: 'アクティビティを割り当てる',
        Ge: 'Aktivitäten zuweisen',
      },
      IRRTB01: {
        En: 'Title',
        Et: 'Pealkiri',
        Ar: 'عنوان',
        Ml: 'തലക്കെട്ട്',
        Ma: 'शीर्षक',
        Fr: 'Titre',
        Hi: 'शीर्षक',
        Ta: 'தலைப்பு',
        Ja: '題名',
        Ge: 'Titel',
      },
      IRRL14: {
        En: 'Type',
        Et: 'Tüüp',
        Ar: 'يكتب',
        Ml: 'ടൈപ്പ് ചെയ്യുക',
        Ma: 'प्रकार',
        Fr: 'Taper',
        Hi: 'प्रकार',
        Ta: 'வகை',
        Ja: 'タイプ',
        Ge: 'Typ',
      },
      IRRTB02: {
        En: 'Type',
        Et: 'Tüüp',
        Ar: 'يكتب',
        Ml: 'ടൈപ്പ് ചെയ്യുക',
        Ma: 'प्रकार',
        Fr: 'Taper',
        Hi: 'प्रकार',
        Ta: 'வகை',
        Ja: 'タイプ',
        Ge: 'Typ',
      },
      IRRL05: {
        En: 'Sender Details',
        Et: 'Saatja üksikasjad',
        Ar: 'بيانات المرسل',
        Ml: 'അയച്ചയാളുടെ വിശദാംശങ്ങൾ',
        Ma: 'प्रेषक तपशील',
        Fr: "Détails de l'expéditeur",
        Hi: 'प्रेषक विवरण',
        Ta: 'அனுப்புநர் விவரங்கள்',
        Ja: '送信者の詳細',
        Ge: 'Sender Details',
      },
      IRRTB03: {
        En: 'Sender Details',
        Et: 'Saatja üksikasjad',
        Ar: 'بيانات المرسل',
        Ml: 'അയച്ചയാളുടെ വിശദാംശങ്ങൾ',
        Ma: 'प्रेषक तपशील',
        Fr: "Détails de l'expéditeur",
        Hi: 'प्रेषक विवरण',
        Ta: 'அனுப்புநர் விவரங்கள்',
        Ja: '送信者の詳細',
        Ge: 'Sender Details',
      },
      IRRL06: {
        En: 'Mode of Transport',
        Et: 'Kuller',
        Ar: 'ساعي',
        Ml: 'കൊറിയർ',
        Ma: 'कुरिअर',
        Fr: 'Courrier',
        Hi: 'संदेशवाहक',
        Ta: 'கூரியர்',
        Ja: 'クーリエ',
        Ge: 'Kurier',
      },
      IRRTB04: {
        En: 'Mode of Transport',
        Et: 'Kuller',
        Ar: 'ساعي',
        Ml: 'കൊറിയർ',
        Ma: 'कुरिअर',
        Fr: 'Courrier',
        Hi: 'संदेशवाहक',
        Ta: 'கூரியர்',
        Ja: 'クーリエ',
        Ge: 'Kurier',
      },
      IRRL07: {
        En: 'Mode of Transport Number',
        Et: 'Kulleri number',
        Ar: 'رقم البريد السريع',
        Ml: 'കൊറിയർ നമ്പർ',
        Ma: 'कुरियर क्रमांक',
        Fr: 'Numéro de messagerie',
        Hi: 'कूरियर संख्या',
        Ta: 'கூரியர் எண்',
        Ja: '宅配便番号',
        Ge: 'Kuriernummer',
      },
      IRRTB05: {
        En: 'Mode of Transport Number',
        Et: 'Kulleri number',
        Ar: 'رقم البريد السريع',
        Ml: 'കൊറിയർ നമ്പർ',
        Ma: 'कुरियर क्रमांक',
        Fr: 'Numéro de messagerie',
        Hi: 'कूरियर संख्या',
        Ta: 'கூரியர் எண்',
        Ja: '宅配便番号',
        Ge: 'Kuriernummer',
      },
      IRRL08: {
        En: 'Date',
        Et: 'Kuupäev',
        Ar: 'تاريخ',
        Ml: 'തീയതി',
        Ma: 'तारीख',
        Fr: 'Date',
        Hi: 'दिनांक',
        Ta: 'தேதி',
        Ja: '日にち',
        Ge: 'Datum',
      },
      IRRTB06: {
        En: 'Date',
        Et: 'Kuupäev',
        Ar: 'تاريخ',
        Ml: 'തീയതി',
        Ma: 'तारीख',
        Fr: 'Date',
        Hi: 'दिनांक',
        Ta: 'தேதி',
        Ja: '日にち',
        Ge: 'Datum',
      },
      IRRB1: {
        En: 'Calender Icon',
        Et: 'Kalendri ikoon',
        Ar: 'أيقونة التقويم',
        Ml: 'കലണ്ടർ ഐക്കൺ',
        Ma: 'कॅलेंडर चिन्ह',
        Fr: 'Icône de calendrier',
        Hi: 'कैलेंडर चिह्न',
        Ta: 'காலெண்டர் ஐகான்',
        Ja: 'カレンダー アイコン',
        Ge: 'Kalender-Symbol',
      },
      IRRL09: {
        En: 'Description',
        Et: 'Kirjeldus',
        Ar: 'وصف',
        Ml: 'വിവരണം',
        Ma: 'वर्णन',
        Fr: 'La description',
        Hi: 'वर्णन',
        Ta: 'விளக்கம்',
        Ja: '説明',
        Ge: 'Beschreibung',
      },
      IRRTB07: {
        En: 'Description',
        Et: 'Kirjeldus',
        Ar: 'وصف',
        Ml: 'വിവരണം',
        Ma: 'वर्णन',
        Fr: 'La description',
        Hi: 'वर्णन',
        Ta: 'விளக்கம்',
        Ja: '説明',
        Ge: 'Beschreibung',
      },
      IRRL10: {
        En: 'Barcode',
        Et: 'Vöötkood',
        Ar: 'الرمز الشريطي',
        Ml: 'ബാർകോഡ്',
        Ma: 'बारकोड',
        Fr: 'code à barre',
        Hi: 'बारकोड',
        Ta: 'பார்கோடு',
        Ja: 'バーコード',
        Ge: 'Strichcode',
      },
      IRRTB08: {
        En: 'Barcode',
        Et: 'Vöötkood',
        Ar: 'الرمز الشريطي',
        Ml: 'ബാർകോഡ്',
        Ma: 'बारकोड',
        Fr: 'code à barre',
        Hi: 'बारकोड',
        Ta: 'பார்கோடு',
        Ja: 'バーコード',
        Ge: 'Strichcode',
      },
      IRRL11: {
        En: 'Assigned Status',
        Et: 'Määratud olek',
        Ar: 'الحالة المعينة',
        Ml: 'അസൈൻഡ് സ്റ്റാറ്റസ്',
        Ma: 'नियुक्त स्थिती',
        Fr: 'Statut attribué',
        Hi: 'नियत स्थिति',
        Ta: 'ஒதுக்கப்பட்ட நிலை',
        Ja: '割り当てられたステータス',
        Ge: 'Zugewiesener Status',
      },
      IRRTB09: {
        En: 'Assigned Status',
        Et: 'Määratud olek',
        Ar: 'الحالة المعينة',
        Ml: 'അസൈൻഡ് സ്റ്റാറ്റസ്',
        Ma: 'नियुक्त स्थिती',
        Fr: 'Statut attribué',
        Hi: 'नियत स्थिति',
        Ta: 'ஒதுக்கப்பட்ட நிலை',
        Ja: '割り当てられたステータス',
        Ge: 'Zugewiesener Status',
      },
      IRRL12: {
        En: 'PHOTOGRAPHS OF PACKAGE',
        Et: 'PAKENDI FOTOD',
        Ar: 'صور العبوة',
        Ml: 'പാക്കേജിന്റെ ഫോട്ടോഗ്രാഫുകൾ',
        Ma: 'पॅकेजची छायाचित्रे',
        Fr: "PHOTOGRAPHIES DE L'EMBALLAGE",
        Hi: 'पैकेज की तस्वीरें',
        Ta: 'பேக்கேஜின் புகைப்படங்கள்',
        Ja: 'パッケージ写真',
        Ge: 'FOTOS DES PAKETS',
      },
      IRRL13: {
        En: 'PACKAGE VIEWS',
        Et: 'PAKENDI VAATAMINE',
        Ar: 'عروض الحزمة',
        Ml: 'പാക്കേജ് കാഴ്ചകൾ',
        Ma: 'पॅकेज दृश्ये',
        Fr: 'VUES DU FORFAIT',
        Hi: 'पैकेज दृश्य',
        Ta: 'தொகுப்பு காட்சிகள்',
        Ja: 'パッケージビュー',
        Ge: 'PAKETANSICHTEN',
      },
      IRRB01: {
        En: 'Add Photographs',
        Et: 'Lisa fotosid',
        Ar: 'أضف الصور',
        Ml: 'ഫോട്ടോഗ്രാഫുകൾ ചേർക്കുക',
        Ma: 'छायाचित्रे जोडा',
        Fr: 'Ajouter des photos',
        Hi: 'तस्वीरें जोड़ें',
        Ta: 'புகைப்படங்களைச் சேர்க்கவும்',
        Ja: '写真を追加',
        Ge: 'Fotos hinzufügen',
      },
      IRRB02: {
        En: 'Print Receipt',
        Et: 'Prindi kviitung',
        Ar: 'اطبع الايصال',
        Ml: 'പ്രിന്റ് രസീത്',
        Ma: 'पावती मुद्रित करा',
        Fr: 'Imprimer le reçu',
        Hi: 'प्रिंट रसीद',
        Ta: 'அச்சு ரசீது',
        Ja: '領収書を印刷する',
        Ge: 'Druckeingang',
      },
      IRRB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IRRB04: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      IRRB05: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      
    },

    Level3InventoryRecievingRegisterCameraModal: {
      IRRCML01: {
        En: 'Camera',
        Et: 'Kaamera',
        Ar: 'آلة تصوير',
        Ml: 'ക്യാമറ',
        Ma: 'कॅमेरा',
        Fr: 'Caméra',
        Hi: 'कैमरा',
        Ta: 'புகைப்பட கருவி',
        Ja: 'カメラ',
        Ge: 'Kamera',
      },
      IRRCML02: {
        En: 'Camera error: Requested device not found',
        Et: 'Kaamera viga: soovitud seadet ei leitud',
        Ar: 'خطأ الكاميرا: الجهاز المطلوب غير موجود',
        Ml: 'ക്യാമറ പിശക്: അഭ്യർത്ഥിച്ച ഉപകരണം കണ്ടെത്തിയില്ല',
        Ma: 'कॅमेरा त्रुटी: विनंती केलेले डिव्हाइस आढळले नाही',
        Fr: 'Erreur de caméra : appareil demandé introuvable',
        Hi: 'कैमरा त्रुटि: अनुरोधित उपकरण नहीं मिला',
        Ta: 'கேமரா பிழை: கோரப்பட்ட சாதனம் கிடைக்கவில்லை',
        Ja: 'カメラ エラー: 要求されたデバイスが見つかりません',
        Ge: 'Kamerafehler: Angefordertes Gerät nicht gefunden',
      },
      IRRCMB01: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IRRCMB02: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    Level3InventoryRecievingRegisterPrintReceiptModal: {
      IRRPMTH01: {
        En: 'Title',
        Et: 'Pealkiri',
        Ar: 'عنوان',
        Ml: 'തലക്കെട്ട്',
        Ma: 'शीर्षक',
        Fr: 'Titre',
        Hi: 'शीर्षक',
        Ta: 'தலைப்பு',
        Ja: '題名',
        Ge: 'Titel',
      },
      IRRPMTH02: {
        En: 'Type',
        Et: 'Tüüp',
        Ar: 'يكتب',
        Ml: 'ടൈപ്പ് ചെയ്യുക',
        Ma: 'प्रकार',
        Fr: 'Taper',
        Hi: 'प्रकार',
        Ta: 'வகை',
        Ja: 'タイプ',
        Ge: 'Typ',
      },
      IRRPMTH03: {
        En: 'Sender Details',
        Et: 'Saatja üksikasjad',
        Ar: 'بيانات المرسل',
        Ml: 'അയച്ചയാളുടെ വിശദാംശങ്ങൾ',
        Ma: 'प्रेषक तपशील',
        Fr: "Détails de l'expéditeur",
        Hi: 'प्रेषक विवरण',
        Ta: 'அனுப்புநர் விவரங்கள்',
        Ja: '送信者の詳細',
        Ge: 'Sender Details',
      },
      IRRPMTH04: {
        En: 'Mode of Transport',
        Et: 'Kuller',
        Ar: 'ساعي',
        Ml: 'കൊറിയർ',
        Ma: 'कुरिअर',
        Fr: 'Courrier',
        Hi: 'संदेशवाहक',
        Ta: 'கூரியர்',
        Ja: 'クーリエ',
        Ge: 'Kurier',
      },
      IRRPMTH05: {
        En: 'Mode of Transport Number',
        Et: 'Kulleri number',
        Ar: 'رقم البريد السريع',
        Ml: 'കൊറിയർ നമ്പർ',
        Ma: 'कुरियर क्रमांक',
        Fr: 'Numéro de messagerie',
        Hi: 'कूरियर संख्या',
        Ta: 'கூரியர் எண்',
        Ja: '宅配便番号',
        Ge: 'Kuriernummer',
      },
      IRRPMTH06: {
        En: 'Date',
        Et: 'Kuupäev',
        Ar: 'تاريخ',
        Ml: 'തീയതി',
        Ma: 'तारीख',
        Fr: 'Date',
        Hi: 'दिनांक',
        Ta: 'தேதி',
        Ja: '日にち',
        Ge: 'Datum',
      },
      IRRPMTH07: {
        En: 'Description',
        Et: 'Vastuvõtja kirjeldus',
        Ar: 'وصف المتلقي',
        Ml: 'റിസീവർ വിവരണം',
        Ma: 'प्राप्तकर्ता वर्णन',
        Fr: 'Description du récepteur',
        Hi: 'प्राप्तकर्ता विवरण',
        Ta: 'பெறுநரின் விளக்கம்',
        Ja: 'レシーバーの説明',
        Ge: 'Beschreibung des Empfängers',
      },
      IRRPMTH08: {
        En: 'Barcode',
        Et: 'Vöötkood',
        Ar: 'الرمز الشريطي',
        Ml: 'ബാർകോഡ്',
        Ma: 'बारकोड',
        Fr: 'code à barre',
        Hi: 'बारकोड',
        Ta: 'பார்கோடு',
        Ja: 'バーコード',
        Ge: 'Strichcode',
      },
      IRRPMTH09: {
        En: 'Assigned Status',
        Et: 'Määratud olek',
        Ar: 'الحالة المعينة',
        Ml: 'അസൈൻഡ് സ്റ്റാറ്റസ്',
        Ma: 'नियुक्त स्थिती',
        Fr: 'Statut attribué',
        Hi: 'नियत स्थिति',
        Ta: 'ஒதுக்கப்பட்ட நிலை',
        Ja: '割り当てられたステータス',
        Ge: 'Zugewiesener Status',
      },
      IRRPMB01: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IRRPMB02: {
        En: 'Print',
        Et: 'Prindi',
        Ar: 'مطبعة',
        Ml: 'അച്ചടിക്കുക',
        Ma: 'छापा',
        Fr: 'Imprimer',
        Hi: 'छाप',
        Ta: 'அச்சிடுக',
        Ja: '印刷する',
        Ge: 'Drucken',
      },
    },

    Level3InventoryRecievingVerifyTableDeleteConfirmationModal: {
      IRVTDCML01: {
        En: 'Delete Confirmation',
        Et: 'Kustutamise kinnitus',
        Ar: 'تأكيد الحذف',
        Ml: 'സ്ഥിരീകരണം ഇല്ലാതാക്കുക',
        Ma: 'पुष्टीकरण हटवा',
        Fr: 'Supprimer la confirmation',
        Hi: 'पुष्टि हटाएं',
        Ta: 'உறுதிப்படுத்தலை நீக்கு',
        Ja: '削除の確認',
        Ge: 'Bestätigung löschen',
      },
      IRVTDCML02: {
        En: 'Are you sure, do you want to delete',
        Et: 'Kas olete kindel, kas soovite kustutada',
        Ar: 'هل أنت متأكد ، هل تريد حذف',
        Ml: 'നിങ്ങൾക്ക് ഉറപ്പാണോ, ഇല്ലാതാക്കണോ',
        Ma: 'तुम्हाला खात्री आहे, तुम्हाला हटवायचे आहे का',
        Fr: 'Êtes-vous sûr, voulez-vous supprimer',
        Hi: 'क्या आप सुनिश्चित हैं, क्या आप हटाना चाहते हैं',
        Ta: 'நிச்சயமாக, நீக்க விரும்புகிறீர்களா',
        Ja: 'よろしいですか、削除しますか',
        Ge: 'Sind Sie sicher, möchten Sie löschen?',
      },
      IRVTDCMB01: {
        En: 'No',
        Et: 'Ei',
        Ar: 'رقم',
        Ml: 'ഇല്ല',
        Ma: 'नाही',
        Fr: 'Non',
        Hi: 'नहीं',
        Ta: 'இல்லை',
        Ja: 'いいえ',
        Ge: 'Nein',
      },
      IRVTDCMB02: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      IRVTDCMB03: {
        En: 'Yes',
        Et: 'Jah',
        Ar: 'نعم',
        Ml: 'അതെ',
        Ma: 'होय',
        Fr: 'Oui',
        Hi: 'हाँ',
        Ta: 'ஆம்',
        Ja: 'はい',
        Ge: 'Ja',
      },
    },

    Level3InventoryRecievingVerify: {
      IRVL01: {
        En: 'Incoming Asset',
        Et: 'KINNITA',
        Ar: 'تحقق',
        Ml: 'സ്ഥിരീകരിക്കുക',
        Ma: 'सत्यापित करा',
        Fr: 'VÉRIFIER',
        Hi: 'सत्यापित करना',
        Ta: 'சரிபார்க்கவும்',
        Ja: '確認',
        Ge: 'VERIFIZIEREN',
      },
      IRVL02: {
        En: 'Worklevel',
        Et: 'Töötase',
        Ar: 'مستوى العمل',
        Ml: 'വർക്ക് ലെവൽ',
        Ma: 'कार्यस्तर',
        Fr: 'Niveau de travail',
        Hi: 'कार्य स्तर',
        Ta: 'பணிநிலை',
        Ja: '作業レベル',
        Ge: 'Arbeitsebene',
      },
      IRVDD01: {
        En: 'Select/Create Worklevel',
        Et: 'Valige/loo töötase',
        Ar: 'حدد / إنشاء مستوى العمل',
        Ml: 'വർക്ക് ലെവൽ തിരഞ്ഞെടുക്കുക/സൃഷ്ടിക്കുക',
        Ma: 'कार्यस्तर निवडा/तयार करा',
        Fr: 'Sélectionner/Créer un niveau de travail',
        Hi: 'वर्कलेवल चुनें/बनाएं',
        Ta: 'பணிநிலையைத் தேர்ந்தெடுக்கவும்/உருவாக்கவும்',
        Ja: 'ワークレベルの選択/作成',
        Ge: 'Arbeitsebene auswählen/erstellen',
      },
      IRVDD02: {
        En: 'Select Type',
        Et: 'Valige Tüüp',
        Ar: 'اختر صنف',
        Ml: 'തരം തിരഞ്ഞെടുക്കുക',
        Ma: 'प्रकार निवडा',
        Fr: 'Sélectionner le genre',
        Hi: 'प्रकार चुनें',
        Ta: 'வகையைத் தேர்ந்தெடுக்கவும்',
        Ja: 'タイプを選択',
        Ge: 'Art auswählen',
      },
      IRVL03: {
        En: 'Elements',
        Et: 'Elemendid',
        Ar: 'عناصر',
        Ml: 'ഘടകങ്ങൾ',
        Ma: 'घटक',
        Fr: 'Éléments',
        Hi: 'तत्वों',
        Ta: 'கூறுகள்',
        Ja: '要素',
        Ge: 'Elemente',
      },
      IRVDD03: {
        En: 'Select Element(s)',
        Et: 'Valige element(id)',
        Ar: 'حدد العنصر (العناصر)',
        Ml: 'ഘടകം(കൾ) തിരഞ്ഞെടുക്കുക',
        Ma: 'घटक निवडा',
        Fr: 'Sélectionnez les éléments',
        Hi: 'तत्वों का चयन करें',
        Ta: 'உறுப்பு(களை) தேர்ந்தெடு',
        Ja: '要素を選択',
        Ge: 'Element(e) auswählen',
      },
      IRVL04: {
        En: 'Number of elements',
        Et: 'Elementide arv',
        Ar: 'عدد العناصر',
        Ml: 'മൂലകങ്ങളുടെ എണ്ണം',
        Ma: 'घटकांची संख्या',
        Fr: "Nombre d'éléments",
        Hi: 'तत्वों की संख्या',
        Ta: 'உறுப்புகளின் எண்ணிக்கை',
        Ja: '要素数',
        Ge: 'Anzahl der Elemente',
      },
      IRVDD04: {
        En: 'Number of elements',
        Et: 'Elementide arv',
        Ar: 'عدد العناصر',
        Ml: 'മൂലകങ്ങളുടെ എണ്ണം',
        Ma: 'घटकांची संख्या',
        Fr: "Nombre d'éléments",
        Hi: 'तत्वों की संख्या',
        Ta: 'உறுப்புகளின் எண்ணிக்கை',
        Ja: '要素数',
        Ge: 'Anzahl der Elemente',
      },
      IRVCB01: {
        En: 'Clone Existing Data',
        Et: 'Olemasolevate andmete kloonimine',
        Ar: 'استنساخ البيانات الموجودة',
        Ml: 'നിലവിലുള്ള ഡാറ്റ ക്ലോൺ ചെയ്യുക',
        Ma: 'विद्यमान डेटा क्लोन करा',
        Fr: 'Cloner les données existantes',
        Hi: 'क्लोन मौजूदा डेटा',
        Ta: 'இருக்கும் தரவை குளோன் செய்யவும்',
        Ja: '既存データの複製',
        Ge: 'Vorhandene Daten klonen',
      },
      IRVB01: {
        En: 'Add Photographs',
        Et: 'Lisa fotosid',
        Ar: 'أضف الصور',
        Ml: 'ഫോട്ടോഗ്രാഫുകൾ ചേർക്കുക',
        Ma: 'छायाचित्रे जोडा',
        Fr: 'Ajouter des photos',
        Hi: 'तस्वीरें जोड़ें',
        Ta: 'புகைப்படங்களைச் சேர்க்கவும்',
        Ja: '写真を追加',
        Ge: 'Fotos hinzufügen',
      },
      IRVB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IRVB03: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
      IRVFDL01: {
        En: 'Add any available documentations like PDF, Authorization Letter, Legal Document, Copyright Document',
        Et: 'Lohistage mõned failid siia või klõpsake failide valimiseks',
        Ar: 'قم بسحب وإفلات بعض الملفات هنا ، أو انقر لتحديد الملفات',
        Ml: 'ചില ഫയലുകൾ ഇവിടെ വലിച്ചിടുക, അല്ലെങ്കിൽ ഫയലുകൾ തിരഞ്ഞെടുക്കാൻ ക്ലിക്ക് ചെയ്യുക',
        Ma: 'काही फाइल्स येथे ड्रॅग आणि ड्रॉप करा किंवा फाइल्स निवडण्यासाठी क्लिक करा',
        Fr: 'Faites glisser et déposez des fichiers ici, ou cliquez pour sélectionner des fichiers',
        Hi: 'कुछ फाइलों को यहां खींचें और छोड़ें, या फाइलों का चयन करने के लिए क्लिक करें',
        Ta: 'சில கோப்புகளை இங்கே இழுத்து விடுங்கள் அல்லது கோப்புகளைத் தேர்ந்தெடுக்க கிளிக் செய்யவும்',
        Ja: 'ここにいくつかのファイルをドラッグ アンド ドロップするか、クリックしてファイルを選択します',
        Ge: 'Ziehen Sie einige Dateien hierher und legen Sie sie dort ab, oder klicken Sie, um Dateien auszuwählen',
      },
      IRVB04: {
        En: 'Upload',
        Et: 'Laadi üles',
        Ar: 'تحميل',
        Ml: 'അപ്‌ലോഡ് ചെയ്യുക',
        Ma: 'अपलोड करा',
        Fr: 'Télécharger',
        Hi: 'डालना',
        Ta: 'பதிவேற்றவும்',
        Ja: 'アップロード',
        Ge: 'Hochladen',
      },
      IRVB05: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    Level3InventoryRecievingVerifyTab: {
      IRVTL01: {
        En: 'Please select item received',
        Et: 'Valige üksus vastu võetud',
        Ar: 'الرجاء تحديد العنصر المستلم',
        Ml: 'ലഭിച്ച ഇനം തിരഞ്ഞെടുക്കുക',
        Ma: 'कृपया प्राप्त आयटम निवडा',
        Fr: "Veuillez sélectionner l'article reçu",
        Hi: 'कृपया प्राप्त आइटम का चयन करें',
        Ta: 'பெற்ற உருப்படியைத் தேர்ந்தெடுக்கவும்',
        Ja: '受け取ったアイテムを選択してください',
        Ge: 'Bitte erhaltenen Artikel auswählen',
      },
    },

    Level3InventoryRecievingVerifyWorkLevelMaster: {
      IRVWLL01: {
        En: 'WORK LEVEL MASTER',
        Et: 'TÖÖTASME MEISTER',
        Ar: 'مستوى العمل ماجستير',
        Ml: 'വർക്ക് ലെവൽ മാസ്റ്റർ',
        Ma: 'वर्क लेव्हल मास्टर',
        Fr: 'MAÎTRE DE NIVEAU DE TRAVAIL',
        Hi: 'कार्य स्तर मास्टर',
        Ta: 'பணி நிலை மாஸ்டர்',
        Ja: 'ワークレベルマスター',
        Ge: 'ARBEITSSTUFE MEISTER',
      },
      IRVWLL02: {
        En: 'Title',
        Et: 'Pealkiri',
        Ar: 'عنوان',
        Ml: 'തലക്കെട്ട്',
        Ma: 'शीर्षक',
        Fr: 'Titre',
        Hi: 'शीर्षक',
        Ta: 'தலைப்பு',
        Ja: '題名',
        Ge: 'Titel',
      },
      IRVWLLTB01: {
        En: 'Title',
        Et: 'Pealkiri',
        Ar: 'عنوان',
        Ml: 'തലക്കെട്ട്',
        Ma: 'शीर्षक',
        Fr: 'Titre',
        Hi: 'शीर्षक',
        Ta: 'தலைப்பு',
        Ja: '題名',
        Ge: 'Titel',
      },
      IRVWLL03: {
        En: 'Year',
        Et: 'aasta',
        Ar: 'سنة',
        Ml: 'വർഷം',
        Ma: 'वर्ष',
        Fr: 'An',
        Hi: 'वर्ष',
        Ta: 'ஆண்டு',
        Ja: '年',
        Ge: 'Jahr',
      },
      IRVWLLTB02: {
        En: 'Year',
        Et: 'aasta',
        Ar: 'سنة',
        Ml: 'വർഷം',
        Ma: 'वर्ष',
        Fr: 'An',
        Hi: 'वर्ष',
        Ta: 'ஆண்டு',
        Ja: '年',
        Ge: 'Jahr',
      },
      IRVWLL04: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      IRVWLLDD01: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      IRVWLL05: {
        En: 'Origin',
        Et: 'Päritolu',
        Ar: 'أصل',
        Ml: 'ഉത്ഭവം',
        Ma: 'मूळ',
        Fr: 'Origine',
        Hi: 'मूल',
        Ta: 'தோற்றம்',
        Ja: '元',
        Ge: 'Herkunft',
      },
      IRVWLDD02: {
        En: 'Origin',
        Et: 'Päritolu',
        Ar: 'أصل',
        Ml: 'ഉത്ഭവം',
        Ma: 'मूळ',
        Fr: 'Origine',
        Hi: 'मूल',
        Ta: 'தோற்றம்',
        Ja: '元',
        Ge: 'Herkunft',
      },
      IRVWLB01: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IRVWLB02: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      IRVWLB03: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
    },

    Level3InventoryRecievingTag: {
      IRTL01: {
        En: 'Tag & Verify',
        Et: 'TAG',
        Ar: 'بطاقة شعار',
        Ml: 'TAG',
        Ma: 'TAG',
        Fr: 'ÉTIQUETTE',
        Hi: 'उपनाम',
        Ta: 'TAG',
        Ja: '鬼ごっこ',
        Ge: 'TAG',
      },
      IRTB01: {
        En: 'Scan',
        Et: 'Skaneeri',
        Ar: 'مسح',
        Ml: 'സ്കാൻ ചെയ്യുക',
        Ma: 'स्कॅन करा',
        Fr: 'Analyse',
        Hi: 'स्कैन',
        Ta: 'ஊடுகதிர்',
        Ja: 'スキャン',
        Ge: 'Scan',
      },
      IRTB02: {
        En: 'Print',
        Et: 'Prindi',
        Ar: 'مطبعة',
        Ml: 'അച്ചടിക്കുക',
        Ma: 'छापा',
        Fr: 'Imprimer',
        Hi: 'छाप',
        Ta: 'அச்சிடுக',
        Ja: '印刷する',
        Ge: 'Drucken',
      },
      IRTB03: {
        En: 'Scan',
        Et: 'Skaneeri',
        Ar: 'مسح',
        Ml: 'സ്കാൻ ചെയ്യുക',
        Ma: 'स्कॅन करा',
        Fr: 'Analyse',
        Hi: 'स्कैन',
        Ta: 'ஊடுகதிர்',
        Ja: 'スキャン',
        Ge: 'Scan',
      },
      IRTB04: {
        En: 'Print',
        Et: 'Prindi',
        Ar: 'مطبعة',
        Ml: 'അച്ചടിക്കുക',
        Ma: 'छापा',
        Fr: 'Imprimer',
        Hi: 'छाप',
        Ta: 'அச்சிடுக',
        Ja: '印刷する',
        Ge: 'Drucken',
      },
      IRTB05: {
        En: 'Scan',
        Et: 'Skaneeri',
        Ar: 'مسح',
        Ml: 'സ്കാൻ ചെയ്യുക',
        Ma: 'स्कॅन करा',
        Fr: 'Analyse',
        Hi: 'स्कैन',
        Ta: 'ஊடுகதிர்',
        Ja: 'スキャン',
        Ge: 'Scan',
      },
      IRTL02: {
        En: 'Vault',
        Et: 'Vault',
        Ar: 'قبو',
        Ml: 'നിലവറ',
        Ma: 'तिजोरी',
        Fr: 'Sauter',
        Hi: 'तिजोरी',
        Ta: 'வால்ட்',
        Ja: 'ボールト',
        Ge: 'Gewölbe',
      },
      IRTDD01: {
        En: 'Vault Names',
        Et: 'Võlvi nimed',
        Ar: 'أسماء Vault',
        Ml: 'നിലവറയുടെ പേരുകൾ',
        Ma: 'तिजोरी नावे',
        Fr: 'Noms de coffre',
        Hi: 'तिजोरी के नाम',
        Ta: 'வால்ட் பெயர்கள்',
        Ja: 'ボールト名',
        Ge: 'Tresornamen',
      },
      IRTL03: {
        En: 'Rack / Shelf',
        Et: 'Riiulid',
        Ar: 'الرفوف',
        Ml: 'ഷെൽഫുകൾ',
        Ma: 'शेल्फ्स',
        Fr: 'Etagères',
        Hi: 'शेल्फ',
        Ta: 'அலமாரிகள்',
        Ja: '棚',
        Ge: 'Regale',
      },
      IRTDD02: {
        En: 'Available Rack / Shelf',
        Et: 'Saadaval riiulid',
        Ar: 'أرفف متوفرة',
        Ml: 'ലഭ്യമായ ഷെൽഫുകൾ',
        Ma: "उपलब्ध शेल्फ् 'चे अव रुप",
        Fr: 'Étagères disponibles',
        Hi: 'उपलब्ध अलमारियां',
        Ta: 'கிடைக்கும் அலமாரிகள்',
        Ja: '利用可能な棚',
        Ge: 'Verfügbare Regale',
      },
      IRTB06: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IRTB07: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      IRTB08: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    Level3InventoryRecievingTagTab: {
      IRVTTL01: {
        En: 'Please select item received',
        Et: 'Valige üksus vastu võetud',
        Ar: 'الرجاء تحديد العنصر المستلم',
        Ml: 'ലഭിച്ച ഇനം തിരഞ്ഞെടുക്കുക',
        Ma: 'कृपया प्राप्त आयटम निवडा',
        Fr: "Veuillez sélectionner l'article reçu",
        Hi: 'कृपया प्राप्त आइटम का चयन करें',
        Ta: 'பெற்ற உருப்படியைத் தேர்ந்தெடுக்கவும்',
        Ja: '受け取ったアイテムを選択してください',
        Ge: 'Bitte erhaltenen Artikel auswählen',
      },
      IRVTTL02: {
        En: 'Vault',
        Et: 'Valige',
        Ar: 'قبو',
        Ml: 'നിലവറ',
        Ma: 'तिजोरी',
        Fr: 'Sauter',
        Hi: 'तिजोरी',
        Ta: 'வால்ட்',
        Ja: 'ボールト',
        Ge: 'Gewölbe',
      },
      IRVTTDD01: {
        En: 'Select Vault',
        Et: 'Valige hoidla',
        Ar: 'اختر القبو',
        Ml: 'Vault തിരഞ്ഞെടുക്കുക',
        Ma: 'Vault निवडा',
        Fr: 'sélectionnez le coffre-fort',
        Hi: 'तिजोरी का चयन करें',
        Ta: 'வால்ட்டைத் தேர்ந்தெடுக்கவும்',
        Ja: 'ボールトを選択',
        Ge: 'Wählen Sie Tresor aus',
      },
      IRVTTD02: {
        En: 'Select Rack',
        Et: 'Vali rack',
        Ar: 'رف الاختيار',
        Ml: 'റാക്ക് തിരഞ്ഞെടുക്കുക',
        Ma: 'रॅक निवडा',
        Fr: 'Sélectionnez le rack',
        Hi: 'रैक का चयन करें',
        Ta: 'ரேக் தேர்ந்தெடு',
        Ja: 'ラックを選択',
        Ge: 'Rack auswählen',
      },
      IRVTTD03: {
        En: 'Select Shelf',
        Et: 'Vali riiul',
        Ar: 'اختر الرف',
        Ml: 'ഷെൽഫ് തിരഞ്ഞെടുക്കുക',
        Ma: 'शेल्फ निवडा',
        Fr: 'Sélectionnez une étagère',
        Hi: 'शेल्फ चुनें',
        Ta: 'ஓர் அலமாரியைத் தேர்ந்தெடுக்கவும்',
        Ja: '棚を選択する',
        Ge: 'Regal auswählen'
      },
      IRVTTD04: {
        En: 'Asset Condition',
        Et: 'Varade seisund',
        Ar: 'حالة الأصل',
        Ml: 'ആസ്തി സ്ഥിതി',
        Ma: 'मालमत्तेची स्थिती',
        Fr: 'État de l`actif',
        Hi: 'संपत्ति की स्थिति',
        Ta: 'சொத்து நிலை',
        Ja: '資産の状態',
        Ge: 'Zustand des Vermögens'
      },
      IRVTTD05: {
        En: 'Evaluate Asset Condition',
        Et: 'Varade seisundi hindamine',
        Ar: 'تقييم حالة الأصل',
        Ml: 'ആസ്തി സ്ഥിതി വിലയിരുത്തുക',
        Ma: 'मालमत्तेची स्थितीचे मूल्यांकन करा',
        Fr: 'Évaluer l`état de l`actif',
        Hi: 'परिसंपत्ति की स्थिति का मूल्यांकन करें',
        Ta: 'சொத்து நிலையை மதிப்பிடுங்கள்',
        Ja: '資産の状態を評価する',
        Ge: 'Zustand des Vermögens bewerten'
      },
      IRVTTD06: {
        En: 'Physical Case Count',
        Et: 'Füüsilise juhtumi arv',
        Ar: 'عدد الحالات المادية',
        Ml: 'ഭൗതിക കേസ് എണ്ണം',
        Ma: 'भौतिक बाक्सांची संख्या',
        Fr: 'Nombre de boîtiers physiques',
        Hi: 'भौतिक मामलों की संख्या',
        Ta: 'உடல் சந்ததியின் எண்ணிக்கை',
        Ja: '物理的なケースの数',
        Ge: 'Anzahl der physischen Fälle'
      },
      IRVTTD07: {
        En: 'Enter Physical Case Count',
        Et: 'Sisestage füüsilise kasti arv',
        Ar: 'تقييم عدد الحالات المادية',
        Ml: 'ഭൗതിക കേസ് എണ്ണം വിലയിരുത്തുക',
        Ma: 'भौतिक प्रकरणांची संख्या मूल्यांकन करा',
        Fr: 'Évaluer le nombre de cas physiques',
        Hi: 'भौतिक मामलों की संख्या का मूल्यांकन करें',
        Ta: 'உடல் சார்ந்த வழக்கு எண்ணிக்கையை மதிப்பிடுங்கள்',
        Ja: '物理的なケース数を評価する',
        Ge: 'Physikalische Fallzahl bewerten'
      },
      IRVTTD08: {
        En: 'Pigeon Hole',
        Et: 'postkast',
        Ar: 'فتحة الحمام ',
        Ml: 'പാചകപ്പാത്രം',
        Ma: 'कबूतरखाना',
        Fr: 'case à lettres',
        Hi: 'कबूतरखाना',
        Ta: 'புறா கூடு',
        Ja: 'ピジョンホール',
        Ge: 'Fach'
      },
      IRVTTL03: {
        En: 'Rack / Shelf',
        Et: 'Riiulid',
        Ar: 'قبو',
        Ml: 'നിലവറ',
        Ma: 'तिजोरी',
        Fr: 'Sauter',
        Hi: 'शेल्फ',
        Ta: 'வால்ட்',
        Ja: 'ボールト',
        Ge: 'Gewölbe',
      },
      IRVTTDD02: {
        En: 'Available Rack / Shelf',
        Et: 'Saadaval riiulid',
        Ar: 'أرفف متوفرة',
        Ml: 'ലഭ്യമായ ഷെൽഫുകൾ',
        Ma: "उपलब्ध शेल्फ् 'चे अव रुप",
        Fr: 'Étagères disponibles',
        Hi: 'उपलब्ध अलमारियां',
        Ta: 'கிடைக்கும் அலமாரிகள்',
        Ja: '利用可能な棚',
        Ge: 'Verfügbare Regale',
      },
      IRVTB01: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IRVTB02: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      IRVTB03: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    Level3InventoryRecievingTagScanQrModal: {
      IRTSQRL01: {
        En: 'Scan QR Code',
        Et: 'Skaneeri QR-kood',
        Ar: 'مسح رمز الاستجابة السريعة',
        Ml: 'QR കോഡ് സ്കാൻ ചെയ്യുക',
        Ma: 'QR कोड स्कॅन करा',
        Fr: 'Scanner le code QR',
        Hi: 'क्यू आर कोड स्कैन करें',
        Ta: 'QR குறியீட்டை ஸ்கேன் செய்யவும்',
        Ja: 'QRコードをスキャン',
        Ge: 'QR-Code scannen',
      },
      IRTSQRL02: {
        En: 'Camera not accessible',
        Et: 'Kaamera pole ligipääsetav',
        Ar: 'لا يمكن الوصول إلى الكاميرا',
        Ml: 'ക്യാമറ ആക്‌സസ് ചെയ്യാനാകുന്നില്ല',
        Ma: 'कॅमेरा प्रवेशयोग्य नाही',
        Fr: 'Caméra non accessible',
        Hi: 'कैमरा सुलभ नहीं है',
        Ta: 'கேமராவை அணுக முடியவில்லை',
        Ja: 'カメラにアクセスできません',
        Ge: 'Kamera nicht zugänglich',
      },
      IRTSQRB01: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IRTSQRB02: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    Level3InventoryRecievingTagScanBarcodeModal: {
      IRTSBCL01: {
        En: 'Scan Barcode',
        Et: 'Vöötkoodi skannimine',
        Ar: 'مسح الرمز الشريطى',
        Ml: 'ബാർകോഡ് സ്കാൻ ചെയ്യുക',
        Ma: 'बारकोड स्कॅन करा',
        Fr: 'Scanner le code-barres',
        Hi: 'बारकोड स्कैन करें',
        Ta: 'பார்கோடு ஸ்கேன் செய்யவும்',
        Ja: 'バーコードをスキャン',
        Ge: 'Barcode scannen',
      },
      IRTSBCTB01: {
        En: 'Barcode',
        Et: 'Vöötkood',
        Ar: 'الرمز الشريطي',
        Ml: 'ബാർകോഡ്',
        Ma: 'बारकोड',
        Fr: 'code à barre',
        Hi: 'बारकोड',
        Ta: 'பார்கோடு',
        Ja: 'バーコード',
        Ge: 'Strichcode',
      },
      IRTSBCB01: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IRTSBCB02: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    Level3InventoryRecievingTagScanRFIDModal: {
      IRTSRFL01: {
        En: 'RFID',
        Et: 'RFID',
        Ar: 'RFID',
        Ml: 'RFID',
        Ma: 'RFID',
        Fr: 'RFID',
        Hi: 'आरएफआईडी',
        Ta: 'RFID',
        Ja: 'RFID',
        Ge: 'RFID',
      },
      IRTSRFL02: {
        En: 'Enter or Scan RFID',
        Et: 'Sisestage või skannige RFID',
        Ar: 'أدخل أو امسح RFID',
        Ml: 'RFID നൽകുക അല്ലെങ്കിൽ സ്കാൻ ചെയ്യുക',
        Ma: 'RFID प्रविष्ट करा किंवा स्कॅन करा',
        Fr: 'Entrez ou scannez RFID',
        Hi: 'आरएफआईडी दर्ज करें या स्कैन करें',
        Ta: 'RFID ஐ உள்ளிடவும் அல்லது ஸ்கேன் செய்யவும்',
        Ja: 'RFIDを入力またはスキャン',
        Ge: 'RFID eingeben oder scannen',
      },
      IRTSRFTB01: {
        En: 'RFID',
        Et: 'RFID',
        Ar: 'RFID',
        Ml: 'RFID',
        Ma: 'RFID',
        Fr: 'RFID',
        Hi: 'आरएफआईडी',
        Ta: 'RFID',
        Ja: 'RFID',
        Ge: 'RFID',
      },
      IRTSRFB01: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IRTSRFB02: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    InventoryReportsDynamicTableSearchPlaceHolder: {
      IRDTSTHP01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
    },

    DynamicTableSearchPlaceHolderTitleAlone: {
      DTSTHPT01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
    },

    DynamicTableSearchPlaceHolderExceptTitle: {
      DTSTHPET01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
    },

    Level3InventoryRecievingCreateOrderTab: {
      IRCOTL01: {
        En: 'Please select item received',
        Et: 'Valige üksus vastu võetud',
        Ar: 'الرجاء تحديد العنصر المستلم',
        Ml: 'ലഭിച്ച ഇനം തിരഞ്ഞെടുക്കുക',
        Ma: 'कृपया प्राप्त आयटम निवडा',
        Fr: "Veuillez sélectionner l'article reçu",
        Hi: 'कृपया प्राप्त आइटम का चयन करें',
        Ta: 'பெற்ற உருப்படியைத் தேர்ந்தெடுக்கவும்',
        Ja: '受け取ったアイテムを選択してください',
        Ge: 'Bitte erhaltenen Artikel auswählen',
      },
    },

    Level3InventoryRecievingCreateOrder: {
      IRCOL01: {
        En: 'ivities',
        Et: 'LOO TELLIMUS',
        Ar: 'إنشاء النظام',
        Ml: 'ഓർഡർ സൃഷ്ടിക്കുക',
        Ma: 'ऑर्डर तयार करा',
        Fr: 'CRÉER UNE COMMANDE',
        Hi: 'आदेश बनाएं',
        Ta: 'ஆர்டரை உருவாக்கவும்',
        Ja: '注文を作成',
        Ge: 'BESTELLUNG ANLEGEN',
      },
      IRCOL02: {
        En: 'Client ',
        Et: 'Klient',
        Ar: 'عميل',
        Ml: 'കക്ഷി',
        Ma: 'क्लायंट',
        Fr: 'Client',
        Hi: 'ग्राहक',
        Ta: 'வாடிக்கையாளர்',
        Ja: 'クライアント',
        Ge: 'Klient',
      },
      IRCOTB01: {
        En: 'Client Box',
        Et: 'Kliendikast',
        Ar: 'صندوق العميل',
        Ml: 'ക്ലയന്റ് ബോക്സ്',
        Ma: 'क्लायंट बॉक्स',
        Fr: 'Boîte client',
        Hi: 'क्लाइंट बॉक्स',
        Ta: 'வாடிக்கையாளர் பெட்டி',
        Ja: 'クライアントボックス',
        Ge: 'Kundenbox',
      },
      IRCOB01: {
        En: '+',
        Et: '+',
        Ar: '+',
        Ml: '+',
        Ma: '+',
        Fr: '+',
        Hi: '+',
        Ta: '+',
        Ja: '＋',
        Ge: '+',
      },
      IRCOL03: {
        En: 'Department',
        Et: 'osakond',
        Ar: 'قسم',
        Ml: 'വകുപ്പ്',
        Ma: 'विभाग',
        Fr: 'département',
        Hi: 'विभाग',
        Ta: 'துறை',
        Ja: 'デパートメント',
        Ge: 'Abteilung',
      },
      IRCODD01: 
      { En: 'Select Department',
        Et: 'Vali osakond',
        Ar: 'اختر القسم',
        Ml: '',
        Ma: '',
        Fr: '',
        Hi: '',
        Ta: '',
        Ja: '',
        Ge: ''


       },
      IRCOTPL01: {
        En: 'Template',
        Et: 'Mall',
        Ar: 'قالب',
        Ml: 'ടെംപ്ലേറ്റ്',
        Ma: 'साचा',
        Fr: 'Modèle',
        Hi: 'सांचा',
        Ta: 'டெம்ப்ளேட்',
        Ja: 'テンプレート',
        Ge: 'Schablone',
      },
      IRCOTPL001:{
        En: 'Template Type',
        Et: 'Mall tüüp',
        Ar: 'نوع القالب',
        Ml: 'ടെംപ്ലേറ്റ് തരം',
        Ma: 'टेम्पलेट प्रकार',
        Fr: 'Type de modèle',
        Hi: 'टेम्पलेट प्रकार',
        Ta: 'வார்ப்புரு வகை',
        Ja: 'テンプレートタイプ',
        Ge: 'Vorlagentyp'
      },
      IRCOTPL02: {
        En: 'Customization',
        Et: 'Kohandamine',
        Ar: 'التخصيص',
        Ml: 'ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'सानुकूलन',
        Fr: 'Personnalisation',
        Hi: 'अनुकूलन',
        Ta: 'தனிப்பயனாக்கம்',
        Ja: 'カスタマイズ',
        Ge: 'Anpassung',
      },
      IRCODD02: {
        En: 'Type',
        Et: 'Tüüp',
        Ar: 'يكتب',
        Ml: 'ടൈപ്പ് ചെയ്യുക',
        Ma: 'प्रकार',
        Fr: 'Taper',
        Hi: 'प्रकार',
        Ta: 'வகை',
        Ja: 'タイプ',
        Ge: 'Typ',
      },
      IRCOB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IRCOB03: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      IRCOB04: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    Level3InventoryDeliveryOrderRequest: {
      IDORSL01: {
        En: 'Order Request',
        Et: 'Tellimuse taotlus',
        Ar: 'طلب',
        Ml: 'ഓർഡർ അഭ്യർത്ഥന',
        Ma: 'ऑर्डर विनंती',
        Fr: 'Demande de commande',
        Hi: 'ऑर्डर अनुरोध',
        Ta: 'ஆர்டர் கோரிக்கை',
        Ja: 'オーダーリクエスト',
        Ge: 'Bestellanfrage',
      },
      IDORFH01: {
        En: 'Outward Request',
        Et: 'Tellimuse taotlus',
        Ar: 'طلب',
        Ml: 'ഓർഡർ അഭ്യർത്ഥന',
        Ma: 'ऑर्डर विनंती',
        Fr: 'Demande de commande',
        Hi: 'ऑर्डर अनुरोध',
        Ta: 'ஆர்டர் கோரிக்கை',
        Ja: 'オーダーリクエスト',
        Ge: 'Bestellanfrage',
      },
      IDORL01: {
        En: 'Worklevel',
        Et: 'Töötase',
        Ar: 'مستوى العمل',
        Ml: 'വർക്ക് ലെവൽ',
        Ma: 'कार्यस्तर',
        Fr: 'Niveau de travail',
        Hi: 'कार्य स्तर',
        Ta: 'பணிநிலை',
        Ja: '作業レベル',
        Ge: 'Arbeitsebene',
      },
      IDORDD01: {
        En: 'Worklevel',
        Et: 'Töötase',
        Ar: 'مستوى العمل',
        Ml: 'വർക്ക് ലെവൽ',
        Ma: 'कार्यस्तर',
        Fr: 'Niveau de travail',
        Hi: 'कार्य स्तर',
        Ta: 'பணிநிலை',
        Ja: '作業レベル',
        Ge: 'Arbeitsebene',
      },
      IDORL02: {
        En: 'Film Title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      IDORDD02: {
        En: 'Film Title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      IDORL03: {
        En: 'Number of Elements',
        Et: 'Elementide arv',
        Ar: 'عدد العناصر',
        Ml: 'മൂലകങ്ങളുടെ എണ്ണം',
        Ma: 'घटकांची संख्या',
        Fr: "Nombre d'éléments",
        Hi: 'तत्वों की संख्या',
        Ta: 'உறுப்புகளின் எண்ணிக்கை',
        Ja: '要素数',
        Ge: 'Anzahl der Elemente',
      },
      IDORTB03: {
        En: 'Number of Elements',
        Et: 'Elementide arv',
        Ar: 'عدد العناصر',
        Ml: 'മൂലകങ്ങളുടെ എണ്ണം',
        Ma: 'घटकांची संख्या',
        Fr: "Nombre d'éléments",
        Hi: 'तत्वों की संख्या',
        Ta: 'உறுப்புகளின் எண்ணிக்கை',
        Ja: '要素数',
        Ge: 'Anzahl der Elemente',
      },
      IDORL04: {
        En: 'Borrower Name',
        Et: 'Laenaja nimi',
        Ar: 'اسم المستعير',
        Ml: 'കടം വാങ്ങുന്നയാളുടെ പേര്',
        Ma: 'कर्जदाराचे नाव',
        Fr: "Nom de l'emprunteur",
        Hi: 'उधारकर्ता का नाम',
        Ta: 'கடன் வாங்கியவர் பெயர்',
        Ja: '借り主の名前',
        Ge: 'Name des Kreditnehmers',
      },
      IDORTB04: {
        En: 'Borrower Name',
        Et: 'Laenaja nimi',
        Ar: 'اسم المستعير',
        Ml: 'കടം വാങ്ങുന്നയാളുടെ പേര്',
        Ma: 'कर्जदाराचे नाव',
        Fr: "Nom de l'emprunteur",
        Hi: 'उधारकर्ता का नाम',
        Ta: 'கடன் வாங்கியவர் பெயர்',
        Ja: '借り主の名前',
        Ge: 'Name des Kreditnehmers',
      },
      IDORL05: {
        En: 'Date',
        Et: 'Kuupäev',
        Ar: 'تاريخ',
        Ml: 'തീയതി',
        Ma: 'तारीख',
        Fr: 'Date',
        Hi: 'दिनांक',
        Ta: 'தேதி',
        Ja: '日にち',
        Ge: 'Datum',
      },
      IDORTB05: {
        En: 'Select date',
        Et: 'Valige kuupäev',
        Ar: 'حدد تاريخ',
        Ml: 'തീയതി തിരഞ്ഞെടുക്കുക',
        Ma: 'तारीख निवडा',
        Fr: 'Sélectionner une date',
        Hi: 'तारीख़ चुनें',
        Ta: 'தேதியைத் தேர்ந்தெடுக்கவும்',
        Ja: '日付を選択',
        Ge: 'Datum auswählen',
      },
      IDORTA01: {
        En: 'Purpose',
        Et: 'Eesmärk',
        Ar: 'غاية',
        Ml: 'ഉദ്ദേശ്യം',
        Ma: 'उद्देश',
        Fr: 'Objectif',
        Hi: 'उद्देश्य',
        Ta: 'நோக்கம்',
        Ja: '目的',
        Ge: 'Zweck',
      },
      IDORL06: {
        En: 'OR',
        Et: 'VÕI',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'OU',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'また',
        Ge: 'ODER',
      },
      IDORL07: {
        En: 'Select Purpose',
        Et: 'Valige Eesmärk',
        Ar: 'حدد الغرض',
        Ml: 'ഉദ്ദേശ്യം തിരഞ്ഞെടുക്കുക',
        Ma: 'उद्देश निवडा',
        Fr: "Sélectionnez l'objectif",
        Hi: 'उद्देश्य चुनें',
        Ta: 'நோக்கத்தைத் தேர்ந்தெடுக்கவும்',
        Ja: '目的を選択',
        Ge: 'Wählen Sie Zweck aus',
      },
      IDORDD03: {
        En: 'Select Purpose',
        Et: 'Valige Eesmärk',
        Ar: 'حدد الغرض',
        Ml: 'ഉദ്ദേശ്യം തിരഞ്ഞെടുക്കുക',
        Ma: 'उद्देश निवडा',
        Fr: "Sélectionnez l'objectif",
        Hi: 'उद्देश्य चुनें',
        Ta: 'நோக்கத்தைத் தேர்ந்தெடுக்கவும்',
        Ja: '目的を選択',
        Ge: 'Wählen Sie Zweck aus',
      },
      IDORDL01: {
        En: 'Drag and drop some files here, or click to select files',
        Et: 'Lohistage mõned failid siia või klõpsake failide valimiseks',
        Ar: 'قم بسحب وإفلات بعض الملفات هنا ، أو انقر لتحديد الملفات',
        Ml: 'ചില ഫയലുകൾ ഇവിടെ വലിച്ചിടുക, അല്ലെങ്കിൽ ഫയലുകൾ തിരഞ്ഞെടുക്കാൻ ക്ലിക്ക് ചെയ്യുക',
        Ma: 'काही फाइल्स येथे ड्रॅग आणि ड्रॉप करा किंवा फाइल्स निवडण्यासाठी क्लिक करा',
        Fr: 'Faites glisser et déposez des fichiers ici, ou cliquez pour sélectionner des fichiers',
        Hi: 'कुछ फाइलों को यहां खींचें और छोड़ें, या फाइलों का चयन करने के लिए क्लिक करें',
        Ta: 'சில கோப்புகளை இங்கே இழுத்து விடுங்கள் அல்லது கோப்புகளைத் தேர்ந்தெடுக்க கிளிக் செய்யவும்',
        Ja: 'ここにいくつかのファイルをドラッグ アンド ドロップするか、クリックしてファイルを選択します',
        Ge: 'Ziehen Sie einige Dateien hierher und legen Sie sie dort ab, oder klicken Sie, um Dateien auszuwählen',
      },
      IDORB01: {
        En: 'Upload',
        Et: 'Laadi üles',
        Ar: 'تحميل',
        Ml: 'അപ്‌ലോഡ് ചെയ്യുക',
        Ma: 'अपलोड करा',
        Fr: 'Télécharger',
        Hi: 'डालना',
        Ta: 'பதிவேற்றவும்',
        Ja: 'アップロード',
        Ge: 'Hochladen',
      },
      IDORB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IDORB03: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      IDORB04: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
      IDORL08: {
        En: 'Asset ID',
        Ar: 'معرّف الأصل',
        Ml: 'ആസ്തി ഐഡി',
        Ma: 'मालमत्ता आयडी',
        Fr: 'Identifiant d` actif',
        Hi: 'परिसंपत्ति आईडी',
        Ta: 'சொத்து அடையாள அட்டை',
        Ja: 'アセット ID',
        Ge: 'Vermögens-ID',
      },
      IDORL09: {
        En: 'Asset Name',
        Ar: 'اسم الأصل',
        Ml: 'ആസ്തി പേര്',
        Ma: 'मालमत्ता नाव',
        Fr: 'Nom de l` actif',
        Hi: 'परिसंपत्ति नाम',
        Ta: 'சொத்து பெயர்',
        Ja: 'アセット名',
        Ge: 'Vermögensname'
      }
    },

    Level3InventoryDeliveryOrderRegister: {
      IDORSL01: {
        En: 'Outward Register',
        Et: 'Tellimuste register',
        Ar: 'طلب تسجيل',
        Ml: 'ഓർഡർ രജിസ്റ്റർ',
        Ma: 'ऑर्डर रजिस्टर',
        Fr: 'Registre des commandes',
        Hi: 'आदेश रजिस्टर',
        Ta: 'ஆர்டர் பதிவு',
        Ja: '注文登録',
        Ge: 'Bestellregister',
      },
      IDORFL01: {
        En: 'FILM CAN OUTWARD REGISTER',
        Et: 'FILMI SAAB VÄLJAS TAOTLEDA',
        Ar: 'يمكن طلب الفيلم في الخارج',
        Ml: 'സിനിമയ്ക്ക് പുറത്ത് അഭ്യർത്ഥന നടത്താം',
        Ma: 'चित्रपट बाहेरून विनंती करू शकतो',
        Fr: "LE FILM PEUT DEMANDER L'EXTÉRIEUR",
        Hi: 'फिल्म जावक अनुरोध कर सकती है',
        Ta: 'திரைப்படம் வெளியில் கோரிக்கை வைக்கலாம்',
        Ja: 'フィルムは外向きの要求をすることができます',
        Ge: 'FILM KANN AUSSEN ANFORDERN',
      },
      IDORL01: {
        En: 'Work Identifier',
        Et: 'Töö identifikaator',
        Ar: 'معرف العمل',
        Ml: 'വർക്ക് ഐഡന്റിഫയർ',
        Ma: 'कार्य ओळखकर्ता',
        Fr: 'Identifiant de travail',
        Hi: 'कार्य पहचानकर्ता',
        Ta: 'வேலை அடையாளங்காட்டி',
        Ja: '作業識別子',
        Ge: 'Arbeitskennung',
      },
      IDORTB01: {
        En: 'Select Work Identifier',
        Et: 'Valige Töö identifikaator',
        Ar: 'حدد معرف العمل',
        Ml: 'വർക്ക് ഐഡന്റിഫയർ തിരഞ്ഞെടുക്കുക',
        Ma: 'कार्य ओळखकर्ता निवडा',
        Fr: "Sélectionnez l'identifiant de travail",
        Hi: 'कार्य पहचानकर्ता का चयन करें',
        Ta: 'பணி அடையாளங்காட்டியைத் தேர்ந்தெடுக்கவும்',
        Ja: '勤務先識別子を選択',
        Ge: 'Wählen Sie Arbeitskennung aus',
      },
      IDORL02: {
        En: 'Item Id',
        Et: 'Kauba ID',
        Ar: 'معرف العنصر',
        Ml: 'ഇനം ഐഡി',
        Ma: 'आयटम आयडी',
        Fr: "ID de l'article",
        Hi: 'सामान आईडी',
        Ta: 'பொருள் ஐடி',
        Ja: 'アイテムID',
        Ge: 'Artikel Identifikationsnummer',
      },
      IDORTB02: {
        En: 'Item Id',
        Et: 'Kauba ID',
        Ar: 'معرف العنصر',
        Ml: 'ഇനം ഐഡി',
        Ma: 'आयटम आयडी',
        Fr: "ID de l'article",
        Hi: 'सामान आईडी',
        Ta: 'பொருள் ஐடி',
        Ja: 'アイテムID',
        Ge: 'Artikel Identifikationsnummer',
      },
      IDORL03: {
        En: 'Element',
        Et: 'Element',
        Ar: 'عنصر',
        Ml: 'ഘടകം',
        Ma: 'घटक',
        Fr: 'Élément',
        Hi: 'तत्व',
        Ta: 'உறுப்பு',
        Ja: 'エレメント',
        Ge: 'Element',
      },
      IDORTB03: {
        En: 'Element',
        Et: 'Element',
        Ar: 'عنصر',
        Ml: 'ഘടകം',
        Ma: 'घटक',
        Fr: 'Élément',
        Hi: 'तत्व',
        Ta: 'உறுப்பு',
        Ja: 'エレメント',
        Ge: 'Element',
      },
      IDORL04: {
        En: 'Number of film CANs',
        Et: 'Kilepurkide arv',
        Ar: 'عدد علب الفيلم',
        Ml: 'ഫിലിം CAN-കളുടെ എണ്ണം',
        Ma: 'चित्रपट CAN ची संख्या',
        Fr: 'Nombre de CAN film',
        Hi: 'फिल्म CANs की संख्या',
        Ta: 'திரைப்பட CANகளின் எண்ணிக்கை',
        Ja: 'フィルム缶数',
        Ge: 'Anzahl Film-CANs',
      },
      IDORTB04: {
        En: 'Enter Number of film CANs',
        Et: 'Sisestage filmipurkide arv',
        Ar: 'أدخل عدد علب الفيلم',
        Ml: 'ഫിലിം CAN-കളുടെ എണ്ണം നൽകുക',
        Ma: 'चित्रपट कॅनची संख्या प्रविष्ट करा',
        Fr: 'Entrez le nombre de films CAN',
        Hi: 'फिल्म CANs की संख्या दर्ज करें',
        Ta: 'திரைப்பட CANகளின் எண்ணிக்கையை உள்ளிடவும்',
        Ja: 'フィルム缶の数を入力してください',
        Ge: 'Geben Sie die Anzahl der Folien-CANs ein',
      },
      IDORL05: {
        En: 'Borrower Name',
        Et: 'Laenaja nimi',
        Ar: 'اسم المستعير',
        Ml: 'കടം വാങ്ങുന്നയാളുടെ പേര്',
        Ma: 'कर्जदाराचे नाव',
        Fr: "Nom de l'emprunteur",
        Hi: 'उधारकर्ता का नाम',
        Ta: 'கடன் வாங்கியவர் பெயர்',
        Ja: '借り主の名前',
        Ge: 'Name des Kreditnehmers',
      },
      IDORTB05: {
        En: 'Select Borrower Name',
        Et: 'Valige laenusaaja nimi',
        Ar: 'حدد اسم المستعير',
        Ml: 'കടം വാങ്ങുന്നയാളുടെ പേര് തിരഞ്ഞെടുക്കുക',
        Ma: 'कर्जदाराचे नाव निवडा',
        Fr: "Sélectionnez le nom de l'emprunteur",
        Hi: 'उधारकर्ता का नाम चुनें',
        Ta: 'கடன் வாங்குபவரின் பெயரைத் தேர்ந்தெடுக்கவும்',
        Ja: '借り主名を選択',
        Ge: 'Wählen Sie den Namen des Kreditnehmers aus',
      },
      IDORL06: {
        En: 'Borrow Unique Code',
        Et: 'Laena unikaalne kood',
        Ar: 'استعارة رمز فريد',
        Ml: 'അദ്വിതീയ കോഡ് കടം വാങ്ങുക',
        Ma: 'युनिक कोड घ्या',
        Fr: 'Emprunter un code unique',
        Hi: 'अद्वितीय कोड उधार लें',
        Ta: 'தனிப்பட்ட குறியீட்டை கடன் வாங்கவும்',
        Ja: '固有のコードを借りる',
        Ge: 'Leihen Sie sich einen einzigartigen Code aus',
      },
      IDORTB06: {
        En: 'Select Borrow Unique Code',
        Et: 'Valige Unikaalse koodi laenutamine',
        Ar: 'حدد استعارة الرمز الفريد',
        Ml: 'Borrow Unique Code തിരഞ്ഞെടുക്കുക',
        Ma: 'उधार घ्या युनिक कोड निवडा',
        Fr: 'Sélectionnez Emprunter le code unique',
        Hi: 'अद्वितीय कोड उधार लें चुनें',
        Ta: 'Borrow Unique Code என்பதைத் தேர்ந்தெடுக்கவும்',
        Ja: '固有コードの借用を選択',
        Ge: 'Wählen Sie Eindeutigen Code ausleihen',
      },
      IDORL07: {
        En: 'Borrower Address',
        Et: 'Laenaja aadress',
        Ar: 'عنوان المستعير',
        Ml: 'കടം വാങ്ങുന്നയാളുടെ വിലാസം',
        Ma: 'कर्जदाराचा पत्ता',
        Fr: "Adresse de l'emprunteur",
        Hi: 'उधारकर्ता का पता',
        Ta: 'கடன் வாங்குபவர் முகவரி',
        Ja: '借り主の住所',
        Ge: 'Adresse des Kreditnehmers',
      },
      IDORTB07: {
        En: 'Enter Borrower Address',
        Et: 'Sisestage laenusaaja aadress',
        Ar: 'أدخل عنوان المستعير',
        Ml: 'കടം വാങ്ങുന്നയാളുടെ വിലാസം നൽകുക',
        Ma: 'कर्जदाराचा पत्ता प्रविष्ट करा',
        Fr: "Entrez l'adresse de l'emprunteur",
        Hi: 'उधारकर्ता का पता दर्ज करें',
        Ta: 'கடன் வாங்குபவர் முகவரியை உள்ளிடவும்',
        Ja: '借り主の住所を入力',
        Ge: 'Geben Sie die Adresse des Kreditnehmers ein',
      },
      IDORL08: {
        En: 'Borrower Phone No',
        Et: 'Laenuvõtja telefoni nr',
        Ar: 'رقم هاتف المستعير',
        Ml: 'കടം വാങ്ങുന്നയാളുടെ ഫോൺ നമ്പർ',
        Ma: 'कर्जदाराचा फोन क्र',
        Fr: "Numéro de téléphone de l'emprunteur",
        Hi: 'उधारकर्ता फोन नंबर',
        Ta: 'கடன் வாங்கியவர் தொலைபேசி எண்',
        Ja: '借り主の電話番号',
        Ge: 'Kreditnehmer Telefonnummer',
      },
      IDORTB08: {
        En: 'Enter Borrower Phone No',
        Et: 'Sisestage laenuvõtja telefoninumber',
        Ar: 'أدخل رقم هاتف المستعير',
        Ml: 'കടം വാങ്ങുന്നയാളുടെ ഫോൺ നമ്പർ നൽകുക',
        Ma: 'कर्जदार फोन नंबर प्रविष्ट करा',
        Fr: "Entrez le numéro de téléphone de l'emprunteur",
        Hi: 'उधारकर्ता का फ़ोन नंबर दर्ज करें',
        Ta: 'கடன் வாங்குபவரின் தொலைபேசி எண்ணை உள்ளிடவும்',
        Ja: '借り手の電話番号を入力',
        Ge: 'Geben Sie die Telefonnummer des Kreditnehmers ein',
      },
      IDORL09: {
        En: 'Date of Request Raised',
        Et: 'Taotluse esitamise kuupäev',
        Ar: 'أثار تاريخ الطلب',
        Ml: 'അഭ്യർത്ഥനയുടെ തീയതി ഉയർത്തി',
        Ma: 'विनंतीची तारीख वाढवली',
        Fr: 'Date de la demande soulevée',
        Hi: 'अनुरोध की तिथि बढ़ी',
        Ta: 'கோரிக்கையின் தேதி உயர்த்தப்பட்டது',
        Ja: '要請日',
        Ge: 'Datum der gestellten Anfrage',
      },
      IDORL10: {
        En: 'Borrower Email-Id',
        Et: 'Laenaja e-posti ID',
        Ar: 'معرف البريد الإلكتروني للمقترض',
        Ml: 'കടം വാങ്ങുന്നയാളുടെ ഇമെയിൽ-ഐഡി',
        Ma: 'कर्जदाराचा ईमेल-आयडी',
        Fr: "Identifiant de l'e-mail de l'emprunteur",
        Hi: 'उधारकर्ता ईमेल-आईडी',
        Ta: 'கடன் வாங்குபவர் மின்னஞ்சல் ஐடி',
        Ja: '借り手の電子メール ID',
        Ge: 'E-Mail-ID des Kreditnehmers',
      },
      IDORTB10: {
        En: 'Email Id',
        Et: 'E-kirja ID',
        Ar: 'عنوان الايميل',
        Ml: 'ഇ - മെയിൽ ഐഡി',
        Ma: 'ई - मेल आयडी',
        Fr: 'Identifiant de messagerie',
        Hi: 'ईमेल आईडी',
        Ta: 'மின்னஞ்சல் முகவரி',
        Ja: '電子メールID',
        Ge: 'E-Mail-ID',
      },
      IDORL11: {
        En: 'Delivery Date',
        Et: 'Saabumise kuupäev',
        Ar: 'تاريخ التسليم او الوصول',
        Ml: 'ഡെലിവറി തീയതി',
        Ma: 'वितरण तारीख',
        Fr: 'Date de livraison',
        Hi: 'डिलीवरी की तारीख',
        Ta: 'டெலிவரி தேதி',
        Ja: '配送日',
        Ge: 'Lieferdatum',
      },
      IDORL12: {
        En: 'Return Date',
        Et: 'Tagastamise kuupäev',
        Ar: 'تاريخ العودة',
        Ml: 'മടങ്ങിവരുന്ന തീയതി',
        Ma: 'परतीची तारीख',
        Fr: 'Date de retour',
        Hi: 'वापसी दिनांक',
        Ta: 'திரும்பும் தேதி',
        Ja: '返却日',
        Ge: 'Rückflugdatum',
      },
      IDORL13: {
        En: 'Movement To',
        Et: 'Liikumine To',
        Ar: 'حركة الى',
        Ml: 'പ്രസ്ഥാനത്തിലേക്ക്',
        Ma: 'चळवळ ते',
        Fr: 'Mouvement vers',
        Hi: 'यहाँ ले जाएँ',
        Ta: 'இயக்கம்',
        Ja: '移動先',
        Ge: 'Bewegung zu',
      },
      IDORDD01: {
        En: 'Select Movement To',
        Et: 'Valige Liikumine',
        Ar: 'حدد نقل إلى',
        Ml: 'ഇതിലേക്ക് ചലനം തിരഞ്ഞെടുക്കുക',
        Ma: 'कडे हालचाल निवडा',
        Fr: 'Sélectionnez Mouvement vers',
        Hi: 'स्थान-परिवर्तन का चयन करें',
        Ta: 'இயக்கம் என்பதைத் தேர்ந்தெடுக்கவும்',
        Ja: '移動先を選択',
        Ge: 'Wählen Sie Bewegung nach',
      },
      IDORL14: {
        En: 'Movement Reason',
        Et: 'Liikumise põhjus',
        Ar: 'سبب الحركة',
        Ml: 'ചലന കാരണം',
        Ma: 'चळवळीचे कारण',
        Fr: 'Raison du mouvement',
        Hi: 'स्थान-परिवर्तन कारण',
        Ta: 'இயக்கம் காரணம்',
        Ja: '移動理由',
        Ge: 'Bewegungsgrund',
      },
      IDORDD02: {
        En: 'Select Movement Reason',
        Et: 'Valige Liikumise põhjus',
        Ar: 'حدد سبب الحركة',
        Ml: 'ചലനത്തിന്റെ കാരണം തിരഞ്ഞെടുക്കുക',
        Ma: 'हालचालीचे कारण निवडा',
        Fr: 'Sélectionnez la raison du mouvement',
        Hi: 'स्थान-परिवर्तन का कारण चुनें',
        Ta: 'இயக்கத்தின் காரணத்தைத் தேர்ந்தெடுக்கவும்',
        Ja: '移動理由の選択',
        Ge: 'Wählen Sie Bewegungsgrund',
      },
      IDORL15: {
        En: 'Purpose',
        Et: 'Eesmärk',
        Ar: 'غاية',
        Ml: 'ഉദ്ദേശ്യം',
        Ma: 'उद्देश',
        Fr: 'Objectif',
        Hi: 'उद्देश्य',
        Ta: 'நோக்கம்',
        Ja: '目的',
        Ge: 'Zweck',
      },
      IDORTB11: {
        En: 'Select Purpose',
        Et: 'Valige Eesmärk',
        Ar: 'حدد الغرض',
        Ml: 'ഉദ്ദേശ്യം തിരഞ്ഞെടുക്കുക',
        Ma: 'उद्देश निवडा',
        Fr: "Sélectionnez l'objectif",
        Hi: 'उद्देश्य चुनें',
        Ta: 'நோக்கத்தைத் தேர்ந்தெடுக்கவும்',
        Ja: '目的を選択',
        Ge: 'Wählen Sie Zweck aus',
      },
      IDORL16: {
        En: 'Movement Type',
        Et: 'Liikumise tüüp',
        Ar: 'نوع الحركة',
        Ml: 'ചലന തരം',
        Ma: 'हालचाली प्रकार',
        Fr: 'Type de mouvement',
        Hi: 'गतिविधि का प्रकार',
        Ta: 'இயக்கம் வகை',
        Ja: '移動タイプ',
        Ge: 'Art der Bewegung',
      },
      IDORDD03: {
        En: 'Select Movement Type',
        Et: 'Valige liikumise tüüp',
        Ar: 'حدد نوع الحركة',
        Ml: 'ചലന തരം തിരഞ്ഞെടുക്കുക',
        Ma: 'हालचाली प्रकार निवडा',
        Fr: 'Sélectionnez le type de mouvement',
        Hi: 'गतिविधि का प्रकार चुनें',
        Ta: 'இயக்க வகையைத் தேர்ந்தெடுக்கவும்',
        Ja: '移動タイプを選択',
        Ge: 'Bewegungstyp auswählen',
      },
      IDORL17: {
        En: 'Mode of Payment',
        Et: 'Makseviis',
        Ar: 'طريقة الدفع',
        Ml: 'പേയ്‌മെന്റ് രീതി',
        Ma: 'पेमेंटची पद्धत',
        Fr: 'Moyen de paiement',
        Hi: 'भुगतान का प्रकार',
        Ta: 'கட்டணம் செலுத்தும் முறை',
        Ja: '支払い方法',
        Ge: 'Zahlungsmethode',
      },
      IDORDD04: {
        En: 'Select Mode of Payment',
        Et: 'Valige Makseviis',
        Ar: 'حدد طريقة الدفع',
        Ml: 'പേയ്‌മെന്റ് മോഡ് തിരഞ്ഞെടുക്കുക',
        Ma: 'पेमेंट मोड निवडा',
        Fr: 'Sélectionnez le mode de paiement',
        Hi: 'भुगतान का प्रकार चुनें',
        Ta: 'கட்டண முறையைத் தேர்ந்தெடுக்கவும்',
        Ja: 'お支払い方法の選択',
        Ge: 'Zahlungsart auswählen',
      },
      IDORL18: {
        En: 'Amount',
        Et: 'Summa',
        Ar: 'مقدار',
        Ml: 'തുക',
        Ma: 'रक्कम',
        Fr: 'Montant',
        Hi: 'राशि',
        Ta: 'தொகை',
        Ja: '額',
        Ge: 'Menge',
      },
      IDORTB12: {
        En: 'Enter Amount',
        Et: 'Sisesta summa',
        Ar: 'أدخل المبلغ',
        Ml: 'തുക നൽകുക',
        Ma: 'रक्कम प्रविष्ट करा',
        Fr: 'Entrer le montant',
        Hi: 'राशि प्रविष्ट',
        Ta: 'தொகையை உள்ளிடவும்',
        Ja: '金額を入力します',
        Ge: 'Menge eingeben',
      },
      IDORB01: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IDORB02: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      IDORB03: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      IDORDD01O1: {
        En: 'PCPL',
        Et: 'PCPL',
        Ar: 'PCPL',
        Ml: 'പി.സി.പി.എൽ',
        Ma: 'PCPL',
        Fr: 'PCPL',
        Hi: 'पीसीपीएल',
        Ta: 'பிசிபிஎல்',
        Ja: 'PCPL',
        Ge: 'PCPL',
      },
      IDORDD01O2: {
        En: 'Party',
        Et: 'Pidu',
        Ar: 'حزب، حفلة',
        Ml: 'പാർട്ടി',
        Ma: 'पार्टी',
        Fr: 'Faire la fête',
        Hi: 'समारोह',
        Ta: 'பார்ட்டி',
        Ja: 'パーティ',
        Ge: 'Party',
      },
      IDORDD02O1: {
        En: 'Preview',
        Et: 'Eelvaade',
        Ar: 'معاينة',
        Ml: 'പ്രിവ്യൂ',
        Ma: 'पूर्वावलोकन',
        Fr: 'Aperçu',
        Hi: 'पूर्वावलोकन',
        Ta: 'முன்னோட்ட',
        Ja: 'プレビュー',
        Ge: 'Vorschau',
      },
      IDORDD02O2: {
        En: 'Restoration',
        Et: 'Restaureerimine',
        Ar: 'استعادة',
        Ml: 'പുനസ്ഥാപിക്കൽ',
        Ma: 'जीर्णोद्धार',
        Fr: 'Restauration',
        Hi: 'मरम्मत',
        Ta: 'மறுசீரமைப்பு',
        Ja: '復元',
        Ge: 'Wiederherstellung',
      },
      IDORDD02O3: {
        En: 'Digitisation',
        Et: 'Digitaliseerimine',
        Ar: 'الرقمنة',
        Ml: 'ഡിജിറ്റൈസേഷൻ',
        Ma: 'डिजिटायझेशन',
        Fr: 'Numérisation',
        Hi: 'डिजिटाइजेशन',
        Ta: 'டிஜிட்டல்மயமாக்கல்',
        Ja: 'デジタル化',
        Ge: 'Digitalisierung',
      },
      IDORDD03O1: {
        En: 'Normal',
        Et: 'Tavaline',
        Ar: 'طبيعي',
        Ml: 'സാധാരണ',
        Ma: 'सामान्य',
        Fr: 'Normal',
        Hi: 'सामान्य',
        Ta: 'இயல்பானது',
        Ja: '普通',
        Ge: 'Normal',
      },
      IDORDD03O2: {
        En: 'Immediate',
        Et: 'Vahetu',
        Ar: 'فوري',
        Ml: 'ഉടനടി',
        Ma: 'तात्काळ',
        Fr: 'Immédiat',
        Hi: 'तुरंत',
        Ta: 'உடனடியாக',
        Ja: '即時',
        Ge: 'Sofort',
      },
      IDORDD04O1: {
        En: 'Cash',
        Et: 'sularaha',
        Ar: 'نقدي',
        Ml: 'പണം',
        Ma: 'रोख',
        Fr: 'En espèces',
        Hi: 'नकद',
        Ta: 'பணம்',
        Ja: '現金',
        Ge: 'Kasse',
      },
      IDORDD04O2: {
        En: 'Upi',
        Et: 'Upi',
        Ar: 'أوبي',
        Ml: 'ഉപി',
        Ma: 'उपि',
        Fr: 'Upi',
        Hi: 'है मैं',
        Ta: 'உபி',
        Ja: 'ウピ',
        Ge: 'Upi',
      },
      IDORDD04O3: {
        En: 'Credit/Debit Card',
        Et: 'Krediit-/deebetkaart',
        Ar: 'بطاقة الائتمان / الخصم',
        Ml: 'ക്രെഡിറ്റ്/ഡെബിറ്റ് കാർഡ്',
        Ma: 'क्रेडिट/डेबिट कार्ड',
        Fr: 'Carte de crédit / débit',
        Hi: 'क्रेडिट / डेबिट कार्ड',
        Ta: 'கிரெடிட்/டெபிட் கார்டு',
        Ja: 'クレジット/デビットカード',
        Ge: 'Kredit-/Debitkarte',
      },
      IDORDD04O4: {
        En: 'Internet Banking',
        Et: 'Interneti pangandus',
        Ar: 'الخدمات المصرفية عبر الإنترنت',
        Ml: 'ഇന്റർനെറ്റ് ബാങ്കിംഗ്',
        Ma: 'इंटरनेट बँकिंग',
        Fr: 'Services bancaires sur Internet',
        Hi: 'अंतराजाल लेन - देन',
        Ta: 'இணைய வங்கி',
        Ja: 'ネットバンク',
        Ge: 'Onlinebanking',
      },
    },

    Level3InventoryDeliveryApprove: {
      IDAST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      IDATH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      IDATH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      IDATH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      IDATH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      IDATH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      IDATH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      IDATH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      IDATH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      IDATH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      IDATH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      IDAB01: {
        En: 'Approve',
        Et: 'Kinnita',
        Ar: 'يوافق',
        Ml: 'അംഗീകരിക്കുക',
        Ma: 'मंजूर',
        Fr: 'Approuver',
        Hi: 'मंज़ूरी देना',
        Ta: 'ஒப்புதல்',
        Ja: '承認',
        Ge: 'Genehmigen',
      },
      IDAB001: {
        En: 'Approved',
        Et: 'Kinnitatud',
        Ar: 'وافق',
        Ml: 'അംഗീകരിച്ചു',
        Ma: 'मंजूर',
        Fr: 'Approuvé',
        Hi: 'स्वीकृत',
        Ta: 'அங்கீகரிக்கப்பட்டது',
        Ja: '承認済み',
        Ge: 'Genehmigt',
      },
      IDAB002: {
        En: 'Denied',
        Et: 'Keelatud',
        Ar: 'رفض',
        Ml: 'നിഷേധിച്ചു',
        Ma: 'नाकारले',
        Fr: 'Refusé',
        Hi: 'इंकार किया',
        Ta: 'மறுக்கப்பட்டது',
        Ja: '拒否された',
        Ge: 'Bestritten',
      },

      IDAB02: {
        En: 'Deny',
        Et: 'Keela',
        Ar: 'ينكر',
        Ml: 'നിഷേധിക്കുക',
        Ma: 'नकार द्या',
        Fr: 'Refuser',
        Hi: 'अस्वीकार करना',
        Ta: 'மறுக்கவும்',
        Ja: '拒否',
        Ge: 'Leugnen',
      },
      IDAL01: {
        En: 'Reason of Denial',
        Et: 'Keeldumise põhjus',
        Ar: 'سبب الرفض',
        Ml: 'നിരസിക്കാനുള്ള കാരണം',
        Ma: 'नकाराचे कारण',
        Fr: 'Raison du refus',
        Hi: 'इनकार का कारण',
        Ta: 'மறுப்புக்கான காரணம்',
        Ja: '拒否の理由',
        Ge: 'Ablehnungsgrund',
      },
      IDAL02: {
        En: 'Comments',
        Et: 'Kommentaarid',
        Ar: 'تعليقات',
        Ml: 'അഭിപ്രായങ്ങൾ',
        Ma: 'टिप्पण्या',
        Fr: 'commentaires',
        Hi: 'टिप्पणियाँ',
        Ta: 'கருத்துகள்',
        Ja: 'コメント',
        Ge: 'Kommentare',
      },
      IDATB01: {
        En: 'Please Specify a reason',
        Et: 'Palun täpsustage põhjus',
        Ar: 'يرجى تحديد سبب',
        Ml: 'ദയവായി ഒരു കാരണം വ്യക്തമാക്കുക',
        Ma: 'कृपया कारण निर्दिष्ट करा',
        Fr: 'Veuillez spécifier une raison',
        Hi: 'कृपया कोई कारण बताएं',
        Ta: 'தயவுசெய்து காரணத்தைக் குறிப்பிடவும்',
        Ja: '理由を指定してください',
        Ge: 'Bitte geben Sie einen Grund an',
      },
      IDAL03: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      IDAL04: {
        En: 'Reasons',
        Et: 'Põhjused',
        Ar: 'الأسباب',
        Ml: 'കാരണങ്ങൾ',
        Ma: 'कारणे',
        Fr: 'Les raisons',
        Hi: 'कारणों',
        Ta: 'காரணங்கள்',
        Ja: '理由',
        Ge: 'Gründe dafür',
      },
      IDADD01: {
        En: 'Select Reason',
        Et: 'Valige Põhjus',
        Ar: 'حدد السبب',
        Ml: 'കാരണം തിരഞ്ഞെടുക്കുക',
        Ma: 'कारण निवडा',
        Fr: 'Sélectionnez la raison',
        Hi: 'कारण चुनें',
        Ta: 'காரணத்தைத் தேர்ந்தெடுக்கவும்',
        Ja: '理由を選択',
        Ge: 'Wählen Sie Grund aus',
      },
      IDAB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IDAB04: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
      IDABDD01O1: {
        En: 'Not Permitted as Per Law',
        Et: 'Seaduse järgi ei ole lubatud',
        Ar: 'غير مسموح به بموجب القانون',
        Ml: 'നിയമപ്രകാരം അനുവദനീയമല്ല',
        Ma: 'कायद्यानुसार परवानगी नाही',
        Fr: 'Non autorisé selon la loi',
        Hi: 'कानून के अनुसार अनुमति नहीं है',
        Ta: 'சட்டப்படி அனுமதிக்கப்படவில்லை',
        Ja: '法律により許可されていません',
        Ge: 'Laut Gesetz nicht zulässig',
      },
      IDABDD01O2: {
        En: 'International Movement not Allow',
        Et: 'Rahvusvaheline liikumine ei ole lubatud',
        Ar: 'الحركة الدولية لا تسمح',
        Ml: 'അന്താരാഷ്ട്ര പ്രസ്ഥാനം അനുവദിക്കില്ല',
        Ma: 'आंतरराष्ट्रीय चळवळीला परवानगी नाही',
        Fr: 'Mouvement international non autorisé',
        Hi: 'अंतर्राष्ट्रीय आंदोलन की अनुमति नहीं',
        Ta: 'சர்வதேச இயக்கம் அனுமதிக்கவில்லை',
        Ja: '国際移動不可',
        Ge: 'Internationale Bewegung nicht erlaubt',
      },
      IDABDD01O3: {
        En: 'Against Corporate Policy',
        Et: 'Ettevõttepoliitika vastu',
        Ar: 'ضد سياسة الشركة',
        Ml: 'കോർപ്പറേറ്റ് നയത്തിനെതിരെ',
        Ma: 'कॉर्पोरेट धोरणाच्या विरोधात',
        Fr: "Contre la politique de l'entreprise",
        Hi: 'कॉर्पोरेट नीति के खिलाफ',
        Ta: 'கார்ப்பரேட் கொள்கைக்கு எதிரானது',
        Ja: '企業ポリシーに反する',
        Ge: 'Gegen die Unternehmenspolitik',
      },
      IDABDD01O4: {
        En: 'Insufficient Trust',
        Et: 'Ebapiisav usaldus',
        Ar: 'ثقة غير كافية',
        Ml: 'അപര്യാപ്തമായ വിശ്വാസം',
        Ma: 'अपुरा विश्वास',
        Fr: 'Confiance insuffisante',
        Hi: 'अपर्याप्त विश्वास',
        Ta: 'போதிய நம்பிக்கை இல்லை',
        Ja: '不十分な信頼',
        Ge: 'Unzureichendes Vertrauen',
      },
      IDABDD02O1: {
        En: 'Verified',
        Et: 'Kinnitatud',
        Ar: 'تم التحقق',
        Ml: 'പരിശോധിച്ചുറപ്പിച്ചു',
        Ma: 'सत्यापित',
        Fr: 'Vérifié',
        Hi: 'सत्यापित',
        Ta: 'சரிபார்க்கப்பட்டது',
        Ja: '検証済み',
        Ge: 'Verifiziert',
      },
      IDABDD02O2: {
        En: 'Request Completed',
        Et: 'Taotlus täidetud',
        Ar: 'الطلب مكتمل',
        Ml: 'അഭ്യർത്ഥന പൂർത്തിയായി',
        Ma: 'विनंती पूर्ण झाली',
        Fr: 'Demande terminée',
        Hi: 'अनुरोध पूरा हुआ',
        Ta: 'கோரிக்கை முடிந்தது',
        Ja: 'リクエスト完了',
        Ge: 'Anfrage abgeschlossen',
      },
      IDABDD02O3: {
        En: 'Authorized',
        Et: 'Volitatud',
        Ar: 'مخول',
        Ml: 'അധികാരപ്പെടുത്തിയത്',
        Ma: 'अधिकृत',
        Fr: 'Autorisé',
        Hi: 'अधिकार दिया गया',
        Ta: 'அங்கீகரிக்கப்பட்டது',
        Ja: '認可済み',
        Ge: 'Autorisiert',
      },
      IDABTT01: {
        En: 'Sorry, no data to show',
        Et: 'Kahjuks pole andmeid, mida näidata',
        Ar: 'آسف ، لا توجد بيانات لعرضها',
        Ml: 'ക്ഷമിക്കണം, കാണിക്കാൻ ഡാറ്റയൊന്നുമില്ല',
        Ma: 'क्षमस्व, दाखवण्यासाठी कोणताही डेटा नाही',
        Fr: 'Désolé, aucune donnée à afficher',
        Hi: 'क्षमा करें, दिखाने के लिए कोई डेटा नहीं',
        Ta: 'மன்னிக்கவும், காட்ட தரவு எதுவும் இல்லை',
        Ja: '表示するデータがありません',
        Ge: 'Entschuldigung, keine Daten zum Anzeigen',
      },
    },
    InventoryDeliveryApproveComponent: {
      IDACB01: {
        En: 'Approved',
        Et: 'Kinnita',
        Ar: 'يوافق',
        Ml: 'അംഗീകരിക്കുക',
        Ma: 'मंजूर',
        Fr: 'Approuver',
        Hi: 'मंज़ूरी देना',
        Ta: 'ஒப்புதல்',
        Ja: '承認',
        Ge: 'Genehmigen',
      },
      IDACB02: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      IDACB03: {
        En: 'Denied',
        Et: 'Keelatud',
        Ar: 'رفض',
        Ml: 'നിഷേധിച്ചു',
        Ma: 'नाकारले',
        Fr: 'Refusé',
        Hi: 'इंकार किया',
        Ta: 'மறுக்கப்பட்டது',
        Ja: '拒否された',
        Ge: 'Bestritten',
      },
      IDACM01: {
        En: 'Reason for',
        Et: 'Keeldumise põhjus',
        Ar: 'سبب الرفض',
        Ml: 'നിരസിക്കാനുള്ള കാരണം',
        Ma: 'नकाराचे कारण',
        Fr: 'Raison du refus',
        Hi: 'इनकार का कारण',
        Ta: 'மறுப்புக்கான காரணம்',
        Ja: '拒否の理由',
        Ge: 'Ablehnungsgrund',
      },
      IDACM02: {
        En: 'Comments',
        Et: 'Kommentaarid',
        Ar: 'تعليقات',
        Ml: 'അഭിപ്രായങ്ങൾ',
        Ma: 'टिप्पण्या',
        Fr: 'commentaires',
        Hi: 'टिप्पणियाँ',
        Ta: 'கருத்துகள்',
        Ja: 'コメント',
        Ge: 'Kommentare',
      },
      IDACMPH01: {
        En: 'Please Specify a reason',
        Et: 'Palun täpsustage põhjus',
        Ar: 'يرجى تحديد سبب',
        Ml: 'ദയവായി ഒരു കാരണം വ്യക്തമാക്കുക',
        Ma: 'कृपया कारण निर्दिष्ट करा',
        Fr: 'Veuillez spécifier une raison',
        Hi: 'कृपया कोई कारण बताएं',
        Ta: 'தயவுசெய்து காரணத்தைக் குறிப்பிடவும்',
        Ja: '理由を指定してください',
        Ge: 'Bitte geben Sie einen Grund an',
      },
      IDACML01: {
        En: 'Reasons',
        Et: 'Põhjused',
        Ar: 'الأسباب',
        Ml: 'കാരണങ്ങൾ',
        Ma: 'कारणे',
        Fr: 'Les raisons',
        Hi: 'कारणों',
        Ta: 'காரணங்கள்',
        Ja: '理由',
        Ge: 'Gründe dafür',
      },
      IDACMB01: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IDACMB02: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
      IDACTB01: {
        En: 'Sorry, no data to show',
        Et: 'Kahjuks pole andmeid, mida näidata',
        Ar: 'آسف ، لا توجد بيانات لعرضها',
        Ml: 'ക്ഷമിക്കണം, കാണിക്കാൻ ഡാറ്റയൊന്നുമില്ല',
        Ma: 'क्षमस्व, दाखवण्यासाठी कोणताही डेटा नाही',
        Fr: 'Désolé, aucune donnée à afficher',
        Hi: 'क्षमा करें, दिखाने के लिए कोई डेटा नहीं',
        Ta: 'மன்னிக்கவும், காட்ட தரவு எதுவும் இல்லை',
        Ja: '表示するデータがありません',
        Ge: 'Entschuldigung, keine Daten zum Anzeigen',
      },
    },
    InventoryDeliveryAssignPickerComponent: {
      IDAPCL01: {
        En: 'Authorized Personnal',
        Et: 'MÄÄRAMINE VALIJA',
        Ar: 'منتقي التعيين',
        Ml: 'പിക്കർ നിയോഗിക്കുക',
        Ma: 'निवडक नियुक्त करा',
        Fr: "SÉLECTIONNEUR D'AFFECTATION",
        Hi: 'पिकर असाइन करें',
        Ta: 'பிக்கரை ஒதுக்கவும்',
        Ja: '割り当てピッカー',
        Ge: 'AUSWAHL ZUWEISEN',
      },
      IDAPCL02: {
        En: 'Please select item received',
        Et: 'Valige üksus vastu võetud',
        Ar: 'الرجاء تحديد العنصر المستلم',
        Ml: 'ലഭിച്ച ഇനം തിരഞ്ഞെടുക്കുക',
        Ma: 'कृपया प्राप्त आयटम निवडा',
        Fr: "Veuillez sélectionner l'article reçu",
        Hi: 'कृपया प्राप्त आइटम का चयन करें',
        Ta: 'பெற்ற உருப்படியைத் தேர்ந்தெடுக்கவும்',
        Ja: '受け取ったアイテムを選択してください',
        Ge: 'Bitte erhaltenen Artikel auswählen',
      },
      IDAPCL03: {
        En: 'Picker Name',
        Et: 'Valija nimi',
        Ar: 'اسم المنتقي',
        Ml: 'പിക്കർ പേര്',
        Ma: 'निवडक नाव',
        Fr: 'Nom du sélecteur',
        Hi: 'पिकर नाम',
        Ta: 'தேர்வு பெயர்',
        Ja: 'ピッカー名',
        Ge: 'Picker-Name',
      },
      IDAPCPH01: {
        En: 'Select Picker Name',
        Et: 'Valige Valija nimi',
        Ar: 'حدد اسم المنتقي',
        Ml: 'പിക്കർ നാമം തിരഞ്ഞെടുക്കുക',
        Ma: 'निवडक नाव निवडा',
        Fr: 'Sélectionnez le nom du sélecteur',
        Hi: 'पिकर नाम चुनें',
        Ta: 'பிக்கர் பெயரைத் தேர்ந்தெடுக்கவும்',
        Ja: 'ピッカー名を選択',
        Ge: 'Wählen Sie Picker-Name aus',
      },
      IDAPCL04: {
        En: 'Picker Phone No',
        Et: 'Valija telefoni nr',
        Ar: 'رقم هاتف المنتقي',
        Ml: 'പിക്കർ ഫോൺ നമ്പർ',
        Ma: 'पिकर फोन क्र',
        Fr: 'Numéro de téléphone du sélecteur',
        Hi: 'पिकर फोन नंबर',
        Ta: 'பிக்கர் தொலைபேசி எண்',
        Ja: 'ピッカー電話番号',
        Ge: 'Picker-Telefonnr',
      },
      IDAPCPH02: {
        En: 'Picker Phone No',
        Et: 'Valija telefoni nr',
        Ar: 'رقم هاتف المنتقي',
        Ml: 'പിക്കർ ഫോൺ നമ്പർ',
        Ma: 'पिकर फोन क्र',
        Fr: 'Numéro de téléphone du sélecteur',
        Hi: 'पिकर फोन नंबर',
        Ta: 'பிக்கர் தொலைபேசி எண்',
        Ja: 'ピッカー電話番号',
        Ge: 'Picker-Telefonnr',
      },
      IDAPCB01: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IDAPCB02: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      IDAPCB03: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      IDAPCTBL01: {
        En: 'Sorry, no data to show',
        Et: 'Kahjuks pole andmeid, mida näidata',
        Ar: 'آسف ، لا توجد بيانات لعرضها',
        Ml: 'ക്ഷമിക്കണം, കാണിക്കാൻ ഡാറ്റയൊന്നുമില്ല',
        Ma: 'क्षमस्व, दाखवण्यासाठी कोणताही डेटा नाही',
        Fr: 'Désolé, aucune donnée à afficher',
        Hi: 'क्षमा करें, दिखाने के लिए कोई डेटा नहीं',
        Ta: 'மன்னிக்கவும், காட்ட தரவு எதுவும் இல்லை',
        Ja: '表示するデータがありません',
        Ge: 'Entschuldigung, keine Daten zum Anzeigen',
      },
    },
    Level3InventoryDeliveryAssignPicker: {
      IDAPL01: {
        En: 'ASSIGN PICKER',
        Et: 'MÄÄRAMINE VALIJA',
        Ar: 'منتقي التعيين',
        Ml: 'പിക്കർ നിയോഗിക്കുക',
        Ma: 'निवडक नियुक्त करा',
        Fr: "SÉLECTIONNEUR D'AFFECTATION",
        Hi: 'पिकर असाइन करें',
        Ta: 'பிக்கரை ஒதுக்கவும்',
        Ja: '割り当てピッカー',
        Ge: 'AUSWAHL ZUWEISEN',
      },
      IDAPL02: {
        En: 'Picker Name',
        Et: 'Valija nimi',
        Ar: 'اسم المنتقي',
        Ml: 'പിക്കർ പേര്',
        Ma: 'निवडक नाव',
        Fr: 'Nom du sélecteur',
        Hi: 'पिकर नाम',
        Ta: 'தேர்வு பெயர்',
        Ja: 'ピッカー名',
        Ge: 'Picker-Name',
      },
      IDAPDD01: {
        En: 'Select Picker Name',
        Et: 'Valige Valija nimi',
        Ar: 'حدد اسم المنتقي',
        Ml: 'പിക്കർ നാമം തിരഞ്ഞെടുക്കുക',
        Ma: 'निवडक नाव निवडा',
        Fr: 'Sélectionnez le nom du sélecteur',
        Hi: 'पिकर नाम चुनें',
        Ta: 'பிக்கர் பெயரைத் தேர்ந்தெடுக்கவும்',
        Ja: 'ピッカー名を選択',
        Ge: 'Wählen Sie Picker-Name aus',
      },
      IDAPL03: {
        En: 'Picker Phone No',
        Et: 'Valija telefoni nr',
        Ar: 'رقم هاتف المنتقي',
        Ml: 'പിക്കർ ഫോൺ നമ്പർ',
        Ma: 'पिकर फोन क्र',
        Fr: 'Numéro de téléphone du sélecteur',
        Hi: 'पिकर फोन नंबर',
        Ta: 'பிக்கர் தொலைபேசி எண்',
        Ja: 'ピッカー電話番号',
        Ge: 'Picker-Telefonnr',
      },
      IDAPTB01: {
        En: 'Enter Picker Phone No',
        Et: 'Sisestage valija telefoninumber',
        Ar: 'أدخل رقم هاتف المنتقي',
        Ml: 'പിക്കർ ഫോൺ നമ്പർ നൽകുക',
        Ma: 'पिकर फोन नंबर एंटर करा',
        Fr: 'Entrez le numéro de téléphone du sélecteur',
        Hi: 'पिकर फोन नंबर दर्ज करें',
        Ta: 'பிக்கர் ஃபோன் எண்ணை உள்ளிடவும்',
        Ja: 'ピッカーの電話番号を入力してください',
        Ge: 'Geben Sie die Picker-Telefonnummer ein',
      },
      IDAPB01: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      IDAPB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IDAPB03: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
    },

    Level3InventoryDeliveryCreateOrder: {
      IDCOL01: {
        En: 'CREATE ORDER',
        Et: 'LOO TELLIMUS',
        Ar: 'إنشاء النظام',
        Ml: 'ഓർഡർ സൃഷ്ടിക്കുക',
        Ma: 'ऑर्डर तयार करा',
        Fr: 'CRÉER UNE COMMANDE',
        Hi: 'आदेश बनाएं',
        Ta: 'ஆர்டரை உருவாக்கவும்',
        Ja: '注文を作成',
        Ge: 'BESTELLUNG ANLEGEN',
      },
      IDCOL02: {
        En: 'Client Headline',
        Et: 'Kliendi pealkiri',
        Ar: 'عنوان العميل',
        Ml: 'ക്ലയന്റ് തലക്കെട്ട്',
        Ma: 'क्लायंट हेडलाइन',
        Fr: 'Titre du client',
        Hi: 'ग्राहक शीर्षक',
        Ta: 'வாடிக்கையாளர் தலைப்பு',
        Ja: 'クライアントの見出し',
        Ge: 'Überschrift des Kunden',
      },
      IDCOTB01: {
        En: 'Client Box',
        Et: 'Kliendikast',
        Ar: 'صندوق العميل',
        Ml: 'ക്ലയന്റ് ബോക്സ്',
        Ma: 'क्लायंट बॉक्स',
        Fr: 'Boîte client',
        Hi: 'क्लाइंट बॉक्स',
        Ta: 'வாடிக்கையாளர் பெட்டி',
        Ja: 'クライアントボックス',
        Ge: 'Kundenbox',
      },
      IDCOB01: {
        En: 'Plus Button',
        Et: 'Plussnupp',
        Ar: 'زر زائد',
        Ml: 'പ്ലസ് ബട്ടൺ',
        Ma: 'प्लस बटण',
        Fr: 'Plus Bouton',
        Hi: 'प्लस बटन',
        Ta: 'பிளஸ் பட்டன்',
        Ja: 'プラスボタン',
        Ge: 'Plus-Taste',
      },
      IDCOL03: {
        En: 'Add Client Details',
        Et: 'Lisage kliendi üksikasjad',
        Ar: 'إضافة تفاصيل العميل',
        Ml: 'ക്ലയന്റ് വിശദാംശങ്ങൾ ചേർക്കുക',
        Ma: 'क्लायंट तपशील जोडा',
        Fr: 'Ajouter les détails du client',
        Hi: 'ग्राहक विवरण जोड़ें',
        Ta: 'வாடிக்கையாளர் விவரங்களைச் சேர்க்கவும்',
        Ja: 'クライアントの詳細を追加',
        Ge: 'Kundendetails hinzufügen',
      },
      IDCOL04: {
        En: 'Client headline',
        Et: 'Kliendi pealkiri',
        Ar: 'عنوان العميل',
        Ml: 'ക്ലയന്റ് തലക്കെട്ട്',
        Ma: 'क्लायंट मथळा',
        Fr: 'Titre du client',
        Hi: 'ग्राहक शीर्षक',
        Ta: 'வாடிக்கையாளர் தலைப்பு',
        Ja: 'クライアントの見出し',
        Ge: 'Überschrift des Kunden',
      },
      IDCOTB02: {
        En: 'Client box',
        Et: 'Kliendikast',
        Ar: 'صندوق العميل',
        Ml: 'ക്ലയന്റ് ബോക്സ്',
        Ma: 'क्लायंट बॉक्स',
        Fr: 'Boîte clients',
        Hi: 'ग्राहक बॉक्स',
        Ta: 'வாடிக்கையாளர் பெட்டி',
        Ja: 'クライアントボックス',
        Ge: 'Client-Box',
      },
      IDCOL05: {
        En: 'Currency Headline',
        Et: 'Valuuta pealkiri',
        Ar: 'عنوان العملة',
        Ml: 'കറൻസി തലക്കെട്ട്',
        Ma: 'चलन मथळा',
        Fr: 'Titre de la devise',
        Hi: 'मुद्रा शीर्षक',
        Ta: 'நாணய தலைப்பு',
        Ja: '通貨の見出し',
        Ge: 'Währungsschlagzeile',
      },
      IDCOTB03: {
        En: 'Currency Box',
        Et: 'Valuutakast',
        Ar: 'صندوق العملات',
        Ml: 'കറൻസി ബോക്സ്',
        Ma: 'चलन बॉक्स',
        Fr: 'Boîte à monnaie',
        Hi: 'मुद्रा बॉक्स',
        Ta: 'நாணயப் பெட்டி',
        Ja: '通貨ボックス',
        Ge: 'Währungsbox',
      },
      IDCOL06: {
        En: 'Email Headline',
        Et: 'Meili pealkiri',
        Ar: 'عنوان البريد الإلكتروني',
        Ml: 'ഇമെയിൽ തലക്കെട്ട്',
        Ma: 'ईमेल हेडलाइन',
        Fr: "Titre de l'e-mail",
        Hi: 'ईमेल शीर्षक',
        Ta: 'மின்னஞ்சல் தலைப்பு',
        Ja: 'メールの見出し',
        Ge: 'E-Mail-Überschrift',
      },
      IDCOTB04: {
        En: 'Email Box',
        Et: 'E-posti kast',
        Ar: 'صندوق البريد الإلكتروني',
        Ml: 'ഇമെയിൽ ബോക്സ്',
        Ma: 'ईमेल बॉक्स',
        Fr: 'Boîte e-mail',
        Hi: 'ईमेल बॉक्स',
        Ta: 'மின்னஞ்சல் பெட்டி',
        Ja: 'メールボックス',
        Ge: 'Postfach',
      },
      IDCOL07: {
        En: 'Address Headline',
        Et: 'Aadressi pealkiri',
        Ar: 'العنوان الرئيسي',
        Ml: 'വിലാസത്തിന്റെ തലക്കെട്ട്',
        Ma: 'पत्ता मथळा',
        Fr: "Titre de l'adresse",
        Hi: 'पता शीर्षक',
        Ta: 'முகவரி தலைப்பு',
        Ja: '住所の見出し',
        Ge: 'Adressüberschrift',
      },
      IDCOTB05: {
        En: 'Address Box',
        Et: 'Aadressi kast',
        Ar: 'مربع العنوان',
        Ml: 'വിലാസ പെട്ടി',
        Ma: 'पत्ता बॉक्स',
        Fr: "Boîte d'adresse",
        Hi: 'पता बॉक्स',
        Ta: 'முகவரி பெட்டி',
        Ja: 'アドレスボックス',
        Ge: 'Adressfeld',
      },
      IDCOL08: {
        En: 'Phone Number',
        Et: 'Telefoninumber',
        Ar: 'رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ',
        Ma: 'फोन नंबर',
        Fr: 'Numéro de téléphone',
        Hi: 'फ़ोन नंबर',
        Ta: 'தொலைபேசி எண்',
        Ja: '電話番号',
        Ge: 'Telefonnummer',
      },
      IDTCOB06: {
        En: 'Phone Number',
        Et: 'Telefoninumber',
        Ar: 'رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ',
        Ma: 'फोन नंबर',
        Fr: 'Numéro de téléphone',
        Hi: 'फ़ोन नंबर',
        Ta: 'தொலைபேசி எண்',
        Ja: '電話番号',
        Ge: 'Telefonnummer',
      },
      IDCOB02: {
        En: 'Cancel client',
        Et: 'Tühista klient',
        Ar: 'إلغاء العميل',
        Ml: 'ക്ലയന്റ് റദ്ദാക്കുക',
        Ma: 'क्लायंट रद्द करा',
        Fr: 'Annuler le client',
        Hi: 'ग्राहक रद्द करें',
        Ta: 'கிளையண்டை ரத்து செய்',
        Ja: 'クライアントをキャンセル',
        Ge: 'Kunde kündigen',
      },
      IDCOB03: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      IDCODD01: {
        En: 'Assign Department',
        Et: 'Määra osakond',
        Ar: 'قسم التنازل',
        Ml: 'വകുപ്പ് ഏൽപ്പിക്കുക',
        Ma: 'विभाग नियुक्त करा',
        Fr: 'Attribuer un service',
        Hi: 'विभाग सौंपें',
        Ta: 'துறையை ஒதுக்குங்கள்',
        Ja: '部門の割り当て',
        Ge: 'Abteilung zuweisen',
      },
      IDCOB04: {
        En: 'Template',
        Et: 'Mall',
        Ar: 'قالب',
        Ml: 'ടെംപ്ലേറ്റ്',
        Ma: 'साचा',
        Fr: 'Modèle',
        Hi: 'टेम्पलेट',
        Ta: 'டெம்ப்ளேட்',
        Ja: 'テンプレート',
        Ge: 'Schablone',
      },
      IDCOB05: {
        En: 'Customization',
        Et: 'Kohandamine',
        Ar: 'التخصيص',
        Ml: 'ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'सानुकूलन',
        Fr: 'Personnalisation',
        Hi: 'अनुकूलन',
        Ta: 'தனிப்பயனாக்கம்',
        Ja: 'カスタマイズ',
        Ge: 'Anpassung',
      },
      IDCODD02: {
        En: 'Type',
        Et: 'Tüüp',
        Ar: 'يكتب',
        Ml: 'ടൈപ്പ് ചെയ്യുക',
        Ma: 'प्रकार',
        Fr: 'Taper',
        Hi: 'प्रकार',
        Ta: 'வகை',
        Ja: 'タイプ',
        Ge: 'Typ',
      },
      IDCOCL01: {
        En: 'Workflow Customization L1',
        Et: 'Töövoo kohandamine L1',
        Ar: 'تخصيص سير العمل L1',
        Ml: 'വർക്ക്ഫ്ലോ ഇഷ്‌ടാനുസൃതമാക്കൽ L1',
        Ma: 'वर्कफ्लो कस्टमायझेशन L1',
        Fr: 'Personnalisation du flux de travail L1',
        Hi: 'कार्यप्रवाह अनुकूलन L1',
        Ta: 'பணிப்பாய்வு தனிப்பயனாக்கம் L1',
        Ja: 'ワークフローのカスタマイズ L1',
        Ge: 'Workflow-Anpassung L1',
      },
      IDCOCL02: {
        En: 'Workflow Customization L2',
        Et: 'Töövoo kohandamine L2',
        Ar: 'تخصيص سير العمل L2',
        Ml: 'വർക്ക്ഫ്ലോ ഇഷ്‌ടാനുസൃതമാക്കൽ L2',
        Ma: 'वर्कफ्लो कस्टमायझेशन L2',
        Fr: 'Personnalisation du flux de travail L2',
        Hi: 'कार्यप्रवाह अनुकूलन L2',
        Ta: 'பணிப்பாய்வு தனிப்பயனாக்கம் L2',
        Ja: 'ワークフローのカスタマイズ L2',
        Ge: 'Workflow-Anpassung L2',
      },
      IDCOCL03: {
        En: 'Workflow Customization L3',
        Et: 'Töövoo kohandamine L3',
        Ar: 'تخصيص سير العمل L3',
        Ml: 'വർക്ക്ഫ്ലോ കസ്റ്റമൈസേഷൻ L3',
        Ma: 'वर्कफ्लो कस्टमायझेशन L3',
        Fr: 'Personnalisation du flux de travail L3',
        Hi: 'कार्यप्रवाह अनुकूलन L3',
        Ta: 'பணிப்பாய்வு தனிப்பயனாக்கம் L3',
        Ja: 'ワークフローのカスタマイズ L3',
        Ge: 'Workflow-Anpassung L3',
      },
      IDCOB06: {
        En: 'Save Template',
        Et: 'Salvesta mall',
        Ar: 'حفظ النموذج',
        Ml: 'ടെംപ്ലേറ്റ് സംരക്ഷിക്കുക',
        Ma: 'टेम्पलेट जतन करा',
        Fr: 'Enregistrer le modèle',
        Hi: 'टेम्पलेट सहेजें',
        Ta: 'டெம்ப்ளேட்டை சேமிக்கவும்',
        Ja: 'テンプレートを保存',
        Ge: 'Vorlage speichern',
      },
      IDCOB07: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      IDCOB08: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IDCOB09: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    Level3InventoryDeliveryDelivery: {
      IDDL01: {
        En: 'DELIVERY',
        Et: 'KOHALETOIMETAMINE',
        Ar: 'توصيل',
        Ml: 'ഡെലിവറി',
        Ma: 'डिलिव्हरी',
        Fr: 'LIVRAISON',
        Hi: 'वितरण',
        Ta: 'டெலிவரி',
        Ja: '配達',
        Ge: 'LIEFERUNG',
      },
      IDDL02: {
        En: 'Attention',
        Et: 'Tähelepanu',
        Ar: 'انتباه',
        Ml: 'ശ്രദ്ധ',
        Ma: 'लक्ष द्या',
        Fr: 'Attention',
        Hi: 'ध्यान',
        Ta: 'கவனம்',
        Ja: '注意',
        Ge: 'Aufmerksamkeit',
      },
      IDDTB01: {
        En: 'Attention Box',
        Et: 'Tähelepanu kast',
        Ar: 'مربع الاهتمام',
        Ml: 'ശ്രദ്ധാ പെട്ടി',
        Ma: 'लक्ष बॉक्स',
        Fr: 'Attention Boîte',
        Hi: 'ध्यान बॉक्स',
        Ta: 'கவனம் பெட்டி',
        Ja: '注意ボックス',
        Ge: 'Achtung Box',
      },
      IDDL03: {
        En: 'Phone',
        Et: 'Telefon',
        Ar: 'هاتف',
        Ml: 'ഫോൺ',
        Ma: 'फोन',
        Fr: 'Téléphoner',
        Hi: 'फ़ोन',
        Ta: 'தொலைபேசி',
        Ja: '電話',
        Ge: 'Telefon',
      },
      IDDTB02: {
        En: 'Phone Box',
        Et: 'Telefonikarp',
        Ar: 'هاتف عمومي',
        Ml: 'ഫോൺ പെട്ടി',
        Ma: 'दूरध्वनी यंत्र',
        Fr: 'Cabine téléphonique',
        Hi: 'फोन बौक्स',
        Ta: 'தொலைபேசி பெட்டி',
        Ja: '電話ボックス',
        Ge: 'Telefonzelle',
      },
      IDDL04: {
        En: 'Ship Via',
        Et: 'Laeva kaudu',
        Ar: 'سفينة عبر',
        Ml: 'വഴി കപ്പൽ',
        Ma: 'मार्गे जहाज',
        Fr: 'Transporté par',
        Hi: 'पानी का जहाज दवारा',
        Ta: 'வழியாக கப்பல்',
        Ja: '発送方法',
        Ge: 'Versenden per',
      },
      IDDTB03: {
        En: 'Ship Via Box',
        Et: 'Saatmine kasti kaudu',
        Ar: 'الشحن عبر الصندوق',
        Ml: 'ബോക്സ് വഴി അയയ്ക്കുക',
        Ma: 'बॉक्स मार्गे जहाज',
        Fr: 'Expédier via la boîte',
        Hi: 'बॉक्स के माध्यम से जहाज',
        Ta: 'பெட்டி வழியாக அனுப்பவும்',
        Ja: 'ボックスで発送',
        Ge: 'Versand per Box',
      },
      IDDL05: {
        En: 'Ship Priority',
        Et: 'Laeva prioriteet',
        Ar: 'أولوية السفينة',
        Ml: 'കപ്പൽ മുൻഗണന',
        Ma: 'जहाज प्राधान्य',
        Fr: "Priorité d'expédition",
        Hi: 'जहाज प्राथमिकता',
        Ta: 'கப்பல் முன்னுரிமை',
        Ja: '船の優先順位',
        Ge: 'Schiffspriorität',
      },
      IDDTB04: {
        En: 'Ship Priority Box',
        Et: 'Laeva prioriteetide kast',
        Ar: 'صندوق أولوية الشحن',
        Ml: 'ഷിപ്പ് പ്രയോറിറ്റി ബോക്സ്',
        Ma: 'शिप प्रायॉरिटी बॉक्स',
        Fr: "Boîte de priorité d'expédition",
        Hi: 'जहाज प्राथमिकता बॉक्स',
        Ta: 'கப்பல் முன்னுரிமை பெட்டி',
        Ja: '発送優先ボックス',
        Ge: 'Schiffsprioritätsbox',
      },
      IDDL06: {
        En: 'Air Way',
        Et: 'Õhutee',
        Ar: 'قناة هوائية',
        Ml: 'എയർ വേ',
        Ma: 'एअर वे',
        Fr: 'Voies aériennes',
        Hi: 'वायुपथ',
        Ta: 'காற்று வழி',
        Ja: '気道',
        Ge: 'Atemweg',
      },
      IDDTB05: {
        En: 'Air Way Box',
        Et: 'Air Way Box',
        Ar: 'صندوق طريق الهواء',
        Ml: 'എയർ വേ ബോക്സ്',
        Ma: 'एअर वे बॉक्स',
        Fr: 'Boîte de transport aérien',
        Hi: 'एयर वे बॉक्स',
        Ta: 'காற்று வழி பெட்டி',
        Ja: 'エアウェイボックス',
        Ge: 'Air-Way-Box',
      },
      IDDL07: {
        En: 'Account',
        Et: 'Konto',
        Ar: 'الحساب',
        Ml: 'അക്കൗണ്ട്',
        Ma: 'खाते',
        Fr: 'Compte',
        Hi: 'खाता',
        Ta: 'கணக்கு',
        Ja: 'アカウント',
        Ge: 'Konto',
      },
      IDDTB06: {
        En: 'Account Box',
        Et: 'Konto kast',
        Ar: 'صندوق الحساب',
        Ml: 'അക്കൗണ്ട് ബോക്സ്',
        Ma: 'खाते बॉक्स',
        Fr: 'Boîte de compte',
        Hi: 'खाता बॉक्स',
        Ta: 'கணக்கு பெட்டி',
        Ja: 'アカウントボックス',
        Ge: 'Kontobox',
      },
      IDDL08: {
        En: 'Pickup By',
        Et: 'Kättesaamine',
        Ar: 'بيك اب بواسطة',
        Ml: 'പിക്കപ്പ് വഴി',
        Ma: 'द्वारे पिकअप',
        Fr: 'Ramassage par',
        Hi: 'पिकअप बाय',
        Ta: 'பிக்கப் மூலம்',
        Ja: 'ピックアップ',
        Ge: 'Abholung durch',
      },
      IDDTB07: {
        En: 'Pickup By Box',
        Et: 'Karbiga järeletulemine',
        Ar: 'بيك اب بالصندوق',
        Ml: 'ബോക്സ് വഴി പിക്കപ്പ്',
        Ma: 'बॉक्सद्वारे पिकअप',
        Fr: 'Ramassage par boîte',
        Hi: 'बॉक्स द्वारा पिकअप',
        Ta: 'பெட்டி மூலம் பிக்கப்',
        Ja: 'ボックスでの受け取り',
        Ge: 'Abholung per Box',
      },
      IDDL09: {
        En: 'Pickup By ID',
        Et: 'Vastuvõtt ID järgi',
        Ar: 'الاستلام بالمعرف',
        Ml: 'ഐഡി വഴി പിക്കപ്പ്',
        Ma: 'आयडी द्वारे पिकअप',
        Fr: 'Ramassage par ID',
        Hi: 'आईडी द्वारा पिकअप',
        Ta: 'ஐடி மூலம் பிக்கப்',
        Ja: 'IDによるピックアップ',
        Ge: 'Abholung nach ID',
      },
      IDDTB08: {
        En: 'Pickup By ID Box',
        Et: 'Kättesaamine ID kasti järgi',
        Ar: 'لاقط بواسطة ID Box',
        Ml: 'ഐഡി ബോക്സ് വഴി പിക്കപ്പ്',
        Ma: 'आयडी बॉक्सद्वारे पिकअप',
        Fr: "Ramassage par boîte d'identité",
        Hi: 'आईडी बॉक्स द्वारा पिकअप',
        Ta: 'அடையாள பெட்டி மூலம் பிக்கப்',
        Ja: 'IDボックスで受け取り',
        Ge: 'Abholung durch ID-Box',
      },
      IDDL10: {
        En: 'Pickup On',
        Et: 'Korje sisse lülitatud',
        Ar: 'بيك اب على',
        Ml: 'പിക്കപ്പ് ഓൺ',
        Ma: 'पिकअप चालू',
        Fr: 'Revenir sur',
        Hi: 'भान्पना',
        Ta: 'பிக்கப் ஆன்',
        Ja: 'に気づく',
        Ge: 'Aufgreifen',
      },
      IDDTB09: {
        En: 'Pickup On Box',
        Et: 'Karbis järeletulemine',
        Ar: 'بيك اب اون بوكس',
        Ml: 'ബോക്സിൽ പിക്കപ്പ്',
        Ma: 'पिकअप ऑन बॉक्स',
        Fr: 'Ramassage sur la boîte',
        Hi: 'बॉक्स पर पिकअप',
        Ta: 'பெட்டியில் பிக்கப்',
        Ja: 'ボックスでの受け取り',
        Ge: 'Abholung am Karton',
      },
      IDDL11: {
        En: 'Ship To',
        Et: 'Saatma',
        Ar: 'سافر على متن سفينة لِـ',
        Ml: 'ഇതിലേക്ക് ഷിപ്പുചെയ്യുക',
        Ma: 'कडे पाठवा',
        Fr: 'Envoyez à',
        Hi: 'यहां भेजें',
        Ta: 'அனுப்பவும்',
        Ja: '送り先',
        Ge: 'Ausliefern',
      },
      IDDTB10: {
        En: 'Ship To Box',
        Et: 'Saatmine kasti',
        Ar: 'شحن إلى الصندوق',
        Ml: 'ബോക്സിലേക്ക് അയയ്ക്കുക',
        Ma: 'शिप टू बॉक्स',
        Fr: 'Expédier à la boîte',
        Hi: 'शिप टू बॉक्स',
        Ta: 'பெட்டிக்கு அனுப்பவும்',
        Ja: 'ボックスに出荷',
        Ge: 'Versand an Box',
      },
      IDDB01: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      IDDB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      IDDB03: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    Level3InventoryReportNewAssetTitlesAddedInThisMonth: {
      IRATST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      IRATTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      IRATTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      IRATTH03: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      IRATTH04: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      IRATTH05: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      IRATTH06: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      IRATTH07: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      IRATTH08: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
    },

    Level3InventoryReportCurrentMonthAssetCANMovement: {
      IRACMST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      IRACMTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      IRACMTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      IRACMTH03: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      IRACMTH04: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      IRACMTH05: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      IRACMTH06: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      IRACMTH07: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      IRACMTH08: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
    },

    Level3InventoryReportPendingReturnsFromBorrowers: {
      IRPRST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      IRPRTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      IRPRTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      IRPRTH03: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      IRPRTH04: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      IRPRTH05: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      IRPRTH06: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      IRPRTH07: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      IRPRTH08: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
    },

    Level3InventoryReportAssetsCleanedInThisMonth: {
      IRACST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      IRACTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      IRACTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      IRACTH03: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      IRACTH04: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      IRACTH05: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      IRACTH06: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      IRACTH07: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      IRACTH08: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
    },

    Level3InventoryReportAssetScheduledForCleaning: {
      IRASCST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      IRASCTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      IRASCTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      IRASCTH03: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      IRASCTH04: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      IRASCTH05: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      IRASCTH06: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      IRASCTH07: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      IRASCTH08: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
    },

    Level3InventoryReportDigitalisationPriority: {
      IRDPST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      IRDPTH01: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      IRDPTH02: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      IRDPTH03: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      IRDPTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      IRDPTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      IRDPTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      IRDPTH07: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      IRDPTH08: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      IRDPTH09: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
    },

    Level2OrdersOutward: {
      OOB01: {
        En: 'Unvault',
        Et: 'Unvault',
        Ar: 'ينفخ',
        Ml: 'അൺവാൾട്ട്',
        Ma: 'अनवॉल्ट',
        Fr: 'Unvault',
        Hi: 'अनवॉल्ट',
        Ta: 'அன்வால்ட்',
        Ja: '保管庫を外す',
        Ge: 'Unvault',
      },
      OOB02: {
        En: 'Verify',
        Et: 'Kinnitage',
        Ar: 'يؤكد',
        Ml: 'സ്ഥിരീകരിക്കുക',
        Ma: 'सत्यापित करा',
        Fr: 'Vérifier',
        Hi: 'सत्यापित करना',
        Ta: 'சரிபார்க்கவும்',
        Ja: '確認',
        Ge: 'Verifizieren',
      },
      OOB03: {
        En: 'Approve',
        Et: 'Kinnita',
        Ar: 'يوافق',
        Ml: 'അംഗീകരിക്കുക',
        Ma: 'मंजूर',
        Fr: 'Approuver',
        Hi: 'मंज़ूरी देना',
        Ta: 'ஒப்புதல்',
        Ja: '承認',
        Ge: 'Genehmigen',
      },
      OOB04: {
        En: 'Assign Picker',
        Et: 'Määra valija',
        Ar: 'منتقي التعيين',
        Ml: 'പിക്കർ അസൈൻ ചെയ്യുക',
        Ma: 'पिकर नियुक्त करा',
        Fr: 'Attribuer un sélecteur',
        Hi: 'पिकर असाइन करें',
        Ta: 'பிக்கரை ஒதுக்கவும்',
        Ja: 'ピッカーの割り当て',
        Ge: 'Picker zuweisen',
      },
      OOB05: {
        En: 'Move',
        Et: 'Liiguta',
        Ar: 'يتحرك',
        Ml: 'നീക്കുക',
        Ma: 'हलवा',
        Fr: 'Déplacer',
        Hi: 'कदम',
        Ta: 'நகர்வு',
        Ja: '動く',
        Ge: 'Bewegen',
      },
      OOB06: {
        En: 'Package',
        Et: 'pakett',
        Ar: 'طَرد',
        Ml: 'പാക്കേജ്',
        Ma: 'पॅकेज',
        Fr: 'Forfait',
        Hi: 'पैकेट',
        Ta: 'தொகுப்பு',
        Ja: 'パッケージ',
        Ge: 'Paket',
      },
      OOB07: {
        En: 'Billing',
        Et: 'Arveldamine',
        Ar: 'الفواتير',
        Ml: 'ബില്ലിംഗ്',
        Ma: 'बिलिंग',
        Fr: 'Facturation',
        Hi: 'बिलिंग',
        Ta: 'பில்லிங்',
        Ja: '請求する',
        Ge: 'Abrechnung',
      },
    },

    Level2OrdersInward: {
      OIDYT1: {
        En: 'Inward Request',
        Et: 'Sisemine taotlus',
        Ar: 'طلب داخلي',
        Ml: 'ആന്തരിക അഭ്യർത്ഥന',
        Ma: 'आवक विनंती',
        Fr: 'Demande entrante',
        Hi: 'आवक अनुरोध',
        Ta: 'உள்நோக்கிய கோரிக்கை',
        Ja: '内向きのリクエスト',
        Ge: 'Innere Anfrage',
      },
      OIB02: {
        En: 'Verify',
        Et: 'Kinnitage',
        Ar: 'يؤكد',
        Ml: 'സ്ഥിരീകരിക്കുക',
        Ma: 'सत्यापित करा',
        Fr: 'Vérifier',
        Hi: 'सत्यापित करना',
        Ta: 'சரிபார்க்கவும்',
        Ja: '確認',
        Ge: 'Verifizieren',
      },
      OIB03: {
        En: 'Approve',
        Et: 'Kinnita',
        Ar: 'يوافق',
        Ml: 'അംഗീകരിക്കുക',
        Ma: 'मंजूर',
        Fr: 'Approuver',
        Hi: 'मंज़ूरी देना',
        Ta: 'ஒப்புதல்',
        Ja: '承認',
        Ge: 'Genehmigen',
      },
      OIB04: {
        En: 'Picker Assign',
        Et: 'Valija määramine',
        Ar: 'تحديد المنتقي',
        Ml: 'പിക്കർ അസൈൻ',
        Ma: 'निवडक नियुक्त करा',
        Fr: 'Affectation du sélecteur',
        Hi: 'पिकर असाइन करें',
        Ta: 'பிக்கர் ஒதுக்கீடு',
        Ja: 'ピッカー割り当て',
        Ge: 'Picker-Zuweisung',
      },
      OIB05: {
        En: 'Move To Vault',
        Et: 'Teisalda Vaulti',
        Ar: 'انتقال إلى قبو',
        Ml: 'നിലവറയിലേക്ക് നീങ്ങുക',
        Ma: 'व्हॉल्टमध्ये हलवा',
        Fr: 'Déplacer vers le coffre-fort',
        Hi: 'गुंबद कि तरफ़ बडो',
        Ta: 'பெட்டகத்தை நகர்த்த',
        Ja: 'ボールトに移動',
        Ge: 'In den Tresor verschieben',
      },
    },

    Level2OrdersReports: {
      ORB01: {
        En: 'Received(n)',
        Et: 'Vastu võetud (n)',
        Ar: 'المتلقاة (ن)',
        Ml: 'ലഭിച്ചു(എൻ)',
        Ma: 'प्राप्त(n)',
        Fr: 'Reçu(n)',
        Hi: 'प्राप्त (एन)',
        Ta: 'பெறப்பட்டது(n)',
        Ja: '受信(n)',
        Ge: 'Empfangen(e)',
      },
      ORB02: {
        En: 'Waiting for Approval(n)',
        Et: 'Heakskiidu ootel (n)',
        Ar: 'في انتظار الموافقة (اسم)',
        Ml: 'അംഗീകാരത്തിനായി കാത്തിരിക്കുന്നു(n)',
        Ma: 'मंजुरीची प्रतीक्षा करत आहे(n)',
        Fr: "En attente d'approbation(n)",
        Hi: 'अनुमोदन की प्रतीक्षा में (एन)',
        Ta: 'ஒப்புதலுக்காகக் காத்திருக்கிறது(n)',
        Ja: '承認待ち(n)',
        Ge: 'Warten auf Genehmigung(en)',
      },
      ORB03: {
        En: 'Approved (n)',
        Et: 'Kinnitatud (n)',
        Ar: 'معتمد (ن)',
        Ml: 'അംഗീകരിച്ചു (n)',
        Ma: 'मंजूर (n)',
        Fr: 'Approuvé (n)',
        Hi: 'स्वीकृत (एन)',
        Ta: 'அங்கீகரிக்கப்பட்டது (n)',
        Ja: '承認済み (n)',
        Ge: 'Genehmigt (n)',
      },
      ORB04: {
        En: 'In Progress (n)',
        Et: 'Pooleli (n)',
        Ar: 'قيد التقدم (اسم)',
        Ml: 'പുരോഗതിയിലാണ് (n)',
        Ma: 'प्रगतीपथावर आहे (n)',
        Fr: 'En cours (n)',
        Hi: 'प्रगति में (एन)',
        Ta: 'செயல்பாட்டில் உள்ளது (n)',
        Ja: '進行中 (n)',
        Ge: 'In Bearbeitung (n)',
      },
      ORB05: {
        En: 'Ready (n)',
        Et: 'Valmis (n)',
        Ar: 'جاهز (اسم)',
        Ml: 'തയ്യാറാണ് (എൻ)',
        Ma: 'तयार (n)',
        Fr: 'Prêt (n)',
        Hi: 'तैयार (एन)',
        Ta: 'தயார் (n)',
        Ja: '準備完了 (n)',
        Ge: 'Bereit (n)',
      },
      ORB06: {
        En: 'Delivered (n)',
        Et: 'Tarnitud (n)',
        Ar: 'تم التسليم (ن)',
        Ml: 'വിതരണം ചെയ്തു (n)',
        Ma: 'वितरित (n)',
        Fr: 'Livré (n)',
        Hi: 'वितरित (एन)',
        Ta: 'வழங்கப்பட்டது (n)',
        Ja: '配達済み (n)',
        Ge: 'Geliefert (n)',
      },
      ORB07: {
        En: 'Returned (n)',
        Et: 'Tagastatud (n)',
        Ar: 'عاد (ن)',
        Ml: 'മടങ്ങിയെത്തി (n)',
        Ma: 'परत आले (n)',
        Fr: 'Renvoyé (n)',
        Hi: 'लौटा (एन)',
        Ta: 'திரும்பியது (n)',
        Ja: '返された (n)',
        Ge: 'Retourniert (n)',
      },
    },

    Level3OrdersOutwardUnvault: {
      OOUVST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      OOUVTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      OOUVTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      OOUVTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      OOUVTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      OOUVTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      OOUVTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      OOUVTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      OOUVTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      OOUVTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      OOUVTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      OOUVB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      OOUVB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      OOUVL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      OOUVCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      OOUVB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      OOUVB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      OOUVB05: {
        En: 'Unvault Complete',
        Et: 'Vault on lõpetatud',
        Ar: 'Unvault كاملة',
        Ml: 'അൺവാൾട്ട് പൂർത്തിയായി',
        Ma: 'अनवॉल्ट पूर्ण',
        Fr: 'Désinstallation complète',
        Hi: 'अनवॉल्ट पूर्ण',
        Ta: 'அன்வால்ட் முடிந்தது',
        Ja: 'アンボールト完了',
        Ge: 'Unvault abgeschlossen',
      },
    },

    Level3OrdersOutwardVerify: {
      OOVST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      OOVTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      OOVTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      OOVTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      OOVTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      OOVTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      OOVTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      OOVTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      OOVTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      OOVTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      OOVTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      OOVB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      OOVB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      OOVL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      OOVCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      OOVB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      OOVB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      OOVB05: {
        En: 'Verified',
        Et: 'Kinnitatud',
        Ar: 'تم التحقق',
        Ml: 'പരിശോധിച്ചുറപ്പിച്ചു',
        Ma: 'सत्यापित',
        Fr: 'Vérifié',
        Hi: 'सत्यापित',
        Ta: 'சரிபார்க்கப்பட்டது',
        Ja: '検証済み',
        Ge: 'Verifiziert',
      },
      OOVB06: {
        En: 'Denied',
        Et: 'Keelatud',
        Ar: 'رفض',
        Ml: 'നിഷേധിച്ചു',
        Ma: 'नाकारले',
        Fr: 'Refusé',
        Hi: 'इंकार किया',
        Ta: 'மறுக்கப்பட்டது',
        Ja: '拒否された',
        Ge: 'Bestritten',
      },
      OOVL02: {
        En: 'Reason of Denial',
        Et: 'Keeldumise põhjus',
        Ar: 'سبب الرفض',
        Ml: 'നിരസിക്കാനുള്ള കാരണം',
        Ma: 'नकाराचे कारण',
        Fr: 'Raison du refus',
        Hi: 'इनकार का कारण',
        Ta: 'மறுப்புக்கான காரணம்',
        Ja: '拒否の理由',
        Ge: 'Ablehnungsgrund',
      },
      OOVL03: {
        En: 'Comments',
        Et: 'Kommentaarid',
        Ar: 'تعليقات',
        Ml: 'അഭിപ്രായങ്ങൾ',
        Ma: 'टिप्पण्या',
        Fr: 'commentaires',
        Hi: 'टिप्पणियाँ',
        Ta: 'கருத்துகள்',
        Ja: 'コメント',
        Ge: 'Kommentare',
      },
      OOVTB01: {
        En: 'Please Specify a reason',
        Et: 'Palun täpsustage põhjus',
        Ar: 'يرجى تحديد سبب',
        Ml: 'ദയവായി ഒരു കാരണം വ്യക്തമാക്കുക',
        Ma: 'कृपया कारण निर्दिष्ट करा',
        Fr: 'Veuillez spécifier une raison',
        Hi: 'कृपया कोई कारण बताएं',
        Ta: 'தயவுசெய்து காரணத்தைக் குறிப்பிடவும்',
        Ja: '理由を指定してください',
        Ge: 'Bitte geben Sie einen Grund an',
      },
      OOVL04: {
        En: 'Reasons',
        Et: 'Põhjused',
        Ar: 'الأسباب',
        Ml: 'കാരണങ്ങൾ',
        Ma: 'कारणे',
        Fr: 'Les raisons',
        Hi: 'कारणों',
        Ta: 'காரணங்கள்',
        Ja: '理由',
        Ge: 'Gründe dafür',
      },
      OOVDD01: {
        En: 'Reasons box',
        Et: 'Põhjuste kast',
        Ar: 'مربع الأسباب',
        Ml: 'കാരണങ്ങൾ ബോക്സ്',
        Ma: 'कारणे बॉक्स',
        Fr: 'Boîte de raisons',
        Hi: 'कारण बॉक्स',
        Ta: 'காரணங்கள் பெட்டி',
        Ja: '理由ボックス',
        Ge: 'Box Gründe',
      },
      OOVB07: {
        En: 'cancel',
        Et: 'tühistada',
        Ar: 'إلغاء',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Abbrechen',
      },
      OOVB08: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    Level3OrdersOutwardApprove: {
      OOAST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      OOATH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      OOATH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      OOATH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      OOATH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      OOATH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      OOATH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      OOATH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      OOATH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      OOATH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      OOATH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      OOAB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      OOAB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      OOAL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      OOACL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      OOAB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      OOAB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      OOAB05: {
        En: 'Approve',
        Et: 'Kinnita',
        Ar: 'يوافق',
        Ml: 'അംഗീകരിക്കുക',
        Ma: 'मंजूर',
        Fr: 'Approuver',
        Hi: 'मंज़ूरी देना',
        Ta: 'ஒப்புதல்',
        Ja: '承認',
        Ge: 'Genehmigen',
      },
      OOAB06: {
        En: 'Deny',
        Et: 'Keela',
        Ar: 'ينكر',
        Ml: 'നിഷേധിക്കുക',
        Ma: 'नकार द्या',
        Fr: 'Refuser',
        Hi: 'अस्वीकार करना',
        Ta: 'மறுக்கவும்',
        Ja: '拒否',
        Ge: 'Leugnen',
      },
      OOAL02: {
        En: 'Reason of Denial',
        Et: 'Keeldumise põhjus',
        Ar: 'سبب الرفض',
        Ml: 'നിരസിക്കാനുള്ള കാരണം',
        Ma: 'नकाराचे कारण',
        Fr: 'Raison du refus',
        Hi: 'इनकार का कारण',
        Ta: 'மறுப்புக்கான காரணம்',
        Ja: '拒否の理由',
        Ge: 'Ablehnungsgrund',
      },
      OOAL03: {
        En: 'Comments',
        Et: 'Kommentaarid',
        Ar: 'تعليقات',
        Ml: 'അഭിപ്രായങ്ങൾ',
        Ma: 'टिप्पण्या',
        Fr: 'commentaires',
        Hi: 'टिप्पणियाँ',
        Ta: 'கருத்துகள்',
        Ja: 'コメント',
        Ge: 'Kommentare',
      },
      OOATB01: {
        En: 'Please Specify a reason',
        Et: 'Palun täpsustage põhjus',
        Ar: 'يرجى تحديد سبب',
        Ml: 'ദയവായി ഒരു കാരണം വ്യക്തമാക്കുക',
        Ma: 'कृपया कारण निर्दिष्ट करा',
        Fr: 'Veuillez spécifier une raison',
        Hi: 'कृपया कोई कारण बताएं',
        Ta: 'தயவுசெய்து காரணத்தைக் குறிப்பிடவும்',
        Ja: '理由を指定してください',
        Ge: 'Bitte geben Sie einen Grund an',
      },
      OOAL04: {
        En: 'Reasons',
        Et: 'Põhjused',
        Ar: 'الأسباب',
        Ml: 'കാരണങ്ങൾ',
        Ma: 'कारणे',
        Fr: 'Les raisons',
        Hi: 'कारणों',
        Ta: 'காரணங்கள்',
        Ja: '理由',
        Ge: 'Gründe dafür',
      },
      OOADD01: {
        En: 'Reasons box',
        Et: 'Põhjuste kast',
        Ar: 'مربع الأسباب',
        Ml: 'കാരണങ്ങൾ ബോക്സ്',
        Ma: 'कारणे बॉक्स',
        Fr: 'Boîte de raisons',
        Hi: 'कारण बॉक्स',
        Ta: 'காரணங்கள் பெட்டி',
        Ja: '理由ボックス',
        Ge: 'Box Gründe',
      },
      OOAB07: {
        En: 'cancel',
        Et: 'tühistada',
        Ar: 'إلغاء',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Abbrechen',
      },
      OOAB08: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    Level3OrdersOutwardAssignPicker: {
      OOAPL01: {
        En: 'ASSIGN PICKER',
        Et: 'MÄÄRAMINE VALIJA',
        Ar: 'منتقي التعيين',
        Ml: 'പിക്കർ നിയോഗിക്കുക',
        Ma: 'निवडक नियुक्त करा',
        Fr: "SÉLECTIONNEUR D'AFFECTATION",
        Hi: 'पिकर असाइन करें',
        Ta: 'பிக்கரை ஒதுக்கவும்',
        Ja: '割り当てピッカー',
        Ge: 'AUSWAHL ZUWEISEN',
      },
      OOAPL02: {
        En: 'Picker Name',
        Et: 'Valija nimi',
        Ar: 'اسم المنتقي',
        Ml: 'പിക്കർ പേര്',
        Ma: 'निवडक नाव',
        Fr: 'Nom du sélecteur',
        Hi: 'पिकर नाम',
        Ta: 'தேர்வு பெயர்',
        Ja: 'ピッカー名',
        Ge: 'Picker-Name',
      },
      OOAPDD01: {
        En: 'Select Picker Name',
        Et: 'Valige Valija nimi',
        Ar: 'حدد اسم المنتقي',
        Ml: 'പിക്കർ നാമം തിരഞ്ഞെടുക്കുക',
        Ma: 'निवडक नाव निवडा',
        Fr: 'Sélectionnez le nom du sélecteur',
        Hi: 'पिकर नाम चुनें',
        Ta: 'பிக்கர் பெயரைத் தேர்ந்தெடுக்கவும்',
        Ja: 'ピッカー名を選択',
        Ge: 'Wählen Sie Picker-Name aus',
      },
      OOAPL03: {
        En: 'Picker Phone No',
        Et: 'Valija telefoni nr',
        Ar: 'رقم هاتف المنتقي',
        Ml: 'പിക്കർ ഫോൺ നമ്പർ',
        Ma: 'पिकर फोन क्र',
        Fr: 'Numéro de téléphone du sélecteur',
        Hi: 'पिकर फोन नंबर',
        Ta: 'பிக்கர் தொலைபேசி எண்',
        Ja: 'ピッカー電話番号',
        Ge: 'Picker-Telefonnr',
      },
      OOAPTB01: {
        En: 'Picker Phone No Box',
        Et: 'Valija telefoni karbita',
        Ar: 'منتقي الهاتف لا يوجد صندوق',
        Ml: 'പിക്കർ ഫോൺ നമ്പർ ബോക്സ്',
        Ma: 'पिकर फोन नंबर बॉक्स',
        Fr: 'Sélecteur de téléphone sans boîte',
        Hi: 'पिकर फोन नंबर बॉक्स',
        Ta: 'பிக்கர் தொலைபேசி எண் பெட்டி',
        Ja: 'ピッカー電話ボックスなし',
        Ge: 'Picker-Telefon keine Box',
      },
      OOAPB01: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      OOAPB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      OOAPB03: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
    },

    Level3OrdersOutwardMove: {
      OOMST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      OOMTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      OOMTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      OOMTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      OOMTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      OOMTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      OOMTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      OOMTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      OOMTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      OOMTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      OOMTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      OOMB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      OOMB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      OOML01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      OOMCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      OOMB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      OOMB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      OOMB05: {
        En: 'Movement Complete',
        Et: 'Liikumine lõpetatud',
        Ar: 'اكتملت الحركة',
        Ml: 'ചലനം പൂർത്തിയായി',
        Ma: 'हालचाल पूर्ण',
        Fr: 'Mouvement terminé',
        Hi: 'आंदोलन पूर्ण',
        Ta: 'இயக்கம் முடிந்தது',
        Ja: '移動完了',
        Ge: 'Bewegung abgeschlossen',
      },
    },

    Level3OrdersOutwardPackage: {
      OOPST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      OOPTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      OOPTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      OOPTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      OOPTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      OOPTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      OOPTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      OOPTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      OOPTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      OOPTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      OOPTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      OOPB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      OOPB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      OOPL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      OOPCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      OOPB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      OOPB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      OOPB05: {
        En: 'Packed',
        Et: 'Pakitud',
        Ar: 'معباه',
        Ml: 'പാക്ക് ചെയ്തു',
        Ma: 'पॅक',
        Fr: 'Emballé',
        Hi: 'पैक्ड',
        Ta: 'நிரம்பியது',
        Ja: '梱包済み',
        Ge: 'Verpackt',
      },
    },

    Level3OrdersOutwardBilling: {
      OOBL01: {
        En: 'BILLING',
        Et: 'ARVELDAMINE',
        Ar: 'الفواتير',
        Ml: 'ബില്ലിംഗ്',
        Ma: 'बिलिंग',
        Fr: 'FACTURATION',
        Hi: 'बिलिंग',
        Ta: 'பில்லிங்',
        Ja: '請求する',
        Ge: 'ABRECHNUNG',
      },
      OOBL02: {
        En: 'Bill Type',
        Et: 'Arve tüüp',
        Ar: 'نوع الفاتورة',
        Ml: 'ബിൽ തരം',
        Ma: 'बिल प्रकार',
        Fr: 'Type de facture',
        Hi: 'बिल प्रकार',
        Ta: 'பில் வகை',
        Ja: '請求書の種類',
        Ge: 'Rechnungstyp',
      },
      OOBDD01: {
        En: 'Bill Type Box',
        Et: 'Arve tüübi kast',
        Ar: 'صندوق نوع الفاتورة',
        Ml: 'ബിൽ ടൈപ്പ് ബോക്സ്',
        Ma: 'बिल टाइप बॉक्स',
        Fr: 'Zone Type de facture',
        Hi: 'बिल टाइप बॉक्स',
        Ta: 'பில் வகை பெட்டி',
        Ja: 'ビルタイプボックス',
        Ge: 'Bill Type Box',
      },
      OOBL03: {
        En: 'Cost',
        Et: 'Maksumus',
        Ar: 'كلفة',
        Ml: 'ചെലവ്',
        Ma: 'खर्च',
        Fr: 'Coût',
        Hi: 'लागत',
        Ta: 'செலவு',
        Ja: '料金',
        Ge: 'Kosten',
      },
      OOBTB01: {
        En: 'Cost Box',
        Et: 'Kulude kast',
        Ar: 'صندوق التكلفة',
        Ml: 'ചെലവ് പെട്ടി',
        Ma: 'खर्च बॉक्स',
        Fr: 'Boîte de coût',
        Hi: 'लागत बॉक्स',
        Ta: 'செலவு பெட்டி',
        Ja: 'コストボックス',
        Ge: 'Kostenbox',
      },
      OOBL04: {
        En: 'Billing Code',
        Et: 'Arvelduskood',
        Ar: 'رمز الفاتورة',
        Ml: 'ബില്ലിംഗ് കോഡ്',
        Ma: 'बिलिंग कोड',
        Fr: 'Code de facturation',
        Hi: 'बिलिंग कोड',
        Ta: 'பில்லிங் குறியீடு',
        Ja: '請求コード',
        Ge: 'Abrechnungscode',
      },
      OOBTB02: {
        En: 'Billing Code Box',
        Et: 'Arvelduskoodi kast',
        Ar: 'صندوق رمز الفواتير',
        Ml: 'ബില്ലിംഗ് കോഡ് ബോക്സ്',
        Ma: 'बिलिंग कोड बॉक्स',
        Fr: 'Zone de code de facturation',
        Hi: 'बिलिंग कोड बॉक्स',
        Ta: 'பில்லிங் குறியீடு பெட்டி',
        Ja: '請求コードボックス',
        Ge: 'Rechnungscode-Feld',
      },
      OOBB01: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      OOBB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      OOBB03: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    Level3OrdersInwardInwardRequest: {
      OIIRL01: {
        En: 'INWARDS ASSETS',
        Et: 'SISSE VARAD',
        Ar: 'الأصول الواردة',
        Ml: 'ഇൻവേർഡ് അസറ്റുകൾ',
        Ma: 'आतील मालमत्ता',
        Fr: "ACTIFS VERS L'INTÉRIEUR",
        Hi: 'आवक संपत्ति',
        Ta: 'உள்நோக்கிய சொத்துக்கள்',
        Ja: '対内資産',
        Ge: 'ZUGANGSVERMÖGEN',
      },
      OIIRL02: {
        En: 'Asset Id',
        Et: 'Vara ID',
        Ar: 'معرف الأصل',
        Ml: 'അസറ്റ് ഐഡി',
        Ma: 'मालमत्ता आयडी',
        Fr: "Identifiant de l'élément",
        Hi: 'एसेट आईडी',
        Ta: 'சொத்து ஐடி',
        Ja: '資産 ID',
        Ge: 'Asset-ID',
      },
      OIIRDD01: {
        En: 'Select Asset Id',
        Et: 'Valige Vara ID',
        Ar: 'حدد معرف الأصل',
        Ml: 'അസറ്റ് ഐഡി തിരഞ്ഞെടുക്കുക',
        Ma: 'मालमत्ता आयडी निवडा',
        Fr: "Sélectionnez l'identifiant de l'actif",
        Hi: 'एसेट आईडी चुनें',
        Ta: 'சொத்து ஐடியைத் தேர்ந்தெடுக்கவும்',
        Ja: 'アセット ID を選択',
        Ge: 'Wählen Sie Asset-ID aus',
      },
      OIIRL03: {
        En: 'Asset Name',
        Et: 'Vara nimi',
        Ar: 'اسم الأصل',
        Ml: 'അസറ്റ് പേര്',
        Ma: 'मालमत्तेचे नाव',
        Fr: "Nom de l'actif",
        Hi: 'संपत्ति का नाम',
        Ta: 'சொத்து பெயர்',
        Ja: 'アセット名',
        Ge: 'Asset-Name',
      },
      OIIRDD02: {
        En: 'Select Asset',
        Et: 'Valige Vara',
        Ar: 'حدد الأصل',
        Ml: 'അസറ്റ് തിരഞ്ഞെടുക്കുക',
        Ma: 'मालमत्ता निवडा',
        Fr: "Sélectionnez l'actif",
        Hi: 'संपत्ति का चयन करें',
        Ta: 'சொத்தைத் தேர்ந்தெடுக்கவும்',
        Ja: 'アセットを選択',
        Ge: 'Wählen Sie Anlage aus',
      },
      OIIRL04: {
        En: 'Total Number of Can',
        Et: 'Konservide koguarv',
        Ar: 'العدد الإجمالي للعلب',
        Ml: 'ക്യാനുകളുടെ ആകെ എണ്ണം',
        Ma: 'कॅनची एकूण संख्या',
        Fr: 'Nombre total de boîtes',
        Hi: 'कैन की कुल संख्या',
        Ta: 'கேனின் மொத்த எண்ணிக்கை',
        Ja: '缶の総数',
        Ge: 'Gesamtzahl der Dosen',
      },
      OIIRDD03: {
        En: 'Select Can Count',
        Et: 'Valige Can Count',
        Ar: 'حدد يمكن العد',
        Ml: 'കാൻ കൌണ്ട് തിരഞ്ഞെടുക്കുക',
        Ma: 'कॅन काउंट निवडा',
        Fr: 'Sélectionnez Peut compter',
        Hi: 'गिनती कर सकते हैं चुनें',
        Ta: 'கணக்கிட முடியும் என்பதைத் தேர்ந்தெடுக்கவும்',
        Ja: 'カウント可能を選択',
        Ge: 'Wählen Sie Kann zählen aus',
      },
      OIIRL05: {
        En: 'Borrower Name',
        Et: 'Laenaja nimi',
        Ar: 'اسم المستعير',
        Ml: 'കടം വാങ്ങുന്നയാളുടെ പേര്',
        Ma: 'कर्जदाराचे नाव',
        Fr: "Nom de l'emprunteur",
        Hi: 'उधारकर्ता का नाम',
        Ta: 'கடன் வாங்கியவர் பெயர்',
        Ja: '借り主の名前',
        Ge: 'Name des Kreditnehmers',
      },
      OIIRDD04: {
        En: 'Select Borrower',
        Et: 'Valige laenuvõtja',
        Ar: 'حدد المستعير',
        Ml: 'കടം വാങ്ങുന്നയാളെ തിരഞ്ഞെടുക്കുക',
        Ma: 'कर्जदार निवडा',
        Fr: "Sélectionnez l'emprunteur",
        Hi: 'उधारकर्ता का चयन करें',
        Ta: 'கடன் வாங்குபவரைத் தேர்ந்தெடுக்கவும்',
        Ja: '借り手を選択',
        Ge: 'Kreditnehmer auswählen',
      },
      OIIRL06: {
        En: 'Location of the CANs',
        Et: 'CAN-ide asukoht',
        Ar: 'موقع CANs',
        Ml: 'CAN-കളുടെ സ്ഥാനം',
        Ma: 'CAN चे स्थान',
        Fr: 'Emplacement des CAN',
        Hi: 'CANs का स्थान',
        Ta: 'CANகளின் இருப்பிடம்',
        Ja: 'CAN の位置',
        Ge: 'Lage der CANs',
      },
      OIIRDD05: {
        En: 'Select Location of the CANs',
        Et: 'Valige CAN-ide asukoht',
        Ar: 'حدد موقع CANs',
        Ml: 'CAN-കളുടെ സ്ഥാനം തിരഞ്ഞെടുക്കുക',
        Ma: 'CAN चे स्थान निवडा',
        Fr: "Sélectionnez l'emplacement des CAN",
        Hi: 'CANs के स्थान का चयन करें',
        Ta: 'CANகளின் இருப்பிடத்தைத் தேர்ந்தெடுக்கவும்',
        Ja: 'CANの場所を選択',
        Ge: 'Standort der CANs auswählen',
      },
      OIIRL07: {
        En: 'Date',
        Et: 'Kuupäev',
        Ar: 'تاريخ',
        Ml: 'തീയതി',
        Ma: 'तारीख',
        Fr: 'Date',
        Hi: 'दिनांक',
        Ta: 'தேதி',
        Ja: '日にち',
        Ge: 'Datum',
      },
      OIIRD01: {
        En: 'Date Box',
        Et: 'Kuupäevakast',
        Ar: 'مربع التاريخ',
        Ml: 'തീയതി ബോക്സ്',
        Ma: 'तारीख बॉक्स',
        Fr: 'Boîte de rendez-vous',
        Hi: 'दिनांक बॉक्स',
        Ta: 'தேதி பெட்டி',
        Ja: '日付ボックス',
        Ge: 'Datumsfeld',
      },
      OIIRL08: {
        En: 'Comments',
        Et: 'Kommentaarid',
        Ar: 'تعليقات',
        Ml: 'അഭിപ്രായങ്ങൾ',
        Ma: 'टिप्पण्या',
        Fr: 'commentaires',
        Hi: 'टिप्पणियाँ',
        Ta: 'கருத்துகள்',
        Ja: 'コメント',
        Ge: 'Kommentare',
      },
      OIIRTB01: {
        En: 'Comments Box',
        Et: 'Kommentaaride kast',
        Ar: 'مربع التعليقات',
        Ml: 'കമന്റ് ബോക്സ്',
        Ma: 'टिप्पण्या बॉक्स',
        Fr: 'Boîte de commentaires',
        Hi: 'कमेंट बॉक्स',
        Ta: 'கருத்துப் பெட்டி',
        Ja: 'コメントボックス',
        Ge: 'Kommentarfeld',
      },
      OIIRB01: {
        En: 'Drag and drop some files here, or click to select files',
        Et: 'Lohistage mõned failid siia või klõpsake failide valimiseks',
        Ar: 'قم بسحب وإفلات بعض الملفات هنا ، أو انقر لتحديد الملفات',
        Ml: 'ചില ഫയലുകൾ ഇവിടെ വലിച്ചിടുക, അല്ലെങ്കിൽ ഫയലുകൾ തിരഞ്ഞെടുക്കാൻ ക്ലിക്ക് ചെയ്യുക',
        Ma: 'काही फाइल्स येथे ड्रॅग आणि ड्रॉप करा किंवा फाइल्स निवडण्यासाठी क्लिक करा',
        Fr: 'Faites glisser et déposez des fichiers ici, ou cliquez pour sélectionner des fichiers',
        Hi: 'कुछ फाइलों को यहां खींचें और छोड़ें, या फाइलों का चयन करने के लिए क्लिक करें',
        Ta: 'சில கோப்புகளை இங்கே இழுத்து விடுங்கள் அல்லது கோப்புகளைத் தேர்ந்தெடுக்க கிளிக் செய்யவும்',
        Ja: 'ここにいくつかのファイルをドラッグ アンド ドロップするか、クリックしてファイルを選択します',
        Ge: 'Ziehen Sie einige Dateien hierher und legen Sie sie dort ab, oder klicken Sie, um Dateien auszuwählen',
      },
      OIIRB02: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      OIIRB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      OIIRB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
    },

    Level3OrdersInwardVerify: {
      OIVST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      OIVTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      OIVTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      OIVTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      OIVTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      OIVTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      OIVTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      OIVTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      OIVTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      OIVTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      OIVTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      OIVB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      OIVB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      OIVL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      OIVCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      OIVB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      OIVB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      OIVB05: {
        En: 'Verified',
        Et: 'Kinnitatud',
        Ar: 'تم التحقق',
        Ml: 'പരിശോധിച്ചുറപ്പിച്ചു',
        Ma: 'सत्यापित',
        Fr: 'Vérifié',
        Hi: 'सत्यापित',
        Ta: 'சரிபார்க்கப்பட்டது',
        Ja: '検証済み',
        Ge: 'Verifiziert',
      },
      OIVB06: {
        En: 'Denied',
        Et: 'Keelatud',
        Ar: 'رفض',
        Ml: 'നിഷേധിച്ചു',
        Ma: 'नाकारले',
        Fr: 'Refusé',
        Hi: 'इंकार किया',
        Ta: 'மறுக்கப்பட்டது',
        Ja: '拒否された',
        Ge: 'Bestritten',
      },
      OIVL02: {
        En: 'Reason of Denial',
        Et: 'Keeldumise põhjus',
        Ar: 'سبب الرفض',
        Ml: 'നിരസിക്കാനുള്ള കാരണം',
        Ma: 'नकाराचे कारण',
        Fr: 'Raison du refus',
        Hi: 'इनकार का कारण',
        Ta: 'மறுப்புக்கான காரணம்',
        Ja: '拒否の理由',
        Ge: 'Ablehnungsgrund',
      },
      OIVL03: {
        En: 'Comments',
        Et: 'Kommentaarid',
        Ar: 'تعليقات',
        Ml: 'അഭിപ്രായങ്ങൾ',
        Ma: 'टिप्पण्या',
        Fr: 'commentaires',
        Hi: 'टिप्पणियाँ',
        Ta: 'கருத்துகள்',
        Ja: 'コメント',
        Ge: 'Kommentare',
      },
      OIVTB01: {
        En: 'Please Specify a reason',
        Et: 'Palun täpsustage põhjus',
        Ar: 'يرجى تحديد سبب',
        Ml: 'ദയവായി ഒരു കാരണം വ്യക്തമാക്കുക',
        Ma: 'कृपया कारण निर्दिष्ट करा',
        Fr: 'Veuillez spécifier une raison',
        Hi: 'कृपया कोई कारण बताएं',
        Ta: 'தயவுசெய்து காரணத்தைக் குறிப்பிடவும்',
        Ja: '理由を指定してください',
        Ge: 'Bitte geben Sie einen Grund an',
      },
      OIVL04: {
        En: 'Reasons',
        Et: 'Põhjused',
        Ar: 'الأسباب',
        Ml: 'കാരണങ്ങൾ',
        Ma: 'कारणे',
        Fr: 'Les raisons',
        Hi: 'कारणों',
        Ta: 'காரணங்கள்',
        Ja: '理由',
        Ge: 'Gründe dafür',
      },
      OIVDD01: {
        En: 'Reasons box',
        Et: 'Põhjuste kast',
        Ar: 'مربع الأسباب',
        Ml: 'കാരണങ്ങൾ ബോക്സ്',
        Ma: 'कारणे बॉक्स',
        Fr: 'Boîte de raisons',
        Hi: 'कारण बॉक्स',
        Ta: 'காரணங்கள் பெட்டி',
        Ja: '理由ボックス',
        Ge: 'Box Gründe',
      },
      OIVB07: {
        En: 'cancel',
        Et: 'tühistada',
        Ar: 'إلغاء',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Abbrechen',
      },
      OIVB08: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    Level3OrdersInwardApprove: {
      OIAST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      OIATH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      OIATH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      OIATH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      OIATH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      OIATH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      OIATH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      OIATH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      OIATH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      OIATH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      OIATH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      OIAB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      OIAB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      OIAL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      OIACL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      OIAB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      OIAB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      OIAB05: {
        En: 'Approve',
        Et: 'Kinnita',
        Ar: 'يوافق',
        Ml: 'അംഗീകരിക്കുക',
        Ma: 'मंजूर',
        Fr: 'Approuver',
        Hi: 'मंज़ूरी देना',
        Ta: 'ஒப்புதல்',
        Ja: '承認',
        Ge: 'Genehmigen',
      },
      OIAB06: {
        En: 'Deny',
        Et: 'Keela',
        Ar: 'ينكر',
        Ml: 'നിഷേധിക്കുക',
        Ma: 'नकार द्या',
        Fr: 'Refuser',
        Hi: 'अस्वीकार करना',
        Ta: 'மறுக்கவும்',
        Ja: '拒否',
        Ge: 'Leugnen',
      },
      OIAL02: {
        En: 'Reason of Denial',
        Et: 'Keeldumise põhjus',
        Ar: 'سبب الرفض',
        Ml: 'നിരസിക്കാനുള്ള കാരണം',
        Ma: 'नकाराचे कारण',
        Fr: 'Raison du refus',
        Hi: 'इनकार का कारण',
        Ta: 'மறுப்புக்கான காரணம்',
        Ja: '拒否の理由',
        Ge: 'Ablehnungsgrund',
      },
      OIAL03: {
        En: 'Comments',
        Et: 'Kommentaarid',
        Ar: 'تعليقات',
        Ml: 'അഭിപ്രായങ്ങൾ',
        Ma: 'टिप्पण्या',
        Fr: 'commentaires',
        Hi: 'टिप्पणियाँ',
        Ta: 'கருத்துகள்',
        Ja: 'コメント',
        Ge: 'Kommentare',
      },
      OIATB01: {
        En: 'Please Specify a reason',
        Et: 'Palun täpsustage põhjus',
        Ar: 'يرجى تحديد سبب',
        Ml: 'ദയവായി ഒരു കാരണം വ്യക്തമാക്കുക',
        Ma: 'कृपया कारण निर्दिष्ट करा',
        Fr: 'Veuillez spécifier une raison',
        Hi: 'कृपया कोई कारण बताएं',
        Ta: 'தயவுசெய்து காரணத்தைக் குறிப்பிடவும்',
        Ja: '理由を指定してください',
        Ge: 'Bitte geben Sie einen Grund an',
      },
      OIAL04: {
        En: 'Reasons',
        Et: 'Põhjused',
        Ar: 'الأسباب',
        Ml: 'കാരണങ്ങൾ',
        Ma: 'कारणे',
        Fr: 'Les raisons',
        Hi: 'कारणों',
        Ta: 'காரணங்கள்',
        Ja: '理由',
        Ge: 'Gründe dafür',
      },
      OIADD01: {
        En: 'Reasons box',
        Et: 'Põhjuste kast',
        Ar: 'مربع الأسباب',
        Ml: 'കാരണങ്ങൾ ബോക്സ്',
        Ma: 'कारणे बॉक्स',
        Fr: 'Boîte de raisons',
        Hi: 'कारण बॉक्स',
        Ta: 'காரணங்கள் பெட்டி',
        Ja: '理由ボックス',
        Ge: 'Box Gründe',
      },
      OIAB07: {
        En: 'cancel',
        Et: 'tühistada',
        Ar: 'إلغاء',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Abbrechen',
      },
      OIAB08: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    Level3OrdersInwardPickerAssign: {
      OIAPL01: {
        En: 'ASSIGN PICKER',
        Et: 'MÄÄRAMINE VALIJA',
        Ar: 'منتقي التعيين',
        Ml: 'പിക്കർ നിയോഗിക്കുക',
        Ma: 'निवडक नियुक्त करा',
        Fr: "SÉLECTIONNEUR D'AFFECTATION",
        Hi: 'पिकर असाइन करें',
        Ta: 'பிக்கரை ஒதுக்கவும்',
        Ja: '割り当てピッカー',
        Ge: 'AUSWAHL ZUWEISEN',
      },
      OIAPL02: {
        En: 'Picker Name',
        Et: 'Valija nimi',
        Ar: 'اسم المنتقي',
        Ml: 'പിക്കർ പേര്',
        Ma: 'निवडक नाव',
        Fr: 'Nom du sélecteur',
        Hi: 'पिकर नाम',
        Ta: 'தேர்வு பெயர்',
        Ja: 'ピッカー名',
        Ge: 'Picker-Name',
      },
      OIAPDD01: {
        En: 'Select Picker Name',
        Et: 'Valige Valija nimi',
        Ar: 'حدد اسم المنتقي',
        Ml: 'പിക്കർ നാമം തിരഞ്ഞെടുക്കുക',
        Ma: 'निवडक नाव निवडा',
        Fr: 'Sélectionnez le nom du sélecteur',
        Hi: 'पिकर नाम चुनें',
        Ta: 'பிக்கர் பெயரைத் தேர்ந்தெடுக்கவும்',
        Ja: 'ピッカー名を選択',
        Ge: 'Wählen Sie Picker-Name aus',
      },
      OIAPL03: {
        En: 'Picker Phone No',
        Et: 'Valija telefoni nr',
        Ar: 'رقم هاتف المنتقي',
        Ml: 'പിക്കർ ഫോൺ നമ്പർ',
        Ma: 'पिकर फोन क्र',
        Fr: 'Numéro de téléphone du sélecteur',
        Hi: 'पिकर फोन नंबर',
        Ta: 'பிக்கர் தொலைபேசி எண்',
        Ja: 'ピッカー電話番号',
        Ge: 'Picker-Telefonnr',
      },
      OIAPTB01: {
        En: 'Picker Phone No Box',
        Et: 'Valija telefoni karbita',
        Ar: 'منتقي الهاتف لا يوجد صندوق',
        Ml: 'പിക്കർ ഫോൺ നമ്പർ ബോക്സ്',
        Ma: 'पिकर फोन नंबर बॉक्स',
        Fr: 'Sélecteur de téléphone sans boîte',
        Hi: 'पिकर फोन नंबर बॉक्स',
        Ta: 'பிக்கர் தொலைபேசி எண் பெட்டி',
        Ja: 'ピッカー電話ボックスなし',
        Ge: 'Picker-Telefon keine Box',
      },
      OIAPB01: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      OIAPB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      OIAPB03: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
    },

    Level3OrdersInwardMoveToVault: {
      OIMST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      OIMTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      OIMTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      OIMTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      OIMTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      OIMTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      OIMTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      OIMTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      OIMTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      OIMTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      OIMTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      OIMB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      OIMB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      OIML01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      OIMCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      OIMB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      OIMB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      OIMB05: {
        En: 'Movement Complete',
        Et: 'Liikumine lõpetatud',
        Ar: 'اكتملت الحركة',
        Ml: 'ചലനം പൂർത്തിയായി',
        Ma: 'हालचाल पूर्ण',
        Fr: 'Mouvement terminé',
        Hi: 'आंदोलन पूर्ण',
        Ta: 'இயக்கம் முடிந்தது',
        Ja: '移動完了',
        Ge: 'Bewegung abgeschlossen',
      },
    },

    Level3OrdersReportsReceived: {
      ORRST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      ORRTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      ORRTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      ORRTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      ORRTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      ORRTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      ORRTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      ORRTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      ORRTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      ORRTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      ORRTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      ORRB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      ORRB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      ORRL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      ORRCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      ORRB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      ORRB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      ORRC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      ORRC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      ORRC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      ORRC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3OrdersReportsWaitingforApproval: {
      ORWAST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      ORWATH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      ORWATH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      ORWATH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      ORWATH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      ORWATH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      ORWATH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      ORWATH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      ORWATH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      ORWATH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      ORWATH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      ORWAB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      ORWAB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      ORWAL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      ORWACL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      ORWAB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      ORWAB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      ORWAC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      ORWAC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      ORWAC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      ORWAC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3OrdersReportsApproved: {
      ORAST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      ORATH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      ORATH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      ORATH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      ORATH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      ORATH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      ORATH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      ORATH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      ORATH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      ORATH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      ORATH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      ORAB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      ORAB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      ORAL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      ORACL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      ORAB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      ORAB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      ORAC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      ORAC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      ORAC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      ORAC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3OrdersReportsInProgress: {
      ORIPST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      ORIPTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      ORIPTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      ORIPTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      ORIPTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      ORIPTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      ORIPTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      ORIPTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      ORIPTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      ORIPTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      ORIPTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      ORIPB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      ORIPB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      ORIPL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      ORIPCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      ORIPB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      ORIPB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      ORIPC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      ORIPC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      ORIPC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      ORIPC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3OrdersReportsReady: {
      ORRST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      ORRTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      ORRTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      ORRTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      ORRTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      ORRTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      ORRTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      ORRTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      ORRTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      ORRTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      ORRTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      ORRB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      ORRB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      ORRL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      ORRCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      ORRB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      ORRB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      ORRC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      ORRC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      ORRC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      ORRC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3OrdersReportsDelivered: {
      ORDST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      ORDTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      ORDTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      ORDTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      ORDTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      ORDTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      ORDTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      ORDTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      ORDTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      ORDTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      ORDTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      ORDB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      ORDB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      ORDL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      ORDCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      ORDB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      ORDB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      ORDC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      ORDC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      ORDC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      ORDC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3OrdersReportsReturned: {
      ORRST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      ORRTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      ORRTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      ORRTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      ORRTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      ORRTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      ORRTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      ORRTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      ORRTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      ORRTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      ORRTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      ORRB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      ORRB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      ORRL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      ORRCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      ORRB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      ORRB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      ORRC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      ORRC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      ORRC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      ORRC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningFilmPictureCatalog: {
      PPFPCST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPFPCTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPFPCTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPFPCTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPFPCTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPFPCTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPFPCTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPFPCTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPFPCTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPFPCTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPFPCTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPFPCB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPFPCB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPFPCL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPFPCCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPFPCB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPFPCB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPFPCC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPFPCC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPFPCC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPFPCC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningFilmPictureDigitization: {
      PPFPDST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPFPDTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPFPDTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPFPDTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPFPDTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPFPDTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPFPDTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPFPDTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPFPDTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPFPDTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPFPDTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPFPDB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPFPDB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPFPDL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPFPDCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPFPDB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPFPDB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPFPDC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPFPDC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPFPDC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPFPDC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningFilmPictureRestoration: {
      PPFPRST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPFPRTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPFPRTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPFPRTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPFPRTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPFPRTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPFPRTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPFPRTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPFPRTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPFPRTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPFPRTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPFPRB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPFPRB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPFPRL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPFPRCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPFPRB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPFPRB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPFPRC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPFPRC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPFPRC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPFPRC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningFilmPictureReview: {
      PPFPRST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPFPRTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPFPRTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPFPRTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPFPRTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPFPRTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPFPRTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPFPRTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPFPRTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPFPRTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPFPRTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPFPRB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPFPRB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPFPRL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPFPRCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPFPRB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPFPRB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPFPRC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPFPRC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPFPRC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPFPRC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningFilmPictureArchive: {
      PPFPAST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPFPATH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPFPATH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPFPATH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPFPATH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPFPATH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPFPATH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPFPATH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPFPATH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPFPATH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPFPATH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPFPAB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPFPAB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPFPAL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPFPACL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPFPAB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPFPAB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPFPAC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPFPAC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPFPAC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPFPAC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningFilmPictureAccess: {
      PPFPAST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPFPATH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPFPATH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPFPATH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPFPATH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPFPATH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPFPATH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPFPATH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPFPATH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPFPATH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPFPATH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPFPAB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPFPAB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPFPAL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPFPACL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPFPAB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPFPAB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPFPAC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPFPAC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPFPAC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPFPAC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningTapeCatalog: {
      PPTCST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPTCTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPTCTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPTCTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPTCTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPTCTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPTCTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPTCTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPTCTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPTCTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPTCTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPTCB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPTCB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPTCL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPTCCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPTCB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPTCB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPTCC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPTCC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPTCC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPTCC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningTapeDigitization: {
      PPTDST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPTDTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPTDTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPTDTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPTDTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPTDTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPTDTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPTDTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPTDTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPTDTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPTDTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPTDB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPTDB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPTDL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPTDCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPTDB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPTDB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPTDC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPTDC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPTDC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPTDC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningTapeRestoration: {
      PPTRST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPTRTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPTRTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPTRTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPTRTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPTRTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPTRTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPTRTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPTRTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPTRTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPTRTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPTRB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPTRB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPTRL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPTRCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPTRB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPTRB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPTRC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPTRC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPTRC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPTRC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningTapeReview: {
      PPTRST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPTRTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPTRTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPTRTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPTRTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPTRTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPTRTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPTRTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPTRTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPTRTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPTRTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPTRB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPTRB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPTRL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPTRCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPTRB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPTRB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPTRC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPTRC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPTRC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPTRC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningTapeArchive: {
      PPTAST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPTATH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPTATH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPTATH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPTATH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPTATH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPTATH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPTATH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPTATH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPTATH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPTATH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPTAB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPTAB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPTAL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPTACL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPTAB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPTAB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPTAC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPTAC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPTAC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPTAC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningTapeAccess: {
      PPTAST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPTATH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPTATH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPTATH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPTATH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPTATH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPTATH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPTATH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPTATH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPTATH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPTATH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPTAB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPTAB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPTAL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPTACL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPTAB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPTAB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPTAC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPTAC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPTAC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPTAC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningFilmAudioCatalog: {
      PPFACST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPFACTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPFACTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPFACTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPFACTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPFACTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPFACTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPFACTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPFACTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPFACTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPFACTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPFACB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPFACB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPFACL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPFACCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPFACB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPFACB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPFACC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPFACC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPFACC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPFACC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningFilmAudioDigitization: {
      PPFADST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPFADTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPFADTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPFADTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPFADTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPFADTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPFADTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPFADTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPFADTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPFADTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPFADTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPFADB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPFADB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPFADL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPFADCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPFADB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPFADB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPFADC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPFADC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPFADC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPFADC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningFilmAudioRestoration: {
      PPFARST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPFARTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPFARTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPFARTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPFARTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPFARTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPFARTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPFARTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPFARTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPFARTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPFARTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPFARB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPFARB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPFARL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPFARCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPFARB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPFARB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPFARC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPFARC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPFARC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPFARC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningFilmAudioReview: {
      PPFARST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPFARTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPFARTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPFARTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPFARTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPFARTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPFARTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPFARTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPFARTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPFARTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPFARTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPFARB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPFARB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPFARL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPFARCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPFARB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPFARB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPFARC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPFARC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPFARC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPFARC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningFilmAudioArchive: {
      PPFAAST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPFAATH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPFAATH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPFAATH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPFAATH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPFAATH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPFAATH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPFAATH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPFAATH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPFAATH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPFAATH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPFAAB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPFAAB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPFAAL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPFAACL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPFAAB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPFAAB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPFAAC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPFAAC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPFAAC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPFAAC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningFilmAudioAccess: {
      PPFAAST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPFAATH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPFAATH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPFAATH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPFAATH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPFAATH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPFAATH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPFAATH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPFAATH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPFAATH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPFAATH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPFAAB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPFAAB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPFAAL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPFAACL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPFAAB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPFAAB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPFAAC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPFAAC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPFAAC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPFAAC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningPhotographCatalog: {
      PPPCST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPPCTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPPCTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPPCTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPPCTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPPCTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPPCTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPPCTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPPCTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPPCTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPPCTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPPCB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPPCB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPPCL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPPCCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPPCB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPPCB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPPCC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPPCC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPPCC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPPCC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningPhotographDigitization: {
      PPPDST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPPDTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPPDTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPPDTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPPDTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPPDTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPPDTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPPDTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPPDTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPPDTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPPDTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPPDB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPPDB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPPDL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPPDCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPPDB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPPDB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPPDC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPPDC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPPDC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPPDC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningPhotographRestoration: {
      PPPRST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPPRTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPPRTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPPRTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPPRTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPPRTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPPRTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPPRTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPPRTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPPRTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPPRTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPPRB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPPRB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPPRL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPPRCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPPRB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPPRB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPPRC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPPRC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPPRC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPPRC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningPhotographReview: {
      PPPRST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPPRTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPPRTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPPRTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPPRTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPPRTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPPRTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPPRTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPPRTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPPRTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPPRTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPPRB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPPRB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPPRL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPPRCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPPRB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPPRB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPPRC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPPRC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPPRC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPPRC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningPhotographArchive: {
      PPPAST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPPATH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPPATH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPPATH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPPATH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPPATH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPPATH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPPATH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPPATH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPPATH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPPATH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPPAB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPPAB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPPAL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPPACL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPPAB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPPAB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPPAC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPPAC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPPAC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPPAC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningPhotographAccess: {
      PPPAST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPPATH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPPATH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPPATH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPPATH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPPATH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPPATH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPPATH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPPATH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPPATH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPPATH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPPAB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPPAB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPPAL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPPACL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPPAB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPPAB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPPAC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPPAC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPPAC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPPAC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningDocumentCatalog: {
      PPDCST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPDCTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPDCTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPDCTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPDCTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPDCTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPDCTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPDCTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPDCTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPDCTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPDCTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPDCB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPDCB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPDCL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPDCCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPDCB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPDCB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPDCC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPDCC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPDCC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPDCC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningDocumentDigitization: {
      PPDDST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPDDTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPDDTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPDDTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPDDTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPDDTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPDDTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPDDTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPDDTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPDDTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPDDTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPDDB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPDDB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPDDL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPDDCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPDDB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPDDB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPDDC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPDDC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPDDC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPDDC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningDocumentRestoration: {
      PPDRST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPDRTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPDRTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPDRTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPDRTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPDRTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPDRTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPDRTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPDRTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPDRTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPDRTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPDRB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPDRB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPDRL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPDRCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPDRB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPDRB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPDRC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPDRC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPDRC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPDRC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningDocumentReview: {
      PPDRST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPDRTH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPDRTH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPDRTH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPDRTH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPDRTH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPDRTH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPDRTH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPDRTH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPDRTH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPDRTH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPDRB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPDRB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPDRL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPDRCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPDRB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPDRB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPDRC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPDRC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPDRC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPDRC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningDocumentArchive: {
      PPDAST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPDATH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPDATH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPDATH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPDATH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPDATH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPDATH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPDATH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPDATH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPDATH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPDATH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPDAB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPDAB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPDAL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPDACL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPDAB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPDAB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPDAC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPDAC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPDAC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPDAC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Level3ProductionPlanningDocumentAccess: {
      PPDAST01: {
        En: 'Search',
        Et: 'Otsing',
        Ar: 'يبحث',
        Ml: 'തിരയുക',
        Ma: 'शोधा',
        Fr: 'Chercher',
        Hi: 'खोज',
        Ta: 'தேடு',
        Ja: '探す',
        Ge: 'Suche',
      },
      PPDATH01: {
        En: 'Film title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      PPDATH02: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      PPDATH03: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      PPDATH04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      PPDATH05: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      PPDATH06: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      PPDATH07: {
        En: 'Order Tracking Status',
        Et: 'Tellimuse jälgimise olek',
        Ar: 'حالة تتبع الطلب',
        Ml: 'ഓർഡർ ട്രാക്കിംഗ് സ്റ്റാറ്റസ്',
        Ma: 'ऑर्डर ट्रॅकिंग स्थिती',
        Fr: 'État du suivi de la commande',
        Hi: 'आदेश ट्रैकिंग स्थिति',
        Ta: 'ஆர்டர் கண்காணிப்பு நிலை',
        Ja: '注文追跡ステータス',
        Ge: 'Auftragsverfolgungsstatus',
      },
      PPDATH08: {
        En: 'Asset Tracking Status',
        Et: 'Varade jälgimise olek',
        Ar: 'حالة تتبع الأصول',
        Ml: 'അസറ്റ് ട്രാക്കിംഗ് നില',
        Ma: 'मालमत्ता ट्रॅकिंग स्थिती',
        Fr: 'État du suivi des actifs',
        Hi: 'एसेट ट्रैकिंग स्थिति',
        Ta: 'சொத்து கண்காணிப்பு நிலை',
        Ja: '資産追跡ステータス',
        Ge: 'Asset-Tracking-Status',
      },
      PPDATH09: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      PPDATH10: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      PPDAB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      PPDAB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      PPDAL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      PPDACL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      PPDAB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      PPDAB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      PPDAC01: {
        En: 'Horizontal Chart',
        Et: 'Horisontaalne diagramm',
        Ar: 'مخطط أفقي',
        Ml: 'തിരശ്ചീന ചാർട്ട്',
        Ma: 'क्षैतिज चार्ट',
        Fr: 'Graphique horizontal',
        Hi: 'क्षैतिज चार्ट',
        Ta: 'கிடைமட்ட விளக்கப்படம்',
        Ja: '水平チャート',
        Ge: 'Horizontales Diagramm',
      },
      PPDAC02: {
        En: 'Line Chart',
        Et: 'Joonediagramm',
        Ar: 'خط الرسم البياني',
        Ml: 'ലൈൻ ചാർട്ട്',
        Ma: 'रेखा चार्ट',
        Fr: 'Graphique en ligne',
        Hi: 'पंक्ति चार्ट',
        Ta: 'வரி விளக்கப்படம்',
        Ja: '折れ線グラフ',
        Ge: 'Liniendiagramm',
      },
      PPDAC03: {
        En: 'Stacked Bar Chart',
        Et: 'Virnastatud tulpdiagramm',
        Ar: 'مخطط شريطي مكدس',
        Ml: 'അടുക്കിയ ബാർ ചാർട്ട്',
        Ma: 'स्टॅक केलेला बार चार्ट',
        Fr: 'Graphique à barres empilées',
        Hi: 'स्टैक्ड बार चार्ट',
        Ta: 'அடுக்கப்பட்ட பட்டை விளக்கப்படம்',
        Ja: '積み上げ棒グラフ',
        Ge: 'Gestapeltes Balkendiagramm',
      },
      PPDAC04: {
        En: 'Pie Chart',
        Et: 'Sektordiagramm',
        Ar: 'مخطط دائري',
        Ml: 'പൈ ചാർട്ട്',
        Ma: 'पाई चार्ट',
        Fr: 'Diagramme circulaire',
        Hi: 'पाई चार्ट',
        Ta: 'பை விளக்கப்படம்',
        Ja: '円グラフ',
        Ge: 'Kuchendiagramm',
      },
    },

    Board: {
      BH01: {
        En: 'Board',
        Ar: 'مجلس',
        Ml: 'ബോർഡ്',
        Fr: 'Planche',
        Hi: 'पटल',
        Ta: 'பலகை',
        Ja: 'ボード',
        Ge: 'Tafel',
      },
    },

    VAULTMASTERRegisterVault: {
      VMRVL01: {
        En: 'VAULT MASTER',
        Et: 'VAULT MEISTER',
        Ar: 'VAULT MASTER',
        Ml: 'വോൾട്ട് മാസ്റ്റർ',
        Ma: 'वॉल्ट मास्टर',
        Fr: 'MAÎTRE DE LA CAISSE',
        Hi: 'तिजोरी मास्टर',
        Ta: 'வால்ட் மாஸ்டர்',
        Ja: 'ボールトマスター',
        Ge: 'Tresormeister',
      },
      VMRVL02: {
        En: 'Vault Name',
        Et: 'Võlvi nimi',
        Ar: 'اسم قبو',
        Ml: 'നിലവറയുടെ പേര്',
        Ma: 'व्हॉल्ट नाव',
        Fr: 'Nom de la voûte',
        Hi: 'तिजोरी का नाम',
        Ta: 'பெட்டகத்தின் பெயர்',
        Ja: 'ボールト名',
        Ge: 'Tresorname',
      },
      VMRVTB01: {
        En: 'Enter Vault Name',
        Et: 'Sisestage Vault Name',
        Ar: 'أدخل اسم Vault',
        Ml: 'നിലവറയുടെ പേര് നൽകുക',
        Ma: 'व्हॉल्टचे नाव एंटर करा',
        Fr: 'Entrez le nom du coffre-fort',
        Hi: 'तिजोरी का नाम दर्ज करें',
        Ta: 'வால்ட் பெயரை உள்ளிடவும்',
        Ja: 'ボールト名を入力',
        Ge: 'Geben Sie den Tresornamen ein',
      },
      VMRVL03: {
        En: 'Vault Code',
        Et: 'Vault Code',
        Ar: 'كود Vault',
        Ml: 'വോൾട്ട് കോഡ്',
        Ma: 'व्हॉल्ट कोड',
        Fr: 'Code de coffre-fort',
        Hi: 'तिजोरी कोड',
        Ta: 'வால்ட் குறியீடு',
        Ja: '金庫コード',
        Ge: 'Vault-Code',
      },
      VMRVTB02: {
        En: 'Enter Vault Code',
        Et: 'Sisestage Vault Code',
        Ar: 'أدخل رمز Vault',
        Ml: 'വോൾട്ട് കോഡ് നൽകുക',
        Ma: 'व्हॉल्ट कोड एंटर करा',
        Fr: 'Entrez le code du coffre-fort',
        Hi: 'तिजोरी कोड दर्ज करें',
        Ta: 'வால்ட் குறியீட்டை உள்ளிடவும்',
        Ja: '保管庫コードを入力してください',
        Ge: 'Tresorcode eingeben',
      },
      VMRVL04: {
        En: 'Country',
        Et: 'Riik',
        Ar: 'دولة',
        Ml: 'രാജ്യം',
        Ma: 'देश',
        Fr: 'Pays',
        Hi: 'देश',
        Ta: 'நாடு',
        Ja: '国',
        Ge: 'Land',
      },
      VMRVTB03: {
        En: 'Enter Country',
        Et: 'Sisesta riik',
        Ar: 'أدخل الدولة',
        Ml: 'രാജ്യത്ത് പ്രവേശിക്കുക',
        Ma: 'देश प्रविष्ट करा',
        Fr: 'Entrez le pays',
        Hi: 'देश दर्ज करें',
        Ta: 'நாட்டிற்குள் நுழையுங்கள்',
        Ja: '国を入力してください',
        Ge: 'Land eingeben',
      },
      VMRVL05: {
        En: 'GPS Location',
        Et: 'GPS-i asukoht',
        Ar: 'موقع GPS',
        Ml: 'ജിപിഎസ് സ്ഥാനം',
        Ma: 'GPS स्थान',
        Fr: 'Localisation GPS',
        Hi: 'जीपीएस स्थान',
        Ta: 'ஜிபிஎஸ் இடம்',
        Ja: 'GPSの位置',
        Ge: 'GPS-Standort',
      },
      VMRVTB04: {
        En: 'Enter GPS Location',
        Et: 'Sisestage GPS-i asukoht',
        Ar: 'أدخل موقع GPS',
        Ml: 'GPS ലൊക്കേഷൻ നൽകുക',
        Ma: 'GPS स्थान प्रविष्ट करा',
        Fr: 'Entrer la position GPS',
        Hi: 'जीपीएस स्थान दर्ज करें',
        Ta: 'GPS இருப்பிடத்தை உள்ளிடவும்',
        Ja: 'GPS 位置情報を入力',
        Ge: 'Geben Sie den GPS-Standort ein',
      },
      VMRVL06: {
        En: 'Contact Person Name',
        Et: 'Kontaktisiku nimi',
        Ar: 'اسم شخص الاتصال',
        Ml: 'ബന്ധപ്പെടാനുള്ള വ്യക്തിയുടെ പേര്',
        Ma: 'संपर्क व्यक्तीचे नाव',
        Fr: "nom de contacte d'une personne",
        Hi: 'संपर्क व्यक्ति का नाम',
        Ta: 'தொடர்பு நபர் பெயர்',
        Ja: '担当者名',
        Ge: 'Kontaktperson Name',
      },
      VMRVTB05: {
        En: 'Enter Contact Person Name',
        Et: 'Sisestage kontaktisiku nimi',
        Ar: 'أدخل اسم جهة الاتصال',
        Ml: 'ബന്ധപ്പെടാനുള്ള വ്യക്തിയുടെ പേര് നൽകുക',
        Ma: 'संपर्क व्यक्तीचे नाव प्रविष्ट करा',
        Fr: 'Entrez le nom de la personne à contacter',
        Hi: 'संपर्क व्यक्ति का नाम दर्ज करें',
        Ta: 'தொடர்பு நபரின் பெயரை உள்ளிடவும்',
        Ja: '担当者名を入力',
        Ge: 'Geben Sie den Namen der Kontaktperson ein',
      },
      VMRVL07: {
        En: 'Contact Person Phone',
        Et: 'Kontaktisiku telefon',
        Ar: 'هاتف الشخص المسؤول',
        Ml: 'വ്യക്തിയുടെ ഫോൺ ബന്ധപ്പെടുക',
        Ma: 'संपर्क व्यक्ती फोन',
        Fr: 'Téléphone de la personne à contacter',
        Hi: 'संपर्क व्यक्ति फोन',
        Ta: 'தொடர்பு நபரின் தொலைபேசி',
        Ja: '担当者の電話番号',
        Ge: 'Ansprechpartner Tel',
      },
      VMRVTB06: {
        En: 'Enter Contact Person Phone',
        Et: 'Sisestage kontaktisiku telefon',
        Ar: 'أدخل رقم هاتف جهة الاتصال',
        Ml: 'ബന്ധപ്പെടാനുള്ള വ്യക്തിയുടെ ഫോൺ നൽകുക',
        Ma: 'संपर्क व्यक्तीचा फोन प्रविष्ट करा',
        Fr: 'Entrer le téléphone de la personne à contacter',
        Hi: 'संपर्क व्यक्ति फोन दर्ज करें',
        Ta: 'தொடர்பு நபரின் தொலைபேசியை உள்ளிடவும்',
        Ja: '担当者の電話番号を入力してください',
        Ge: 'Geben Sie die Telefonnummer der Kontaktperson ein',
      },
      VMRVB01: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      VMRVB02: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      VMRVB03: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
    },

    VAULTMASTERViewVault: {
      VMVVL01: {
        En: 'VIEW VAULT',
        Et: 'VAATA VAULT',
        Ar: 'عرض الخزنة',
        Ml: 'വോൾട്ട് കാണുക',
        Ma: 'वॉल्ट पहा',
        Fr: 'VOIR LE COFFRE-FORT',
        Hi: 'तिजोरी देखें',
        Ta: 'வால்ட் பார்க்கவும்',
        Ja: 'ボールトを表示',
        Ge: 'Tresor anzeigen',
      },
      VMVVTH01: {
        En: 'Vault Name',
        Et: 'Võlvi nimi',
        Ar: 'اسم قبو',
        Ml: 'നിലവറയുടെ പേര്',
        Ma: 'व्हॉल्ट नाव',
        Fr: 'Nom de la voûte',
        Hi: 'तिजोरी का नाम',
        Ta: 'பெட்டகத்தின் பெயர்',
        Ja: 'ボールト名',
        Ge: 'Tresorname',
      },
      VMVVTH02: {
        En: 'Vault Code',
        Et: 'Vault Code',
        Ar: 'كود Vault',
        Ml: 'വോൾട്ട് കോഡ്',
        Ma: 'व्हॉल्ट कोड',
        Fr: 'Code de coffre-fort',
        Hi: 'तिजोरी कोड',
        Ta: 'வால்ட் குறியீடு',
        Ja: '金庫コード',
        Ge: 'Vault-Code',
      },
      VMVVTH03: {
        En: 'Country',
        Et: 'Riik',
        Ar: 'دولة',
        Ml: 'രാജ്യം',
        Ma: 'देश',
        Fr: 'Pays',
        Hi: 'देश',
        Ta: 'நாடு',
        Ja: '国',
        Ge: 'Land',
      },
      VMVVTH04: {
        En: 'GPS Location',
        Et: 'GPS-i asukoht',
        Ar: 'موقع GPS',
        Ml: 'ജിപിഎസ് സ്ഥാനം',
        Ma: 'GPS स्थान',
        Fr: 'Localisation GPS',
        Hi: 'जीपीएस स्थान',
        Ta: 'ஜிபிஎஸ் இடம்',
        Ja: 'GPSの位置',
        Ge: 'GPS-Standort',
      },
      VMVVTH05: {
        En: 'Contact Person',
        Et: 'Kontaktisik',
        Ar: 'الشخص الذي يمكن الاتصال به',
        Ml: 'ബന്ധപ്പെടേണ്ട വ്യക്തി',
        Ma: 'संपर्क व्यक्ती',
        Fr: 'Personne de contact',
        Hi: 'संपर्क व्यक्ति',
        Ta: 'தொடர்பு நபர்',
        Ja: '連絡窓口',
        Ge: 'Gesprächspartner',
      },
      VMVVTH06: {
        En: 'Phone Number',
        Et: 'Telefoninumber',
        Ar: 'رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ',
        Ma: 'फोन नंबर',
        Fr: 'Numéro de téléphone',
        Hi: 'फ़ोन नंबर',
        Ta: 'தொலைபேசி எண்',
        Ja: '電話番号',
        Ge: 'Telefonnummer',
      },
      VMVVB01: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      VMVVB02: {
        En: 'Delete',
        Et: 'Kustuta',
        Ar: 'حذف',
        Ml: 'ഇല്ലാതാക്കുക',
        Ma: 'हटवा',
        Fr: 'Effacer',
        Hi: 'मिटाना',
        Ta: 'அழி',
        Ja: '消去',
        Ge: 'Löschen',
      },
    },

    DEVICEMASTERRegisterDevice: {
      DMRDL01: {
        En: 'DEVICE MASTER',
        Et: 'SEADME MEISTER',
        Ar: 'رئيس الجهاز',
        Ml: 'ഉപകരണ മാസ്റ്റർ',
        Ma: 'डिव्हाइस मास्टर',
        Fr: 'APPAREIL MAÎTRE',
        Hi: 'डिवाइस मास्टर',
        Ta: 'டிவைஸ் மாஸ்டர்',
        Ja: 'デバイスマスター',
        Ge: 'GERÄTEMASTER',
      },
      DMRDL02: {
        En: 'Device Type',
        Et: 'Seadme tüüp',
        Ar: 'نوع الجهاز',
        Ml: 'ഉപകരണ തരം',
        Ma: 'डिव्हाइस प्रकार',
        Fr: "Type d'appareil",
        Hi: 'उपकरण का प्रकार',
        Ta: 'கருவியின் வகை',
        Ja: 'デバイスタイプ',
        Ge: 'Gerätetyp',
      },
      DMRDDD01: {
        En: 'Select Device Type',
        Et: 'Valige Seadme tüüp',
        Ar: 'حدد نوع الجهاز',
        Ml: 'ഉപകരണ തരം തിരഞ്ഞെടുക്കുക',
        Ma: 'डिव्हाइस प्रकार निवडा',
        Fr: "Sélectionnez le type d'appareil",
        Hi: 'डिवाइस प्रकार चुनें',
        Ta: 'சாதன வகையைத் தேர்ந்தெடுக்கவும்',
        Ja: 'デバイスの種類を選択',
        Ge: 'Wählen Sie Gerätetyp',
      },
      DMRDL03: {
        En: 'Vault',
        Et: 'Vault',
        Ar: 'قبو',
        Ml: 'നിലവറ',
        Ma: 'तिजोरी',
        Fr: 'Sauter',
        Hi: 'मेहराब',
        Ta: 'வால்ட்',
        Ja: 'ボールト',
        Ge: 'Gewölbe',
      },
      DMRDDD02: {
        En: 'select Vault',
        Et: 'valige Vault',
        Ar: 'حدد Vault',
        Ml: 'Vault തിരഞ്ഞെടുക്കുക',
        Ma: 'Vault निवडा',
        Fr: 'sélectionnez le coffre-fort',
        Hi: 'तिजोरी का चयन करें',
        Ta: 'வால்ட்டைத் தேர்ந்தெடுக்கவும்',
        Ja: 'ボールトを選択',
        Ge: 'Wählen Sie Tresor aus',
      },
      DMRDL04: {
        En: 'Physical Location',
        Et: 'Füüsiline asukoht',
        Ar: 'الموقع المادي',
        Ml: 'ഫിസിക്കൽ ലൊക്കേഷൻ',
        Ma: 'भौतिक स्थान',
        Fr: 'Emplacement physique',
        Hi: 'भौतिक स्थान',
        Ta: 'உடல் இருப்பிடம்',
        Ja: '物理的な位置',
        Ge: 'Physischer Standort',
      },
      DMRDDD03: {
        En: 'Select Location',
        Et: 'Valige Asukoht',
        Ar: 'اختر موقعا',
        Ml: 'ലൊക്കേഷൻ തിരഞ്ഞെടുക്കുക',
        Ma: 'स्थान निवडा',
        Fr: "Sélectionnez l'emplacement",
        Hi: 'स्थान चुनें',
        Ta: 'இருப்பிடத்தைத் தேர்ந்தெடுக்கவும்',
        Ja: '場所を選択',
        Ge: 'Ort auswählen',
      },
      DMRDL05: {
        En: 'Reader IP',
        Et: 'Lugeja IP',
        Ar: 'IP القارئ',
        Ml: 'റീഡർ ഐ.പി',
        Ma: 'वाचक आयपी',
        Fr: 'IP du lecteur',
        Hi: 'पाठक आईपी',
        Ta: 'ரீடர் ஐபி',
        Ja: 'リーダー IP',
        Ge: 'Leser-IP',
      },
      DMRDTB01: {
        En: 'Reader IP Box',
        Et: 'Lugeja IP Box',
        Ar: 'قارئ IP Box',
        Ml: 'റീഡർ ഐപി ബോക്സ്',
        Ma: 'वाचक आयपी बॉक्स',
        Fr: 'Boîtier IP lecteur',
        Hi: 'रीडर आईपी बॉक्स',
        Ta: 'ரீடர் ஐபி பாக்ஸ்',
        Ja: 'リーダー IP ボックス',
        Ge: 'Leser-IP-Box',
      },
      DMRDL06: {
        En: 'Port No.',
        Et: 'sadam nr.',
        Ar: 'رقم المنفذ.',
        Ml: 'പോർട്ട് നമ്പർ.',
        Ma: 'पोर्ट क्र.',
        Fr: 'n° de port',
        Hi: 'बंदरगाह संख्या',
        Ta: 'துறைமுக எண்.',
        Ja: 'ポート番号',
        Ge: 'Port-Nr.',
      },
      DMRDTB02: {
        En: 'Port number',
        Et: 'Pordi number',
        Ar: 'رقم المنفذ',
        Ml: 'പോർട്ട് നമ്പർ',
        Ma: 'पोर्ट क्रमांक',
        Fr: 'Numéro de port',
        Hi: 'पोर्ट संख्या',
        Ta: 'போர்ட் எண்',
        Ja: 'ポート番号',
        Ge: 'Port-Nummer',
      },
      DMRDB01: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      DMRDB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      DMRDB03: {
        En: 'Create',
        Et: 'Loo',
        Ar: 'خلق',
        Ml: 'സൃഷ്ടിക്കാൻ',
        Ma: 'तयार करा',
        Fr: 'Créer',
        Hi: 'सृजन करना',
        Ta: 'உருவாக்கு',
        Ja: '作成',
        Ge: 'Schaffen',
      },
    },

    DEVICEMASTERViewDevice: {
      DMVDL01: {
        En: 'DEVICES',
        Et: 'SEADMED',
        Ar: 'الأجهزة',
        Ml: 'ഉപകരണങ്ങൾ',
        Ma: 'डिव्हाइसेस',
        Fr: 'DISPOSITIFS',
        Hi: 'उपकरण',
        Ta: 'சாதனங்கள்',
        Ja: 'デバイス',
        Ge: 'GERÄTE',
      },
      DMVDTH01: {
        En: 'SNo',
        Et: 'SNo',
        Ar: 'SNo',
        Ml: 'SNo',
        Ma: 'SNo',
        Fr: 'SNon',
        Hi: 'एसएनओ',
        Ta: 'SNo',
        Ja: 'S番号',
        Ge: 'SNr',
      },
      DMVDTH02: {
        En: 'DeviceType',
        Et: 'Seadme tüüp',
        Ar: 'نوع الجهاز',
        Ml: 'ഉപകരണ തരം',
        Ma: 'डिव्हाइस प्रकार',
        Fr: "Type d'appareil",
        Hi: 'उपकरण का प्रकार',
        Ta: 'கருவியின் வகை',
        Ja: 'デバイスタイプ',
        Ge: 'Gerätetyp',
      },
      DMVDTH03: {
        En: 'Vault',
        Et: 'Vault',
        Ar: 'قبو',
        Ml: 'നിലവറ',
        Ma: 'तिजोरी',
        Fr: 'Sauter',
        Hi: 'मेहराब',
        Ta: 'வால்ட்',
        Ja: 'ボールト',
        Ge: 'Gewölbe',
      },
      DMVDTH04: {
        En: 'Location',
        Et: 'Asukoht',
        Ar: 'موقع',
        Ml: 'സ്ഥാനം',
        Ma: 'स्थान',
        Fr: 'Emplacement',
        Hi: 'स्थान',
        Ta: 'இடம்',
        Ja: '位置',
        Ge: 'Ort',
      },
      DMVDTH05: {
        En: 'ReaderIP',
        Et: 'ReaderIP',
        Ar: 'ReaderIP',
        Ml: 'ReaderIP',
        Ma: 'रीडरआयपी',
        Fr: 'ReaderIP',
        Hi: 'रीडरआईपी',
        Ta: 'ReaderIP',
        Ja: 'リーダーIP',
        Ge: 'ReaderIP',
      },
      DMVDTH06: {
        En: 'Port No',
        Et: 'Sadam nr.',
        Ar: 'رقم المنفذ',
        Ml: 'പോർട്ട് നമ്പർ.',
        Ma: 'बंदर क्र.',
        Fr: 'Numéro de port',
        Hi: 'पोर्ट नं.',
        Ta: 'துறைமுக எண்.',
        Ja: 'ポート番号',
        Ge: 'Port-Nr.',
      },
      DMVDTH07: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
    },

    SHELFRACKMASTERRegisterShelfRack: {
      SRMRL01: {
        En: 'SHELF/RACK MASTER',
        Et: 'RIIUL/RIIUL MASTER',
        Ar: 'الرف / الرف الرئيسي',
        Ml: 'ഷെൽഫ്/റാക്ക് മാസ്റ്റർ',
        Ma: 'शेल्फ/रॅक मास्टर',
        Fr: "MAÎTRE D'ÉTAGÈRE/RACK",
        Hi: 'शेल्फ / रैक मास्टर',
        Ta: 'ஷெல்ஃப்/ரேக் மாஸ்டர்',
        Ja: 'シェルフ/ラックマスター',
        Ge: 'REGAL-/REGAL-MASTER',
      },
      SRMRL02: {
        En: 'Vault Name',
        Et: 'Võlvi nimi',
        Ar: 'اسم قبو',
        Ml: 'നിലവറയുടെ പേര്',
        Ma: 'व्हॉल्ट नाव',
        Fr: 'Nom de la voûte',
        Hi: 'तिजोरी का नाम',
        Ta: 'பெட்டகத்தின் பெயர்',
        Ja: 'ボールト名',
        Ge: 'Tresorname',
      },
      SRMRDD01: {
        En: 'Select Vault Name',
        Et: 'Valige Vault Name',
        Ar: 'حدد اسم Vault',
        Ml: 'നിലവറയുടെ പേര് തിരഞ്ഞെടുക്കുക',
        Ma: 'व्हॉल्ट नाव निवडा',
        Fr: 'Sélectionnez le nom du coffre-fort',
        Hi: 'तिजोरी का नाम चुनें',
        Ta: 'வால்ட் பெயரைத் தேர்ந்தெடுக்கவும்',
        Ja: 'ボールト名を選択',
        Ge: 'Wählen Sie Tresorname aus',
      },
      SRMRL03: {
        En: 'Shelf Number',
        Et: 'Riiuli number',
        Ar: 'رقم الرف',
        Ml: 'ഷെൽഫ് നമ്പർ',
        Ma: 'शेल्फ क्रमांक',
        Fr: "Numéro d'étagère",
        Hi: 'शेल्फ नंबर',
        Ta: 'ஷெல்ஃப் எண்',
        Ja: '棚番号',
        Ge: 'Regalnummer',
      },
      SRMRTB01: {
        En: 'Shelf Number Box',
        Et: 'Riiuli numbrikast',
        Ar: 'صندوق رقم الجرف',
        Ml: 'ഷെൽഫ് നമ്പർ ബോക്സ്',
        Ma: 'शेल्फ नंबर बॉक्स',
        Fr: "Boîte de numéro d'étagère",
        Hi: 'शेल्फ नंबर बॉक्स',
        Ta: 'ஷெல்ஃப் எண் பெட்டி',
        Ja: '棚番ボックス',
        Ge: 'Regalnummer-Box',
      },
      SRMRL04: {
        En: 'Rack Number',
        Et: 'Rack number',
        Ar: 'رقم الرف',
        Ml: 'റാക്ക് നമ്പർ',
        Ma: 'रॅक क्रमांक',
        Fr: 'Numéro de rack',
        Hi: 'रैक संख्या',
        Ta: 'ரேக் எண்',
        Ja: 'ラック番号',
        Ge: 'Rack-Nummer',
      },
      SRMRTB02: {
        En: ' Enter Rack Number',
        Et: 'Sisestage riiuli number',
        Ar: 'أدخل رقم الرف',
        Ml: 'റാക്ക് നമ്പർ നൽകുക',
        Ma: 'रॅक क्रमांक प्रविष्ट करा',
        Fr: 'Entrer le numéro de rack',
        Hi: 'रैक नंबर दर्ज करें',
        Ta: 'ரேக் எண்ணை உள்ளிடவும்',
        Ja: 'ラック番号を入力してください',
        Ge: 'Racknummer eingeben',
      },
      SRMRL05: {
        En: 'Rack Type',
        Et: 'Racki tüüp',
        Ar: 'نوع الرف',
        Ml: 'റാക്ക് തരം',
        Ma: 'रॅक प्रकार',
        Fr: 'Type de crémaillère',
        Hi: 'रैक प्रकार',
        Ta: 'ரேக் வகை',
        Ja: 'ラックタイプ',
        Ge: 'Rack-Typ',
      },
      SRMRTB03: {
        En: 'Enter Rack Type',
        Et: 'Sisestage riiuli tüüp',
        Ar: 'أدخل نوع الرف',
        Ml: 'റാക്ക് തരം നൽകുക',
        Ma: 'रॅक प्रकार प्रविष्ट करा',
        Fr: 'Entrer le type de rack',
        Hi: 'रैक प्रकार दर्ज करें',
        Ta: 'ரேக் வகையை உள்ளிடவும்',
        Ja: 'ラックタイプを入力してください',
        Ge: 'Rack-Typ eingeben',
      },
      SRMRB01: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      SRMRB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      SRMRB03: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      SRMRB04: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
    },

    SHELFRACKMASTERViewShelfRack: {
      SRMVL01: {
        En: 'VIEW SHELF/RACK',
        Et: 'VAATA RIIUL/RIIUL',
        Ar: 'عرض الرف / الرف',
        Ml: 'ഷെൽഫ്/റാക്ക് കാണുക',
        Ma: 'शेल्फ/रॅक पहा',
        Fr: "VOIR L'ÉTAGÈRE/RACK",
        Hi: 'शेल्फ/रैक देखें',
        Ta: 'ஷெல்ஃப்/ரேக் பார்க்கவும்',
        Ja: 'シェルフ/ラックを見る',
        Ge: 'REGAL/REGAL ANSEHEN',
      },
      SRMVTH01: {
        En: 'SNo',
        Et: 'SNo',
        Ar: 'SNo',
        Ml: 'SNo',
        Ma: 'SNo',
        Fr: 'SNon',
        Hi: 'एसएनओ',
        Ta: 'SNo',
        Ja: 'S番号',
        Ge: 'SNr',
      },
      SRMVTH02: {
        En: 'Vault Name',
        Et: 'Võlvi nimi',
        Ar: 'اسم قبو',
        Ml: 'നിലവറയുടെ പേര്',
        Ma: 'व्हॉल्ट नाव',
        Fr: 'Nom de la voûte',
        Hi: 'तिजोरी का नाम',
        Ta: 'பெட்டகத்தின் பெயர்',
        Ja: 'ボールト名',
        Ge: 'Tresorname',
      },
      SRMVTH03: {
        En: 'Shelf Number',
        Et: 'Riiuli number',
        Ar: 'رقم الرف',
        Ml: 'ഷെൽഫ് നമ്പർ',
        Ma: 'शेल्फ क्रमांक',
        Fr: "Numéro d'étagère",
        Hi: 'शेल्फ संख्या',
        Ta: 'ஷெல்ஃப் எண்',
        Ja: '棚番号',
        Ge: 'Regalnummer',
      },
      SRMVTH04: {
        En: 'Rack Number',
        Et: 'Rack number',
        Ar: 'رقم الرف',
        Ml: 'റാക്ക് നമ്പർ',
        Ma: 'रॅक क्रमांक',
        Fr: 'Numéro de rack',
        Hi: 'रैक संख्या',
        Ta: 'ரேக் எண்',
        Ja: 'ラック番号',
        Ge: 'Rack-Nummer',
      },
      SRMVTH05: {
        En: 'Rack Types',
        Et: 'Rack tüübid',
        Ar: 'أنواع الرف',
        Ml: 'റാക്ക് തരങ്ങൾ',
        Ma: 'रॅकचे प्रकार',
        Fr: 'Types de racks',
        Hi: 'रैक प्रकार',
        Ta: 'ரேக் வகைகள்',
        Ja: 'ラックの種類',
        Ge: 'Rack-Typen',
      },
    },

    DEPARTMENTMASTERRegisterDepartment: {
      DMRL01: {
        En: 'DEPARTMENT MASTER',
        Et: 'OSAKONDMEISTRE',
        Ar: 'ماجستير قسم',
        Ml: 'വകുപ്പ് മാസ്റ്റർ',
        Ma: 'विभाग मास्तर',
        Fr: 'MAÎTRE DE DÉPARTEMENT',
        Hi: 'विभाग मास्टर',
        Ta: 'துறை மாஸ்டர்',
        Ja: '部門長',
        Ge: 'ABTEILUNGSMEISTER',
      },
      DMRL02: {
        En: 'Department Name',
        Et: 'Osakonna nimi',
        Ar: 'اسم القسم',
        Ml: 'വകുപ്പിന്റെ പേര്',
        Ma: 'विभागाचे नाव',
        Fr: 'Nom du département',
        Hi: 'विभाग का नाम',
        Ta: 'துறை பெயர்',
        Ja: '部署名',
        Ge: 'Abteilungsname',
      },
      DMRTB01: {
        En: 'Enter Department Name',
        Et: 'Sisestage osakonna nimi',
        Ar: 'أدخل اسم القسم',
        Ml: 'വകുപ്പിന്റെ പേര് നൽകുക',
        Ma: 'विभागाचे नाव प्रविष्ट करा',
        Fr: 'Entrez le nom du département',
        Hi: 'विभाग का नाम दर्ज करें',
        Ta: 'துறையின் பெயரை உள்ளிடவும்',
        Ja: '部署名を入力',
        Ge: 'Geben Sie den Abteilungsnamen ein',
      },
      DMRL03: {
        En: 'Department Code',
        Et: 'Osakonna kood',
        Ar: 'كود قسم',
        Ml: 'വകുപ്പ് കോഡ്',
        Ma: 'विभाग कोड',
        Fr: 'Indicatif départemental',
        Hi: 'विभाग कोड',
        Ta: 'துறை குறியீடு',
        Ja: '部門コード',
        Ge: 'Abteilungscode',
      },
      DMRTB02: {
        En: 'Enter Department Code',
        Et: 'Sisestage osakonna kood',
        Ar: 'أدخل رمز القسم',
        Ml: 'ഡിപ്പാർട്ട്മെന്റ് കോഡ് നൽകുക',
        Ma: 'विभाग कोड प्रविष्ट करा',
        Fr: 'Entrez le code du département',
        Hi: 'विभाग कोड दर्ज करें',
        Ta: 'துறைக் குறியீட்டை உள்ளிடவும்',
        Ja: '部門コードを入力してください',
        Ge: 'Geben Sie den Abteilungscode ein',
      },
      DMRL04: {
        En: 'Description',
        Et: 'Kirjeldus',
        Ar: 'وصف',
        Ml: 'വിവരണം',
        Ma: 'वर्णन',
        Fr: 'La description',
        Hi: 'विवरण',
        Ta: 'விளக்கம்',
        Ja: '説明',
        Ge: 'Beschreibung',
      },
      DMRTB03: {
        En: 'Enter Department Description',
        Et: 'Sisestage osakonna kirjeldus',
        Ar: 'أدخل وصف القسم',
        Ml: 'വകുപ്പിന്റെ വിവരണം നൽകുക',
        Ma: 'विभाग वर्णन प्रविष्ट करा',
        Fr: 'Entrez la description du département',
        Hi: 'विभाग विवरण दर्ज करें',
        Ta: 'துறை விளக்கத்தை உள்ளிடவும்',
        Ja: '部門の説明を入力してください',
        Ge: 'Abteilungsbeschreibung eingeben',
      },
      DMRL05: {
        En: 'Department Email',
        Et: 'Osakonna e-post',
        Ar: 'البريد الإلكتروني للقسم',
        Ml: 'വകുപ്പ് ഇമെയിൽ',
        Ma: 'विभाग ईमेल',
        Fr: 'Courriel du service',
        Hi: 'विभाग ईमेल',
        Ta: 'துறை மின்னஞ்சல்',
        Ja: '部門の電子メール',
        Ge: 'E-Mail der Abteilung',
      },
      DMRTB04: {
        En: 'Enter Department Email',
        Et: 'Sisestage osakonna e-post',
        Ar: 'أدخل البريد الإلكتروني للقسم',
        Ml: 'വകുപ്പിന്റെ ഇമെയിൽ നൽകുക',
        Ma: 'विभाग ईमेल प्रविष्ट करा',
        Fr: "Saisissez l'e-mail du service",
        Hi: 'विभाग ईमेल दर्ज करें',
        Ta: 'துறை மின்னஞ்சலை உள்ளிடவும்',
        Ja: '部門の電子メールを入力してください',
        Ge: 'Geben Sie die E-Mail-Adresse der Abteilung ein',
      },
      DMRL06: {
        En: 'Phone Number',
        Et: 'Telefoninumber',
        Ar: 'رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ',
        Ma: 'फोन नंबर',
        Fr: 'Numéro de téléphone',
        Hi: 'फ़ोन नंबर',
        Ta: 'தொலைபேசி எண்',
        Ja: '電話番号',
        Ge: 'Telefonnummer',
      },
      DMRTB05: {
        En: 'Enter Phone Number',
        Et: 'Sisesta telefoninumber',
        Ar: 'أدخل رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ നൽകുക',
        Ma: 'फोन नंबर प्रविष्ट करा',
        Fr: 'Entrez le numéro de téléphone',
        Hi: 'फोन नंबर दर्ज',
        Ta: 'தொலைபேசி எண்ணை உள்ளிடவும்',
        Ja: '電話番号を入力',
        Ge: 'Telefonnummer eingeben',
      },
      DMRB01: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      DMRB02: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      DMRB03: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
    },

    DEPARTMEnTMASTERViewDepartment: {
      DMVL01: {
        En: 'VIEW DEPARTMENTS',
        Et: 'VAATA OSAKONDID',
        Ar: 'عرض الأقسام',
        Ml: 'വകുപ്പുകൾ കാണുക',
        Ma: 'विभाग पहा',
        Fr: 'VOIR LES DÉPARTEMENTS',
        Hi: 'विभाग देखें',
        Ta: 'துறைகளைப் பார்க்கவும்',
        Ja: '部門を表示',
        Ge: 'ABTEILUNGEN ANZEIGEN',
      },
      DMVTH01: {
        En: 'Department Name',
        Et: 'Osakonna nimi',
        Ar: 'اسم القسم',
        Ml: 'വകുപ്പിന്റെ പേര്',
        Ma: 'विभागाचे नाव',
        Fr: 'Nom du département',
        Hi: 'विभाग का नाम',
        Ta: 'துறை பெயர்',
        Ja: '部署名',
        Ge: 'Abteilungsname',
      },
      DMVTH02: {
        En: 'Department Id',
        Et: 'Osakonna ID',
        Ar: 'معرف القسم',
        Ml: 'വകുപ്പ് ഐഡി',
        Ma: 'विभाग आयडी',
        Fr: 'Identifiant du département',
        Hi: 'विभाग आईडी',
        Ta: 'துறை ஐடி',
        Ja: '部門ID',
        Ge: 'Abteilungs-ID',
      },
      DMVTH03: {
        En: 'Description',
        Et: 'Kirjeldus',
        Ar: 'وصف',
        Ml: 'വിവരണം',
        Ma: 'वर्णन',
        Fr: 'La description',
        Hi: 'विवरण',
        Ta: 'விளக்கம்',
        Ja: '説明',
        Ge: 'Beschreibung',
      },
      DMVTH04: {
        En: 'Email',
        Et: 'Meil',
        Ar: 'البريد الإلكتروني',
        Ml: 'ഇമെയിൽ',
        Ma: 'ईमेल',
        Fr: 'E-mail',
        Hi: 'ईमेल',
        Ta: 'மின்னஞ்சல்',
        Ja: 'Eメール',
        Ge: 'Email',
      },
      DMVTH05: {
        En: 'Phone Number',
        Et: 'Telefoninumber',
        Ar: 'رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ',
        Ma: 'फोन नंबर',
        Fr: 'Numéro de téléphone',
        Hi: 'फ़ोन नंबर',
        Ta: 'தொலைபேசி எண்',
        Ja: '電話番号',
        Ge: 'Telefonnummer',
      },
      DMVB01: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      DMVB02: {
        En: 'Delete',
        Et: 'Kustuta',
        Ar: 'حذف',
        Ml: 'ഇല്ലാതാക്കുക',
        Ma: 'हटवा',
        Fr: 'Effacer',
        Hi: 'मिटाना',
        Ta: 'அழி',
        Ja: '消去',
        Ge: 'Löschen',
      },
    },

    AllocateUser: {
      AUH01: {
        En: 'Allocate User',
        Ta: 'பயனரை ஒதுக்குங்கள்',
        Et: 'Määra kasutaja',
        Fr: 'Attribuer un utilisateur',
        Ar: 'تخصيص المستخدم',
        Ml: 'ഉപയോക്താവിനെ അനുവദിക്കുക',
        Hi: 'उपयोगकर्ता आवंटित करें',
        Ma: 'वापरकर्ता वाटप',
        Ja: 'ユーザーの割り当て',
        Ge: 'Benutzer zuweisen',
      },
      AUH02: {
        En: 'Select All  ',
        Et: 'Vali kõik',
        Ml: 'എല്ലാം തിരഞ്ഞെടുക്കുക',
        Ma: 'सर्व निवडा',
        Hi: 'सभी का चयन करे',
        Fr: 'Tout sélectionner',
        Ta: 'அனைத்தையும் தெரிவுசெய்',
        Ja: 'すべて選択',
        Ge: 'Wählen Sie Alle',
      },
      AUB02: {
        En: 'Submit',
        Ta: 'சமர்ப்பிக்கவும்',
        Et: 'Esita',
        Fr: 'Soumettre',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Hi: 'प्रस्तुत करना',
        Ma: 'प्रस्तुत करणे',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      AUB03: {
        En: 'Assign Users',
        Ta: 'பயனர்களை ஒதுக்குங்கள்',
        Et: 'Kasutajate määramine',
        Fr: 'Attribuer des utilisateurs',
        Ar: 'تعيين المستخدمين',
        Ml: 'ഉപയോക്താക്കളെ നിയോഗിക്കുക',
        Hi: 'उपयोगकर्ताओं को असाइन करें',
        Ma: 'वापरकर्ते नियुक्त करा',
        Ja: 'ユーザーの割り当て',
        Ge: 'Benutzer zuweisen',
      },
      AUB04: {
        En: 'Remove Users',
        Ta: 'பயனர்களை அகற்று',
        Et: 'Kasutajate eemaldamine',
        Fr: 'Supprimer des utilisateurs',
        Ar: 'إزالة المستخدمين',
        Ml: 'ഉപയോക്താക്കളെ നീക്കം ചെയ്യുക',
        Hi: 'उपयोगकर्ता हटाएं',
        Ma: 'वापरकर्ते काढा',
        Ja: 'ユーザーを削除',
        Ge: 'Benutzer entfernen',
      },
      AUB05: {
        En: 'Scan',
        Ta: 'ஊடுகதிர்',
        Et: 'Skaneeri',
        Fr: 'Analyse',
        Ar: 'مسح',
        Ml: 'സ്കാൻ ചെയ്യുക',
        Hi: 'स्कैन',
        Ma: 'स्कॅन करा',
        Ja: 'スキャン',
        Ge: 'Scan',
      },
      //AUDD01: {En: "Choose Users" },
    },

    QuickScan: {
      AUH01: {
        En: 'Quick Scan',
        Et: 'Määra kasutaja',
        Ar: 'تخصيص المستخدم',
        Ml: 'ഉപയോക്താവിനെ അനുവദിക്കുക',
        Ma: 'वापरकर्ता वाटप',
        Fr: 'Attribuer un utilisateur',
        Hi: 'उपयोगकर्ता आवंटित करें',
        Ta: 'பயனரை ஒதுக்குங்கள்',
        Ja: 'ユーザーの割り当て',
        Ge: 'Benutzer zuweisen',
      },
      AUB01: {
        En: 'Scan',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
      //AUDD01: {En: "Quick Scan" },
    },

    CUSTOMERMASTERRegisterCustomer: {
      CMRL01: {
        En: 'CUSTOMER MASTER',
        Et: 'KLIENDIDE MEISTER',
        Ar: 'العميل الرئيسي',
        Ml: 'കസ്റ്റമർ മാസ്റ്റർ',
        Ma: 'ग्राहक मास्टर',
        Fr: 'CLIENT MAÎTRE',
        Hi: 'ग्राहक मास्टर',
        Ta: 'வாடிக்கையாளர் மாஸ்டர்',
        Ja: 'カスタマーマスター',
        Ge: 'KUNDENSTAMM',
      },
      CMRL02: {
        En: 'Full Name',
        Et: 'Täisnimi',
        Ar: 'الاسم الكامل',
        Ml: 'പൂർണ്ണമായ പേര്',
        Ma: 'पूर्ण नाव',
        Fr: 'Nom et prénom',
        Hi: 'पूरा नाम',
        Ta: 'முழு பெயர்',
        Ja: 'フルネーム',
        Ge: 'Vollständiger Name',
      },
      CMRTB01: {
        En: 'Enter Customer Name',
        Et: 'Sisestage kliendi nimi',
        Ar: 'أدخل اسم العميل',
        Ml: 'ഉപഭോക്താവിന്റെ പേര് നൽകുക',
        Ma: 'ग्राहकाचे नाव प्रविष्ट करा',
        Fr: 'Entrez le nom du client',
        Hi: 'ग्राहक का नाम दर्ज करें',
        Ta: 'வாடிக்கையாளர் பெயரை உள்ளிடவும்',
        Ja: '顧客名を入力',
        Ge: 'Geben Sie den Kundennamen ein',
      },
      CMRL03: {
        En: 'Currency',
        Et: 'Valuuta',
        Ar: 'عملة',
        Ml: 'കറൻസി',
        Ma: 'चलन',
        Fr: 'Devise',
        Hi: 'मुद्रा',
        Ta: 'நாணய',
        Ja: '通貨',
        Ge: 'Währung',
      },
      CMRTB02: {
        En: 'Enter Currency',
        Et: 'Sisestage valuuta',
        Ar: 'أدخل العملة',
        Ml: 'കറൻസി നൽകുക',
        Ma: 'चलन प्रविष्ट करा',
        Fr: 'Entrer la devise',
        Hi: 'मुद्रा दर्ज करें',
        Ta: 'நாணயத்தை உள்ளிடவும்',
        Ja: '通貨を入力してください',
        Ge: 'Währung eingeben',
      },
      CMRL04: {
        En: 'Email',
        Et: 'Meil',
        Ar: 'البريد الإلكتروني',
        Ml: 'ഇമെയിൽ',
        Ma: 'ईमेल',
        Fr: 'E-mail',
        Hi: 'ईमेल',
        Ta: 'மின்னஞ்சல்',
        Ja: 'Eメール',
        Ge: 'Email',
      },
      CMRTB03: {
        En: 'Enter Customer Email',
        Et: 'Sisestage kliendi e-posti aadress',
        Ar: 'أدخل البريد الإلكتروني للعميل',
        Ml: 'ഉപഭോക്തൃ ഇമെയിൽ നൽകുക',
        Ma: 'ग्राहक ईमेल प्रविष्ट करा',
        Fr: "Saisissez l'e-mail du client",
        Hi: 'ग्राहक ईमेल दर्ज करें',
        Ta: 'வாடிக்கையாளர் மின்னஞ்சலை உள்ளிடவும்',
        Ja: '顧客の電子メールを入力してください',
        Ge: 'Geben Sie die Kunden-E-Mail ein',
      },
      CMRL05: {
        En: 'Address',
        Et: 'Aadress',
        Ar: 'تبوك',
        Ml: 'വിലാസം',
        Ma: 'पत्ता',
        Fr: 'Adresse',
        Hi: 'पता',
        Ta: 'முகவரி',
        Ja: '住所',
        Ge: 'Adresse',
      },
      CMRTB04: {
        En: 'Enter Address',
        Et: 'Sisesta aadress',
        Ar: 'أدخل العنوان',
        Ml: 'വിലാസം നൽകുക',
        Ma: 'पत्ता प्रविष्ट करा',
        Fr: "Entrer l'adresse",
        Hi: 'पता लिखिए',
        Ta: 'முகவரியை உள்ளிடவும்',
        Ja: '住所を入力',
        Ge: 'Adresse eingeben',
      },
      CMRL06: {
        En: 'Phone Number',
        Et: 'Telefoninumber',
        Ar: 'رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ',
        Ma: 'फोन नंबर',
        Fr: 'Numéro de téléphone',
        Hi: 'फ़ोन नंबर',
        Ta: 'தொலைபேசி எண்',
        Ja: '電話番号',
        Ge: 'Telefonnummer',
      },
      CMRTB05: {
        En: 'Enter Phone Number',
        Et: 'Sisesta telefoninumber',
        Ar: 'أدخل رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ നൽകുക',
        Ma: 'फोन नंबर प्रविष्ट करा',
        Fr: 'Entrez le numéro de téléphone',
        Hi: 'फोन नंबर दर्ज',
        Ta: 'தொலைபேசி எண்ணை உள்ளிடவும்',
        Ja: '電話番号を入力',
        Ge: 'Telefonnummer eingeben',
      },
      CMRB01: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      CMRB02: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      CMRB03: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
    },

    CUSTOMERMASTERViewCustomer: {
      CMVL01: {
        En: 'VIEW CUSTOMERS',
        Et: 'VAADAKE KLIENTE',
        Ar: 'عرض العملاء',
        Ml: 'ഉപഭോക്താക്കളെ കാണുക',
        Ma: 'ग्राहक पहा',
        Fr: 'VOIR LES CLIENTS',
        Hi: 'ग्राहकों को देखें',
        Ta: 'வாடிக்கையாளர்களைப் பார்க்கவும்',
        Ja: '顧客を見る',
        Ge: 'KUNDEN ANSEHEN',
      },
      CMVTH01: {
        En: 'Name',
        Et: 'Nimi',
        Ar: 'اسم',
        Ml: 'പേര്',
        Ma: 'नाव',
        Fr: 'Nom',
        Hi: 'नाम',
        Ta: 'பெயர்',
        Ja: '名前',
        Ge: 'Name',
      },
      CMVTH02: {
        En: 'Currency',
        Et: 'Valuuta',
        Ar: 'عملة',
        Ml: 'കറൻസി',
        Ma: 'चलन',
        Fr: 'Devise',
        Hi: 'मुद्रा',
        Ta: 'நாணய',
        Ja: '通貨',
        Ge: 'Währung',
      },
      CMVTH03: {
        En: 'Email',
        Et: 'Meil',
        Ar: 'البريد الإلكتروني',
        Ml: 'ഇമെയിൽ',
        Ma: 'ईमेल',
        Fr: 'E-mail',
        Hi: 'ईमेल',
        Ta: 'மின்னஞ்சல்',
        Ja: 'Eメール',
        Ge: 'Email',
      },
      CMVTH04: {
        En: 'Address',
        Et: 'Aadress',
        Ar: 'تبوك',
        Ml: 'വിലാസം',
        Ma: 'पत्ता',
        Fr: 'Adresse',
        Hi: 'पता',
        Ta: 'முகவரி',
        Ja: '住所',
        Ge: 'Adresse',
      },
      CMVTH05: {
        En: 'Phone Number',
        Et: 'Telefoninumber',
        Ar: 'رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ',
        Ma: 'फोन नंबर',
        Fr: 'Numéro de téléphone',
        Hi: 'फ़ोन नंबर',
        Ta: 'தொலைபேசி எண்',
        Ja: '電話番号',
        Ge: 'Telefonnummer',
      },
      CMVB01: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      CMVB02: {
        En: 'Delete',
        Et: 'Kustuta',
        Ar: 'حذف',
        Ml: 'ഇല്ലാതാക്കുക',
        Ma: 'हटवा',
        Fr: 'Effacer',
        Hi: 'मिटाना',
        Ta: 'அழி',
        Ja: '消去',
        Ge: 'Löschen',
      },
    },

    AssetWorkLevelMaster: {
      AWLL01: {
        En: 'WORK LEVEL MASTER',
        Et: 'TÖÖTASME MEISTER',
        Ar: 'مستوى العمل ماجستير',
        Ml: 'വർക്ക് ലെവൽ മാസ്റ്റർ',
        Ma: 'वर्क लेव्हल मास्टर',
        Fr: 'MAÎTRE DE NIVEAU DE TRAVAIL',
        Hi: 'कार्य स्तर मास्टर',
        Ta: 'பணி நிலை மாஸ்டர்',
        Ja: 'ワークレベルマスター',
        Ge: 'ARBEITSSTUFE MEISTER',
      },
      AWLL02: {
        En: 'Film Title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      AWLTB01: {
        En: 'Film Title Box',
        Et: 'Filmi pealkirja kast',
        Ar: 'صندوق عنوان الفيلم',
        Ml: 'ഫിലിം ടൈറ്റിൽ ബോക്സ്',
        Ma: 'चित्रपट शीर्षक बॉक्स',
        Fr: 'Boîte de titre de film',
        Hi: 'फिल्म शीर्षक बॉक्स',
        Ta: 'படத்தின் தலைப்பு பெட்டி',
        Ja: '映画タイトルボックス',
        Ge: 'Filmtitel-Box',
      },
      AWLL03: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      AWLDD01: {
        En: 'Language Box',
        Et: 'Keelekast',
        Ar: 'مربع اللغة',
        Ml: 'ഭാഷാ പെട്ടി',
        Ma: 'भाषा पेटी',
        Fr: 'Boîte de langue',
        Hi: 'भाषा बॉक्स',
        Ta: 'மொழி பெட்டி',
        Ja: '言語ボックス',
        Ge: 'Sprachbox',
      },
      AWLL04: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      AWLDD02: {
        En: 'Film Year Box',
        Et: 'Filmi aasta kast',
        Ar: 'صندوق العام للفيلم',
        Ml: 'ഫിലിം ഇയർ ബോക്സ്',
        Ma: 'चित्रपट वर्ष बॉक्स',
        Fr: "Boîte de l'année du film",
        Hi: 'फिल्म वर्ष बॉक्स',
        Ta: 'திரைப்பட ஆண்டு பெட்டி',
        Ja: 'フィルムイヤーボックス',
        Ge: 'Filmjahr-Box',
      },
      AWLL05: {
        En: 'Origin',
        Et: 'Päritolu',
        Ar: 'أصل',
        Ml: 'ഉത്ഭവം',
        Ma: 'मूळ',
        Fr: 'Origine',
        Hi: 'मूल',
        Ta: 'தோற்றம்',
        Ja: '元',
        Ge: 'Herkunft',
      },
      AWLDD03: {
        En: 'Origin Box',
        Et: 'Päritolukast',
        Ar: 'صندوق المنشأ',
        Ml: 'ഒറിജിൻ ബോക്സ്',
        Ma: 'मूळ बॉक्स',
        Fr: "Boîte d'origine",
        Hi: 'मूल बॉक्स',
        Ta: 'மூலப் பெட்டி',
        Ja: 'オリジンボックス',
        Ge: 'Origin-Box',
      },
      AWLB01: {
        En: 'Clear',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      AWLB02: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      AWLB03: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
    },

    AssetViewWorkLevel: {
      AVWLL01: {
        En: 'VIEW WORK LEVEL',
        Et: 'VAATA TÖÖTASET',
        Ar: 'عرض مستوى العمل',
        Ml: 'വർക്ക് ലെവൽ കാണുക',
        Ma: 'कामाची पातळी पहा',
        Fr: 'VOIR LE NIVEAU DE TRAVAIL',
        Hi: 'कार्य स्तर देखें',
        Ta: 'பணி மட்டத்தைப் பார்க்கவும்',
        Ja: '作業レベルを表示',
        Ge: 'ARBEITSEBENE ANZEIGEN',
      },
      AVWLTH01: {
        En: 'Film Title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      AVWLTH02: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      AVWLTH03: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      AVWLTH04: {
        En: 'Origin',
        Et: 'Päritolu',
        Ar: 'أصل',
        Ml: 'ഉത്ഭവം',
        Ma: 'मूळ',
        Fr: 'Origine',
        Hi: 'मूल',
        Ta: 'தோற்றம்',
        Ja: '元',
        Ge: 'Herkunft',
      },
      AVWLB01: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      AVWLB02: {
        En: 'Delete',
        Et: 'Kustuta',
        Ar: 'حذف',
        Ml: 'ഇല്ലാതാക്കുക',
        Ma: 'हटवा',
        Fr: 'Effacer',
        Hi: 'मिटाना',
        Ta: 'அழி',
        Ja: '消去',
        Ge: 'Löschen',
      },
    },

    AssetItemLevel: {
      AILL01: {
        En: 'CREATE/EDIT ASSET - WORK LEVEL METADATA',
        Et: 'LOO/MUUDA VARA – TÖÖTASME METAANDMED',
        Ar: 'إنشاء / تحرير الأصل - البيانات الوصفية لمستوى العمل',
        Ml: 'അസറ്റ് സൃഷ്‌ടിക്കുക/എഡിറ്റ് ചെയ്യുക - വർക്ക് ലെവൽ മെറ്റാഡാറ്റ',
        Ma: 'मालमत्ता तयार करा/संपादित करा - वर्क लेव्हल मेटाडेटा',
        Fr: "CRÉER/MODIFIER L'ACTIF - MÉTADONNÉES DE NIVEAU DE TRAVAIL",
        Hi: 'संपत्ति बनाएं/संपादित करें - कार्य स्तर मेटाडेटा',
        Ta: 'சொத்தை உருவாக்கவும்/திருத்தவும் - பணி நிலை மெட்டாடேட்டா',
        Ja: 'アセットの作成/編集 - 作業レベルのメタデータ',
        Ge: 'ASSET ERSTELLEN/BEARBEITEN – METADATEN AUF ARBEITSEBENE',
      },
      AILL02: {
        En: 'Work Level Master',
        Et: 'Töötaseme meister',
        Ar: 'ماجستير مستوى العمل',
        Ml: 'വർക്ക് ലെവൽ മാസ്റ്റർ',
        Ma: 'वर्क लेव्हल मास्टर',
        Fr: 'Maître de niveau de travail',
        Hi: 'कार्य स्तर मास्टर',
        Ta: 'வேலை நிலை மாஸ்டர்',
        Ja: '作業レベルマスター',
        Ge: 'Meister der Arbeitsebene',
      },
      AILDD01: {
        En: 'Select Work Level Master',
        Et: 'Valige töötaseme meister',
        Ar: 'حدد مستوى العمل الرئيسي',
        Ml: 'വർക്ക് ലെവൽ മാസ്റ്റർ തിരഞ്ഞെടുക്കുക',
        Ma: 'वर्क लेव्हल मास्टर निवडा',
        Fr: 'Sélectionnez le maître de niveau de travail',
        Hi: 'कार्य स्तर मास्टर का चयन करें',
        Ta: 'பணி நிலை மாஸ்டர் என்பதைத் தேர்ந்தெடுக்கவும்',
        Ja: '作業レベル マスターの選択',
        Ge: 'Wählen Sie Arbeitsebene Master',
      },
      AILL03: {
        En: 'METADATA DETAILS',
        Et: 'METAANDMETE ANDMED',
        Ar: 'تفاصيل البيانات الوصفية',
        Ml: 'മെറ്റാഡാറ്റ വിശദാംശങ്ങൾ',
        Ma: 'मेटाडेटा तपशील',
        Fr: 'DÉTAILS DES MÉTADONNÉES',
        Hi: 'मेटाडेटा विवरण',
        Ta: 'மெட்டாடேட்டா விவரங்கள்',
        Ja: 'メタデータの詳細',
        Ge: 'METADATEN-DETAILS',
      },
      AILL04: {
        En: 'WORK IDEnTIFIER',
        Et: 'TÖÖ IDENTIFIKAATOR',
        Ar: 'معرف العمل',
        Ml: 'വർക്ക് ഐഡന്റിഫയർ',
        Ma: 'कार्य ओळखकर्ता',
        Fr: 'IDENTIFIANT DE TRAVAIL',
        Hi: 'कार्य पहचानकर्ता',
        Ta: 'பணி அடையாளங்காட்டி',
        Ja: '作業識別子',
        Ge: 'ARBEITSKENNZEICHNUNG',
      },
      AILL05: {
        En: 'TITLE',
        Et: 'PEALKIRI',
        Ar: 'لقب',
        Ml: 'TITLE',
        Ma: 'शीर्षक',
        Fr: 'TITRE',
        Hi: 'शीर्षक',
        Ta: 'தலைப்பு',
        Ja: '題名',
        Ge: 'TITEL',
      },
      AILL06: {
        En: 'LANGUAGE',
        Et: 'KEEL',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'LANGUE',
        Hi: 'भाषा: हिन्दी',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'SPRACHE',
      },
      AILL07: {
        En: 'CERTIFICATION',
        Et: 'SERTIFITSEERIMINE',
        Ar: 'شهادة',
        Ml: 'സർട്ടിഫിക്കേഷൻ',
        Ma: 'प्रमाणपत्र',
        Fr: 'CERTIFICAT',
        Hi: 'प्रमाणीकरण',
        Ta: 'சான்றிதழ்',
        Ja: '認証',
        Ge: 'ZERTIFIZIERUNG',
      },
      AILL08: {
        En: 'PHYSICAL ASSET DETAILS',
        Et: 'FÜÜSILISE VARA ANDMED',
        Ar: 'تفاصيل الأصول المادية',
        Ml: 'ഫിസിക്കൽ അസറ്റ് വിശദാംശങ്ങൾ',
        Ma: 'भौतिक मालमत्तेचे तपशील',
        Fr: 'DÉTAILS DES ACTIFS PHYSIQUES',
        Hi: 'भौतिक संपत्ति विवरण',
        Ta: 'உடல் சொத்து விவரங்கள்',
        Ja: '物的資産の詳細',
        Ge: 'DETAILS DER PHYSIKALISCHEN VERMÖGENSWERTE',
      },
      AILL09: {
        En: 'ASSET PREVIEW DETAILS',
        Et: 'VARA EELVAATAMISE ANDMED',
        Ar: 'تفاصيل معاينة الأصول',
        Ml: 'അസറ്റ് പ്രിവ്യൂ വിശദാംശങ്ങൾ',
        Ma: 'मालमत्ता पूर्वावलोकन तपशील',
        Fr: "DÉTAILS DE L'APERÇU DE L'ACTIF",
        Hi: 'संपत्ति पूर्वावलोकन विवरण',
        Ta: 'சொத்து மாதிரிக்காட்சி விவரங்கள்',
        Ja: 'アセット プレビューの詳細',
        Ge: 'ANLAGENVORSCHAU DETAILS',
      },
      AILL10: {
        En: 'ASSET STORAGE DETAILS',
        Et: 'VARA HOOLDUSE ANDMED',
        Ar: 'تفاصيل تخزين الأصول',
        Ml: 'അസറ്റ് സ്റ്റോറേജ് വിശദാംശങ്ങൾ',
        Ma: 'मालमत्ता स्टोरेज तपशील',
        Fr: 'DÉTAILS DU STOCKAGE DES ACTIFS',
        Hi: 'संपत्ति भंडारण विवरण',
        Ta: 'சொத்து சேமிப்பு விவரங்கள்',
        Ja: 'アセット ストレージの詳細',
        Ge: 'DETAILS DER ASSET-SPEICHERUNG',
      },
      AILL11: {
        En: 'PRODUCTION',
        Et: 'TOOTMINE',
        Ar: 'إنتاج',
        Ml: 'ഉത്പാദനം',
        Ma: 'उत्पादन',
        Fr: 'PRODUCTION',
        Hi: 'उत्पादन',
        Ta: 'உற்பத்தி',
        Ja: '製造',
        Ge: 'PRODUKTION',
      },
      AILL12: {
        En: 'STORY AND SCREEnPLAY',
        Et: 'LUGU JA STSENÄRID',
        Ar: 'قصة وشاشة',
        Ml: 'കഥയും തിരക്കഥയും',
        Ma: 'कथा आणि पटकथा',
        Fr: 'HISTOIRE ET SCÉNARIO',
        Hi: 'कहानी और पटकथा',
        Ta: 'கதை மற்றும் திரைக்கதை',
        Ja: 'ストーリーと脚本',
        Ge: 'GESCHICHTE UND DREHBUCH',
      },
      AILL13: {
        En: 'ART DIRECTION AND EDITING',
        Et: 'KUNSTI JUHTIMINE JA TOIMING',
        Ar: 'اتجاه الفن والتحرير',
        Ml: 'കലാസംവിധാനവും എഡിറ്റിംഗും',
        Ma: 'कला दिग्दर्शन आणि संपादन',
        Fr: 'DIRECTION ARTISTIQUE ET MONTAGE',
        Hi: 'कला निर्देशन और संपादन',
        Ta: 'கலை இயக்கம் மற்றும் எடிட்டிங்',
        Ja: 'アートディレクションと編集',
        Ge: 'ART DIREKTION UND BEARBEITUNG',
      },
      AILL14: {
        En: 'SOUND',
        Et: 'HELI',
        Ar: 'يبدو',
        Ml: 'ശബ്ദം',
        Ma: 'आवाज',
        Fr: 'DU SON',
        Hi: 'ध्वनि',
        Ta: 'ஒலி',
        Ja: '音',
        Ge: 'KLANG',
      },
      AILL15: {
        En: 'MUSIC',
        Et: 'MUUSIKA',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'MUSIQUE',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'MUSIK',
      },
      AILL16: {
        En: 'CAST AND ARTISTS',
        Et: 'Näitlejad JA ARTISTID',
        Ar: 'الممثلون والفنانون',
        Ml: 'അഭിനേതാക്കളും കലാകാരന്മാരും',
        Ma: 'कलाकार आणि कलाकार',
        Fr: 'DISTRIBUTION ET ARTISTES',
        Hi: 'कलाकार और कलाकार',
        Ta: 'நடிகர்கள் மற்றும் கலைஞர்கள்',
        Ja: 'キャストとアーティスト',
        Ge: 'DARSTELLER UND KÜNSTLER',
      },
      AILL17: {
        En: 'APPEARANCE AND ACTION',
        Et: 'VÄLIMUS JA TEGEVUS',
        Ar: 'المظهر والعمل',
        Ml: 'രൂപഭാവവും പ്രവർത്തനവും',
        Ma: 'देखावा आणि कृती',
        Fr: 'APPARENCE ET ACTION',
        Hi: 'प्रकटन और क्रिया',
        Ta: 'தோற்றம் மற்றும் செயல்',
        Ja: '外観とアクション',
        Ge: 'AUSSEHEN UND AKTION',
      },
      AILL18: {
        En: 'DIRECTORS AND PRODUCTION MANAGERS',
        Et: 'DIREKTORID JA TOOTMISJUHTID',
        Ar: 'المديرين ومديري الإنتاج',
        Ml: 'ഡയറക്ടർമാരും പ്രൊഡക്ഷൻ മാനേജർമാരും',
        Ma: 'दिग्दर्शक आणि उत्पादन व्यवस्थापक',
        Fr: 'RÉALISATEURS ET DIRECTEURS DE PRODUCTION',
        Hi: 'निदेशक और उत्पादन प्रबंधक',
        Ta: 'இயக்குனர்கள் மற்றும் தயாரிப்பு மேலாளர்கள்',
        Ja: 'ディレクターとプロダクションマネージャー',
        Ge: 'DIREKTOREN UND PRODUKTIONSLEITER',
      },
      AILL19: {
        En: 'PRODUCTION STUDIO AND VISUAL EFFECTS',
        Et: 'TOOTMISSTUUDIO JA VISUAALSED EFEKTID',
        Ar: 'استوديو الإنتاج والتأثيرات المرئية',
        Ml: 'പ്രൊഡക്ഷൻ സ്റ്റുഡിയോയും വിഷ്വൽ ഇഫക്റ്റുകളും',
        Ma: 'प्रोडक्शन स्टुडिओ आणि व्हिज्युअल इफेक्ट्स',
        Fr: 'STUDIO DE PRODUCTION ET EFFETS VISUELS',
        Hi: 'उत्पादन स्टूडियो और दृश्य प्रभाव',
        Ta: 'தயாரிப்பு ஸ்டுடியோ மற்றும் காட்சி விளைவுகள்',
        Ja: '制作スタジオと視覚効果',
        Ge: 'PRODUKTIONSSTUDIO UND VISUELLE EFFEKTE',
      },
      AILL20: {
        En: 'AWARDS AND PUBLICITY',
        Et: 'AUHINNAD JA AVALIKUSTUS',
        Ar: 'الجوائز والدعاية',
        Ml: 'അവാർഡുകളും പബ്ലിസിറ്റിയും',
        Ma: 'पुरस्कार आणि प्रसिद्धी',
        Fr: 'PRIX ET PUBLICITÉ',
        Hi: 'पुरस्कार और प्रचार',
        Ta: 'விருதுகள் மற்றும் விளம்பரம்',
        Ja: '賞と広報',
        Ge: 'AUSZEICHNUNGEN UND WERBUNG',
      },
      AILL21: {
        En: 'GENRE',
        Et: 'ŽANR',
        Ar: 'النوع',
        Ml: 'GENRE',
        Ma: 'शैली',
        Fr: 'GENRE',
        Hi: 'शैली',
        Ta: 'வகை',
        Ja: 'ジャンル',
        Ge: 'GENRE',
      },
      AILCL01: {
        En: 'Confirm field',
        Et: 'Kinnitage väli',
        Ar: 'تأكيد الحقل',
        Ml: 'ഫീൽഡ് സ്ഥിരീകരിക്കുക',
        Ma: 'फील्डची पुष्टी करा',
        Fr: 'Confirmer le champ',
        Hi: 'फ़ील्ड की पुष्टि करें',
        Ta: 'புலத்தை உறுதிப்படுத்தவும்',
        Ja: 'フィールドを確認',
        Ge: 'Feld bestätigen',
      },
      AILB01: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      AILL22: {
        En: 'IDEnTIFIER TAGS FOR PHYSICAL ASSET',
        Et: 'FÜÜSILISE VARA IDENTIFITSEERIMISMÄRGID',
        Ar: 'علامات معرف للأصول المادية',
        Ml: 'ഫിസിക്കൽ അസറ്റിനുള്ള ഐഡന്റിഫയർ ടാഗുകൾ',
        Ma: 'भौतिक मालमत्तेसाठी आयडेंटिफायर टॅग',
        Fr: "ÉTIQUETTES D'IDENTIFICATION DES BIENS PHYSIQUES",
        Hi: 'भौतिक संपत्ति के लिए पहचानकर्ता टैग',
        Ta: 'இயற்பியல் சொத்துக்கான அடையாள குறிகள்',
        Ja: '物理的資産の識別子タグ',
        Ge: 'KENNZEICHNUNGS-TAGS FÜR PHYSISCHE VERMÖGENSWERTE',
      },
      AILB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      AILB03: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
    },

    AssetItemLevelWORKIDEnTIFIER: {
      AILWIL01: {
        En: 'Film Title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      AILWITB01: {
        En: 'Enter Film Title',
        Et: 'Sisestage filmi pealkiri',
        Ar: 'أدخل عنوان الفيلم',
        Ml: 'ഫിലിം ടൈറ്റിൽ നൽകുക',
        Ma: 'चित्रपटाचे शीर्षक प्रविष्ट करा',
        Fr: 'Entrez le titre du film',
        Hi: 'फिल्म का शीर्षक दर्ज करें',
        Ta: 'படத்தின் தலைப்பை உள்ளிடவும்',
        Ja: '映画のタイトルを入力',
        Ge: 'Filmtitel eingeben',
      },
      AILWIL02: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      AILWIDD01: {
        En: 'Select Language',
        Et: 'Vali keel',
        Ar: 'اختار اللغة',
        Ml: 'ഭാഷ തിരഞ്ഞെടുക്കുക',
        Ma: 'भाषा निवडा',
        Fr: 'Choisir la langue',
        Hi: 'भाषा चुने',
        Ta: 'மொழியை தேர்ந்தெடுங்கள்',
        Ja: '言語を選択する',
        Ge: 'Sprache auswählen',
      },
      AILWIL03: {
        En: 'Film Year',
        Et: 'Filmiaasta',
        Ar: 'عام الفيلم',
        Ml: 'ചലച്ചിത്ര വർഷം',
        Ma: 'चित्रपट वर्ष',
        Fr: 'Année cinématographique',
        Hi: 'फिल्म वर्ष',
        Ta: 'திரைப்பட ஆண்டு',
        Ja: '映画の年',
        Ge: 'Filmjahr',
      },
      AILWIDD02: {
        En: 'Select Film Year',
        Et: 'Valige filmiaasta',
        Ar: 'حدد سنة الفيلم',
        Ml: 'ഫിലിം വർഷം തിരഞ്ഞെടുക്കുക',
        Ma: 'चित्रपट वर्ष निवडा',
        Fr: "Sélectionnez l'année du film",
        Hi: 'फिल्म वर्ष चुनें',
        Ta: 'திரைப்பட ஆண்டைத் தேர்ந்தெடுக்கவும்',
        Ja: '映画の年を選択',
        Ge: 'Filmjahr auswählen',
      },
      AILWIL04: {
        En: 'Origin',
        Et: 'Päritolu',
        Ar: 'أصل',
        Ml: 'ഉത്ഭവം',
        Ma: 'मूळ',
        Fr: 'Origine',
        Hi: 'मूल',
        Ta: 'தோற்றம்',
        Ja: '元',
        Ge: 'Herkunft',
      },
      AILWIDD03: {
        En: 'Select Origin',
        Et: 'Valige Origin',
        Ar: 'حدد الأصل',
        Ml: 'ഉത്ഭവം തിരഞ്ഞെടുക്കുക',
        Ma: 'मूळ निवडा',
        Fr: "Sélectionnez l'origine",
        Hi: 'उत्पत्ति का चयन करें',
        Ta: 'தோற்றத்தைத் தேர்ந்தெடுக்கவும்',
        Ja: '原点を選択',
        Ge: 'Wählen Sie Ursprung',
      },
    },

    AssetItemLevelTITLE: {
      AILTL01: {
        En: 'Original Title',
        Et: 'Algne pealkiri',
        Ar: 'العنوان الأصلي',
        Ml: 'യഥാർത്ഥ തലക്കെട്ട്',
        Ma: 'मूळ शीर्षक',
        Fr: 'Titre original',
        Hi: 'मूल शीर्षक',
        Ta: 'அசல் தலைப்பு',
        Ja: '元のタイトル',
        Ge: 'Originaler Titel',
      },
      AILTTB01: {
        En: 'Original Title Box',
        Et: 'Originaalpealkirja kast',
        Ar: 'مربع العنوان الأصلي',
        Ml: 'യഥാർത്ഥ ടൈറ്റിൽ ബോക്സ്',
        Ma: 'मूळ शीर्षक बॉक्स',
        Fr: 'Boîte de titre originale',
        Hi: 'मूल शीर्षक बॉक्स',
        Ta: 'அசல் தலைப்புப் பெட்டி',
        Ja: '元のタイトル ボックス',
        Ge: 'Originale Titelbox',
      },
      AILTL02: {
        En: 'Translated Title',
        Et: 'Tõlgitud pealkiri',
        Ar: 'عنوان مترجم',
        Ml: 'വിവർത്തനം ചെയ്ത ശീർഷകം',
        Ma: 'भाषांतरित शीर्षक',
        Fr: 'Titre traduit',
        Hi: 'अनुवादित शीर्षक',
        Ta: 'மொழிபெயர்க்கப்பட்ட தலைப்பு',
        Ja: '翻訳されたタイトル',
        Ge: 'Übersetzter Titel',
      },
      AILTTB02: {
        En: 'Translated Title Box',
        Et: 'Tõlgitud pealkirjakast',
        Ar: 'مربع العنوان المترجم',
        Ml: 'വിവർത്തനം ചെയ്ത ടൈറ്റിൽ ബോക്സ്',
        Ma: 'अनुवादित शीर्षक बॉक्स',
        Fr: 'Boîte de titre traduite',
        Hi: 'अनुवादित शीर्षक बॉक्स',
        Ta: 'மொழிபெயர்க்கப்பட்ட தலைப்புப் பெட்டி',
        Ja: '翻訳されたタイトル ボックス',
        Ge: 'Übersetztes Titelfeld',
      },
      AILTL03: {
        En: 'Alternative Title',
        Et: 'Alternatiivne pealkiri',
        Ar: 'عنوان بديل',
        Ml: 'ഇതര തലക്കെട്ട്',
        Ma: 'पर्यायी शीर्षक',
        Fr: 'Titre alternatif',
        Hi: 'वैकल्पिक शीर्षक',
        Ta: 'மாற்று தலைப்பு',
        Ja: '代替タイトル',
        Ge: 'Alternativer Titel',
      },
      AILTTB03: {
        En: 'Alternative Title Box',
        Et: 'Alternatiivne pealkirjakast',
        Ar: 'مربع العنوان البديل',
        Ml: 'ഇതര ടൈറ്റിൽ ബോക്സ്',
        Ma: 'पर्यायी शीर्षक बॉक्स',
        Fr: 'Zone de titre alternatif',
        Hi: 'वैकल्पिक शीर्षक बॉक्स',
        Ta: 'மாற்று தலைப்பு பெட்டி',
        Ja: '代替タイトル ボックス',
        Ge: 'Alternatives Titelfeld',
      },
    },

    AssetItemLevelLANGUAGE: {
      AILL01: {
        En: 'Original Language Origin',
        Et: 'Algkeele päritolu',
        Ar: 'أصل اللغة الأصلية',
        Ml: 'യഥാർത്ഥ ഭാഷയുടെ ഉത്ഭവം',
        Ma: 'मूळ भाषा मूळ',
        Fr: "Origine de la langue d'origine",
        Hi: 'मूल भाषा मूल',
        Ta: 'மூல மொழியின் தோற்றம்',
        Ja: '元の言語の起源',
        Ge: 'Herkunft der Originalsprache',
      },
      AILLDD01: {
        En: 'Original Language Origin Box',
        Et: 'Algkeele päritolu kast',
        Ar: 'مربع أصل اللغة الأصلية',
        Ml: 'യഥാർത്ഥ ഭാഷയുടെ ഉത്ഭവ ബോക്സ്',
        Ma: 'मूळ भाषा मूळ बॉक्स',
        Fr: "Boîte d'origine de la langue d'origine",
        Hi: 'मूल भाषा मूल बॉक्स',
        Ta: 'அசல் மொழி மூலப் பெட்டி',
        Ja: '原語起源ボックス',
        Ge: 'Ursprungsbox in Originalsprache',
      },
      AILL02: {
        En: 'Original Language',
        Et: 'Algkeel',
        Ar: 'اللغة الأصلية',
        Ml: 'യഥാർത്ഥ ഭാഷ',
        Ma: 'मूळ भाषा',
        Fr: 'Langue originale',
        Hi: 'वास्तविक भाषा',
        Ta: 'அசல் மொழி',
        Ja: '元の言語',
        Ge: 'Ursprache',
      },
      AILLDD02: {
        En: 'Original Language Box',
        Et: 'Algne keelekast',
        Ar: 'مربع اللغة الأصلية',
        Ml: 'യഥാർത്ഥ ഭാഷാ ബോക്സ്',
        Ma: 'मूळ भाषा बॉक्स',
        Fr: "Boîte de langue d'origine",
        Hi: 'मूल भाषा बॉक्स',
        Ta: 'அசல் மொழி பெட்டி',
        Ja: 'オリジナル言語ボックス',
        Ge: 'Box in der Originalsprache',
      },
      AILL03: {
        En: 'Dubbed Language Origin',
        Et: 'Dubleeritud keele päritolu',
        Ar: 'أصل اللغة المدبلجة',
        Ml: 'ഭാഷാ ഉത്ഭവം',
        Ma: 'डब केलेली भाषा मूळ',
        Fr: 'Origine de la langue doublée',
        Hi: 'डब की गई भाषा की उत्पत्ति',
        Ta: 'டப்பிங் மொழியின் தோற்றம்',
        Ja: '吹き替え言語の起源',
        Ge: 'Synchronisierter Sprachursprung',
      },
      AILLDD03: {
        En: 'Dubbed Language Origin Box',
        Et: 'Dubleeritud keele päritolu kast',
        Ar: 'مربع أصل اللغة المدبلجة',
        Ml: 'ഡബ്ബ് ചെയ്ത ഭാഷാ ഉത്ഭവ ബോക്സ്',
        Ma: 'डब केलेली भाषा मूळ बॉक्स',
        Fr: "Boîte d'origine de la langue doublée",
        Hi: 'डब की गई भाषा मूल बॉक्स',
        Ta: 'டப்பிங் மொழி மூலப் பெட்டி',
        Ja: '吹き替え言語の起源ボックス',
        Ge: 'Ursprungsbox für synchronisierte Sprache',
      },
      AILL04: {
        En: 'Dubbed Language',
        Et: 'Dubleeritud keel',
        Ar: 'اللغة المدبلجة',
        Ml: 'ഡബ്ബ് ചെയ്ത ഭാഷ',
        Ma: 'डब केलेली भाषा',
        Fr: 'Langue doublée',
        Hi: 'डब की गई भाषा',
        Ta: 'டப்பிங் மொழி',
        Ja: '吹き替え言語',
        Ge: 'Synchronisierte Sprache',
      },
      AILLDD04: {
        En: 'Dubbed Language Box',
        Et: 'Dubleeritud keelekast',
        Ar: 'مربع اللغة المدبلج',
        Ml: 'ഡബ്ബ് ചെയ്ത ഭാഷാ പെട്ടി',
        Ma: 'डब केलेला भाषा बॉक्स',
        Fr: 'Boîte de langue doublée',
        Hi: 'डब भाषा बॉक्स',
        Ta: 'டப்பிங் மொழி பெட்டி',
        Ja: '吹き替え言語ボックス',
        Ge: 'Synchronisierte Sprachbox',
      },
    },

    AssetItemLevelCERTIFICATION: {
      AILCL01: {
        En: 'Country of Production',
        Et: 'Tootmisriik',
        Ar: 'بلد الإنتاج',
        Ml: 'ഉൽപ്പാദന രാജ്യം',
        Ma: 'उत्पादन देश',
        Fr: 'Pays de production',
        Hi: 'उत्पादन का देश',
        Ta: 'உற்பத்தி நாடு',
        Ja: '生産国',
        Ge: 'Produktionsland',
      },
      AILCDD01: {
        En: 'Country of Production Box',
        Et: 'Tootmisriik Box',
        Ar: 'بلد الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ ബോക്സ് രാജ്യം',
        Ma: 'उत्पादन बॉक्स देश',
        Fr: 'Boîte Pays de production',
        Hi: 'उत्पादन बॉक्स का देश',
        Ta: 'உற்பத்தி பெட்டியின் நாடு',
        Ja: '生産国 箱',
        Ge: 'Produktionsland Box',
      },
      AILCL02: {
        En: 'Original Production Format',
        Et: 'Algne tootmisvorm',
        Ar: 'تنسيق الإنتاج الأصلي',
        Ml: 'ഒറിജിനൽ പ്രൊഡക്ഷൻ ഫോർമാറ്റ്',
        Ma: 'मूळ उत्पादन स्वरूप',
        Fr: 'Format de production original',
        Hi: 'मूल उत्पादन प्रारूप',
        Ta: 'அசல் உற்பத்தி வடிவம்',
        Ja: 'オリジナル制作フォーマット',
        Ge: 'Ursprüngliches Produktionsformat',
      },
      AILCDD02: {
        En: 'Original Production Format Box',
        Et: 'Originaalne tootmisformaadi karp',
        Ar: 'مربع تنسيق الإنتاج الأصلي',
        Ml: 'ഒറിജിനൽ പ്രൊഡക്ഷൻ ഫോർമാറ്റ് ബോക്സ്',
        Ma: 'मूळ उत्पादन स्वरूप बॉक्स',
        Fr: 'Boîte de format de production originale',
        Hi: 'मूल उत्पादन प्रारूप बॉक्स',
        Ta: 'அசல் தயாரிப்பு வடிவமைப்பு பெட்டி',
        Ja: 'オリジナル・プロダクション・フォーマット・ボックス',
        Ge: 'Box im Original-Produktionsformat',
      },
      AILCL03: {
        En: 'Released/Unreleased',
        Et: 'Välja antud/avaldamata',
        Ar: 'صدر / لم يطلق سراحه',
        Ml: 'റിലീസ് / റിലീസ് ചെയ്യാത്തത്',
        Ma: 'रिलीझ/अप्रकाशित',
        Fr: 'Sorti/Inédit',
        Hi: 'जारी/अप्रकाशित',
        Ta: 'வெளியிடப்பட்டது/வெளியிடப்படாதது',
        Ja: 'リリース済み/未リリース',
        Ge: 'Freigegeben/Nicht freigegeben',
      },
      AILCDD03: {
        En: 'Released/Unreleased Box',
        Et: 'Välja antud/avaldamata kast',
        Ar: 'صندوق تم إصداره / لم يتم طرحه',
        Ml: 'റിലീസ് ചെയ്‌ത/റിലീസ് ചെയ്യാത്ത ബോക്‌സ്',
        Ma: 'रिलीज केलेला/अप्रकाशित बॉक्स',
        Fr: 'Boîte publiée/inédite',
        Hi: 'जारी/अप्रकाशित बॉक्स',
        Ta: 'வெளியிடப்பட்ட/வெளியிடப்படாத பெட்டி',
        Ja: '発売済・未発売BOX',
        Ge: 'Freigegebene/unveröffentlichte Box',
      },
      AILCL04: {
        En: 'Year Of Reference',
        Et: 'Võrdlusaasta',
        Ar: 'سنة المرجع',
        Ml: 'റഫറൻസ് വർഷം',
        Ma: 'संदर्भ वर्ष',
        Fr: 'Année de référence',
        Hi: 'संदर्भ का वर्ष',
        Ta: 'குறிப்பு ஆண்டு',
        Ja: '基準年',
        Ge: 'Bezugsjahr',
      },
      AILCDD04: {
        En: 'Year Of Reference Box',
        Et: 'Aasta võrdluskast',
        Ar: 'سنة الصندوق المرجعي',
        Ml: 'റഫറൻസ് ബോക്സ് വർഷം',
        Ma: 'संदर्भ बॉक्सचे वर्ष',
        Fr: 'Année de la case de référence',
        Hi: 'संदर्भ बॉक्स का वर्ष',
        Ta: 'ஆண்டு குறிப்பு பெட்டி',
        Ja: '基準ボックスの年',
        Ge: 'Jahr der Referenzbox',
      },
      AILCL05: {
        En: 'Work Category',
        Et: 'Töö kategooria',
        Ar: 'فئة العمل',
        Ml: 'ജോലി വിഭാഗം',
        Ma: 'कार्य श्रेणी',
        Fr: 'Catégorie de travail',
        Hi: 'कार्य श्रेणी',
        Ta: 'வேலை வகை',
        Ja: '作業カテゴリ',
        Ge: 'Arbeitskategorie',
      },
      AILCDD05: {
        En: 'Work Category Box',
        Et: 'Töökategooria kast',
        Ar: 'مربع فئة العمل',
        Ml: 'വർക്ക് കാറ്റഗറി ബോക്സ്',
        Ma: 'कार्य श्रेणी बॉक्स',
        Fr: 'Zone de catégorie de travail',
        Hi: 'कार्य श्रेणी बॉक्स',
        Ta: 'வேலை வகை பெட்டி',
        Ja: '作品カテゴリーボックス',
        Ge: 'Feld „Arbeitskategorie“.',
      },
      AILCL06: {
        En: 'Certification No.',
        Et: 'Sertifikaadi nr.',
        Ar: 'رقم الشهادة',
        Ml: 'സർട്ടിഫിക്കേഷൻ നമ്പർ.',
        Ma: 'प्रमाणन क्र.',
        Fr: 'Numéro de certification',
        Hi: 'प्रमाणन संख्या',
        Ta: 'சான்றிதழ் எண்.',
        Ja: '認証番号',
        Ge: 'Zertifizierungs-Nr.',
      },
      AILCTB01: {
        En: 'Certification No. Box',
        Et: 'Sertifikaadi nr Kast',
        Ar: 'رقم الشهادة صندوق',
        Ml: 'സർട്ടിഫിക്കറ്റ് നമ്പർ ബോക്സ്',
        Ma: 'प्रमाणन क्रमांक बॉक्स',
        Fr: 'N° de certification Boîte',
        Hi: 'प्रमाणन संख्या बॉक्स',
        Ta: 'சான்றிதழ் எண். பெட்டி',
        Ja: '認証番号ボックス',
        Ge: 'Zertifizierung Nr. Feld',
      },
      AILCL07: {
        En: 'Certification Center',
        Et: 'Sertifitseerimiskeskus',
        Ar: 'مركز الاعتماد',
        Ml: 'സർട്ടിഫിക്കേഷൻ സെന്റർ',
        Ma: 'प्रमाणन केंद्र',
        Fr: 'Centre de certification',
        Hi: 'प्रमाणन केंद्र',
        Ta: 'சான்றிதழ் மையம்',
        Ja: '認証センター',
        Ge: 'Zertifizierungszentrum',
      },
      AILCTB02: {
        En: 'Certification Center Box',
        Et: 'Sertifitseerimiskeskuse kast',
        Ar: 'صندوق مركز الشهادات',
        Ml: 'സർട്ടിഫിക്കേഷൻ സെന്റർ ബോക്സ്',
        Ma: 'प्रमाणन केंद्र बॉक्स',
        Fr: 'Boîte du centre de certification',
        Hi: 'प्रमाणन केंद्र बॉक्स',
        Ta: 'சான்றிதழ் மைய பெட்டி',
        Ja: '認証センター ボックス',
        Ge: 'Box des Zertifizierungszentrums',
      },
      AILCL08: {
        En: 'Certification Date',
        Et: 'Sertifitseerimise kuupäev',
        Ar: 'تاريخ الشهادة',
        Ml: 'സർട്ടിഫിക്കേഷൻ തീയതി',
        Ma: 'प्रमाणन तारीख',
        Fr: 'Date de certification',
        Hi: 'प्रमाणन तिथि',
        Ta: 'சான்றிதழ் தேதி',
        Ja: '認証日',
        Ge: 'Zertifizierungsdatum',
      },
      AILCTB03: {
        En: 'Certification Date Box',
        Et: 'Sertifitseerimise kuupäeva kast',
        Ar: 'مربع تاريخ الشهادة',
        Ml: 'സർട്ടിഫിക്കേഷൻ തീയതി ബോക്സ്',
        Ma: 'प्रमाणन तारीख बॉक्स',
        Fr: 'Case de la date de certification',
        Hi: 'प्रमाणन तिथि बॉक्स',
        Ta: 'சான்றிதழ் தேதி பெட்டி',
        Ja: '認証日ボックス',
        Ge: 'Feld Zertifizierungsdatum',
      },
      AILCL09: {
        En: 'Synopsis',
        Et: 'Sisukokkuvõte',
        Ar: 'ملخص',
        Ml: 'സംഗ്രഹം',
        Ma: 'सारांश',
        Fr: 'Synopsis',
        Hi: 'सार',
        Ta: 'சுருக்கம்',
        Ja: 'あらすじ',
        Ge: 'Zusammenfassung',
      },
      AILCTB04: {
        En: 'Synopsis Box',
        Et: 'Kokkuvõtte kast',
        Ar: 'مربع ملخص',
        Ml: 'സംഗ്രഹ പെട്ടി',
        Ma: 'सारांश बॉक्स',
        Fr: 'Encadré Résumé',
        Hi: 'सारांश बॉक्स',
        Ta: 'சுருக்கப் பெட்டி',
        Ja: 'まとめボックス',
        Ge: 'Übersichtsbox',
      },
    },

    AssetItemLevelPHYSICALASSETDETAILS: {
      AILPAL01: {
        En: 'Length of Film(meters)',
        Et: 'Filmi pikkus (meetrites)',
        Ar: 'طول الفيلم (متر)',
        Ml: 'സിനിമയുടെ ദൈർഘ്യം (മീറ്റർ)',
        Ma: 'चित्रपटाची लांबी (मीटर)',
        Fr: 'Longueur du film (mètres)',
        Hi: 'फिल्म की लंबाई (मीटर)',
        Ta: 'படத்தின் நீளம் (மீட்டர்கள்)',
        Ja: 'フィルムの長さ(メートル)',
        Ge: 'Filmlänge (Meter)',
      },
      AILPATB01: {
        En: 'Length of Film(meters) Box',
        Et: 'Kile pikkus (meetrites) Kast',
        Ar: 'طول الفيلم (متر) صندوق',
        Ml: 'ഫിലിം (മീറ്റർ) ബോക്‌സിന്റെ നീളം',
        Ma: 'चित्रपटाची लांबी (मीटर) बॉक्स',
        Fr: 'Boîte de longueur de film (mètres)',
        Hi: 'फिल्म की लंबाई (मीटर) बॉक्स',
        Ta: 'ஃபிலிம் (மீட்டர்) பெட்டியின் நீளம்',
        Ja: 'フィルムの長さ(メートル) ボックス',
        Ge: 'Länge des Films (Meter) Box',
      },
      AILPAL02: {
        En: 'Duration in Minutes',
        Et: 'Kestus minutites',
        Ar: 'المدة بالدقائق',
        Ml: 'മിനിറ്റുകളിൽ ദൈർഘ്യം',
        Ma: 'मिनिटांमध्ये कालावधी',
        Fr: 'Durée en minutes',
        Hi: 'मिनटों में अवधि',
        Ta: 'நிமிடங்களில் கால அளவு',
        Ja: '期間 (分)',
        Ge: 'Dauer in Minuten',
      },
      AILPATB02: {
        En: 'Duration in Minutes Box',
        Et: 'Kestus minutites',
        Ar: 'المدة في مربع الدقائق',
        Ml: 'മിനിറ്റ് ബോക്സിലെ ദൈർഘ്യം',
        Ma: 'मिनिट बॉक्समध्ये कालावधी',
        Fr: 'Case Durée en minutes',
        Hi: 'मिनट बॉक्स में अवधि',
        Ta: 'நிமிடப் பெட்டியில் கால அளவு',
        Ja: '期間 (分) ボックス',
        Ge: 'Dauer im Minutenfeld',
      },
      AILPAL04: {
        En: 'Total No. of Reel/CAN',
        Et: 'Rulli/CANi koguarv',
        Ar: 'إجمالي عدد بكرة / CAN',
        Ml: 'റീൽ/CAN-ന്റെ ആകെ എണ്ണം',
        Ma: 'Reel/CAN ची एकूण संख्या',
        Fr: 'Nombre total de bobines/CAN',
        Hi: 'रील/CAN . की कुल संख्या',
        Ta: 'ரீல்/CAN மொத்த எண்ணிக்கை',
        Ja: 'リール/CANの総数',
        Ge: 'Gesamtzahl der Rollen/CAN',
      },
      AILPATB03: {
        En: 'Total No. of Reel/CAN Box',
        Et: 'Rulli/CAN-kasti koguarv',
        Ar: 'إجمالي عدد بكرة / علبة علب',
        Ml: 'റീൽ/CAN ബോക്‌സിന്റെ ആകെ എണ്ണം',
        Ma: 'रील/कॅन बॉक्सची एकूण संख्या',
        Fr: 'Nombre total de bobines/boîte CAN',
        Hi: 'रील/कैन बॉक्स की कुल संख्या',
        Ta: 'ரீல்/CAN பெட்டியின் மொத்த எண்ணிக்கை',
        Ja: 'リール/CAN ボックスの総数',
        Ge: 'Gesamtzahl der Rollen/CAN-Boxen',
      },
    },

    AssetItemLevelASSETPREVIEWDETAILS: {
      AILAPL01: {
        En: 'Proxy',
        Et: 'Puhverserver',
        Ar: 'الوكيل',
        Ml: 'പ്രോക്സി',
        Ma: 'प्रॉक्सी',
        Fr: 'Procuration',
        Hi: 'प्रतिनिधि',
        Ta: 'பதிலாள்',
        Ja: 'プロキシー',
        Ge: 'Proxy',
      },
      AILAPDD01: {
        En: 'Proxy Box',
        Et: 'Puhverserveri kast',
        Ar: 'صندوق الوكيل',
        Ml: 'പ്രോക്സി ബോക്സ്',
        Ma: 'प्रॉक्सी बॉक्स',
        Fr: 'Boîte de procuration',
        Hi: 'प्रॉक्सी बॉक्स',
        Ta: 'பதிலாள் பெட்டி',
        Ja: 'プロキシボックス',
        Ge: 'Proxy-Box',
      },
      AILAPL02: {
        En: 'Small Thumbnail',
        Et: 'Väike pisipilt',
        Ar: 'صورة مصغرة صغيرة',
        Ml: 'ചെറിയ ലഘുചിത്രം',
        Ma: 'लहान लघुप्रतिमा',
        Fr: 'Petite vignette',
        Hi: 'छोटा थंबनेल',
        Ta: 'சிறிய சிறுபடம்',
        Ja: '小さなサムネイル',
        Ge: 'Kleines Vorschaubild',
      },
      AILAPTB01: {
        En: 'Small Thumbnail Box',
        Et: 'Väike pisipiltide kast',
        Ar: 'صندوق مصغّر صغير',
        Ml: 'ചെറിയ ലഘുചിത്ര ബോക്സ്',
        Ma: 'लहान लघुप्रतिमा बॉक्स',
        Fr: 'Petite boîte de vignettes',
        Hi: 'छोटा थंबनेल बॉक्स',
        Ta: 'சிறிய சிறுபடப்பெட்டி',
        Ja: '小さいサムネイル ボックス',
        Ge: 'Kleine Thumbnail-Box',
      },
      AILAPL03: {
        En: 'Large Thumbnail',
        Et: 'Suur pisipilt',
        Ar: 'صورة مصغرة كبيرة',
        Ml: 'വലിയ ലഘുചിത്രം',
        Ma: 'मोठी लघुप्रतिमा',
        Fr: 'Grande vignette',
        Hi: 'बड़ा थंबनेल',
        Ta: 'பெரிய சிறுபடம்',
        Ja: '大きなサムネイル',
        Ge: 'Großes Miniaturbild',
      },
      AILAPTB02: {
        En: 'Large Thumbnail Box',
        Et: 'Suur pisipiltide kast',
        Ar: 'صندوق مصغّر كبير',
        Ml: 'വലിയ ലഘുചിത്ര ബോക്സ്',
        Ma: 'मोठा लघुप्रतिमा बॉक्स',
        Fr: 'Grande boîte de vignettes',
        Hi: 'बड़ा थंबनेल बॉक्स',
        Ta: 'பெரிய சிறுபடப்பெட்டி',
        Ja: '大きなサムネイル ボックス',
        Ge: 'Große Miniaturansichtsbox',
      },
    },

    AssetItemLevelASSETSTORAGEDETAILS: {
      AILASL01: {
        En: 'Barcode',
        Et: 'Vöötkood',
        Ar: 'الرمز الشريطي',
        Ml: 'ബാർകോഡ്',
        Ma: 'बारकोड',
        Fr: 'code à barre',
        Hi: 'बारकोड',
        Ta: 'பார்கோடு',
        Ja: 'バーコード',
        Ge: 'Strichcode',
      },
      AILASTB01: {
        En: 'Barcode Box',
        Et: 'Vöötkoodi kast',
        Ar: 'صندوق الباركود',
        Ml: 'ബാർകോഡ് ബോക്സ്',
        Ma: 'बारकोड बॉक्स',
        Fr: 'Boîte à code-barres',
        Hi: 'बारकोड बॉक्स',
        Ta: 'பார்கோடு பெட்டி',
        Ja: 'バーコードボックス',
        Ge: 'Barcode-Box',
      },
      AILASL02: {
        En: 'NFC',
        Et: 'NFC',
        Ar: 'NFC',
        Ml: 'എൻഎഫ്സി',
        Ma: 'NFC',
        Fr: 'NFC',
        Hi: 'एनएफसी',
        Ta: 'NFC',
        Ja: 'NFC',
        Ge: 'NFC',
      },
      AILASTB02: {
        En: 'NFC Box',
        Et: 'NFC kast',
        Ar: 'صندوق NFC',
        Ml: 'NFC ബോക്സ്',
        Ma: 'NFC बॉक्स',
        Fr: 'Boîte NFC',
        Hi: 'एनएफसी बॉक्स',
        Ta: 'NFC பெட்டி',
        Ja: 'NFC ボックス',
        Ge: 'NFC-Box',
      },
      AILASL03: {
        En: 'RFID',
        Et: 'RFID',
        Ar: 'RFID',
        Ml: 'RFID',
        Ma: 'RFID',
        Fr: 'RFID',
        Hi: 'आरएफआईडी',
        Ta: 'RFID',
        Ja: 'RFID',
        Ge: 'RFID',
      },
      AILASTB03: {
        En: 'RFID Box',
        Et: 'RFID kast',
        Ar: 'صندوق RFID',
        Ml: 'RFID ബോക്സ്',
        Ma: 'आरएफआयडी बॉक्स',
        Fr: 'Boîte RFID',
        Hi: 'आरएफआईडी बॉक्स',
        Ta: 'RFID பெட்டி',
        Ja: 'RFID ボックス',
        Ge: 'RFID-Box',
      },
      AILASL04: {
        En: 'Rack Location',
        Et: 'Racki asukoht',
        Ar: 'موقع الرف',
        Ml: 'റാക്ക് സ്ഥാനം',
        Ma: 'रॅक स्थान',
        Fr: 'Emplacement du rack',
        Hi: 'रैक स्थान',
        Ta: 'ரேக் இடம்',
        Ja: 'ラックの場所',
        Ge: 'Rack-Standort',
      },
      AILASTB04: {
        En: 'Rack Location Box',
        Et: 'Rack asukoha kast',
        Ar: 'صندوق موقع الرف',
        Ml: 'റാക്ക് ലൊക്കേഷൻ ബോക്സ്',
        Ma: 'रॅक स्थान बॉक्स',
        Fr: "Boîte d'emplacement de rack",
        Hi: 'रैक स्थान बॉक्स',
        Ta: 'ரேக் இருப்பிடப் பெட்டி',
        Ja: 'ラックロケーションボックス',
        Ge: 'Rack-Location-Box',
      },
      AILASL05: {
        En: 'Shelf Location',
        Et: 'Riiuli asukoht',
        Ar: 'موقع الجرف',
        Ml: 'ഷെൽഫ് സ്ഥാനം',
        Ma: 'शेल्फ स्थान',
        Fr: "Emplacement de l'étagère",
        Hi: 'शेल्फ स्थान',
        Ta: 'ஷெல்ஃப் இடம்',
        Ja: '棚の場所',
        Ge: 'Regalstandort',
      },
      AILASTB05: {
        En: 'Shelf Location Box',
        Et: 'Riiuli asukoha kast',
        Ar: 'صندوق موقع الجرف',
        Ml: 'ഷെൽഫ് ലൊക്കേഷൻ ബോക്സ്',
        Ma: 'शेल्फ स्थान बॉक्स',
        Fr: "Boîte d'emplacement d'étagère",
        Hi: 'शेल्फ स्थान बॉक्स',
        Ta: 'ஷெல்ஃப் இருப்பிடப் பெட்டி',
        Ja: '棚位置ボックス',
        Ge: 'Regalplatzbox',
      },
      AILASL06: {
        En: 'Vault Location',
        Et: 'Võlvi asukoht',
        Ar: 'موقع Vault',
        Ml: 'വോൾട്ട് സ്ഥാനം',
        Ma: 'वॉल्ट स्थान',
        Fr: 'Emplacement du coffre-fort',
        Hi: 'तिजोरी स्थान',
        Ta: 'வால்ட் இடம்',
        Ja: 'ボールトの場所',
        Ge: 'Vault-Standort',
      },
      AILASTB06: {
        En: 'Vault Location Box',
        Et: 'Võlvi asukohakast',
        Ar: 'صندوق موقع Vault',
        Ml: 'വോൾട്ട് ലൊക്കേഷൻ ബോക്സ്',
        Ma: 'वॉल्ट स्थान बॉक्स',
        Fr: "Zone d'emplacement du coffre-fort",
        Hi: 'तिजोरी स्थान बॉक्स',
        Ta: 'வால்ட் இருப்பிட பெட்டி',
        Ja: 'ボールト ロケーション ボックス',
        Ge: 'Vault-Standort-Box',
      },
    },

    AssetItemLevelPRODUCTION: {
      AILPL01: {
        En: 'Banner',
        Et: 'Bänner',
        Ar: 'لافتة',
        Ml: 'ബാനർ',
        Ma: 'बॅनर',
        Fr: 'Bannière',
        Hi: 'बैनर',
        Ta: 'பதாகை',
        Ja: 'バナー',
        Ge: 'Banner',
      },
      AILPTB01: {
        En: 'Banner Box',
        Et: 'Bänneri kast',
        Ar: 'صندوق بانر',
        Ml: 'ബാനർ ബോക്സ്',
        Ma: 'बॅनर बॉक्स',
        Fr: 'Boîte à bannières',
        Hi: 'बैनर बॉक्स',
        Ta: 'பேனர் பெட்டி',
        Ja: 'バナーボックス',
        Ge: 'Banner-Box',
      },
      AILPL02: {
        En: 'Associate Producer',
        Et: 'Kaasprodutsent',
        Ar: 'منتج مشارك',
        Ml: 'അസോസിയേറ്റ് പ്രൊഡ്യൂസർ',
        Ma: 'सहयोगी निर्माता',
        Fr: 'Producteur associé',
        Hi: 'सहयोगी निर्माता',
        Ta: 'இணை தயாரிப்பாளர்',
        Ja: 'アソシエイトプロデューサー',
        Ge: 'Assoziierter Produzent',
      },
      AILPTB02: {
        En: 'Associate Producer Box',
        Et: 'Kaasprodutsendi kast',
        Ar: 'صندوق المنتج المساعد',
        Ml: 'അസോസിയേറ്റ് പ്രൊഡ്യൂസർ ബോക്സ്',
        Ma: 'सहयोगी निर्माता बॉक्स',
        Fr: 'Boîte de producteur associé',
        Hi: 'एसोसिएट प्रोड्यूसर बॉक्स',
        Ta: 'இணை தயாரிப்பாளர் பெட்டி',
        Ja: 'アソシエイトプロデューサーボックス',
        Ge: 'Associate Producer-Box',
      },
      AILPL03: {
        En: 'Executive Producer',
        Et: 'Produtsent',
        Ar: 'المنتج التنفيذي',
        Ml: 'എക്സിക്യൂട്ടീവ് പ്രൊഡ്യൂസർ',
        Ma: 'कार्यकारी निर्माता',
        Fr: 'Producteur exécutif',
        Hi: 'कार्यकारी निर्माता',
        Ta: 'நிர்வாக தயாரிப்பாளர்',
        Ja: '製作責任者',
        Ge: 'Ausführender Produzent',
      },
      AILPTB03: {
        En: 'Executive Producer Box',
        Et: 'Tegevprodutsendi kast',
        Ar: 'صندوق المنتج التنفيذي',
        Ml: 'എക്സിക്യൂട്ടീവ് പ്രൊഡ്യൂസർ ബോക്സ്',
        Ma: 'कार्यकारी निर्माता बॉक्स',
        Fr: 'Boîte de producteur exécutif',
        Hi: 'कार्यकारी निर्माता बॉक्स',
        Ta: 'நிர்வாக தயாரிப்பாளர் பெட்டி',
        Ja: '製作総指揮ボックス',
        Ge: 'Executive-Producer-Box',
      },
      AILPL04: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      AILPTB04: {
        En: 'Director Box',
        Et: 'Direktor Box',
        Ar: 'صندوق المخرج',
        Ml: 'ഡയറക്ടർ ബോക്സ്',
        Ma: 'दिग्दर्शक बॉक्स',
        Fr: 'Boîte de réalisateur',
        Hi: 'निदेशक बॉक्स',
        Ta: 'இயக்குனர் பெட்டி',
        Ja: 'ディレクターボックス',
        Ge: 'Direktor Box',
      },
    },

    AssetItemLevelSTORYANDSCREEnPLAY: {
      AILSL01: {
        En: 'Story',
        Et: 'Lugu',
        Ar: 'قصة',
        Ml: 'കഥ',
        Ma: 'कथा',
        Fr: 'Histoire',
        Hi: 'कहानी',
        Ta: 'கதை',
        Ja: '話',
        Ge: 'Geschichte',
      },
      AILSTB01: {
        En: 'Story Box',
        Et: 'Lugude kast',
        Ar: 'صندوق القصة',
        Ml: 'സ്റ്റോറി ബോക്സ്',
        Ma: 'कथा पेटी',
        Fr: 'Boîte à histoire',
        Hi: 'कहानी बॉक्स',
        Ta: 'கதை பெட்டி',
        Ja: 'ストーリーボックス',
        Ge: 'Story-Box',
      },
      AILSL02: {
        En: 'Screen Play',
        Et: 'Ekraani esitamine',
        Ar: 'تشغيل الشاشة',
        Ml: 'സ്ക്രീൻ പ്ലേ',
        Ma: 'स्क्रीन प्ले',
        Fr: "Lecture d'écran",
        Hi: 'स्क्रीन प्ले',
        Ta: 'ஸ்கிரீன் ப்ளே',
        Ja: 'スクリーンプレイ',
        Ge: 'Bildschirmwiedergabe',
      },
      AILSTB02: {
        En: 'Screen Play Box',
        Et: 'Ekraani esituskast',
        Ar: 'مربع تشغيل الشاشة',
        Ml: 'സ്ക്രീൻ പ്ലേ ബോക്സ്',
        Ma: 'स्क्रीन प्ले बॉक्स',
        Fr: "Boîte de lecture d'écran",
        Hi: 'स्क्रीन प्ले बॉक्स',
        Ta: 'ஸ்கிரீன் ப்ளே பாக்ஸ்',
        Ja: 'スクリーン プレイ ボックス',
        Ge: 'Screen-Play-Box',
      },
      AILSL03: {
        En: 'Dialogue',
        Et: 'Dialoog',
        Ar: 'حوار',
        Ml: 'ഡയലോഗ്',
        Ma: 'संवाद',
        Fr: 'Dialogue',
        Hi: 'वार्ता',
        Ta: 'உரையாடல்',
        Ja: 'ダイアログ',
        Ge: 'Dialog',
      },
      AILSTB03: {
        En: 'Dialogue Box',
        Et: 'Dialoogikast',
        Ar: 'مربع حوار',
        Ml: 'ഡയലോഗ് ബോക്സ്',
        Ma: 'डायलॉग बॉक्स',
        Fr: 'Boîte de dialogue',
        Hi: 'डायलॉग बॉक्स',
        Ta: 'உரையாடல் பெட்டி',
        Ja: 'ダイアログ ボックス',
        Ge: 'Dialog Box',
      },
      AILSL04: {
        En: 'Cinematography',
        Et: 'Kinematograafia',
        Ar: 'تصوير سينمائي',
        Ml: 'ഛായാഗ്രഹണം',
        Ma: 'सिनेमॅटोग्राफी',
        Fr: 'Cinématographie',
        Hi: 'छायांकन',
        Ta: 'ஒளிப்பதிவு',
        Ja: '撮影',
        Ge: 'Kinematographie',
      },
      AILSTB04: {
        En: 'Cinematography Box',
        Et: 'Kinematograafiakast',
        Ar: 'صندوق التصوير السينمائي',
        Ml: 'സിനിമാട്ടോഗ്രാഫി ബോക്സ്',
        Ma: 'सिनेमॅटोग्राफी बॉक्स',
        Fr: 'Boîte de cinématographie',
        Hi: 'छायांकन बॉक्स',
        Ta: 'ஒளிப்பதிவு பெட்டி',
        Ja: '撮影ボックス',
        Ge: 'Kinematographie-Box',
      },
    },

    AssetItemLevelARTDIRECTIONANDEDITING: {
      AILAL01: {
        En: 'Art Direction',
        Et: 'Kunstisuund',
        Ar: 'اتجاه الفن',
        Ml: 'കലാസംവിധാനം',
        Ma: 'कला दिग्दर्शन',
        Fr: 'Direction artistique',
        Hi: 'कला निर्देशन',
        Ta: 'கலை இயக்கம்',
        Ja: 'アートディレクション',
        Ge: 'Kunstrichtung',
      },
      AILATB01: {
        En: 'Art Direction Box',
        Et: 'Kunsti suunakast',
        Ar: 'صندوق اتجاه الفن',
        Ml: 'ആർട്ട് ഡയറക്ഷൻ ബോക്സ്',
        Ma: 'कला दिग्दर्शन बॉक्स',
        Fr: 'Boîte de direction artistique',
        Hi: 'कला निर्देशन बॉक्स',
        Ta: 'கலை இயக்கு பெட்டி',
        Ja: 'アートディレクションボックス',
        Ge: 'Art-Direction-Box',
      },
      AILAL02: {
        En: 'Photography',
        Et: 'Fotograafia',
        Ar: 'التصوير',
        Ml: 'ഫോട്ടോഗ്രാഫി',
        Ma: 'छायाचित्रण',
        Fr: 'La photographie',
        Hi: 'फोटोग्राफी',
        Ta: 'புகைப்படம் எடுத்தல்',
        Ja: '写真撮影',
        Ge: 'Fotografie',
      },
      AILATB02: {
        En: 'Photography Box',
        Et: 'Fotokast',
        Ar: 'صندوق التصوير',
        Ml: 'ഫോട്ടോഗ്രാഫി ബോക്സ്',
        Ma: 'फोटोग्राफी बॉक्स',
        Fr: 'Coffret Photographie',
        Hi: 'फोटोग्राफी बॉक्स',
        Ta: 'புகைப்பட பெட்டி',
        Ja: '写真ボックス',
        Ge: 'Fotografie-Box',
      },
      AILAL03: {
        En: 'Editing',
        Et: 'Redigeerimine',
        Ar: 'التحرير',
        Ml: 'എഡിറ്റിംഗ്',
        Ma: 'संपादन',
        Fr: 'Édition',
        Hi: 'संपादन',
        Ta: 'எடிட்டிங்',
        Ja: '編集',
        Ge: 'Bearbeitung',
      },
      AILATB03: {
        En: 'Editing Box',
        Et: 'Redigeerimiskast',
        Ar: 'مربع التحرير',
        Ml: 'എഡിറ്റിംഗ് ബോക്സ്',
        Ma: 'संपादन बॉक्स',
        Fr: "Boîte d'édition",
        Hi: 'संपादन बॉक्स',
        Ta: 'எடிட்டிங் பாக்ஸ்',
        Ja: '編集ボックス',
        Ge: 'Bearbeitungsfeld',
      },
      AILAL04: {
        En: 'Dubbing',
        Et: 'Dubleerimine',
        Ar: 'الدبلجة',
        Ml: 'ഡബ്ബിംഗ്',
        Ma: 'डबिंग',
        Fr: 'Doublage',
        Hi: 'एक प्रकार की चरबी',
        Ta: 'டப்பிங்',
        Ja: 'ダビング',
        Ge: 'Überspielen',
      },
      AILATB04: {
        En: 'Dubbing Box',
        Et: 'Dubleerimiskast',
        Ar: 'صندوق الدبلجة',
        Ml: 'ഡബ്ബിംഗ് ബോക്സ്',
        Ma: 'डबिंग बॉक्स',
        Fr: 'Boîte de doublage',
        Hi: 'डबिंग बॉक्स',
        Ta: 'டப்பிங் பாக்ஸ்',
        Ja: 'ダビングボックス',
        Ge: 'Dubbing-Box',
      },
    },

    AssetItemLevelSOUND: {
      AILSL01: {
        En: 'Sound Designer',
        Et: 'Helikujundaja',
        Ar: 'مصمم الصوت',
        Ml: 'സൗണ്ട് ഡിസൈനർ',
        Ma: 'ध्वनी डिझायनर',
        Fr: 'Concepteur sonore',
        Hi: 'ध्वनि डिजाइनर',
        Ta: 'ஒலி வடிவமைப்பாளர்',
        Ja: 'サウンドデザイナー',
        Ge: 'Sounddesigner',
      },
      AILSTB01: {
        En: 'Sound Designer Box',
        Et: 'Helikujundaja kast',
        Ar: 'صندوق مصمم الصوت',
        Ml: 'സൗണ്ട് ഡിസൈനർ ബോക്സ്',
        Ma: 'साउंड डिझायनर बॉक्स',
        Fr: 'Boîte de concepteur sonore',
        Hi: 'ध्वनि डिजाइनर बॉक्स',
        Ta: 'ஒலி வடிவமைப்பாளர் பெட்டி',
        Ja: 'サウンドデザイナーボックス',
        Ge: 'Sound-Designer-Box',
      },
      AILSL02: {
        En: 'Sound Effects',
        Et: 'Heliefektid',
        Ar: 'مؤثرات صوتية',
        Ml: 'സൗണ്ട് ഇഫക്റ്റുകൾ',
        Ma: 'ध्वनी प्रभाव',
        Fr: 'Effets sonores',
        Hi: 'ध्वनि प्रभाव',
        Ta: 'ஒலி விளைவுகள்',
        Ja: '音響効果',
        Ge: 'Soundeffekte',
      },
      AILSTB02: {
        En: 'Sound Effects Box',
        Et: 'Heliefektide kast',
        Ar: 'صندوق المؤثرات الصوتية',
        Ml: 'സൗണ്ട് ഇഫക്റ്റ് ബോക്സ്',
        Ma: 'ध्वनी प्रभाव बॉक्स',
        Fr: 'Boîte à effets sonores',
        Hi: 'ध्वनि प्रभाव बॉक्स',
        Ta: 'ஒலி விளைவுகள் பெட்டி',
        Ja: '効果音ボックス',
        Ge: 'Soundeffekt-Box',
      },
      AILSL03: {
        En: 'Sound Mixing',
        Et: 'Heli segamine',
        Ar: 'خلط الصوت',
        Ml: 'ശബ്ദ മിശ്രണം',
        Ma: 'ध्वनी मिक्सिंग',
        Fr: 'Mixage du son',
        Hi: 'ध्वनि मिश्रण',
        Ta: 'ஒலி கலவை',
        Ja: 'サウンドミキシング',
        Ge: 'Tonmischung',
      },
      AILSTB03: {
        En: 'Sound Mixing Box',
        Et: 'Heli segamise kast',
        Ar: 'صندوق خلط الصوت',
        Ml: 'സൗണ്ട് മിക്സിംഗ് ബോക്സ്',
        Ma: 'साउंड मिक्सिंग बॉक्स',
        Fr: 'Boîte de mixage sonore',
        Hi: 'ध्वनि मिश्रण बॉक्स',
        Ta: 'ஒலி கலவை பெட்டி',
        Ja: 'サウンドミキシングボックス',
        Ge: 'Sound-Mischbox',
      },
      AILSL04: {
        En: 'Sound Recordist',
        Et: 'Helisalvestus',
        Ar: 'مسجل صوت',
        Ml: 'സൗണ്ട് റെക്കോർഡിസ്റ്റ്',
        Ma: 'ध्वनी रेकॉर्डिस्ट',
        Fr: 'Enregistreur de son',
        Hi: 'ध्वनि रिकॉर्डिस्ट',
        Ta: 'ஒலிப்பதிவாளர்',
        Ja: '録音技師',
        Ge: 'Tonmeister',
      },
      AILSTB04: {
        En: 'Sound Recordist Box',
        Et: 'Helisalvestuse kast',
        Ar: 'صندوق مسجل الصوت',
        Ml: 'സൗണ്ട് റെക്കോർഡിസ്റ്റ് ബോക്സ്',
        Ma: 'ध्वनी रेकॉर्डिस्ट बॉक्स',
        Fr: "Boîte d'enregistrement sonore",
        Hi: 'ध्वनि रिकॉर्डिस्ट बॉक्स',
        Ta: 'ஒலிப்பதிவு பெட்டி',
        Ja: '録音ボックス',
        Ge: 'Soundrecordist-Box',
      },
    },

    AssetItemLevelMUSIC: {
      AILML01: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      AILMTB01: {
        En: 'Music Box',
        Et: 'Muusikakast',
        Ar: 'صندوق الموسيقى',
        Ml: 'പാട്ടുപെട്ടി',
        Ma: 'संगीत पेटी',
        Fr: 'Boîte à musique',
        Hi: 'संगीत बक्सा',
        Ta: 'இசை பெட்டி',
        Ja: 'オルゴール',
        Ge: 'Musikbox',
      },
      AILML02: {
        En: 'Music Background Score',
        Et: 'Muusika taustamuusika',
        Ar: 'نتيجة خلفية الموسيقى',
        Ml: 'സംഗീത പശ്ചാത്തല സ്കോർ',
        Ma: 'संगीत पार्श्वभूमी स्कोअर',
        Fr: 'Musique de fond',
        Hi: 'संगीत पृष्ठभूमि स्कोर',
        Ta: 'இசை பின்னணி இசை',
        Ja: '音楽のバックグラウンド スコア',
        Ge: 'Musik-Hintergrund-Score',
      },
      AILMTB02: {
        En: 'Music Background Score Box',
        Et: 'Muusika taustamuusika kast',
        Ar: 'مربع نقاط خلفية الموسيقى',
        Ml: 'സംഗീത പശ്ചാത്തല സ്കോർ ബോക്സ്',
        Ma: 'संगीत पार्श्वभूमी स्कोअर बॉक्स',
        Fr: 'Boîte de partition de fond musical',
        Hi: 'संगीत पृष्ठभूमि स्कोर बॉक्स',
        Ta: 'இசை பின்னணி மதிப்பெண் பெட்டி',
        Ja: 'ミュージック バックグラウンド スコア ボックス',
        Ge: 'Musik-Hintergrund-Score-Box',
      },
      AILML03: {
        En: 'Lyrics',
        Et: 'Laulusõnad',
        Ar: 'كلمات الاغنية',
        Ml: 'വരികൾ',
        Ma: 'गाण्याचे बोल',
        Fr: 'Paroles',
        Hi: 'बोल',
        Ta: 'பாடல் வரிகள்',
        Ja: '歌詞',
        Ge: 'Text',
      },
      AILMTB03: {
        En: 'Lyrics Box',
        Et: 'Laulusõnade kast',
        Ar: 'صندوق الأغاني',
        Ml: 'ലിറിക്സ് ബോക്സ്',
        Ma: 'लिरिक्स बॉक्स',
        Fr: 'Boîte à paroles',
        Hi: 'गीत बॉक्स',
        Ta: 'பாடல் வரிகள் பெட்டி',
        Ja: '歌詞ボックス',
        Ge: 'Songtext-Box',
      },
      AILML04: {
        En: 'Songs',
        Et: 'Laulud',
        Ar: 'الأغاني',
        Ml: 'ഗാനങ്ങൾ',
        Ma: 'गाणी',
        Fr: 'Chansons',
        Hi: 'गीत',
        Ta: 'பாடல்கள்',
        Ja: '曲',
        Ge: 'Lieder',
      },
      AILMTB04: {
        En: 'Songs Box',
        Et: 'Laulude kast',
        Ar: 'صندوق الأغاني',
        Ml: 'പാട്ടുകളുടെ പെട്ടി',
        Ma: 'गाण्यांची पेटी',
        Fr: 'Boîte à chansons',
        Hi: 'गाने का डिब्बा',
        Ta: 'பாடல் பெட்டி',
        Ja: 'ソングスボックス',
        Ge: 'Lieder-Box',
      },
    },

    AssetItemLevelCASTANDARTISTS: {
      AILCAL01: {
        En: 'Cast',
        Et: 'Cast',
        Ar: 'يقذف',
        Ml: 'കാസ്റ്റ്',
        Ma: 'कास्ट',
        Fr: 'Moulage',
        Hi: 'फेंकना',
        Ta: 'நடிகர்கள்',
        Ja: 'キャスト',
        Ge: 'Gießen',
      },
      AILCATB01: {
        En: 'Cast Box',
        Et: 'Castbox',
        Ar: 'Castbox',
        Ml: 'കാസ്റ്റ്ബോക്സ്',
        Ma: 'कास्टबॉक्स',
        Fr: 'Castbox',
        Hi: 'कास्टबॉक्स',
        Ta: 'காஸ்ட்பாக்ஸ்',
        Ja: 'キャストボックス',
        Ge: 'Castbox',
      },
      AILCAL02: {
        En: 'Playback Singers',
        Et: 'Playback Singers',
        Ar: 'مطربين التشغيل',
        Ml: 'പിന്നണി ഗായകർ',
        Ma: 'पार्श्वगायक',
        Fr: 'Chanteurs de lecture',
        Hi: 'पार्श्व गायक',
        Ta: 'பின்னணி பாடகர்கள்',
        Ja: '再生歌手',
        Ge: 'Playback-Sänger',
      },
      AILCATB02: {
        En: 'Playback Singers Box',
        Et: 'Playback Singers Box',
        Ar: 'صندوق مطربين التشغيل',
        Ml: 'പിന്നണി ഗായകരുടെ ബോക്സ്',
        Ma: 'प्लेबॅक सिंगर्स बॉक्स',
        Fr: 'Playback Singers Box',
        Hi: 'पार्श्व गायक बॉक्स',
        Ta: 'பின்னணி பாடகர்கள் பெட்டி',
        Ja: 'プレイバック・シンガーズ・ボックス',
        Ge: 'Playback-Sänger-Box',
      },
    },

    AssetItemLevelAPPEARANCEANDACTION: {
      AILAAL01: {
        En: 'Costume',
        Et: 'Kostüüm',
        Ar: 'زي',
        Ml: 'വേഷവിധാനം',
        Ma: 'पोशाख',
        Fr: 'Costume',
        Hi: 'पोशाक',
        Ta: 'உடையில்',
        Ja: 'コスチューム',
        Ge: 'Kostüm',
      },
      AILAATB01: {
        En: 'Costume Box',
        Et: 'Kostüümikarp',
        Ar: 'صندوق الملابس',
        Ml: 'കോസ്റ്റ്യൂം ബോക്സ്',
        Ma: 'पोशाख पेटी',
        Fr: 'Boîte à costumes',
        Hi: 'कॉस्टयूम बॉक्स',
        Ta: 'ஆடை பெட்டி',
        Ja: 'コスチュームボックス',
        Ge: 'Kostümkiste',
      },
      AILAAL02: {
        En: 'Make Up',
        Et: 'Meik',
        Ar: 'ميك أب',
        Ml: 'മേക്ക് അപ്പ്',
        Ma: 'मेक अप करा',
        Fr: 'Se maquiller',
        Hi: 'शृंगार',
        Ta: 'ஒப்பனை',
        Ja: '化粧',
        Ge: 'Bilden',
      },
      AILAATB02: {
        En: 'Make Up Box',
        Et: 'Meigikarp',
        Ar: 'صندوق المكياج',
        Ml: 'മേക്കപ്പ് ബോക്സ്',
        Ma: 'मेक अप बॉक्स',
        Fr: 'Boîte de maquillage',
        Hi: 'मेक अप बॉक्स',
        Ta: 'மேக் அப் பாக்ஸ்',
        Ja: '化粧箱',
        Ge: 'Make-up-Box',
      },
      AILAAL03: {
        En: 'Choreography',
        Et: 'Koreograafia',
        Ar: 'الكوريغرافيا',
        Ml: 'നൃത്തസംവിധാനം',
        Ma: 'नृत्यदिग्दर्शन',
        Fr: 'Chorégraphie',
        Hi: 'नृत्यकला',
        Ta: 'நடன அமைப்பு',
        Ja: '振り付け',
        Ge: 'Choreographie',
      },
      AILAATB03: {
        En: 'Choreography Box',
        Et: 'Koreograafia kast',
        Ar: 'مربع الكوريغرافيا',
        Ml: 'കൊറിയോഗ്രാഫി ബോക്സ്',
        Ma: 'कोरिओग्राफी बॉक्स',
        Fr: 'Coffret Chorégraphie',
        Hi: 'कोरियोग्राफी बॉक्स',
        Ta: 'நடனப் பெட்டி',
        Ja: '振付ボックス',
        Ge: 'Choreographie-Box',
      },
      AILAAL04: {
        En: 'Action',
        Et: 'Tegevus',
        Ar: 'عمل',
        Ml: 'ആക്ഷൻ',
        Ma: 'कृती',
        Fr: 'Action',
        Hi: 'गतिविधि',
        Ta: 'செயல்',
        Ja: 'アクション',
        Ge: 'Aktion',
      },
      AILAATB04: {
        En: 'Action Box',
        Et: 'Tegevuskast',
        Ar: 'مربع العمل',
        Ml: 'ആക്ഷൻ ബോക്സ്',
        Ma: 'कृती बॉक्स',
        Fr: "Boîte d'action",
        Hi: 'एक्शन बॉक्स',
        Ta: 'அதிரடி பெட்டி',
        Ja: 'アクションボックス',
        Ge: 'Aktionsfeld',
      },
    },

    AssetItemLevelDIRECTORSANDPRODUCTIONMANAGERS: {
      AILDPL01: {
        En: 'Associate Director',
        Et: 'Abidirektor',
        Ar: 'المدير المساعد',
        Ml: 'സഹ സംവിധായകാൻ',
        Ma: 'सहयोगी संचालक',
        Fr: 'Directeur associé',
        Hi: 'एसोसिएट निदेशक',
        Ta: 'இணை இயக்குனர்',
        Ja: 'アソシエイトディレクター',
        Ge: 'Stellvertretender Direktor',
      },
      AILDPTB01: {
        En: 'Associate Director Box',
        Et: 'Assotsieerunud direktor',
        Ar: 'صندوق مدير مشارك',
        Ml: 'അസോസിയേറ്റ് ഡയറക്ടർ ബോക്സ്',
        Ma: 'सहयोगी संचालक बॉक्स',
        Fr: 'Boîte de directeur associé',
        Hi: 'एसोसिएट डायरेक्टर बॉक्स',
        Ta: 'இணை இயக்குனர் பெட்டி',
        Ja: 'アソシエイトディレクターボックス',
        Ge: 'Stellvertretender Direktor Box',
      },
      AILDPL02: {
        En: 'Assistant Directors',
        Et: 'Režissööride abid',
        Ar: 'مدراء مساعدون',
        Ml: 'അസിസ്റ്റന്റ് ഡയറക്ടർമാർ',
        Ma: 'सहाय्यक संचालक',
        Fr: 'Directeurs adjoints',
        Hi: 'सहायक निदेशक',
        Ta: 'உதவி இயக்குநர்கள்',
        Ja: '助監督',
        Ge: 'Assistenten der Direktoren',
      },
      AILDPTB02: {
        En: 'Assistant Directors Box',
        Et: 'Režissööri assistentide kast',
        Ar: 'صندوق المدراء المساعدين',
        Ml: 'അസിസ്റ്റന്റ് ഡയറക്ടർമാരുടെ ബോക്സ്',
        Ma: 'सहाय्यक संचालक बॉक्स',
        Fr: 'Case des assistants réalisateurs',
        Hi: 'सहायक निदेशक बॉक्स',
        Ta: 'உதவி இயக்குனர்கள் பெட்டி',
        Ja: '助監督ボックス',
        Ge: 'Box für stellvertretende Direktoren',
      },
      AILDPL03: {
        En: 'Other Assistants',
        Et: 'Teised assistendid',
        Ar: 'مساعدين آخرين',
        Ml: 'മറ്റ് സഹായികൾ',
        Ma: 'इतर सहाय्यक',
        Fr: 'Autres adjoints',
        Hi: 'अन्य सहायक',
        Ta: 'மற்ற உதவியாளர்கள்',
        Ja: 'その他のアシスタント',
        Ge: 'Andere Assistenten',
      },
      AILDPTB03: {
        En: 'Other Assistants Box',
        Et: 'Muude assistentide kast',
        Ar: 'صندوق مساعدين آخرين',
        Ml: 'മറ്റ് അസിസ്റ്റന്റ് ബോക്സ്',
        Ma: 'इतर सहाय्यक बॉक्स',
        Fr: "Boîte d'autres assistants",
        Hi: 'अन्य सहायक बॉक्स',
        Ta: 'மற்ற உதவியாளர்கள் பெட்டி',
        Ja: 'その他アシスタントボックス',
        Ge: 'Andere Assistenten-Box',
      },
      AILDPL04: {
        En: 'Production Manager',
        Et: 'Tootmisjuht',
        Ar: 'مدير الانتاج',
        Ml: 'പ്രൊഡക്ഷൻ മാനേജർ',
        Ma: 'उत्पादन व्यवस्थापक',
        Fr: 'Directeur de production',
        Hi: 'उत्पादन प्रबंधक',
        Ta: 'தயாரிப்பு மேலாளர்',
        Ja: 'プロダクションマネージャー',
        Ge: 'Produktionsleiter',
      },
      AILDPTB04: {
        En: 'Production Manager Box',
        Et: 'Tootmisjuhi boks',
        Ar: 'صندوق مدير الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ മാനേജർ ബോക്സ്',
        Ma: 'उत्पादन व्यवस्थापक बॉक्स',
        Fr: 'Boîte de directeur de production',
        Hi: 'उत्पादन प्रबंधक बॉक्स',
        Ta: 'உற்பத்தி மேலாளர் பெட்டி',
        Ja: 'プロダクションマネージャーボックス',
        Ge: 'Produktionsmanager-Box',
      },
    },

    AssetItemLevelPRODUCTIONSTUDIOANDVISUALEFFECTS: {
      AILPVL01: {
        En: 'Production Company',
        Et: 'Tootmisettevõte',
        Ar: 'شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി',
        Ma: 'उत्पादन कंपनी',
        Fr: 'Société de production',
        Hi: 'निर्माण कंपनी',
        Ta: 'தயாரிப்பு நிறுவனம்',
        Ja: '芸能事務所',
        Ge: 'Produktionsfirma',
      },
      AILPVTB01: {
        En: 'Production Company Box',
        Et: 'Tootmisettevõtte kast',
        Ar: 'صندوق شركة الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ കമ്പനി ബോക്സ്',
        Ma: 'उत्पादन कंपनी बॉक्स',
        Fr: 'Boîte de la société de production',
        Hi: 'प्रोडक्शन कंपनी बॉक्स',
        Ta: 'தயாரிப்பு நிறுவனத்தின் பெட்டி',
        Ja: '制作会社ボックス',
        Ge: 'Box der Produktionsfirma',
      },
      AILPVL02: {
        En: 'Production Studio',
        Et: 'Tootmisstuudio',
        Ar: 'استوديو الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ സ്റ്റുഡിയോ',
        Ma: 'उत्पादन स्टुडिओ',
        Fr: 'Atelier de production',
        Hi: 'प्रोडक्शन स्टूडियो',
        Ta: 'தயாரிப்பு ஸ்டுடியோ',
        Ja: '制作スタジオ',
        Ge: 'Produktionsstudio',
      },
      AILPVTB02: {
        En: 'Production Studio Box',
        Et: 'Tootmisstuudio kast',
        Ar: 'صندوق استوديو الإنتاج',
        Ml: 'പ്രൊഡക്ഷൻ സ്റ്റുഡിയോ ബോക്സ്',
        Ma: 'उत्पादन स्टुडिओ बॉक्स',
        Fr: 'Boîte de studio de production',
        Hi: 'प्रोडक्शन स्टूडियो बॉक्स',
        Ta: 'தயாரிப்பு ஸ்டுடியோ பெட்டி',
        Ja: '制作スタジオボックス',
        Ge: 'Produktionsstudio-Box',
      },
      AILPVL03: {
        En: 'Film Processing Laboratory',
        Et: 'Filmitöötlemise labor',
        Ar: 'معمل معالجة الأفلام',
        Ml: 'ഫിലിം പ്രോസസ്സിംഗ് ലബോറട്ടറി',
        Ma: 'चित्रपट प्रक्रिया प्रयोगशाळा',
        Fr: 'Laboratoire de traitement de film',
        Hi: 'फिल्म प्रसंस्करण प्रयोगशाला',
        Ta: 'திரைப்பட செயலாக்க ஆய்வகம்',
        Ja: 'フィルム加工研究室',
        Ge: 'Filmverarbeitungslabor',
      },
      AILPVTB03: {
        En: 'Film Processing Laboratory Box',
        Et: 'Filmi töötlemise laboriboks',
        Ar: 'صندوق مختبر معالجة الفيلم',
        Ml: 'ഫിലിം പ്രോസസ്സിംഗ് ലബോറട്ടറി ബോക്സ്',
        Ma: 'चित्रपट प्रक्रिया प्रयोगशाळा बॉक्स',
        Fr: 'Boîte de laboratoire de traitement de film',
        Hi: 'फिल्म प्रसंस्करण प्रयोगशाला बॉक्स',
        Ta: 'திரைப்பட செயலாக்க ஆய்வக பெட்டி',
        Ja: 'フィルム現像実験ボックス',
        Ge: 'Laborbox für die Filmentwicklung',
      },
      AILPVL04: {
        En: 'VFX',
        Et: 'VFX',
        Ar: 'المؤثرات البصرية',
        Ml: 'വിഎഫ്എക്സ്',
        Ma: 'VFX',
        Fr: 'Effets visuels',
        Hi: 'वीएफएक्स',
        Ta: 'VFX',
        Ja: 'VFX',
        Ge: 'VFX',
      },
      AILPVTB04: {
        En: 'VFX Box',
        Et: 'VFX kast',
        Ar: 'صندوق VFX',
        Ml: 'വിഎഫ്എക്സ് ബോക്സ്',
        Ma: 'VFX बॉक्स',
        Fr: "Boîte d'effets visuels",
        Hi: 'वीएफएक्स बॉक्स',
        Ta: 'VFX பெட்டி',
        Ja: 'VFX ボックス',
        Ge: 'VFX-Box',
      },
      AILPVL05: {
        En: 'Animation',
        Et: 'Animatsioon',
        Ar: 'الرسوم المتحركة',
        Ml: 'ആനിമേഷൻ',
        Ma: 'अॅनिमेशन',
        Fr: 'Animation',
        Hi: 'एनीमेशन',
        Ta: 'இயங்குபடம்',
        Ja: 'アニメーション',
        Ge: 'Animation',
      },
      AILPVTB05: {
        En: 'Animation Box',
        Et: 'Animatsioonikast',
        Ar: 'مربع الرسوم المتحركة',
        Ml: 'ആനിമേഷൻ ബോക്സ്',
        Ma: 'अॅनिमेशन बॉक्स',
        Fr: "Boîte d'animations",
        Hi: 'एनिमेशन बॉक्स',
        Ta: 'அனிமேஷன் பெட்டி',
        Ja: 'アニメーションボックス',
        Ge: 'Animationsbox',
      },
      AILPVL06: {
        En: 'Colorist',
        Et: 'Kolorist',
        Ar: 'ملون',
        Ml: 'കളറിസ്റ്റ്',
        Ma: 'कलरिस्ट',
        Fr: 'Coloriste',
        Hi: 'कलरिस्ट',
        Ta: 'வண்ணமயமானவர்',
        Ja: 'カラーリスト',
        Ge: 'Kolorist',
      },
      AILPVTB06: {
        En: 'Colorist Box',
        Et: 'Colorist Box',
        Ar: 'صندوق تلوين',
        Ml: 'കളറിസ്റ്റ് ബോക്സ്',
        Ma: 'कलरिस्ट बॉक्स',
        Fr: 'Coffret Coloriste',
        Hi: 'रंगीन बॉक्स',
        Ta: 'வண்ணப் பெட்டி',
        Ja: 'カラリストボックス',
        Ge: 'Colorist-Box',
      },
      AILPVL07: {
        En: 'CGI',
        Et: 'CGI',
        Ar: 'CGI',
        Ml: 'സിജിഐ',
        Ma: 'CGI',
        Fr: 'Image de synthèse',
        Hi: 'सीजीआई',
        Ta: 'CGI',
        Ja: 'CG',
        Ge: 'CGI',
      },
      AILPVTB07: {
        En: 'CGI Box',
        Et: 'CGI kast',
        Ar: 'صندوق CGI',
        Ml: 'CGI ബോക്സ്',
        Ma: 'CGI बॉक्स',
        Fr: 'Boîte CGI',
        Hi: 'सीजीआई बॉक्स',
        Ta: 'CGI பெட்டி',
        Ja: 'CGIボックス',
        Ge: 'CGI-Box',
      },
      AILPVL08: {
        En: 'DI',
        Et: 'FROM',
        Ar: 'من',
        Ml: 'നിന്ന്',
        Ma: 'पासून',
        Fr: 'DE',
        Hi: 'से',
        Ta: 'இருந்து',
        Ja: 'から',
        Ge: 'AUS',
      },
      AILPVTB08: {
        En: 'DI Box',
        Et: 'DI kast',
        Ar: 'صندوق DI',
        Ml: 'DI ബോക്സ്',
        Ma: 'डीआय बॉक्स',
        Fr: 'Boîte de direct',
        Hi: 'डि बॉक्स',
        Ta: 'DI பெட்டி',
        Ja: 'DI ボックス',
        Ge: 'DI-Box',
      },
    },

    AssetItemLevelAWARDSANDPUBLICITY: {
      AILAPL01: {
        En: 'Awards',
        Et: 'Auhinnad',
        Ar: 'الجوائز',
        Ml: 'അവാർഡുകൾ',
        Ma: 'पुरस्कार',
        Fr: 'Prix',
        Hi: 'पुरस्कार',
        Ta: 'விருதுகள்',
        Ja: '賞',
        Ge: 'Auszeichnungen',
      },
      AILAPTB01: {
        En: 'Awards Box',
        Et: 'Auhindade kast',
        Ar: 'صندوق الجوائز',
        Ml: 'അവാർഡ് ബോക്സ്',
        Ma: 'पुरस्कार बॉक्स',
        Fr: 'Boîte de récompenses',
        Hi: 'पुरस्कार बॉक्स',
        Ta: 'விருது பெட்டி',
        Ja: 'アワードボックス',
        Ge: 'Auszeichnungsbox',
      },
      AILAPL02: {
        En: 'Screening',
        Et: 'Sõelumine',
        Ar: 'تحري',
        Ml: 'സ്ക്രീനിംഗ്',
        Ma: 'स्क्रीनिंग',
        Fr: 'Dépistage',
        Hi: 'स्क्रीनिंग',
        Ta: 'திரையிடல்',
        Ja: 'ふるい分け',
        Ge: 'Screening',
      },
      AILAPTB02: {
        En: 'Screening Box',
        Et: 'Sõelumiskast',
        Ar: 'صندوق الفرز',
        Ml: 'സ്ക്രീനിംഗ് ബോക്സ്',
        Ma: 'स्क्रीनिंग बॉक्स',
        Fr: 'Boîte de dépistage',
        Hi: 'स्क्रीनिंग बॉक्स',
        Ta: 'திரையிடல் பெட்டி',
        Ja: 'スクリーニングボックス',
        Ge: 'Screening-Box',
      },
      AILAPL03: {
        En: 'Publicity Designer',
        Et: 'Reklaami kujundaja',
        Ar: 'مصمم دعاية',
        Ml: 'പബ്ലിസിറ്റി ഡിസൈനർ',
        Ma: 'प्रसिद्धी डिझायनर',
        Fr: 'Concepteur publicitaire',
        Hi: 'प्रचार डिजाइनर',
        Ta: 'விளம்பர வடிவமைப்பாளர்',
        Ja: '宣伝デザイナー',
        Ge: 'Werbedesigner',
      },
      AILAPTB03: {
        En: 'Publicity Designer Box',
        Et: 'Reklaami kujundaja kast',
        Ar: 'صندوق مصمم الدعاية',
        Ml: 'പബ്ലിസിറ്റി ഡിസൈനർ ബോക്സ്',
        Ma: 'प्रसिद्धी डिझायनर बॉक्स',
        Fr: 'Coffret Publicitaire Designer',
        Hi: 'प्रचार डिजाइनर बॉक्स',
        Ta: 'விளம்பர வடிவமைப்பாளர் பெட்டி',
        Ja: '宣伝デザイナーボックス',
        Ge: 'Werbe-Designer-Box',
      },
      AILAPL04: {
        En: 'Copy Right',
        Et: 'Autoriõigus',
        Ar: 'حقوق النشر',
        Ml: 'പകർപ്പവകാശം',
        Ma: 'कॉपीराइट',
        Fr: "droits d'auteur",
        Hi: 'कॉपीराइट',
        Ta: 'காப்புரிமை',
        Ja: '著作権',
        Ge: 'Urheberrechte ©',
      },
      AILAPTB04: {
        En: 'Copy Right Box',
        Et: 'Kopeeri parem kast',
        Ar: 'نسخ المربع الأيمن',
        Ml: 'വലത് ബോക്സ് പകർത്തുക',
        Ma: 'कॉपी राईट बॉक्स',
        Fr: 'Copier la bonne case',
        Hi: 'कॉपी राइट बॉक्स',
        Ta: 'நகல் வலது பெட்டி',
        Ja: 'コピーライトボックス',
        Ge: 'Rechtes Feld kopieren',
      },
      AILAPL05: {
        En: 'Audio Right',
        Et: 'Parem heli',
        Ar: 'حق الصوت',
        Ml: 'ഓഡിയോ റൈറ്റ്',
        Ma: 'ऑडिओ उजवा',
        Fr: 'Droit audio',
        Hi: 'ऑडियो अधिकार',
        Ta: 'ஆடியோ உரிமை',
        Ja: '音声右',
        Ge: 'Audio rechts',
      },
      AILAPTB05: {
        En: 'Audio Right Box',
        Et: 'Audio parem kast',
        Ar: 'صندوق الصوت الأيمن',
        Ml: 'ഓഡിയോ റൈറ്റ് ബോക്സ്',
        Ma: 'ऑडिओ उजवा बॉक्स',
        Fr: 'Boîte audio droite',
        Hi: 'ऑडियो राइट बॉक्स',
        Ta: 'ஆடியோ வலது பெட்டி',
        Ja: 'オーディオ右ボックス',
        Ge: 'Audio-Rechts-Box',
      },
      AILAPL06: {
        En: 'Notes',
        Et: 'Märkmed',
        Ar: 'ملحوظات',
        Ml: 'കുറിപ്പുകൾ',
        Ma: 'नोट्स',
        Fr: 'Remarques',
        Hi: 'टिप्पणियाँ',
        Ta: 'குறிப்புகள்',
        Ja: 'ノート',
        Ge: 'Anmerkungen',
      },
      AILAPTB06: {
        En: 'Notes Box',
        Et: 'Märkmete kast',
        Ar: 'صندوق الملاحظات',
        Ml: 'നോട്ട് ബോക്സ്',
        Ma: 'नोट्स बॉक्स',
        Fr: 'Boîte à notes',
        Hi: 'नोट्स बॉक्स',
        Ta: 'குறிப்புகள் பெட்டி',
        Ja: 'メモボックス',
        Ge: 'Notizen-Box',
      },
    },

    AssetItemLevelGEnRE: {
      AILGL01: {
        En: 'Genre',
        Et: 'Žanr',
        Ar: 'النوع',
        Ml: 'തരം',
        Ma: 'शैली',
        Fr: 'Genre',
        Hi: 'शैली',
        Ta: 'வகை',
        Ja: 'ジャンル',
        Ge: 'Genre',
      },
      AILGTB01: {
        En: 'Genre Box',
        Et: 'Žanri kast',
        Ar: 'صندوق النوع',
        Ml: 'ജെനർ ബോക്സ്',
        Ma: 'शैली बॉक्स',
        Fr: 'Boîte à genres',
        Hi: 'शैली बॉक्स',
        Ta: 'வகை பெட்டி',
        Ja: 'ジャンルボックス',
        Ge: 'Genre-Box',
      },
      AILGL02: {
        En: 'Keywords',
        Et: 'Märksõnad',
        Ar: 'الكلمات الدالة',
        Ml: 'കീവേഡുകൾ',
        Ma: 'कीवर्ड',
        Fr: 'Mots clés',
        Hi: 'कीवर्ड',
        Ta: 'முக்கிய வார்த்தைகள்',
        Ja: 'キーワード',
        Ge: 'Schlüsselwörter',
      },
      AILGTB02: {
        En: 'Keywords Box',
        Et: 'Märksõnade kast',
        Ar: 'مربع الكلمات الرئيسية',
        Ml: 'കീവേഡുകൾ ബോക്സ്',
        Ma: 'कीवर्ड बॉक्स',
        Fr: 'Boîte de mots-clés',
        Hi: 'कीवर्ड बॉक्स',
        Ta: 'முக்கிய வார்த்தைகள் பெட்டி',
        Ja: 'キーワードボックス',
        Ge: 'Keyword-Box',
      },
      AILGL03: {
        En: 'Recording Company',
        Et: 'Salvestusfirma',
        Ar: 'شركة تسجيل',
        Ml: 'റെക്കോർഡിംഗ് കമ്പനി',
        Ma: 'रेकॉर्डिंग कंपनी',
        Fr: "Compagnie d'enregistrement",
        Hi: 'रिकॉर्डिंग कंपनी',
        Ta: 'பதிவு நிறுவனம்',
        Ja: 'レコード会社',
        Ge: 'Plattenfirma',
      },
      AILGTB03: {
        En: 'Recording Company Box',
        Et: 'Salvestusfirma Box',
        Ar: 'صندوق تسجيل الشركة',
        Ml: 'റെക്കോർഡിംഗ് കമ്പനി ബോക്സ്',
        Ma: 'रेकॉर्डिंग कंपनी बॉक्स',
        Fr: "Boîte de la société d'enregistrement",
        Hi: 'रिकॉर्डिंग कंपनी बॉक्स',
        Ta: 'ரெக்கார்டிங் கம்பெனி பெட்டி',
        Ja: 'レコード会社ボックス',
        Ge: 'Aufnahmefirma-Box',
      },
      AILGL04: {
        En: 'Curatorial Notes',
        Et: 'Kuraatorite märkmed',
        Ar: 'ملاحظات تنظيمية',
        Ml: 'ക്യൂറേറ്റോറിയൽ കുറിപ്പുകൾ',
        Ma: 'क्युरेटोरियल नोट्स',
        Fr: 'Notes de conservation',
        Hi: 'क्यूरेटोरियल नोट्स',
        Ta: 'க்யூரேடோரியல் குறிப்புகள்',
        Ja: 'キュレーターノート',
        Ge: 'Kuratorische Notizen',
      },
      AILGTB04: {
        En: 'Curatorial Notes Box',
        Et: 'Kuraatorite märkmete kast',
        Ar: 'صندوق الملاحظات القيمية',
        Ml: 'ക്യൂറേറ്റോറിയൽ നോട്ട്സ് ബോക്സ്',
        Ma: 'क्युरेटोरियल नोट्स बॉक्स',
        Fr: 'Encadré des notes de conservation',
        Hi: 'क्यूरेटोरियल नोट्स बॉक्स',
        Ta: 'க்யூரேடோரியல் குறிப்புகள் பெட்டி',
        Ja: 'キュレーターノートボックス',
        Ge: 'Box für kuratorische Notizen',
      },
    },

    AssetItemLevelIDEnTIFIERTAGSFORPHYSICALASSET: {
      AILITL01: {
        En: 'IDEnTIFIER TAGS FOR PHYSICAL ASSET',
        Et: 'FÜÜSILISE VARA IDENTIFITSEERIMISMÄRGID',
        Ar: 'علامات معرف للأصول المادية',
        Ml: 'ഫിസിക്കൽ അസറ്റിനുള്ള ഐഡന്റിഫയർ ടാഗുകൾ',
        Ma: 'भौतिक मालमत्तेसाठी आयडेंटिफायर टॅग',
        Fr: "ÉTIQUETTES D'IDENTIFICATION DES BIENS PHYSIQUES",
        Hi: 'भौतिक संपत्ति के लिए पहचानकर्ता टैग',
        Ta: 'இயற்பியல் சொத்துக்கான அடையாள குறிகள்',
        Ja: '物理的資産の識別子タグ',
        Ge: 'KENNZEICHNUNGS-TAGS FÜR PHYSISCHE VERMÖGENSWERTE',
      },
      AILITL02: {
        En: 'BARCODE',
        Et: 'VÖÖBKOOOD',
        Ar: 'الرمز الشريطي',
        Ml: 'ബാർകോഡ്',
        Ma: 'बारकोड',
        Fr: 'CODE À BARRE',
        Hi: 'बारकोड',
        Ta: 'பார்கோடு',
        Ja: 'バーコード',
        Ge: 'BARCODE',
      },
      AILITB01: {
        En: 'Print BARCODE',
        Et: 'Prindi VÖÖTKOOOD',
        Ar: 'طباعة الباركود',
        Ml: 'ബാർകോഡ് പ്രിന്റ് ചെയ്യുക',
        Ma: 'बारकोड प्रिंट करा',
        Fr: 'Imprimer CODE-BARRES',
        Hi: 'बारकोड प्रिंट करें',
        Ta: 'பார்கோடு அச்சிடவும்',
        Ja: 'バーコードを印刷',
        Ge: 'BARCODE drucken',
      },
      AILITL03: {
        En: 'QRCODE',
        Et: 'QR KOOD',
        Ar: 'رمز الاستجابة السريعة',
        Ml: 'QR കോഡ്',
        Ma: 'QR कोड',
        Fr: 'QR CODE',
        Hi: 'क्यू आर संहिता',
        Ta: 'க்யு ஆர் குறியீடு',
        Ja: 'QRコード',
        Ge: 'QR-CODE',
      },
      AILITB02: {
        En: 'Print QRCODE',
        Et: 'Prindi QRCODE',
        Ar: 'طباعة QRCODE',
        Ml: 'QRCODE പ്രിന്റ് ചെയ്യുക',
        Ma: 'QRCODE प्रिंट करा',
        Fr: 'Imprimer QRCODE',
        Hi: 'QRCODE प्रिंट करें',
        Ta: 'QRCODE ஐ அச்சிடவும்',
        Ja: 'QRコードを印刷',
        Ge: 'QRCODE drucken',
      },
      AILITL04: {
        En: 'NFC',
        Et: 'NFC',
        Ar: 'NFC',
        Ml: 'എൻഎഫ്സി',
        Ma: 'NFC',
        Fr: 'NFC',
        Hi: 'एनएफसी',
        Ta: 'NFC',
        Ja: 'NFC',
        Ge: 'NFC',
      },
      AILITB03: {
        En: 'Set NFC',
        Et: 'Määrake NFC',
        Ar: 'ضبط NFC',
        Ml: 'NFC സജ്ജമാക്കുക',
        Ma: 'NFC सेट करा',
        Fr: 'Définir NFC',
        Hi: 'एनएफसी सेट करें',
        Ta: 'NFC ஐ அமைக்கவும்',
        Ja: 'NFC を設定する',
        Ge: 'NFC einstellen',
      },
      AILITL05: {
        En: 'RFID TAGS',
        Et: 'RFID-MÄRGID',
        Ar: 'علامات RFID',
        Ml: 'RFID ടാഗുകൾ',
        Ma: 'RFID टॅग',
        Fr: 'ÉTIQUETTES RFID',
        Hi: 'आरएफआईडी टैग',
        Ta: 'RFID குறிச்சொற்கள்',
        Ja: 'RFID タグ',
        Ge: 'RFID-TAGS',
      },
      AILITL06: {
        En: 'RFID',
        Et: 'RFID',
        Ar: 'RFID',
        Ml: 'RFID',
        Ma: 'RFID',
        Fr: 'RFID',
        Hi: 'आरएफआईडी',
        Ta: 'RFID',
        Ja: 'RFID',
        Ge: 'RFID',
      },
      AILITB04: {
        En: 'Can RFID',
        Et: 'Kas RFID',
        Ar: 'يمكن RFID',
        Ml: 'RFID കഴിയും',
        Ma: 'RFID करू शकता',
        Fr: 'La RFID peut-elle',
        Hi: 'आरएफआईडी कर सकते हैं',
        Ta: 'RFID முடியும்',
        Ja: 'RFIDできますか',
        Ge: 'Kann RFID',
      },
      AILITL07: {
        En: 'START',
        Et: 'START',
        Ar: 'بداية',
        Ml: 'ആരംഭിക്കുക',
        Ma: 'सुरू करा',
        Fr: 'DÉBUT',
        Hi: 'प्रारंभ',
        Ta: 'START',
        Ja: '始める',
        Ge: 'ANFANG',
      },
      AILITB05: {
        En: 'START RFid',
        Et: 'START RFid',
        Ar: 'START RFid',
        Ml: 'RFid ആരംഭിക്കുക',
        Ma: 'आरएफआयडी सुरू करा',
        Fr: 'DÉMARRER RFid',
        Hi: 'आरएफआईडी शुरू करें',
        Ta: 'RFid தொடங்கவும்',
        Ja: 'RFid を開始',
        Ge: 'RFID STARTEN',
      },
      AILITL08: {
        En: 'EnD',
        Et: 'Lõpp',
        Ar: 'نهاية',
        Ml: 'അവസാനിക്കുന്നു',
        Ma: 'EnD',
        Fr: 'Fin',
        Hi: 'समाप्त',
        Ta: 'முடிவு',
        Ja: '終わり',
        Ge: 'Ende',
      },
      AILITB06: {
        En: 'EnD RFid',
        Et: 'End RFid',
        Ar: 'EnD RFid',
        Ml: 'എൻഡി RFid',
        Ma: 'समाप्त RFid',
        Fr: 'Fin RFID',
        Hi: 'अंत आरएफआईडी',
        Ta: 'EnD RFid',
        Ja: 'End RFID',
        Ge: 'EnD-RFid',
      },
      AILITL09: {
        En: 'ACTIVE RFID',
        Et: 'AKTIIVNE RFID',
        Ar: 'نشط RFID',
        Ml: 'സജീവ RFID',
        Ma: 'सक्रिय RFID',
        Fr: 'RFID ACTIVE',
        Hi: 'सक्रिय आरएफआईडी',
        Ta: 'செயலில் RFID',
        Ja: 'アクティブRFID',
        Ge: 'AKTIV-RFID',
      },
      AILITB07: {
        En: 'Can RFid',
        Et: 'Kas RFid',
        Ar: 'يمكن RFid',
        Ml: 'RFid ചെയ്യാൻ കഴിയും',
        Ma: 'RFid करू शकता',
        Fr: 'Peut RFid',
        Hi: 'आरएफआईडी कर सकते हैं',
        Ta: 'RFid முடியும்',
        Ja: 'RFIDができる',
        Ge: 'Kann RFid',
      },
      AILITL10: {
        En: 'START RFID',
        Et: 'KÄIVITA RFID',
        Ar: 'بدء RFID',
        Ml: 'RFID ആരംഭിക്കുക',
        Ma: 'आरएफआयडी सुरू करा',
        Fr: 'DÉMARRER RFID',
        Hi: 'आरएफआईडी शुरू करें',
        Ta: 'RFIDயைத் தொடங்கவும்',
        Ja: 'RFIDを開始',
        Ge: 'RFID STARTEN',
      },
      AILITB08: {
        En: 'START RFID',
        Et: 'KÄIVITA RFID',
        Ar: 'بدء RFID',
        Ml: 'RFID ആരംഭിക്കുക',
        Ma: 'आरएफआयडी सुरू करा',
        Fr: 'DÉMARRER RFID',
        Hi: 'आरएफआईडी शुरू करें',
        Ta: 'RFIDயைத் தொடங்கவும்',
        Ja: 'RFIDを開始',
        Ge: 'RFID STARTEN',
      },
      AILITL11: {
        En: 'EnD RFID',
        Et: 'LÕPP RFID',
        Ar: 'EnD RFID',
        Ml: 'RFID അവസാനിപ്പിക്കുക',
        Ma: 'RFID समाप्त करा',
        Fr: 'Fin RFID',
        Hi: 'अंत आरएफआईडी',
        Ta: 'முடிவு RFID',
        Ja: 'エンドRFID',
        Ge: 'EnD-RFID',
      },
      AILITB09: {
        En: 'EnD RFid',
        Et: 'End RFid',
        Ar: 'EnD RFid',
        Ml: 'എൻഡി RFid',
        Ma: 'समाप्त RFid',
        Fr: 'Fin RFID',
        Hi: 'अंत आरएफआईडी',
        Ta: 'EnD RFid',
        Ja: 'End RFID',
        Ge: 'EnD-RFid',
      },
      AILITB10: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      AILITB11: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    AssetViewItemLevelListPage: {
      AVISTB01: {
        En: 'Search...',
        Et: 'Otsing...',
        Ar: 'يبحث...',
        Ml: 'തിരയുക...',
        Ma: 'शोधा...',
        Fr: 'Chercher...',
        Hi: 'खोज...',
        Ta: 'தேடு...',
        Ja: '探す...',
        Ge: 'Suche...',
      },
      AVIDD01: {
        En: 'Item Group',
        Et: 'Kaubarühm',
        Ar: 'مجموعة العناصر',
        Ml: 'ഇനം ഗ്രൂപ്പ്',
        Ma: 'आयटम गट',
        Fr: "Groupe d'articles",
        Hi: 'वस्तु समूह',
        Ta: 'பொருள் குழு',
        Ja: '品目グループ',
        Ge: 'Artikelgruppe',
      },
      //AVID01: {En: "Date", Et: "Kuupäev", Ar: "تاريخ", Ml: "തീയതി", Ma: "तारीख", Fr: "Date", Hi: "दिनांक", Ta: "தேதி", Ja: "日にち", Ge: "Datum", },
      AVIB01: {
        En: 'Filter',
        Et: 'Filter',
        Ar: 'منقي',
        Ml: 'ഫിൽട്ടർ ചെയ്യുക',
        Ma: 'फिल्टर करा',
        Fr: 'Filtre',
        Hi: 'फ़िल्टर',
        Ta: 'வடிகட்டி',
        Ja: 'フィルター',
        Ge: 'Filter',
      },
      AVIB02: {
        En: 'All Assets',
        Et: 'Kõik varad',
        Ar: 'جميع الأصول',
        Ml: 'എല്ലാ ആസ്തികളും',
        Ma: 'सर्व मालमत्ता',
        Fr: 'Tous les actifs',
        Hi: 'सभी संपत्ति',
        Ta: 'அனைத்து சொத்துக்கள்',
        Ja: 'すべての資産',
        Ge: 'Alle Vermögenswerte',
      },
      AVIB03: {
        En: 'PENDING RETURNS FROM BORROWERS (n)',
        Et: 'OOTEL TAGASTUSED LAENAJATELT (n)',
        Ar: 'المرتجعات المعلقة من المقترضين (اسم)',
        Ml: 'കടം വാങ്ങുന്നവരിൽ നിന്ന് തീർച്ചപ്പെടുത്താത്ത റിട്ടേണുകൾ (n)',
        Ma: 'कर्जदारांकडून प्रलंबित परतावे (n)',
        Fr: 'RETOURS EN ATTENTE DES EMPRUNTEURS (n)',
        Hi: 'उधारकर्ताओं से लंबित रिटर्न (एन)',
        Ta: 'கடன் வாங்கியவர்களிடமிருந்து நிலுவையில் உள்ள வருமானங்கள் (n)',
        Ja: '借り手からの保留中の返品 (n)',
        Ge: 'AUSSTEHENDE RÜCKGABEN VON KREDITNEHMERN (n)',
      },
      AVIB04: {
        En: 'Assets Cleaned (n)',
        Et: 'SELLES KUU PUHASTATUD VARAD (n)',
        Ar: 'الأصول التي تم تنظيفها في هذا الشهر (ن)',
        Ml: 'ഈ മാസം (n) വൃത്തിയാക്കിയ അസറ്റുകൾ',
        Ma: 'या महिन्यात क्लीन केलेली मालमत्ता (n)',
        Fr: 'ACTIFS NETTOYÉS AU COURS DE CE MOIS (n)',
        Hi: 'इस महीने में साफ की गई संपत्ति (एन)',
        Ta: 'இந்த மாதத்தில் சுத்தம் செய்யப்பட்ட சொத்துகள் (n)',
        Ja: '今月クリーニングされた資産 (n)',
        Ge: 'IN DIESEM MONAT GEREINIGTE VERMÖGENSWERTE (n)',
      },
      AVIB05: {
        En: 'CURRENT MONTH ASSET CAN MOVEMEnT (n)',
        Et: 'JOOKSE KUU VARA VÕIB LIIKUTA (n)',
        Ar: 'يمكن نقل أصول الشهر الحالي (ن)',
        Ml: 'നിലവിലെ മാസത്തെ ആസ്തിക്ക് ചലിക്കാനാകും (n)',
        Ma: 'चालू महिन्याची मालमत्ता हलवू शकते (n)',
        Fr: "MOUVEMENT DE L'ACTIF CAN DU MOIS EN COURS (n)",
        Hi: 'चालू माह की संपत्ति चल सकती है (एन)',
        Ta: 'நடப்பு மாத சொத்து இயக்கம் (n)',
        Ja: '今月の資産の変動 (n)',
        Ge: 'AKTUELLER MONAT VERMÖGENSKANN BEWEGUNG (n)',
      },
      AVIB06: {
        En: 'New Asset Added (n)',
        Et: 'SELLES KUU LISATUD UUED VARADE NIMETUSED (n)',
        Ar: 'تمت إضافة عناوين الأصول الجديدة في هذا الشهر (اسم)',
        Ml: 'ഈ മാസത്തിൽ പുതിയ അസറ്റ് ശീർഷകങ്ങൾ ചേർത്തു (n)',
        Ma: 'या महिन्यात जोडलेली नवीन मालमत्ता शीर्षके (n)',
        Fr: "NOUVEAUX TITRES D'ACTIFS AJOUTÉS CE MOIS (n)",
        Hi: 'इस महीने में जोड़े गए नए एसेट टाइटल (एन)',
        Ta: 'இந்த மாதத்தில் சேர்க்கப்பட்ட புதிய சொத்து தலைப்புகள் (n)',
        Ja: '今月追加された新しいアセット タイトル (n)',
        Ge: 'NEUE IN DIESEM MONAT HINZUGEFÜGTE ANLAGENBEZEICHNUNGEN (n)',
      },
      AVIB07: {
        En: 'ASSETS SCHEDULED FOR CLEANING (n)',
        Et: 'PUHASTAMISEKS PLAANID VARAD (n)',
        Ar: 'الأصول المجدولة للتنظيف (ن)',
        Ml: 'ശുചീകരണത്തിനായി ഷെഡ്യൂൾ ചെയ്ത അസറ്റുകൾ (n)',
        Ma: 'साफसफाईसाठी शेड्यूल केलेली मालमत्ता (n)',
        Fr: 'ACTIFS À NETTOYER (n)',
        Hi: 'सफाई के लिए निर्धारित परिसंपत्तियां (एन)',
        Ta: 'சுத்தம் செய்ய திட்டமிடப்பட்ட சொத்துகள் (n)',
        Ja: 'クリーニングが予定されているアセット (n)',
        Ge: 'ZUR REINIGUNG VORGESEHENE ANLAGEN (n)',
      },
      AVIB08: {
        En: 'PEnDING RETURNS FROM BORROWERS',
        Et: 'OTSELISED TAGASTUSED LAENUTAJATELT',
        Ar: 'العائدات من المقترضين',
        Ml: 'കടം വാങ്ങുന്നവരിൽ നിന്ന് തീർപ്പാക്കാത്ത റിട്ടേണുകൾ',
        Ma: 'कर्जदारांकडून प्रलंबित परतावे',
        Fr: 'RETOURS EN ATTENTE DES EMPRUNTEURS',
        Hi: 'उधारकर्ताओं से लंबित रिटर्न',
        Ta: 'கடன் வாங்கியவர்களிடமிருந்து நிலுவையில் உள்ள வருமானம்',
        Ja: '借り手からの保留中の返品',
        Ge: 'AUSSTEHENDE RÜCKGABEN VON KREDITNEHMERN',
      },
      AVIB09: {
        En: 'Assets Cleaned',
        Et: 'SELLES KUU PUHASTATUD VARAD',
        Ar: 'تم تنظيف الأصول في هذا الشهر',
        Ml: 'ഈ മാസം വൃത്തിയാക്കിയ അസറ്റുകൾ',
        Ma: 'या महिन्यात मालमत्ता साफ केली',
        Fr: 'ACTIFS NETTOYÉS AU COURS DE CE MOIS',
        Hi: 'इस महीने में साफ की गई संपत्ति',
        Ta: 'இந்த மாதத்தில் சொத்துக்கள் சுத்தம் செய்யப்பட்டன',
        Ja: '今月クリーニングされたアセット',
        Ge: 'IN DIESEM MONAT GERÄUMTE VERMÖGENSWERTE',
      },
      AVIB10: {
        En: 'CURRENT MONTH ASSET CAN MOVEMEnT',
        Et: 'JOOKSE KUU VARA VÕIB LIIKUTADA',
        Ar: 'يمكن نقل أصول الشهر الحالي',
        Ml: 'നിലവിലെ മാസത്തെ ആസ്തി നീക്കാൻ കഴിയും',
        Ma: 'चालू महिन्याची मालमत्ता हलवू शकते',
        Fr: "MOUVEMENT DE L'ACTIF CAN DU MOIS EN COURS",
        Hi: 'चालू माह की संपत्ति चल सकती है',
        Ta: 'நடப்பு மாதச் சொத்து நகர்த்தலாம்',
        Ja: '当月の資産は変動する可能性があります',
        Ge: 'DER AKTUELLE MONAT VERMÖGEN KANN SICH BEWEGEN',
      },
      AVIB11: {
        En: 'New Asset Added',
        Et: 'SEL KUU LISATUD UUED VARADE NIMETUSED',
        Ar: 'تمت إضافة عناوين أصول جديدة في هذا الشهر',
        Ml: 'ഈ മാസത്തിൽ പുതിയ അസറ്റ് ശീർഷകങ്ങൾ ചേർത്തു',
        Ma: 'या महिन्यात नवीन मालमत्ता शीर्षके जोडली गेली',
        Fr: "NOUVEAUX TITRES D'ACTIFS AJOUTÉS CE MOIS-CI",
        Hi: 'इस महीने में जोड़े गए नए एसेट टाइटल',
        Ta: 'இந்த மாதத்தில் சேர்க்கப்பட்ட புதிய சொத்து தலைப்புகள்',
        Ja: '今月追加された新しいアセット タイトル',
        Ge: 'IN DIESEM MONAT HINZUGEFÜGTE NEUE INSTRUMENTENBEZEICHNUNGEN',
      },
      AVIB12: {
        En: 'ASSETS SCHEDULED FOR CLEANING',
        Et: 'VARAD PLAANIS PUHASTAMISEKS',
        Ar: 'الأصول المجدولة للتنظيف',
        Ml: 'ശുചീകരണത്തിനായി ഷെഡ്യൂൾ ചെയ്ത അസറ്റുകൾ',
        Ma: 'साफसफाईसाठी शेड्यूल केलेली मालमत्ता',
        Fr: 'ACTIFS PRÉVUS POUR LE NETTOYAGE',
        Hi: 'सफाई के लिए निर्धारित संपत्ति',
        Ta: 'சுத்தம் செய்ய திட்டமிடப்பட்ட சொத்துகள்',
        Ja: 'クリーニングが予定されている資産',
        Ge: 'ZUR REINIGUNG VORGESEHENE ANLAGEN',
      },
      AVIB13: {
        En: 'View',
        Et: 'Vaade',
        Ar: 'رأي',
        Ml: 'കാണുക',
        Ma: 'पहा',
        Fr: 'Voir',
        Hi: 'देखें',
        Ta: 'காண்க',
        Ja: '意見',
        Ge: 'Aussicht',
      },
    },

    AssetViewItemLevelPEnDINGRETURNSFROMBORROWERS: {
      AVLPRI01: {
        En: 'Asset Image',
        Et: 'Vara pilt',
        Ar: 'صورة الأصل',
        Ml: 'അസറ്റ് ചിത്രം',
        Ma: 'मालमत्ता प्रतिमा',
        Fr: "Image de l'élément",
        Hi: 'एसेट इमेज',
        Ta: 'சொத்து படம்',
        Ja: '資産イメージ',
        Ge: 'Asset-Bild',
      },
      AVLPRB01: {
        En: 'Usernames',
        Et: 'Kasutajanimed',
        Ar: 'أسماء المستخدمين',
        Ml: 'ഉപയോക്തൃനാമങ്ങൾ',
        Ma: 'वापरकर्तानावे',
        Fr: "Noms d'utilisateur",
        Hi: 'उपयोगकर्ताओं के नाम',
        Ta: 'பயனர் பெயர்கள்',
        Ja: 'ユーザー名',
        Ge: 'Benutzernamen',
      },
      AVLPRB02: {
        En: 'View',
        Et: 'Vaade',
        Ar: 'رأي',
        Ml: 'കാണുക',
        Ma: 'पहा',
        Fr: 'Voir',
        Hi: 'देखें',
        Ta: 'காண்க',
        Ja: '意見',
        Ge: 'Aussicht',
      },
      AVLPRL01: {
        En: 'Asset Name',
        Et: 'Vara nimi',
        Ar: 'اسم الأصل',
        Ml: 'അസറ്റ് പേര്',
        Ma: 'मालमत्तेचे नाव',
        Fr: "Nom de l'actif",
        Hi: 'संपत्ति का नाम',
        Ta: 'சொத்து பெயர்',
        Ja: 'アセット名',
        Ge: 'Asset-Name',
      },
    },

    AssetViewItemLevelASSETSCLEANEDINTHISMONTH: {
      AVLACI01: {
        En: 'Asset Image',
        Et: 'Vara pilt',
        Ar: 'صورة الأصل',
        Ml: 'അസറ്റ് ചിത്രം',
        Ma: 'मालमत्ता प्रतिमा',
        Fr: "Image de l'élément",
        Hi: 'एसेट इमेज',
        Ta: 'சொத்து படம்',
        Ja: '資産イメージ',
        Ge: 'Asset-Bild',
      },
      AVLACB01: {
        En: 'Usernames',
        Et: 'Kasutajanimed',
        Ar: 'أسماء المستخدمين',
        Ml: 'ഉപയോക്തൃനാമങ്ങൾ',
        Ma: 'वापरकर्तानावे',
        Fr: "Noms d'utilisateur",
        Hi: 'उपयोगकर्ताओं के नाम',
        Ta: 'பயனர் பெயர்கள்',
        Ja: 'ユーザー名',
        Ge: 'Benutzernamen',
      },
      AVLACB02: {
        En: 'View',
        Et: 'Vaade',
        Ar: 'رأي',
        Ml: 'കാണുക',
        Ma: 'पहा',
        Fr: 'Voir',
        Hi: 'देखें',
        Ta: 'காண்க',
        Ja: '意見',
        Ge: 'Aussicht',
      },
      AVLACL01: {
        En: 'Asset Name',
        Et: 'Vara nimi',
        Ar: 'اسم الأصل',
        Ml: 'അസറ്റ് പേര്',
        Ma: 'मालमत्तेचे नाव',
        Fr: "Nom de l'actif",
        Hi: 'संपत्ति का नाम',
        Ta: 'சொத்து பெயர்',
        Ja: 'アセット名',
        Ge: 'Asset-Name',
      },
    },

    AssetViewItemLevelCURREnTMONTHASSETCANMOVEMEnT: {
      AVLAMI01: {
        En: 'Asset Image',
        Et: 'Vara pilt',
        Ar: 'صورة الأصل',
        Ml: 'അസറ്റ് ചിത്രം',
        Ma: 'मालमत्ता प्रतिमा',
        Fr: "Image de l'élément",
        Hi: 'एसेट इमेज',
        Ta: 'சொத்து படம்',
        Ja: '資産イメージ',
        Ge: 'Asset-Bild',
      },
      AVLAMB01: {
        En: 'Usernames',
        Et: 'Kasutajanimed',
        Ar: 'أسماء المستخدمين',
        Ml: 'ഉപയോക്തൃനാമങ്ങൾ',
        Ma: 'वापरकर्तानावे',
        Fr: "Noms d'utilisateur",
        Hi: 'उपयोगकर्ताओं के नाम',
        Ta: 'பயனர் பெயர்கள்',
        Ja: 'ユーザー名',
        Ge: 'Benutzernamen',
      },
      AVLAMB02: {
        En: 'View',
        Et: 'Vaade',
        Ar: 'رأي',
        Ml: 'കാണുക',
        Ma: 'पहा',
        Fr: 'Voir',
        Hi: 'देखें',
        Ta: 'காண்க',
        Ja: '意見',
        Ge: 'Aussicht',
      },
      AVLAML01: {
        En: 'Asset Name',
        Et: 'Vara nimi',
        Ar: 'اسم الأصل',
        Ml: 'അസറ്റ് പേര്',
        Ma: 'मालमत्तेचे नाव',
        Fr: "Nom de l'actif",
        Hi: 'संपत्ति का नाम',
        Ta: 'சொத்து பெயர்',
        Ja: 'アセット名',
        Ge: 'Asset-Name',
      },
    },

    AssetViewItemLevelNEWASSETTITLESADDEDINTHISMONTH: {
      AVLNAI01: {
        En: 'Asset Image',
        Et: 'Vara pilt',
        Ar: 'صورة الأصل',
        Ml: 'അസറ്റ് ചിത്രം',
        Ma: 'मालमत्ता प्रतिमा',
        Fr: "Image de l'élément",
        Hi: 'एसेट इमेज',
        Ta: 'சொத்து படம்',
        Ja: '資産イメージ',
        Ge: 'Asset-Bild',
      },
      AVLNAB01: {
        En: 'Usernames',
        Et: 'Kasutajanimed',
        Ar: 'أسماء المستخدمين',
        Ml: 'ഉപയോക്തൃനാമങ്ങൾ',
        Ma: 'वापरकर्तानावे',
        Fr: "Noms d'utilisateur",
        Hi: 'उपयोगकर्ताओं के नाम',
        Ta: 'பயனர் பெயர்கள்',
        Ja: 'ユーザー名',
        Ge: 'Benutzernamen',
      },
      AVLNAB02: {
        En: 'View',
        Et: 'Vaade',
        Ar: 'رأي',
        Ml: 'കാണുക',
        Ma: 'पहा',
        Fr: 'Voir',
        Hi: 'देखें',
        Ta: 'காண்க',
        Ja: '意見',
        Ge: 'Aussicht',
      },
      AVLNAL01: {
        En: 'Asset Name',
        Et: 'Vara nimi',
        Ar: 'اسم الأصل',
        Ml: 'അസറ്റ് പേര്',
        Ma: 'मालमत्तेचे नाव',
        Fr: "Nom de l'actif",
        Hi: 'संपत्ति का नाम',
        Ta: 'சொத்து பெயர்',
        Ja: 'アセット名',
        Ge: 'Asset-Name',
      },
    },

    AssetViewItemLevelASSETSSCHEDULEDFORCLEANING: {
      AVLACI01: {
        En: 'Asset Image',
        Et: 'Vara pilt',
        Ar: 'صورة الأصل',
        Ml: 'അസറ്റ് ചിത്രം',
        Ma: 'मालमत्ता प्रतिमा',
        Fr: "Image de l'élément",
        Hi: 'एसेट इमेज',
        Ta: 'சொத்து படம்',
        Ja: '資産イメージ',
        Ge: 'Asset-Bild',
      },
      AVLACB01: {
        En: 'Usernames',
        Et: 'Kasutajanimed',
        Ar: 'أسماء المستخدمين',
        Ml: 'ഉപയോക്തൃനാമങ്ങൾ',
        Ma: 'वापरकर्तानावे',
        Fr: "Noms d'utilisateur",
        Hi: 'उपयोगकर्ताओं के नाम',
        Ta: 'பயனர் பெயர்கள்',
        Ja: 'ユーザー名',
        Ge: 'Benutzernamen',
      },
      AVLACB02: {
        En: 'View',
        Et: 'Vaade',
        Ar: 'رأي',
        Ml: 'കാണുക',
        Ma: 'पहा',
        Fr: 'Voir',
        Hi: 'देखें',
        Ta: 'காண்க',
        Ja: '意見',
        Ge: 'Aussicht',
      },
      AVLACL01: {
        En: 'Asset Name',
        Et: 'Vara nimi',
        Ar: 'اسم الأصل',
        Ml: 'അസറ്റ് പേര്',
        Ma: 'मालमत्तेचे नाव',
        Fr: "Nom de l'actif",
        Hi: 'संपत्ति का नाम',
        Ta: 'சொத்து பெயர்',
        Ja: 'アセット名',
        Ge: 'Asset-Name',
      },
    },

    AssetViewItemLevelAllAssetsView: {
      AVLAVI01: {
        En: 'Asset Image',
        Et: 'Vara pilt',
        Ar: 'صورة الأصل',
        Ml: 'അസറ്റ് ചിത്രം',
        Ma: 'मालमत्ता प्रतिमा',
        Fr: "Image de l'élément",
        Hi: 'एसेट इमेज',
        Ta: 'சொத்து படம்',
        Ja: '資産イメージ',
        Ge: 'Asset-Bild',
      },
      AVLAVB01: {
        En: 'Manage Asset',
        Et: 'Halda vara',
        Ar: 'إدارة الأصول',
        Ml: 'അസറ്റ് കൈകാര്യം ചെയ്യുക',
        Ma: 'मालमत्ता व्यवस्थापित करा',
        Fr: "Gérer l'actif",
        Hi: 'संपत्ति का प्रबंधन करें',
        Ta: 'சொத்தை நிர்வகிக்கவும்',
        Ja: '資産の管理',
        Ge: 'Vermögen verwalten',
      },
      AVLAVB02: {
        En: 'Edit Workflow',
        Et: 'Töövoo muutmine',
        Ar: 'تحرير سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ എഡിറ്റ് ചെയ്യുക',
        Ma: 'वर्कफ्लो संपादित करा',
        Fr: 'Modifier le flux de travail',
        Hi: 'वर्कफ़्लो संपादित करें',
        Ta: 'பணிப்பாய்வுகளைத் திருத்தவும்',
        Ja: 'ワークフローの編集',
        Ge: 'Arbeitsablauf bearbeiten',
      },
      AVLAVB03: {
        En: 'Movement Tracker',
        Et: 'Liikumise jälgija',
        Ar: 'تعقب الحركة',
        Ml: 'മൂവ്മെന്റ് ട്രാക്കർ',
        Ma: 'हालचाल ट्रॅकर',
        Fr: 'Traqueur de mouvement',
        Hi: 'आंदोलन ट्रैकर',
        Ta: 'இயக்கம் டிராக்கர்',
        Ja: 'ムーブメントトラッカー',
        Ge: 'Bewegungs-Tracker',
      },
      AVLAVB04: {
        En: 'User Tracker',
        Et: 'Kasutaja jälgija',
        Ar: 'تعقب المستخدم',
        Ml: 'ഉപയോക്തൃ ട്രാക്കർ',
        Ma: 'वापरकर्ता ट्रॅकर',
        Fr: 'Suivi des utilisateurs',
        Hi: 'उपयोगकर्ता ट्रैकर',
        Ta: 'பயனர் டிராக்கர்',
        Ja: 'ユーザートラッカー',
        Ge: 'Benutzer-Tracker',
      },
      AVLAVL01: {
        En: 'Asset Name',
        Et: 'Vara nimi',
        Ar: 'اسم الأصل',
        Ml: 'അസറ്റ് പേര്',
        Ma: 'मालमत्तेचे नाव',
        Fr: "Nom de l'actif",
        Hi: 'संपत्ति का नाम',
        Ta: 'சொத்து பெயர்',
        Ja: 'アセット名',
        Ge: 'Asset-Name',
      },
      AVLAVL02: {
        En: 'Language: x',
        Et: 'Keel: x',
        Ar: 'اللغة: x',
        Ml: 'ഭാഷ: x',
        Ma: 'भाषा: x',
        Fr: 'Langue : x',
        Hi: 'भाषा: x',
        Ta: 'மொழி: x',
        Ja: '言語: ×',
        Ge: 'Sprache: x',
      },

      AVLAVL08: {
        En: 'Histroy',
        Et: 'hisstroy',
        Ar: 'هستروي',
        Ml: 'ഹിസ്ട്രോയ്',
        Ma: 'hisstroy',
        Fr: 'hisstroy',
        Hi: 'हिस्ट्रोय',
        Ta: 'ஹிஸ்ட்ரோய்',
        Ja: '歴史',
        Ge: 'histroy',
      },
    },

    AssetsViewItemLevelViewPagesSidebarTabpane: {
      AVILVPSTL01: {
        En: 'Meta Data',
        Et: 'Metaandmed',
        Ar: 'البيانات الوصفية',
        Ml: 'മെറ്റാ ഡാറ്റ',
        Ma: 'मेटा डेटा',
        Fr: 'Métadonnées',
        Hi: 'मेटा डेटा',
        Ta: 'மெட்டா டேட்டா',
        Ja: 'メタデータ',
        Ge: 'Metadaten',
      },
      AVILVPSTL02: {
        En: 'Technical',
        Et: 'Tehniline',
        Ar: 'اِصطِلاحِيّ',
        Ml: 'സാങ്കേതികമായ',
        Ma: 'तांत्रिक',
        Fr: 'Technique',
        Hi: 'तकनीकी',
        Ta: 'தொழில்நுட்பம்',
        Ja: 'テクニカル',
        Ge: 'Technisch',
      },
      AVILVPSTL03: {
        En: 'Physical',
        Et: 'Füüsiline',
        Ar: 'بدني',
        Ml: 'ശാരീരികം',
        Ma: 'शारीरिक',
        Fr: 'Physique',
        Hi: 'भौतिक',
        Ta: 'உடல்',
        Ja: '物理的',
        Ge: 'Physisch',
      },
      AVILVPSTL04: {
        En: 'Schedule',
        Ar: 'جدول ',
        Ml: 'സമയപട്ടിക',
        Ma: 'वेळापत्रक',
        Fr: 'Calendrier',
        Hi: 'समय सारणी',
        Ta: 'நேர அட்டவணை',
        Ja: 'スケジュール',
        Ge: 'Zeitplan'
      }
    },

    AssetsViewItemLevelViewPagesSidebarTabpaneMetadata: {
      AVILVPSTPML01: {
        En: 'Work Identifier',
        Et: 'Töö identifikaator',
        Ar: 'معرف العمل',
        Ml: 'വർക്ക് ഐഡന്റിഫയർ',
        Ma: 'कार्य ओळखकर्ता',
        Fr: 'Identifiant de travail',
        Hi: 'कार्य पहचानकर्ता',
        Ta: 'வேலை அடையாளங்காட்டி',
        Ja: '作業識別子',
        Ge: 'Arbeitskennung',
      },
      AVILVPSTPML02: {
        En: 'Synopsis',
        Et: 'Sisukokkuvõte',
        Ar: 'ملخص',
        Ml: 'സംഗ്രഹം',
        Ma: 'सारांश',
        Fr: 'Synopsis',
        Hi: 'सार',
        Ta: 'சுருக்கம்',
        Ja: 'あらすじ',
        Ge: 'Zusammenfassung',
      },
      AVILVPSTPML03: {
        En: 'Meta Data',
        Et: 'Metaandmed',
        Ar: 'البيانات الوصفية',
        Ml: 'മെറ്റാ ഡാറ്റ',
        Ma: 'मेटा डेटा',
        Fr: 'Métadonnées',
        Hi: 'मेटा डेटा',
        Ta: 'மெட்டா டேட்டா',
        Ja: 'メタデータ',
        Ge: 'Metadaten',
      },
      AVILVPSTPML04: {
        En: 'No Metadata found',
        Et: 'Metaandmeid ei leitud',
        Ar: 'لم يتم العثور على بيانات وصفية',
        Ml: 'മെറ്റാഡാറ്റയൊന്നും കണ്ടെത്തിയില്ല',
        Ma: 'कोणताही मेटाडेटा आढळला नाही',
        Fr: 'Aucune métadonnée trouvée',
        Hi: 'कोई मेटाडेटा नहीं मिला',
        Ta: 'மெட்டாடேட்டா எதுவும் இல்லை',
        Ja: 'メタデータが見つかりません',
        Ge: 'Keine Metadaten gefunden',
      },
    },

    AssetsViewItemLevelViewPagesSidebarTabpaneMetadataWorkIdentifier: {
      AVILVPSTPMWIL01: {
        En: 'Id',
        Et: 'Id',
        Ar: 'هوية شخصية',
        Ml: 'ഐഡി',
        Ma: 'आयडी',
        Fr: 'Identifiant',
        Hi: 'पहचान',
        Ta: 'ஐடி',
        Ja: 'ID',
        Ge: 'Ausweis',
      },
      AVILVPSTPMWIL02: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      AVILVPSTPMWIL03: {
        En: 'Title',
        Et: 'Pealkiri',
        Ar: 'عنوان',
        Ml: 'തലക്കെട്ട്',
        Ma: 'शीर्षक',
        Fr: 'Titre',
        Hi: 'शीर्षक',
        Ta: 'தலைப்பு',
        Ja: '題名',
        Ge: 'Titel',
      },
      AVILVPSTPMWIL04: {
        En: 'Year',
        Et: 'aasta',
        Ar: 'سنة',
        Ml: 'വർഷം',
        Ma: 'वर्ष',
        Fr: 'An',
        Hi: 'साल',
        Ta: 'ஆண்டு',
        Ja: '年',
        Ge: 'Jahr',
      },
      AVILVPSTPMWIL05: {
        En: 'Origin',
        Et: 'Päritolu',
        Ar: 'أصل',
        Ml: 'ഉത്ഭവം',
        Ma: 'मूळ',
        Fr: 'Origine',
        Hi: 'मूल',
        Ta: 'தோற்றம்',
        Ja: '元',
        Ge: 'Herkunft',
      },
    },

    AssetsViewItemLevelViewPagesSidebarTabpanePhysical: {
      AVILVPSTPPL01: {
        En: 'Physical Assets',
        Et: 'Füüsilised varad',
        Ar: 'اصول فيزيائية',
        Ml: 'ഭൗതിക ആസ്തികൾ',
        Ma: 'भौतिक मालमत्ता',
        Fr: 'Actifs physiques',
        Hi: 'भौतिक संपत्ति',
        Ta: 'உடல் சொத்துக்கள்',
        Ja: '物的資産',
        Ge: 'Physische Vermögenswerte',
      },
      AVILVPSTPPL02: {
        En: 'Physical Sensor NFC',
        Et: 'Füüsiline andur NFC',
        Ar: 'الاستشعار الفيزيائي NFC',
        Ml: 'ഫിസിക്കൽ സെൻസർ NFC',
        Ma: 'भौतिक सेन्सर NFC',
        Fr: 'Capteur physique NFC',
        Hi: 'भौतिक सेंसर एनएफसी',
        Ta: 'இயற்பியல் சென்சார் NFC',
        Ja: '物理センサー NFC',
        Ge: 'Physischer Sensor NFC',
      },
      AVILVPSTPPL03: {
        En: 'Physcial Sensor BarCode',
        Et: 'Füüsilise anduri vöötkood',
        Ar: 'الرمز الشريطي لجهاز الاستشعار المادي',
        Ml: 'ഫിസിക്കൽ സെൻസർ ബാർകോഡ്',
        Ma: 'भौतिक सेन्सर बारकोड',
        Fr: 'Code-barres du capteur physique',
        Hi: 'भौतिक सेंसर बारकोड',
        Ta: 'இயற்பியல் சென்சார் பார்கோடு',
        Ja: '物理センサー バーコード',
        Ge: 'Physischer Sensor-BarCode',
      },
      AVILVPSTPPL04: {
        En: 'Physcial Sensor QRCode',
        Et: 'Füüsilise anduri QR-kood',
        Ar: 'رمز الاستجابة السريعة للمستشعر المادي',
        Ml: 'ഫിസിക്കൽ സെൻസർ QR കോഡ്',
        Ma: 'भौतिक सेन्सर QR कोड',
        Fr: 'Code QR du capteur physique',
        Hi: 'भौतिक सेंसर क्यूआर कोड',
        Ta: 'இயற்பியல் சென்சார் QR குறியீடு',
        Ja: '物理センサーの QR コード',
        Ge: 'QR-Code des physischen Sensors',
      },
      AVILVPSTPPL05: {
        En: 'Physcial Sensor RFID',
        Et: 'Füüsilised andurid RFID',
        Ar: 'RFID أجهزة الاستشعار الفيزيائية',
        Ml: 'ഫിസിക്കൽ സെൻസറുകൾ RFID',
        Ma: 'भौतिक सेन्सर्स RFID',
        Fr: 'Capteurs physiques RFID',
        Hi: 'भौतिक सेंसर आरएफआईडी',
        Ta: 'இயற்பியல் சென்சார்கள் RFID',
        Ja: '物理センサー RFID',
        Ge: 'Physikalische Sensoren RFID',
      },
      AVILVPSTPPL06: {
        En: 'Physcial Location Rack',
        Et: 'Füüsilise asukoha jälgimine',
        Ar: 'مسار الموقع الفعلي',
        Ml: 'ഫിസിക്കൽ ലൊക്കേഷൻ ട്രാക്ക്',
        Ma: 'भौतिक स्थान ट्रॅक',
        Fr: "Piste d'emplacement physique",
        Hi: 'भौतिक स्थान ट्रैक',
        Ta: 'இயற்பியல் இருப்பிடத் தடம்',
        Ja: '物理的な場所のトラック',
        Ge: 'Physische Standortverfolgung',
      },
      AVILVPSTPPL07: {
        En: 'Physical Location Shelf',
        Et: 'Füüsilise asukoha riiul',
        Ar: 'رف الموقع المادي',
        Ml: 'ഫിസിക്കൽ ലൊക്കേഷൻ ഷെൽഫ്',
        Ma: 'भौतिक स्थान शेल्फ',
        Fr: "Étagère d'emplacement physique",
        Hi: 'भौतिक स्थान शेल्फ',
        Ta: 'உடல் இருப்பிட அலமாரி',
        Ja: '物理的な場所の棚',
        Ge: 'Physischer Standort Regal',
      },
      AVILVPSTPPL08: {
        En: 'Physcial Location Vault',
        Et: 'Füüsilise asukoha varahoidla',
        Ar: 'قبو الموقع الفعلي',
        Ml: 'ഫിസിക്കൽ ലൊക്കേഷൻ വോൾട്ട്',
        Ma: 'भौतिक स्थान वॉल्ट',
        Fr: "Coffre-fort d'emplacement physique",
        Hi: 'भौतिक स्थान वॉल्ट',
        Ta: 'உடல் இருப்பிட வால்ட்',
        Ja: '物理的な場所のボールト',
        Ge: 'Tresor für physische Standorte',
      },
      AVILVPSTPPL09: {
        En: 'Global Positioning System',
        Et: 'Globaalne positsioneerimissüsteem',
        Ar: 'نظام تحديد المواقع العالمي',
        Ml: 'ഗ്ലോബൽ പൊസിഷനിങ് സിസ്റ്റം',
        Ma: 'ग्लोबल पोझिशनिंग सिस्टम',
        Fr: 'Système de positionnement global',
        Hi: 'ग्लोबल पोजिशनिंग सिस्टम',
        Ta: 'குளோபல் பொசிஷனிங் சிஸ்டம்',
        Ja: '全地球測位システム',
        Ge: 'Global Positioning System',
      },
      AVILVPSTPPL10: {
        En: 'Asset In Vault',
        Et: 'Vara Vault',
        Ar: 'الأصول في الخزنة',
        Ml: 'വോൾട്ടിലെ അസറ്റ്',
        Ma: 'व्हॉल्टमध्ये मालमत्ता',
        Fr: 'Actif dans le coffre-fort',
        Hi: 'तिजोरी में संपत्ति',
        Ta: 'வால்ட்டில் உள்ள சொத்து',
        Ja: 'ボールト内のアセット',
        Ge: 'Asset im Tresor',
      },
      AVILVPSTPPL11: {
        En: 'Movement Time',
        Et: 'Liikumise aeg',
        Ar: 'وقت الحركة',
        Ml: 'ചലന സമയം',
        Ma: 'हालचाल वेळ',
        Fr: 'Temps de mouvement',
        Hi: 'आंदोलन का समय',
        Ta: 'இயக்க நேரம்',
        Ja: '移動時間',
        Ge: 'Bewegungszeit',
      },
    },

    AssetsViewItemLevelViewPageWorkflowStepper: {
      AVILVPWSL01: {
        En: 'No active workflow',
        Et: 'Aktiivne töövoog puudub',
        Ar: 'لا يوجد سير عمل نشط',
        Ml: 'സജീവമായ വർക്ക്ഫ്ലോ ഇല്ല',
        Ma: 'सक्रिय कार्यप्रवाह नाही',
        Fr: 'Aucun flux de travail actif',
        Hi: 'कोई सक्रिय कार्यप्रवाह नहीं',
        Ta: 'செயலில் பணிப்பாய்வு இல்லை',
        Ja: 'アクティブなワークフローがありません',
        Ge: 'Kein aktiver Workflow',
      },
      AVILVPWSL02: {
        En: 'Create Order',
        Ar: 'إنشاء طلب',
        Ml: 'ഓർഡർ സൃഷ്ടിക്കുക',
        Ma: 'ऑर्डर तयार करा',
        Fr: 'Créer une commande',
        Hi: 'ऑर्डर बनाएं',
        Ta: 'ஆர்டர் உருவாக்கு',
        Ja: '注文を作成する',
        Ge: 'Bestellung erstellen',
      }
    },

    AssetsViewItemLevelViewPage: {
      AVILVPS01: {
        En: 'Assets',
        Et: 'Varad',
        Ar: 'أصول',
        Ml: 'ആസ്തികൾ',
        Ma: 'मालमत्ता',
        Fr: 'Les atouts',
        Hi: 'संपत्ति',
        Ta: 'சொத்துக்கள்',
        Ja: '資産',
        Ge: 'Vermögenswerte',
      },
      AVILVPS02: {
        En: 'Users Assigned',
        Et: 'Kasutajad määratud',
        Ar: 'المستخدمون المعينون',
        Ml: 'ഉപയോക്താക്കളെ നിയോഗിച്ചു',
        Ma: 'वापरकर्ते नियुक्त',
        Fr: 'Utilisateurs affectés',
        Hi: 'उपयोगकर्ता असाइन किए गए',
        Ta: 'பயனர்கள் ஒதுக்கப்பட்டனர்',
        Ja: '割り当てられたユーザー',
        Ge: 'Benutzer zugewiesen',
      },
      AVILVPS03: {
        En: 'Chat about this event',
        Et: 'Vestelge selle sündmuse kohta',
        Ar: 'الدردشة حول هذا الحدث',
        Ml: 'ഈ ഇവന്റിനെക്കുറിച്ച് ചാറ്റ് ചെയ്യുക',
        Ma: 'या कार्यक्रमाबद्दल गप्पा मारा',
        Fr: 'Discuter de cet événement',
        Hi: 'इस घटना के बारे में चैट करें',
        Ta: 'இந்த நிகழ்வைப் பற்றி அரட்டை அடிக்கவும்',
        Ja: 'このイベントについてチャットする',
        Ge: 'Chatten Sie über diese Veranstaltung',
      },
    },

    AssetsViewItemLevelViewPageAssetsSegment: {
      AVILVPASTP01: {
        En: 'Digital',
        Et: 'Digitaalne',
        Ar: 'رقمي',
        Ml: 'ഡിജിറ്റൽ',
        Ma: 'डिजिटल',
        Fr: 'Numérique',
        Hi: 'डिजिटल',
        Ta: 'டிஜிட்டல்',
        Ja: 'デジタル',
        Ge: 'Digital',
      },
      AVILVPASTP02: {
        En: 'GPS',
        Et: 'GPS',
        Ar: 'نظام تحديد المواقع',
        Ml: 'ജിപിഎസ്',
        Ma: 'जीपीएस',
        Fr: 'GPS',
        Hi: 'GPS',
        Ta: 'ஜி.பி.எஸ்',
        Ja: 'GPS',
        Ge: 'Geographisches Positionierungs System',
      },
      AVILVPASTP03: {
        En: 'Cloned Items',
        Et: 'Kloonitud esemed',
        Ar: 'العناصر المستنسخة',
        Ml: 'ക്ലോൺ ചെയ്ത ഇനങ്ങൾ',
        Ma: 'क्लोन केलेले आयटम',
        Fr: 'Articles clonés',
        Hi: 'क्लोन किए गए आइटम',
        Ta: 'குளோன் செய்யப்பட்ட பொருட்கள்',
        Ja: 'クローンアイテム',
        Ge: 'Geklonte Gegenstände',
      },
      AVILVPASTP04: {
        En: 'Physical',
        Et: 'Füüsiline',
        Ar: 'بدني',
        Ml: 'ശാരീരികം',
        Ma: 'शारीरिक',
        Fr: 'Physique',
        Hi: 'भौतिक',
        Ta: 'உடல்',
        Ja: '物理的',
        Ge: 'Physisch',
      },
      AVILVPASTP05: {
        En: 'Cutlist',
        Et: 'Füüsiline',
        Ar: 'بدني',
        Ml: 'ശാരീരികം',
        Ma: 'शारीरिक',
        Fr: 'Physique',
        Hi: 'भौतिक',
        Ta: 'உடல்',
        Ja: '物理的',
        Ge: 'Physisch',
      },
      AVILVPASTP06: {
        En: 'Orders',
        Ar: 'طلبات',
        Ml: 'ഓർഡറുകൾ',
        Ma: 'ऑर्डर',
        Fr: 'Commandes',
        Hi: 'ऑर्डर',
        Ta: 'ஆர்டர்கள்',
        Ja: '注文',
        Ge: 'Bestellungen'
      }
    },

    AssetsViewItemLevelViewPageAssetsSegmentDigitalTab: {
      AVILVPASDTPL01: {
        En: 'Files',
        Et: 'Failid',
        Ar: 'الملفات',
        Ml: 'ഫയലുകൾ',
        Ma: 'फाईल्स',
        Fr: 'Des dossiers',
        Hi: 'फ़ाइलें',
        Ta: 'கோப்புகள்',
        Ja: 'ファイル',
        Ge: 'Dateien',
      },
    },

    AssetsViewItemLevelViewPageAssetsSegmentClonedItemsTab: {
      AVILVPASCITPL01: {
        En: 'No Cloned Assets Found',
        Et: 'Kloonitud varasid ei leitud',
        Ar: 'لم يتم العثور على أصول مستنسخة',
        Ml: 'ക്ലോൺ ചെയ്ത അസറ്റുകളൊന്നും കണ്ടെത്തിയില്ല',
        Ma: 'कोणतीही क्लोन केलेली मालमत्ता आढळली नाही',
        Fr: 'Aucun actif cloné trouvé',
        Hi: 'कोई क्लोन की गई संपत्ति नहीं मिली',
        Ta: 'குளோன் செய்யப்பட்ட சொத்துக்கள் எதுவும் இல்லை',
        Ja: '複製されたアセットが見つかりません',
        Ge: 'Keine geklonten Assets gefunden',
      },
    },

    AssetsViewItemLevelViewPageAssetsSegmentPhysicalTab: {
      AVILVPASPTPB01: {
        En: 'Create Single',
        Et: 'Looge üksik',
        Ar: 'إنشاء واحدة',
        Ml: 'സിംഗിൾ സൃഷ്ടിക്കുക',
        Ma: 'एकल तयार करा',
        Fr: 'Créer un single',
        Hi: 'सिंगल बनाएं',
        Ta: 'ஒற்றை உருவாக்கவும்',
        Ja: 'シングルを作成',
        Ge: 'Single erstellen',
      },
      AVILVPASPTPB02: {
        En: 'Create Multiple',
        Et: 'Loo mitu',
        Ar: 'إنشاء متعددة',
        Ml: 'ഒന്നിലധികം സൃഷ്ടിക്കുക',
        Ma: 'एकाधिक तयार करा',
        Fr: 'Créer plusieurs',
        Hi: 'एकाधिक बनाएं',
        Ta: 'பல உருவாக்கவும்',
        Ja: '複数作成',
        Ge: 'Mehrere erstellen',
      },
      AVILVPASPTPB03: {
        En: 'Link Existing',
        Et: 'Link olemas',
        Ar: 'ارتباط موجود',
        Ml: 'ലിങ്ക് നിലവിലുണ്ട്',
        Ma: 'दुवा अस्तित्वात आहे',
        Fr: 'Lien existant',
        Hi: 'मौजूदा लिंक',
        Ta: 'இணைப்பு உள்ளது',
        Ja: '既存のリンク',
        Ge: 'Verknüpfung vorhanden',
      },
      AVILVPASPTPL01: {
        En: 'No Sections Found',
        Et: 'Sektsioone ei leitud',
        Ar: 'لم يتم العثور على أقسام',
        Ml: 'വിഭാഗങ്ങളൊന്നും കണ്ടെത്തിയില്ല',
        Ma: 'कोणतेही विभाग आढळले नाहीत',
        Fr: 'Aucune rubrique trouvée',
        Hi: 'कोई अनुभाग नहीं मिला',
        Ta: 'பிரிவுகள் எதுவும் இல்லை',
        Ja: 'セクションが見つかりません',
        Ge: 'Keine Abschnitte gefunden',
      },
    },

    AssetsViewItemLevelViewPageUsersAssignedSegment: {
      AVILVPUASL01A1: {
        En: 'User',
        Et: 'Kasutaja',
        Ar: 'المستعمل',
        Ml: 'ഉപയോക്താവ്',
        Ma: 'वापरकर्ता',
        Fr: 'Utilisateur',
        Hi: 'उपयोगकर्ता',
        Ta: 'பயனர்',
        Ja: 'ユーザー',
        Ge: 'Benutzer',
      },
      AVILVPUASL01A2: {
        En: 'Users',
        Et: 'Kasutajad',
        Ar: 'المستخدمون',
        Ml: 'ഉപയോക്താക്കൾ',
        Ma: 'वापरकर्ते',
        Fr: 'Utilisateurs',
        Hi: 'उपयोगकर्ताओं',
        Ta: 'பயனர்கள்',
        Ja: 'ユーザー',
        Ge: 'Benutzer',
      },
      AVILVPUASL01B: {
        En: 'Assigned',
        Et: 'Määratud',
        Ar: 'مُكَلَّف',
        Ml: 'ചുമതലപ്പെടുത്തി',
        Ma: 'नियुक्त केले',
        Fr: 'Attribué',
        Hi: 'सौंपा गया',
        Ta: 'ஒதுக்கப்படும்',
        Ja: '割り当て済み',
        Ge: 'Zugewiesen',
      },
      AVILVPUASL02: {
        En: 'Assigned',
        Et: 'Määratud',
        Ar: 'مُكَلَّف',
        Ml: 'ചുമതലപ്പെടുത്തി',
        Ma: 'नियुक्त केले',
        Fr: 'Attribué',
        Hi: 'सौंपा गया',
        Ta: 'ஒதுக்கப்படும்',
        Ja: '割り当て済み',
        Ge: 'Zugewiesen',
      },
      AVILVPUASTB01: {
        En: 'Search...',
        Et: 'Otsing...',
        Ar: 'يبحث...',
        Ml: 'തിരയുക...',
        Ma: 'शोधा...',
        Fr: 'Chercher...',
        Hi: 'खोज...',
        Ta: 'தேடு...',
        Ja: '探す...',
        Ge: 'Suche...',
      },
      AVILVPUASB01: {
        En: 'Add',
        Et: 'Lisama',
        Ar: 'يضيف',
        Ml: 'ചേർക്കുക',
        Ma: 'अॅड',
        Fr: 'Ajouter',
        Hi: 'जोड़ें',
        Ta: 'கூட்டு',
        Ja: '追加',
        Ge: 'Hinzufügen',
      },
    },

    AssetsViewItemLevelViewPageChat: {
      AVILVPCTA01: {
        En: 'Add Comment',
        Et: 'Lisa kommentaar',
        Ar: 'أضف تعليق',
        Ml: 'അഭിപ്രായം ചേർക്കുക',
        Ma: 'टिप्पणी जोडा',
        Fr: 'Add Comment',
        Hi: 'टिप्पणी जोड़ें',
        Ta: 'கருத்தைச் சேர்க்கவும்',
        Ja: 'コメントを追加する',
        Ge: 'Einen Kommentar hinzufügen',
      },
      AVILVPCB01: {
        En: ' Send',
        Et: 'Saada',
        Ar: 'إرسال',
        Ml: 'അയക്കുക',
        Ma: 'पाठवा',
        Fr: 'Envoyer',
        Hi: 'भेजना',
        Ta: 'அனுப்பு',
        Ja: '送信',
        Ge: 'Senden',
      },
      AVILVPCL01: {
        En: 'ago',
        Et: 'tagasi',
        Ar: 'منذ',
        Ml: 'മുമ്പ്',
        Ma: 'पूर्वी',
        Fr: 'depuis',
        Hi: 'पहले',
        Ta: 'முன்பு',
        Ja: '前に',
        Ge: 'vor',
      },
    },

    AssetViewItemLevelAllAssetsViewManageAsset: {
      ILP: {
        En: 'Manage Asset',
        Et: 'Halda vara',
        Ar: 'إدارة الأصول',
        Ml: 'അസറ്റ് കൈകാര്യം ചെയ്യുക',
        Ma: 'मालमत्ता व्यवस्थापित करा',
        Fr: "Gérer l'actif",
        Hi: 'संपत्ति का प्रबंधन करें',
        Ta: 'சொத்தை நிர்வகிக்கவும்',
        Ja: '資産の管理',
        Ge: 'Vermögen verwalten',
      },
    },

    AssetViewItemLevelAllAssetsViewEditWorkflow: {
      AVIALVEB1: {
        En: 'cancel',
        Et: 'tühistada',
        Ar: 'إلغاء',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Abbrechen',
      },
      AVIALVEB2: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    AssetViewItemLevelAllAssetsViewPhysicalInspection: {
      AVLAPIB01: {
        En: 'PI & Manual Cleaning',
        Et: 'PI ja käsitsi puhastamine',
        Ar: 'PI والتنظيف اليدوي',
        Ml: 'PI & മാനുവൽ ക്ലീനിംഗ്',
        Ma: 'PI आणि मॅन्युअल साफसफाई',
        Fr: 'PI et nettoyage manuel',
        Hi: 'पीआई और मैनुअल सफाई',
        Ta: 'PI & கைமுறை சுத்தம்',
        Ja: 'PI & 手動クリーニング',
        Ge: 'PI & manuelle Reinigung',
      },
      AVLAPIB02: {
        En: 'Categorization',
        Et: 'Kategoriseerimine',
        Ar: 'التصنيف',
        Ml: 'വർഗ്ഗീകരണം',
        Ma: 'वर्गीकरण',
        Fr: 'Catégorisation',
        Hi: 'वर्गीकरण',
        Ta: 'வகைப்படுத்தல்',
        Ja: '分類',
        Ge: 'Kategorisierung',
      },
      AVLAPIB03: {
        En: 'Repair',
        Et: 'Remont',
        Ar: 'بصلح',
        Ml: 'നന്നാക്കുക',
        Ma: 'दुरुस्ती',
        Fr: 'Réparation',
        Hi: 'मरम्मत करना',
        Ta: 'பழுது',
        Ja: '修理',
        Ge: 'Reparatur',
      },
      AVLAPIB04: {
        En: 'Photo Chemical Restoration',
        Et: 'Foto keemiline taastamine',
        Ar: 'استعادة الصور الكيميائية',
        Ml: 'ഫോട്ടോ കെമിക്കൽ പുനഃസ്ഥാപനം',
        Ma: 'फोटो केमिकल रिस्टोरेशन',
        Fr: 'Restauration photochimique',
        Hi: 'फोटो रासायनिक बहाली',
        Ta: 'புகைப்பட இரசாயன மறுசீரமைப்பு',
        Ja: 'フォトケミカル修復',
        Ge: 'Fotochemische Restaurierung',
      },
      AVLAPIB05: {
        En: 'Ultra Sonic Cleaning',
        Et: 'Ultraheli puhastamine',
        Ar: 'تنظيف الترا سونيك',
        Ml: 'അൾട്രാ സോണിക് ക്ലീനിംഗ്',
        Ma: 'अल्ट्रा सोनिक क्लीनिंग',
        Fr: 'Nettoyage ultra sonique',
        Hi: 'अल्ट्रा सोनिक सफाई',
        Ta: 'அல்ட்ரா சோனிக் கிளீனிங்',
        Ja: '超音波洗浄',
        Ge: 'Ultraschallreinigung',
      },
    },

    AssetViewItemLevelAllAssetsViewPhysicalInspectionPIandManualCleaning: {
      AVIAVPICL01: {
        En: 'PI & Manual Cleaning',
        Et: 'PI ja käsitsi puhastamine',
        Ar: 'PI والتنظيف اليدوي',
        Ml: 'PI & മാനുവൽ ക്ലീനിംഗ്',
        Ma: 'PI आणि मॅन्युअल साफसफाई',
        Fr: 'PI et nettoyage manuel',
        Hi: 'पीआई और मैनुअल सफाई',
        Ta: 'PI & கைமுறை சுத்தம்',
        Ja: 'PI & 手動クリーニング',
        Ge: 'PI & manuelle Reinigung',
      },
      AVIAVPICL02: {
        En: 'Length In Ft',
        Et: 'Pikkus Ft',
        Ar: 'الطول بالقدم',
        Ml: 'അടിയിൽ നീളം',
        Ma: 'फूट मध्ये लांबी',
        Fr: 'Longueur en pieds',
        Hi: 'फीट में लंबाई',
        Ta: 'அடியில் நீளம்',
        Ja: '長さ (フィート)',
        Ge: 'Länge in Ft',
      },
      AVIAVPICTB01: {
        En: 'Length In Ft Box',
        Et: 'Pikkus Ft Karbis',
        Ar: 'الطول في صندوق قدم',
        Ml: 'അടി പെട്ടിയിലെ നീളം',
        Ma: 'फूट बॉक्समध्ये लांबी',
        Fr: 'Boîte de longueur en pieds',
        Hi: 'फीट बॉक्स में लंबाई',
        Ta: 'அடி பெட்டியில் நீளம்',
        Ja: 'フィートボックスの長さ',
        Ge: 'Länge in Ft-Box',
      },
      AVIAVPICDD01: {
        En: 'Elements',
        Et: 'Elemendid',
        Ar: 'عناصر',
        Ml: 'ഘടകങ്ങൾ',
        Ma: 'घटक',
        Fr: 'Éléments',
        Hi: 'तत्वों',
        Ta: 'கூறுகள்',
        Ja: '要素',
        Ge: 'Elemente',
      },
      AVIAVPICDD02: {
        En: 'Reel/Can Size',
        Et: 'Rulli/purgi suurus',
        Ar: 'بكرة / يمكن الحجم',
        Ml: 'റീൽ/കാൻ വലിപ്പം',
        Ma: 'रील/कॅन आकार',
        Fr: 'Taille de bobine/boîte',
        Hi: 'रील / आकार कर सकते हैं',
        Ta: 'ரீல்/கேன் அளவு',
        Ja: 'リール・缶サイズ',
        Ge: 'Rollen-/Dosengröße',
      },
      AVIAVPICDD03: {
        En: 'Film Gauge',
        Et: 'Filmi mõõtur',
        Ar: 'مقياس الفيلم',
        Ml: 'മൂവി ഗേജ്',
        Ma: 'चित्रपट गेज',
        Fr: 'Jauge de film',
        Hi: 'मूवी गेज',
        Ta: 'மூவி கேஜ்',
        Ja: 'ムービーゲージ',
        Ge: 'Filmanzeige',
      },
      AVIAVPICDD04: {
        En: 'Film Gauge',
        Et: 'Filmi mõõtur',
        Ar: 'مقياس الفيلم',
        Ml: 'മൂവി ഗേജ്',
        Ma: 'चित्रपट गेज',
        Fr: 'Jauge de film',
        Hi: 'मूवी गेज',
        Ta: 'மூவி கேஜ்',
        Ja: 'ムービーゲージ',
        Ge: 'Filmanzeige',
      },
      AVIAVPICDD05: {
        En: 'Colour',
        Et: 'Värv',
        Ar: 'لون',
        Ml: 'നിറം',
        Ma: 'रंग',
        Fr: 'Couleur',
        Hi: 'रंग',
        Ta: 'நிறம்',
        Ja: '色',
        Ge: 'Farbe',
      },
      AVIAVPICDD06: {
        En: 'Stock/Brand',
        Et: 'Aktsia/bränd',
        Ar: 'الأسهم / العلامة التجارية',
        Ml: 'സ്റ്റോക്ക്/ബ്രാൻഡ്',
        Ma: 'स्टॉक/ब्रँड',
        Fr: 'Stock/Marque',
        Hi: 'स्टॉक/ब्रांड',
        Ta: 'பங்கு/பிராண்டு',
        Ja: '在庫・ブランド',
        Ge: 'Lager/Marke',
      },
      AVIAVPICDD07: {
        En: 'Image Format',
        Et: 'Pildi formaat',
        Ar: 'شكل صورة',
        Ml: 'ഇമേജ് ഫോർമാറ്റ്',
        Ma: 'प्रतिमा स्वरूप',
        Fr: "Format d'image",
        Hi: 'छवि प्रारूप',
        Ta: 'பட வடிவம்',
        Ja: '画像フォーマット',
        Ge: 'Bildformat',
      },
      AVIAVPICDD08: {
        En: 'Sound Format',
        Et: 'Helivorming',
        Ar: 'تنسيق الصوت',
        Ml: 'ശബ്ദ ഫോർമാറ്റ്',
        Ma: 'ध्वनी स्वरूप',
        Fr: 'Format du son',
        Hi: 'ध्वनि प्रारूप',
        Ta: 'ஒலி வடிவம்',
        Ja: 'サウンドフォーマット',
        Ge: 'Tonformat',
      },
      AVIAVPICDD09: {
        En: 'Dolby Digital',
        Et: 'Dolby Digital',
        Ar: 'دولبي ديجيتال',
        Ml: 'ഡോൾബി ഡിജിറ്റൽ',
        Ma: 'डॉल्बी डिजिटल',
        Fr: 'Dolby Digital',
        Hi: 'डॉल्बी डिजिटल',
        Ta: 'டால்பி டிஜிட்டல்',
        Ja: 'ドルビーデジタル',
        Ge: 'Dolby Digital',
      },
      AVIAVPICDD10: {
        En: 'Film Categorization',
        Et: 'Filmi kategoriseerimine',
        Ar: 'تصنيف الفيلم',
        Ml: 'ചലച്ചിത്ര വർഗ്ഗീകരണം',
        Ma: 'चित्रपट वर्गीकरण',
        Fr: 'Catégorisation des films',
        Hi: 'फिल्म वर्गीकरण',
        Ta: 'திரைப்பட வகைப்பாடு',
        Ja: '映画の分類',
        Ge: 'Film Kategorisierung',
      },
      AVIAVPICDD11: {
        En: 'Film Status',
        Et: 'Filmi olek',
        Ar: 'حالة الفيلم',
        Ml: 'ഫിലിം സ്റ്റാറ്റസ്',
        Ma: 'चित्रपट स्थिती',
        Fr: 'Statut du film',
        Hi: 'फिल्म की स्थिति',
        Ta: 'திரைப்பட நிலை',
        Ja: 'フィルムステータス',
        Ge: 'Filmstatus',
      },
      AVIAVPICDD12: {
        En: 'Film Status Scale',
        Et: 'Filmi oleku skaala',
        Ar: 'مقياس حالة الفيلم',
        Ml: 'ഫിലിം സ്റ്റാറ്റസ് സ്കെയിൽ',
        Ma: 'चित्रपट स्थिती स्केल',
        Fr: "Échelle d'état du film",
        Hi: 'फिल्म स्थिति स्केल',
        Ta: 'திரைப்பட நிலை அளவுகோல்',
        Ja: 'フィルム ステータス スケール',
        Ge: 'Filmstatus-Skala',
      },
      AVIAVPICDD13: {
        En: 'Foreign Matters',
        Et: 'Välisasjad',
        Ar: 'المسائل الخارجية',
        Ml: 'വിദേശ കാര്യങ്ങൾ',
        Ma: 'परदेशी बाबी',
        Fr: 'Affaires étrangères',
        Hi: 'विदेशी मामले',
        Ta: 'வெளிநாட்டு விஷயங்கள்',
        Ja: '外国問題',
        Ge: 'Ausländische Angelegenheiten',
      },
      AVIAVPICDD14: {
        En: 'Physical Damage',
        Et: 'Füüsiline kahju',
        Ar: 'الأضرار المادية',
        Ml: 'ശാരീരിക ക്ഷതം',
        Ma: 'शारीरिक नुकसान',
        Fr: 'Dommages physiques',
        Hi: 'शारीरिक क्षति',
        Ta: 'உடல் சேதம்',
        Ja: '物理的損傷',
        Ge: 'Körperlicher Schaden',
      },
      AVIAVPICDD15: {
        En: 'Emulsion Scratches',
        Et: 'Emulsioonkriimud',
        Ar: 'خدوش المستحلب',
        Ml: 'എമൽഷൻ പോറലുകൾ',
        Ma: 'इमल्शन ओरखडे',
        Fr: "Rayures d'émulsion",
        Hi: 'इमल्शन स्क्रैच',
        Ta: 'குழம்பு கீறல்கள்',
        Ja: 'エマルジョンスクラッチ',
        Ge: 'Emulsionskratzer',
      },
      AVIAVPICDD16: {
        En: 'Emulsion Scratches Scale',
        Et: 'Emulsioon kriimustuste skaala',
        Ar: 'مقياس خدوش المستحلب',
        Ml: 'എമൽഷൻ സ്ക്രാച്ചസ് സ്കെയിൽ',
        Ma: 'इमल्शन स्क्रॅच स्केल',
        Fr: "Échelle de rayures d'émulsion",
        Hi: 'इमल्शन स्क्रैच स्केल',
        Ta: 'குழம்பு கீறல்கள் அளவு',
        Ja: 'エマルジョンスクラッチスケール',
        Ge: 'Skala für Emulsionskratzer',
      },
      AVIAVPICDD17: {
        En: 'Base Scratches',
        Et: 'Aluskriimud',
        Ar: 'خدوش القاعدة',
        Ml: 'അടിസ്ഥാന പോറലുകൾ',
        Ma: 'बेस स्क्रॅच',
        Fr: 'Rayures de la base',
        Hi: 'आधार खरोंच',
        Ta: 'அடிப்படை கீறல்கள்',
        Ja: 'ベースの傷',
        Ge: 'Basis Kratzer',
      },
      AVIAVPICDD18: {
        En: 'Base Scratches Scale',
        Et: 'Aluskriimustuste skaala',
        Ar: 'مقياس الخدوش الأساسي',
        Ml: 'അടിസ്ഥാന സ്ക്രാച്ചസ് സ്കെയിൽ',
        Ma: 'बेस स्क्रॅच स्केल',
        Fr: 'Échelle des rayures de base',
        Hi: 'बेस स्क्रैच स्केल',
        Ta: 'அடிப்படை கீறல்கள் அளவுகோல்',
        Ja: 'ベーススクラッチスケール',
        Ge: 'Basiskratzer-Skala',
      },
      AVIAVPICDD19: {
        En: 'Wind of Film Before',
        Et: 'Filmi tuul Enne',
        Ar: 'ريح الفيلم من قبل',
        Ml: 'മുമ്പ് സിനിമയുടെ കാറ്റ്',
        Ma: 'चित्रपटाच्या आधी वारा',
        Fr: 'Vent de film avant',
        Hi: 'फिल्म की हवा पहले',
        Ta: 'முன் படத்தின் காற்று',
        Ja: '映画以前の風',
        Ge: 'Wind des Films vor',
      },
      AVIAVPICDD20: {
        En: 'Yes/No',
        Et: 'Jah ei',
        Ar: 'نعم / لا',
        Ml: 'അതെ അല്ല',
        Ma: 'होय नाही',
        Fr: 'Oui Non',
        Hi: 'हां नहीं',
        Ta: 'ஆ ம் இல்லை',
        Ja: 'はい・いいえ',
        Ge: 'Ja Nein',
      },
      AVIAVPICDD21: {
        En: 'Subtitle Languages',
        Et: 'Subtiitrite keeled',
        Ar: 'لغات الترجمة',
        Ml: 'ഉപശീർഷക ഭാഷകൾ',
        Ma: 'उपशीर्षक भाषा',
        Fr: 'Langues des sous-titres',
        Hi: 'उपशीर्षक भाषाएँ',
        Ta: 'வசன மொழிகள்',
        Ja: '字幕言語',
        Ge: 'Untertitelsprachen',
      },
      AVIAVPICDD22: {
        En: 'Treatment Recommended',
        Et: 'Soovitatav ravi',
        Ar: 'يوصى بالعلاج',
        Ml: 'ചികിത്സ ശുപാർശ ചെയ്യുന്നു',
        Ma: 'उपचार शिफारस',
        Fr: 'Traitement recommandé',
        Hi: 'उपचार की सिफारिश',
        Ta: 'சிகிச்சை பரிந்துரைக்கப்படுகிறது',
        Ja: '治療推奨',
        Ge: 'Behandlung empfohlen',
      },
      AVIAVPICDD23: {
        En: 'Shrinkage',
        Et: 'Kokkutõmbumine',
        Ar: 'انكماش',
        Ml: 'ചുരുങ്ങൽ',
        Ma: 'संकोचन',
        Fr: 'Rétrécissement',
        Hi: 'संकोचन',
        Ta: 'சுருக்கம்',
        Ja: '収縮',
        Ge: 'Schwindung',
      },
      AVIAVPICL03: {
        En: 'Photography',
        Et: 'Fotograafia',
        Ar: 'التصوير',
        Ml: 'ഫോട്ടോഗ്രാഫി',
        Ma: 'छायाचित्रण',
        Fr: 'La photographie',
        Hi: 'फोटोग्राफी',
        Ta: 'புகைப்படம் எடுத்தல்',
        Ja: '写真撮影',
        Ge: 'Fotografie',
      },
      AVIAVPICTB02: {
        En: 'Photography Box',
        Et: 'Fotokast',
        Ar: 'صندوق التصوير',
        Ml: 'ഫോട്ടോഗ്രാഫി ബോക്സ്',
        Ma: 'फोटोग्राफी बॉक्स',
        Fr: 'Coffret Photographie',
        Hi: 'फोटोग्राफी बॉक्स',
        Ta: 'புகைப்பட பெட்டி',
        Ja: '写真ボックス',
        Ge: 'Fotografie-Box',
      },
      AVIAVPICB01: {
        En: 'Add Photographs',
        Et: 'Lisa fotosid',
        Ar: 'أضف الصور',
        Ml: 'ഫോട്ടോഗ്രാഫുകൾ ചേർക്കുക',
        Ma: 'छायाचित्रे जोडा',
        Fr: 'Ajouter des photos',
        Hi: 'तस्वीरें जोड़ें',
        Ta: 'புகைப்படங்களைச் சேர்க்கவும்',
        Ja: '写真を追加',
        Ge: 'Fotos hinzufügen',
      },
      AVIAVPICL04: {
        En: 'Comments',
        Et: 'Kommentaarid',
        Ar: 'تعليقات',
        Ml: 'അഭിപ്രായങ്ങൾ',
        Ma: 'टिप्पण्या',
        Fr: 'commentaires',
        Hi: 'टिप्पणियाँ',
        Ta: 'கருத்துகள்',
        Ja: 'コメント',
        Ge: 'Kommentare',
      },
      AVIAVPICTB03: {
        En: 'Comments Box',
        Et: 'Kommentaaride kast',
        Ar: 'مربع التعليقات',
        Ml: 'കമന്റ് ബോക്സ്',
        Ma: 'टिप्पण्या बॉक्स',
        Fr: 'Boîte de commentaires',
        Hi: 'कमेंट बॉक्स',
        Ta: 'கருத்துப் பெட்டி',
        Ja: 'コメントボックス',
        Ge: 'Kommentarfeld',
      },
      AVIAVPICI01: {
        En: 'User Profile Image',
        Et: 'Kasutaja profiili pilt',
        Ar: 'صورة الملف الشخصي للمستخدم',
        Ml: 'ഉപയോക്തൃ പ്രൊഫൈൽ ചിത്രം',
        Ma: 'वापरकर्ता प्रोफाइल प्रतिमा',
        Fr: 'Image de profil utilisateur',
        Hi: 'उपयोगकर्ता प्रोफ़ाइल छवि',
        Ta: 'பயனர் சுயவிவரப் படம்',
        Ja: 'ユーザープロフィール画像',
        Ge: 'Benutzerprofilbild',
      },
      AVIAVPICB02: {
        En: 'Start',
        Et: 'Alusta',
        Ar: 'بداية',
        Ml: 'ആരംഭിക്കുക',
        Ma: 'सुरू करा',
        Fr: 'Commencer',
        Hi: 'शुरू',
        Ta: 'தொடங்கு',
        Ja: '始める',
        Ge: 'Anfang',
      },
      AVIAVPICB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      AVIAVPICB04: {
        En: 'Accept',
        Et: 'Nõustu',
        Ar: 'قبول',
        Ml: 'സ്വീകരിക്കുക',
        Ma: 'स्वीकारा',
        Fr: 'Accepter',
        Hi: 'स्वीकार करना',
        Ta: 'ஏற்றுக்கொள்',
        Ja: '承認',
        Ge: 'Annehmen',
      },
    },

    AssetViewItemLevelAllAssetsViewPhysicalInspectionCategorization: {
      AVIAVPICL01: {
        En: 'Categorization',
        Et: 'Kategoriseerimine',
        Ar: 'التصنيف',
        Ml: 'വർഗ്ഗീകരണം',
        Ma: 'वर्गीकरण',
        Fr: 'Catégorisation',
        Hi: 'वर्गीकरण',
        Ta: 'வகைப்படுத்தல்',
        Ja: '分類',
        Ge: 'Kategorisierung',
      },
      AVIAVPICDD01: {
        En: 'Categorization using AD strip',
        Et: 'Kategoriseerimine AD-riba abil',
        Ar: 'التصنيف باستخدام شريط م',
        Ml: 'AD സ്ട്രിപ്പ് ഉപയോഗിച്ചുള്ള വർഗ്ഗീകരണം',
        Ma: 'AD पट्टी वापरून वर्गीकरण',
        Fr: "Catégorisation à l'aide de la bande AD",
        Hi: 'एडी पट्टी का उपयोग कर वर्गीकरण',
        Ta: 'AD பட்டையைப் பயன்படுத்தி வகைப்படுத்துதல்',
        Ja: 'AD ストリップを使用した分類',
        Ge: 'Kategorisierung mit AD-Streifen',
      },
      AVIAVPICDD02: {
        En: 'Colour of AD strip with PH Value',
        Et: 'AD-riba värv PH väärtusega',
        Ar: 'لون شريط AD مع قيمة PH',
        Ml: 'PH മൂല്യമുള്ള AD സ്ട്രിപ്പിന്റെ നിറം',
        Ma: 'PH मूल्यासह AD पट्टीचा रंग',
        Fr: 'Couleur de la bande AD avec valeur PH',
        Hi: 'PH मान के साथ AD पट्टी का रंग',
        Ta: 'PH மதிப்புடன் AD பட்டையின் நிறம்',
        Ja: 'PH 値を持つ AD ストリップの色',
        Ge: 'Farbe des AD-Streifens mit PH-Wert',
      },
      AVIAVPICDD03: {
        En: 'Treatment Suggested',
        Et: 'Soovitatav ravi',
        Ar: 'اقترح العلاج',
        Ml: 'ചികിത്സ നിർദ്ദേശിച്ചു',
        Ma: 'उपचार सुचवले',
        Fr: 'Traitement suggéré',
        Hi: 'उपचार सुझाया गया',
        Ta: 'சிகிச்சை பரிந்துரைக்கப்படுகிறது',
        Ja: '推奨される治療法',
        Ge: 'Behandlung empfohlen',
      },
      AVIAVPICDD04: {
        En: 'Final Vault Location',
        Et: 'Lõplik varahoidla asukoht',
        Ar: 'موقع Vault النهائي',
        Ml: 'അന്തിമ വോൾട്ട് സ്ഥാനം',
        Ma: 'अंतिम वॉल्ट स्थान',
        Fr: 'Emplacement final du coffre-fort',
        Hi: 'अंतिम तिजोरी स्थान',
        Ta: 'இறுதி வால்ட் இடம்',
        Ja: '最終保管場所',
        Ge: 'Endgültiger Tresorstandort',
      },
      AVIAVPICDD05: {
        En: 'Green Sticker',
        Et: 'Roheline kleebis',
        Ar: 'ملصق أخضر',
        Ml: 'പച്ച സ്റ്റിക്കർ',
        Ma: 'हिरवे स्टिकर',
        Fr: 'Autocollant vert',
        Hi: 'हरा स्टिकर',
        Ta: 'பச்சை ஸ்டிக்கர்',
        Ja: 'グリーンステッカー',
        Ge: 'Grüner Aufkleber',
      },
      AVIAVPICL02: {
        En: 'Comments',
        Et: 'Kommentaarid',
        Ar: 'تعليقات',
        Ml: 'അഭിപ്രായങ്ങൾ',
        Ma: 'टिप्पण्या',
        Fr: 'commentaires',
        Hi: 'टिप्पणियाँ',
        Ta: 'கருத்துகள்',
        Ja: 'コメント',
        Ge: 'Kommentare',
      },
      AVIAVPICTB01: {
        En: 'Comments Box',
        Et: 'Kommentaaride kast',
        Ar: 'مربع التعليقات',
        Ml: 'കമന്റ് ബോക്സ്',
        Ma: 'टिप्पण्या बॉक्स',
        Fr: 'Boîte de commentaires',
        Hi: 'कमेंट बॉक्स',
        Ta: 'கருத்துப் பெட்டி',
        Ja: 'コメントボックス',
        Ge: 'Kommentarfeld',
      },
      AVIAVPICI01: {
        En: 'User Profile Image',
        Et: 'Kasutaja profiili pilt',
        Ar: 'صورة الملف الشخصي للمستخدم',
        Ml: 'ഉപയോക്തൃ പ്രൊഫൈൽ ചിത്രം',
        Ma: 'वापरकर्ता प्रोफाइल प्रतिमा',
        Fr: 'Image de profil utilisateur',
        Hi: 'उपयोगकर्ता प्रोफ़ाइल छवि',
        Ta: 'பயனர் சுயவிவரப் படம்',
        Ja: 'ユーザープロフィール画像',
        Ge: 'Benutzerprofilbild',
      },
      AVIAVPICB01: {
        En: 'Start',
        Et: 'Alusta',
        Ar: 'بداية',
        Ml: 'ആരംഭിക്കുക',
        Ma: 'सुरू करा',
        Fr: 'Commencer',
        Hi: 'शुरू',
        Ta: 'தொடங்கு',
        Ja: '始める',
        Ge: 'Anfang',
      },
      AVIAVPICB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      AVIAVPICB03: {
        En: 'Accept',
        Et: 'Nõustu',
        Ar: 'قبول',
        Ml: 'സ്വീകരിക്കുക',
        Ma: 'स्वीकारा',
        Fr: 'Accepter',
        Hi: 'स्वीकार करना',
        Ta: 'ஏற்றுக்கொள்',
        Ja: '承認',
        Ge: 'Annehmen',
      },
    },

    AssetViewItemLevelAllAssetsViewPhysicalInspectionRepair: {
      AVIAVPIRL01: {
        En: 'Repair',
        Et: 'Remont',
        Ar: 'بصلح',
        Ml: 'നന്നാക്കുക',
        Ma: 'दुरुस्ती',
        Fr: 'Réparation',
        Hi: 'मरम्मत करना',
        Ta: 'பழுது',
        Ja: '修理',
        Ge: 'Reparatur',
      },
      AVIAVPIRDD01: {
        En: 'Repair Type',
        Et: 'Remondi tüüp',
        Ar: 'نوع الإصلاح',
        Ml: 'റിപ്പയർ തരം',
        Ma: 'दुरुस्ती प्रकार',
        Fr: 'Type de réparation',
        Hi: 'मरम्मत का प्रकार',
        Ta: 'பழுதுபார்க்கும் வகை',
        Ja: '修理タイプ',
        Ge: 'Reparaturtyp',
      },
      AVIAVPIRDD02: {
        En: 'Type of Joints',
        Et: 'Liigeste tüüp',
        Ar: 'نوع المفاصل',
        Ml: 'സന്ധികളുടെ തരം',
        Ma: 'सांध्याचा प्रकार',
        Fr: 'Type de joints',
        Hi: 'जोड़ों का प्रकार',
        Ta: 'மூட்டுகளின் வகை',
        Ja: '関節の種類',
        Ge: 'Art der Gelenke',
      },
      AVIAVPIRDD03: {
        En: 'Leader Type',
        Et: 'Juhi tüüp',
        Ar: 'نوع القائد',
        Ml: 'ലീഡർ തരം',
        Ma: 'नेता प्रकार',
        Fr: 'Type de chef',
        Hi: 'नेता का प्रकार',
        Ta: 'தலைவர் வகை',
        Ja: 'リーダーの種類',
        Ge: 'Leader-Typ',
      },
      AVIAVPIRDD04: {
        En: 'Can After',
        Et: 'Saab Pärast',
        Ar: 'يمكن بعد',
        Ml: 'ശേഷം കഴിയും',
        Ma: 'नंतर करू शकता',
        Fr: 'Peut après',
        Hi: 'के बाद कर सकते हैं',
        Ta: 'பிறகு முடியும்',
        Ja: '後にすることができます',
        Ge: 'Kann nach',
      },
      AVIAVPIRDD05: {
        En: 'Photography Taken After',
        Et: 'Pärast tehtud foto',
        Ar: 'تصوير مأخوذ بعد',
        Ml: 'ശേഷം എടുത്ത ഫോട്ടോ',
        Ma: 'फोटोग्राफी नंतर घेतली',
        Fr: 'Photographie prise après',
        Hi: 'फोटोग्राफी के बाद लिया गया',
        Ta: 'பிறகு எடுக்கப்பட்ட புகைப்படம்',
        Ja: '後に撮影した写真',
        Ge: 'Nachher aufgenommene Fotografie',
      },
      AVIAVPIRDD06: {
        En: 'History Card Inside Can',
        Et: 'Ajalookaart purgi sees',
        Ar: 'بطاقة التاريخ داخل العلبة',
        Ml: 'ചരിത്ര കാർഡ് ക്യാനിനുള്ളിൽ',
        Ma: 'कॅन आत इतिहास कार्ड',
        Fr: "Carte d'histoire à l'intérieur de la boîte",
        Hi: 'इतिहास कार्ड अंदर कैन',
        Ta: 'கேன் உள்ளே வரலாற்று அட்டை',
        Ja: 'ヒストリーカード 缶入り',
        Ge: 'Geschichtskarte im Inneren der Dose',
      },
      AVIAVPIRDD07: {
        En: 'History Card Photgraph',
        Et: 'Ajaloo kaardi foto',
        Ar: 'صورة بطاقة التاريخ',
        Ml: 'ചരിത്ര കാർഡ് ഫോട്ടോ',
        Ma: 'इतिहास कार्ड फोटो',
        Fr: "Photographie de la carte d'histoire",
        Hi: 'इतिहास कार्ड फोटो',
        Ta: 'வரலாற்று அட்டை புகைப்படம்',
        Ja: 'ヒストリーカード写真',
        Ge: 'Foto der Geschichtskarte',
      },
      AVIAVPIRDD08: {
        En: 'Details Of Repair',
        Et: 'Remondi üksikasjad',
        Ar: 'تفاصيل الإصلاح',
        Ml: 'അറ്റകുറ്റപ്പണിയുടെ വിശദാംശങ്ങൾ',
        Ma: 'दुरुस्तीचे तपशील',
        Fr: 'Détails de la réparation',
        Hi: 'मरम्मत का विवरण',
        Ta: 'பழுதுபார்ப்பு விவரங்கள்',
        Ja: '修理内容',
        Ge: 'Details der Reparatur',
      },
      AVIAVPIRDD09: {
        En: 'Core changed',
        Et: 'Tuum muudetud',
        Ar: 'تغير جوهر',
        Ml: 'കാമ്പ് മാറി',
        Ma: 'कोर बदलला',
        Fr: 'Noyau modifié',
        Hi: 'कोर बदल गया',
        Ta: 'கோர் மாறியது',
        Ja: 'コアが変更されました',
        Ge: 'Kern geändert',
      },
      AVIAVPIRDD10: {
        En: 'Can Changed',
        Et: 'Saab Muudetud',
        Ar: 'يمكن تغييرها',
        Ml: 'മാറ്റാൻ കഴിയും',
        Ma: 'बदलू ​​शकतो',
        Fr: 'Peut changé',
        Hi: 'बदल सकता है',
        Ta: 'மாற்ற முடியும்',
        Ja: '変更可能',
        Ge: 'Kann geändert werden',
      },
      AVIAVPIRL02: {
        En: 'Photography After Repair',
        Et: 'Pildistamine pärast remonti',
        Ar: 'التصوير الفوتوغرافي بعد الإصلاح',
        Ml: 'അറ്റകുറ്റപ്പണിക്ക് ശേഷം ഫോട്ടോഗ്രാഫി',
        Ma: 'दुरुस्ती नंतर फोटोग्राफी',
        Fr: 'Photographie après réparation',
        Hi: 'मरम्मत के बाद फोटोग्राफी',
        Ta: 'பழுதுபார்த்த பிறகு புகைப்படம் எடுத்தல்',
        Ja: '修理後の写真',
        Ge: 'Fotografie nach der Reparatur',
      },
      AVIAVPIRTB01: {
        En: 'Photography Box',
        Et: 'Fotokast',
        Ar: 'صندوق التصوير',
        Ml: 'ഫോട്ടോഗ്രാഫി ബോക്സ്',
        Ma: 'फोटोग्राफी बॉक्स',
        Fr: 'Coffret Photographie',
        Hi: 'फोटोग्राफी बॉक्स',
        Ta: 'புகைப்பட பெட்டி',
        Ja: '写真ボックス',
        Ge: 'Fotografie-Box',
      },
      AVIAVPIRB01: {
        En: 'Add Photographs',
        Et: 'Lisa fotosid',
        Ar: 'أضف الصور',
        Ml: 'ഫോട്ടോഗ്രാഫുകൾ ചേർക്കുക',
        Ma: 'छायाचित्रे जोडा',
        Fr: 'Ajouter des photos',
        Hi: 'तस्वीरें जोड़ें',
        Ta: 'புகைப்படங்களைச் சேர்க்கவும்',
        Ja: '写真を追加',
        Ge: 'Fotos hinzufügen',
      },
      AVIAVPIRL03: {
        En: 'Comments',
        Et: 'Kommentaarid',
        Ar: 'تعليقات',
        Ml: 'അഭിപ്രായങ്ങൾ',
        Ma: 'टिप्पण्या',
        Fr: 'commentaires',
        Hi: 'टिप्पणियाँ',
        Ta: 'கருத்துகள்',
        Ja: 'コメント',
        Ge: 'Kommentare',
      },
      AVIAVPIRTB02: {
        En: 'Comments Box',
        Et: 'Kommentaaride kast',
        Ar: 'مربع التعليقات',
        Ml: 'കമന്റ് ബോക്സ്',
        Ma: 'टिप्पण्या बॉक्स',
        Fr: 'Boîte de commentaires',
        Hi: 'कमेंट बॉक्स',
        Ta: 'கருத்துப் பெட்டி',
        Ja: 'コメントボックス',
        Ge: 'Kommentarfeld',
      },
      AVIAVPIRI01: {
        En: 'User Profile Image',
        Et: 'Kasutaja profiili pilt',
        Ar: 'صورة الملف الشخصي للمستخدم',
        Ml: 'ഉപയോക്തൃ പ്രൊഫൈൽ ചിത്രം',
        Ma: 'वापरकर्ता प्रोफाइल प्रतिमा',
        Fr: 'Image de profil utilisateur',
        Hi: 'उपयोगकर्ता प्रोफ़ाइल छवि',
        Ta: 'பயனர் சுயவிவரப் படம்',
        Ja: 'ユーザープロフィール画像',
        Ge: 'Benutzerprofilbild',
      },
      AVIAVPIRB02: {
        En: 'Start',
        Et: 'Alusta',
        Ar: 'بداية',
        Ml: 'ആരംഭിക്കുക',
        Ma: 'सुरू करा',
        Fr: 'Commencer',
        Hi: 'शुरू',
        Ta: 'தொடங்கு',
        Ja: '始める',
        Ge: 'Anfang',
      },
      AVIAVPIRB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      AVIAVPIRB04: {
        En: 'Accept',
        Et: 'Nõustu',
        Ar: 'قبول',
        Ml: 'സ്വീകരിക്കുക',
        Ma: 'स्वीकारा',
        Fr: 'Accepter',
        Hi: 'स्वीकार करना',
        Ta: 'ஏற்றுக்கொள்',
        Ja: '承認',
        Ge: 'Annehmen',
      },
    },

    AssetViewItemLevelAllAssetsViewPhysicalInspectionPhotoChemicalRestoration: {
      AVIAVPIPRL01: {
        En: 'Photo Chemical Restoration',
        Et: 'Foto keemiline taastamine',
        Ar: 'استعادة الصور الكيميائية',
        Ml: 'ഫോട്ടോ കെമിക്കൽ പുനഃസ്ഥാപനം',
        Ma: 'फोटो केमिकल रिस्टोरेशन',
        Fr: 'Restauration photochimique',
        Hi: 'फोटो रासायनिक बहाली',
        Ta: 'புகைப்பட இரசாயன மறுசீரமைப்பு',
        Ja: 'フォトケミカル修復',
        Ge: 'Fotochemische Restaurierung',
      },
      AVIAVPIPRL02: {
        En: 'Dessication Treatment',
        Et: 'Kuivamisravi',
        Ar: 'علاج الجفاف',
        Ml: 'ഡെസിക്കേഷൻ ചികിത്സ',
        Ma: 'डेसिकेशन उपचार',
        Fr: 'Dessication Treatment',
        Hi: 'निर्जलीकरण उपचार',
        Ta: 'வறட்சி சிகிச்சை',
        Ja: '乾燥処理',
        Ge: 'Austrocknungsbehandlung',
      },
      AVIAVPIPRTB01: {
        En: 'Dessication Treatment Box',
        Et: 'Kuivatamise ravikast',
        Ar: 'صندوق علاج التجفيف',
        Ml: 'ഡെസിക്കേഷൻ ട്രീറ്റ്മെന്റ് ബോക്സ്',
        Ma: 'Dessication उपचार बॉक्स',
        Fr: 'Dessication Treatment Box',
        Hi: 'Dessication उपचार बॉक्स',
        Ta: 'டெசிகேஷன் ட்ரீட்மென்ட் பாக்ஸ்',
        Ja: '乾燥処理ボックス',
        Ge: 'Austrocknungsbehandlungsbox',
      },
      AVIAVPIPRL03: {
        En: 'Rehydration',
        Et: 'Rehüdratsioon',
        Ar: 'معالجة الجفاف',
        Ml: 'റീഹൈഡ്രേഷൻ',
        Ma: 'रीहायड्रेशन',
        Fr: 'Réhydratation',
        Hi: 'रिहाइड्रेशन',
        Ta: 'நீரேற்றம்',
        Ja: '水分補給',
        Ge: 'Rehydrierung',
      },
      AVIAVPIPRTB02: {
        En: 'Rehydration Box',
        Et: 'Rehüdratsioonikast',
        Ar: 'صندوق معالجة الجفاف',
        Ml: 'റീഹൈഡ്രേഷൻ ബോക്സ്',
        Ma: 'रीहायड्रेशन बॉक्स',
        Fr: 'Boîte de réhydratation',
        Hi: 'पुनर्जलीकरण बॉक्स',
        Ta: 'மறுசீரமைப்பு பெட்டி',
        Ja: '水分補給ボックス',
        Ge: 'Rehydrationsbox',
      },
      AVIAVPIPRL04: {
        En: 'Unblocking',
        Et: 'Blokeeringu tühistamine',
        Ar: 'فتح',
        Ml: 'അൺബ്ലോക്ക് ചെയ്യുന്നു',
        Ma: 'अनब्लॉक करत आहे',
        Fr: 'Déblocage',
        Hi: 'अनब्लॉक',
        Ta: 'தடையை நீக்குகிறது',
        Ja: 'ブロック解除',
        Ge: 'Entsperren',
      },
      AVIAVPIPRTB03: {
        En: 'Unblocking Box',
        Et: 'Boksi deblokeerimine',
        Ar: 'فتح صندوق',
        Ml: 'അൺബ്ലോക്കിംഗ് ബോക്സ്',
        Ma: 'अनब्लॉकिंग बॉक्स',
        Fr: 'Boîte de déblocage',
        Hi: 'अनब्लॉकिंग बॉक्स',
        Ta: 'தடைநீக்கும் பெட்டி',
        Ja: 'ブロック解除ボックス',
        Ge: 'Box entsperren',
      },
      AVIAVPIPRL05: {
        En: 'Photography After Photocheical Treatment',
        Et: 'Fotograafia pärast fotokeemilist töötlemist',
        Ar: 'التصوير الفوتوغرافي بعد المعالجة الضوئية',
        Ml: 'ഫോട്ടോകീക്കൽ ചികിത്സയ്ക്ക് ശേഷം ഫോട്ടോഗ്രാഫി',
        Ma: 'छायाचित्रण उपचारानंतर छायाचित्रण',
        Fr: 'Photographie après traitement photochimique',
        Hi: 'Photocheical उपचार के बाद फोटोग्राफी',
        Ta: 'ஒளிச்சேர்க்கை சிகிச்சைக்குப் பிறகு புகைப்படம் எடுத்தல்',
        Ja: 'フォトケミカル治療後の写真撮影',
        Ge: 'Fotografie nach photochemischer Behandlung',
      },
      AVIAVPIPRTB04: {
        En: 'Photography Box',
        Et: 'Fotokast',
        Ar: 'صندوق التصوير',
        Ml: 'ഫോട്ടോഗ്രാഫി ബോക്സ്',
        Ma: 'फोटोग्राफी बॉक्स',
        Fr: 'Coffret Photographie',
        Hi: 'फोटोग्राफी बॉक्स',
        Ta: 'புகைப்பட பெட்டி',
        Ja: '写真ボックス',
        Ge: 'Fotografie-Box',
      },
      AVIAVPIPRB01: {
        En: 'Add Photographs',
        Et: 'Lisa fotosid',
        Ar: 'أضف الصور',
        Ml: 'ഫോട്ടോഗ്രാഫുകൾ ചേർക്കുക',
        Ma: 'छायाचित्रे जोडा',
        Fr: 'Ajouter des photos',
        Hi: 'तस्वीरें जोड़ें',
        Ta: 'புகைப்படங்களைச் சேர்க்கவும்',
        Ja: '写真を追加',
        Ge: 'Fotos hinzufügen',
      },
      AVIAVPIPRL06: {
        En: 'Comments',
        Et: 'Kommentaarid',
        Ar: 'تعليقات',
        Ml: 'അഭിപ്രായങ്ങൾ',
        Ma: 'टिप्पण्या',
        Fr: 'commentaires',
        Hi: 'टिप्पणियाँ',
        Ta: 'கருத்துகள்',
        Ja: 'コメント',
        Ge: 'Kommentare',
      },
      AVIAVPIPRTB05: {
        En: 'Comments Box',
        Et: 'Kommentaaride kast',
        Ar: 'مربع التعليقات',
        Ml: 'കമന്റ് ബോക്സ്',
        Ma: 'टिप्पण्या बॉक्स',
        Fr: 'Boîte de commentaires',
        Hi: 'कमेंट बॉक्स',
        Ta: 'கருத்துப் பெட்டி',
        Ja: 'コメントボックス',
        Ge: 'Kommentarfeld',
      },
      AVIAVPIPRI01: {
        En: 'User Profile Image',
        Et: 'Kasutaja profiili pilt',
        Ar: 'صورة الملف الشخصي للمستخدم',
        Ml: 'ഉപയോക്തൃ പ്രൊഫൈൽ ചിത്രം',
        Ma: 'वापरकर्ता प्रोफाइल प्रतिमा',
        Fr: 'Image de profil utilisateur',
        Hi: 'उपयोगकर्ता प्रोफ़ाइल छवि',
        Ta: 'பயனர் சுயவிவரப் படம்',
        Ja: 'ユーザープロフィール画像',
        Ge: 'Benutzerprofilbild',
      },
      AVIAVPIPRB02: {
        En: 'Start',
        Et: 'Alusta',
        Ar: 'بداية',
        Ml: 'ആരംഭിക്കുക',
        Ma: 'सुरू करा',
        Fr: 'Commencer',
        Hi: 'शुरू',
        Ta: 'தொடங்கு',
        Ja: '始める',
        Ge: 'Anfang',
      },
      AVIAVPIPRB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      AVIAVPIPRB04: {
        En: 'Accept',
        Et: 'Nõustu',
        Ar: 'قبول',
        Ml: 'സ്വീകരിക്കുക',
        Ma: 'स्वीकारा',
        Fr: 'Accepter',
        Hi: 'स्वीकार करना',
        Ta: 'ஏற்றுக்கொள்',
        Ja: '承認',
        Ge: 'Annehmen',
      },
    },

    AssetViewItemLevelAllAssetsViewPhysicalInspectionUltraSonicCleaning: {
      AVIAVPIUCL01: {
        En: 'Ultra Sonic Cleaning',
        Et: 'Ultraheli puhastamine',
        Ar: 'تنظيف الترا سونيك',
        Ml: 'അൾട്രാ സോണിക് ക്ലീനിംഗ്',
        Ma: 'अल्ट्रा सोनिक क्लीनिंग',
        Fr: 'Nettoyage ultra sonique',
        Hi: 'अल्ट्रा सोनिक सफाई',
        Ta: 'அல்ட்ரா சோனிக் கிளீனிங்',
        Ja: '超音波洗浄',
        Ge: 'Ultraschallreinigung',
      },
      AVIAVPIUCL02: {
        En: 'Comments',
        Et: 'Kommentaarid',
        Ar: 'تعليقات',
        Ml: 'അഭിപ്രായങ്ങൾ',
        Ma: 'टिप्पण्या',
        Fr: 'commentaires',
        Hi: 'टिप्पणियाँ',
        Ta: 'கருத்துகள்',
        Ja: 'コメント',
        Ge: 'Kommentare',
      },
      AVIAVPIUCTB01: {
        En: 'Comments Box',
        Et: 'Kommentaaride kast',
        Ar: 'مربع التعليقات',
        Ml: 'കമന്റ് ബോക്സ്',
        Ma: 'टिप्पण्या बॉक्स',
        Fr: 'Boîte de commentaires',
        Hi: 'कमेंट बॉक्स',
        Ta: 'கருத்துப் பெட்டி',
        Ja: 'コメントボックス',
        Ge: 'Kommentarfeld',
      },
      AVIAVPIUCI01: {
        En: 'User Profile Image',
        Et: 'Kasutaja profiili pilt',
        Ar: 'صورة الملف الشخصي للمستخدم',
        Ml: 'ഉപയോക്തൃ പ്രൊഫൈൽ ചിത്രം',
        Ma: 'वापरकर्ता प्रोफाइल प्रतिमा',
        Fr: 'Image de profil utilisateur',
        Hi: 'उपयोगकर्ता प्रोफ़ाइल छवि',
        Ta: 'பயனர் சுயவிவரப் படம்',
        Ja: 'ユーザープロフィール画像',
        Ge: 'Benutzerprofilbild',
      },
      AVIAVPIUCB01: {
        En: 'Start',
        Et: 'Alusta',
        Ar: 'بداية',
        Ml: 'ആരംഭിക്കുക',
        Ma: 'सुरू करा',
        Fr: 'Commencer',
        Hi: 'शुरू',
        Ta: 'தொடங்கு',
        Ja: '始める',
        Ge: 'Anfang',
      },
      AVIAVPIUCB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      AVIAVPIUCB03: {
        En: 'Accept',
        Et: 'Nõustu',
        Ar: 'قبول',
        Ml: 'സ്വീകരിക്കുക',
        Ma: 'स्वीकारा',
        Fr: 'Accepter',
        Hi: 'स्वीकार करना',
        Ta: 'ஏற்றுக்கொள்',
        Ja: '承認',
        Ge: 'Annehmen',
      },
    },

    AssetViewItemLevelAllAssetsViewReview: {
      AVLARB01: {
        En: 'Option 1',
        Et: 'valik 1',
        Ar: 'الخيار 1',
        Ml: 'ഓപ്ഷൻ 1',
        Ma: 'पर्याय 1',
        Fr: 'Option 1',
        Hi: 'विकल्प 1',
        Ta: 'விருப்பம் 1',
        Ja: 'オプション1',
        Ge: 'Option 1',
      },
      AVLARB02: {
        En: 'Option 2',
        Et: '2. võimalus',
        Ar: 'الخيار 2',
        Ml: 'ഓപ്ഷൻ 2',
        Ma: 'पर्याय २',
        Fr: 'Option 2',
        Hi: 'विकल्प 2',
        Ta: 'விருப்பம் 2',
        Ja: 'オプション 2',
        Ge: 'Option 2',
      },
      AVLARB03: {
        En: 'Option 3',
        Et: '3. võimalus',
        Ar: 'الخيار 3',
        Ml: 'ഓപ്ഷൻ 3',
        Ma: 'पर्याय 3',
        Fr: 'Variante 3',
        Hi: 'विकल्प 3',
        Ta: 'விருப்பம் 3',
        Ja: 'オプション 3',
        Ge: 'Möglichkeit 3',
      },
    },

    AssetViewItemLevelAllAssetsViewReviewOptions: {
      AVIAVROL01: {
        En: 'Option',
        Et: 'Võimalus',
        Ar: 'خيار',
        Ml: 'ഓപ്ഷൻ',
        Ma: 'पर्याय',
        Fr: 'Option',
        Hi: 'विकल्प',
        Ta: 'விருப்பம்',
        Ja: 'オプション',
        Ge: 'Möglichkeit',
      },
      AVIAVROI01: {
        En: 'User Profile Image',
        Et: 'Kasutaja profiili pilt',
        Ar: 'صورة الملف الشخصي للمستخدم',
        Ml: 'ഉപയോക്തൃ പ്രൊഫൈൽ ചിത്രം',
        Ma: 'वापरकर्ता प्रोफाइल प्रतिमा',
        Fr: 'Image de profil utilisateur',
        Hi: 'उपयोगकर्ता प्रोफ़ाइल छवि',
        Ta: 'பயனர் சுயவிவரப் படம்',
        Ja: 'ユーザープロフィール画像',
        Ge: 'Benutzerprofilbild',
      },
      AVIAVROB01: {
        En: 'Start',
        Et: 'Alusta',
        Ar: 'بداية',
        Ml: 'ആരംഭിക്കുക',
        Ma: 'सुरू करा',
        Fr: 'Commencer',
        Hi: 'शुरू',
        Ta: 'தொடங்கு',
        Ja: '始める',
        Ge: 'Anfang',
      },
      AVIAVROB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      AVIAVROB03: {
        En: 'Accept',
        Et: 'Nõustu',
        Ar: 'قبول',
        Ml: 'സ്വീകരിക്കുക',
        Ma: 'स्वीकारा',
        Fr: 'Accepter',
        Hi: 'स्वीकार करना',
        Ta: 'ஏற்றுக்கொள்',
        Ja: '承認',
        Ge: 'Annehmen',
      },
    },

    AssetViewItemLevelAllAssetsViewArchive: {
      AVLAAB01: {
        En: 'Picker Assign',
        Et: 'Valija määramine',
        Ar: 'تحديد المنتقي',
        Ml: 'പിക്കർ അസൈൻ',
        Ma: 'निवडक नियुक्त करा',
        Fr: 'Affectation du sélecteur',
        Hi: 'पिकर असाइन करें',
        Ta: 'பிக்கர் ஒதுக்கீடு',
        Ja: 'ピッカー割り当て',
        Ge: 'Picker-Zuweisung',
      },
      AVLAAB02: {
        En: 'Move to Vault',
        Et: 'Liikuge Vaulti',
        Ar: 'انتقال إلى قبو',
        Ml: 'വോൾട്ടിലേക്ക് നീങ്ങുക',
        Ma: 'व्हॉल्टमध्ये हलवा',
        Fr: 'Déplacer vers le coffre-fort',
        Hi: 'गुंबद कि तरफ़ बडो',
        Ta: 'பெட்டகத்தை நகர்த்த',
        Ja: 'ボールトに移動',
        Ge: 'Wechseln Sie in den Tresor',
      },
    },

    AssetViewItemLevelAllAssetsViewArchivePickerAssign: {
      AVIAVAPL01: {
        En: 'Picker Assign',
        Et: 'Valija määramine',
        Ar: 'تحديد المنتقي',
        Ml: 'പിക്കർ അസൈൻ',
        Ma: 'निवडक नियुक्त करा',
        Fr: 'Affectation du sélecteur',
        Hi: 'पिकर असाइन करें',
        Ta: 'பிக்கர் ஒதுக்கீடு',
        Ja: 'ピッカー割り当て',
        Ge: 'Picker-Zuweisung',
      },
      AVIAVAPDD01: {
        En: 'Names',
        Et: 'Nimed',
        Ar: 'الأسماء',
        Ml: 'പേരുകൾ',
        Ma: 'नावे',
        Fr: 'Des noms',
        Hi: 'नाम',
        Ta: 'பெயர்கள்',
        Ja: '名前',
        Ge: 'Namen',
      },
      AVIAVAPL02: {
        En: 'Comments',
        Et: 'Kommentaarid',
        Ar: 'تعليقات',
        Ml: 'അഭിപ്രായങ്ങൾ',
        Ma: 'टिप्पण्या',
        Fr: 'commentaires',
        Hi: 'टिप्पणियाँ',
        Ta: 'கருத்துகள்',
        Ja: 'コメント',
        Ge: 'Kommentare',
      },
      AVIAVAPTB01: {
        En: 'Comments Box',
        Et: 'Kommentaaride kast',
        Ar: 'مربع التعليقات',
        Ml: 'കമന്റ് ബോക്സ്',
        Ma: 'टिप्पण्या बॉक्स',
        Fr: 'Boîte de commentaires',
        Hi: 'कमेंट बॉक्स',
        Ta: 'கருத்துப் பெட்டி',
        Ja: 'コメントボックス',
        Ge: 'Kommentarfeld',
      },
      AVIAVAPI01: {
        En: 'User Profile Image',
        Et: 'Kasutaja profiili pilt',
        Ar: 'صورة الملف الشخصي للمستخدم',
        Ml: 'ഉപയോക്തൃ പ്രൊഫൈൽ ചിത്രം',
        Ma: 'वापरकर्ता प्रोफाइल प्रतिमा',
        Fr: 'Image de profil utilisateur',
        Hi: 'उपयोगकर्ता प्रोफ़ाइल छवि',
        Ta: 'பயனர் சுயவிவரப் படம்',
        Ja: 'ユーザープロフィール画像',
        Ge: 'Benutzerprofilbild',
      },
      AVIAVAPB01: {
        En: 'Start',
        Et: 'Alusta',
        Ar: 'بداية',
        Ml: 'ആരംഭിക്കുക',
        Ma: 'सुरू करा',
        Fr: 'Commencer',
        Hi: 'शुरू',
        Ta: 'தொடங்கு',
        Ja: '始める',
        Ge: 'Anfang',
      },
      AVIAVAPB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      AVIAVAPB03: {
        En: 'Accept',
        Et: 'Nõustu',
        Ar: 'قبول',
        Ml: 'സ്വീകരിക്കുക',
        Ma: 'स्वीकारा',
        Fr: 'Accepter',
        Hi: 'स्वीकार करना',
        Ta: 'ஏற்றுக்கொள்',
        Ja: '承認',
        Ge: 'Annehmen',
      },
    },

    AssetViewItemLevelAllAssetsViewArchiveMovetoVault: {
      AVIAVAML01: {
        En: 'Move to Vault',
        Et: 'Liikuge Vaulti',
        Ar: 'انتقال إلى قبو',
        Ml: 'വോൾട്ടിലേക്ക് നീങ്ങുക',
        Ma: 'व्हॉल्टमध्ये हलवा',
        Fr: 'Déplacer vers le coffre-fort',
        Hi: 'गुंबद कि तरफ़ बडो',
        Ta: 'பெட்டகத்தை நகர்த்த',
        Ja: 'ボールトに移動',
        Ge: 'Wechseln Sie in den Tresor',
      },
      AVIAVAML02: {
        En: 'QR Code',
        Et: 'QR kood',
        Ar: 'رمز الاستجابة السريعة',
        Ml: 'QR കോഡ്',
        Ma: 'QR कोड',
        Fr: 'QR Code',
        Hi: 'क्यू आर संहिता',
        Ta: 'க்யு ஆர் குறியீடு',
        Ja: 'QRコード',
        Ge: 'QR-Code',
      },
      AVIAVAMTB01: {
        En: 'QR Code Box',
        Et: 'QR-koodi kast',
        Ar: 'مربع رمز الاستجابة السريعة',
        Ml: 'QR കോഡ് ബോക്സ്',
        Ma: 'QR कोड बॉक्स',
        Fr: 'Boîte à code QR',
        Hi: 'क्यूआर कोड बॉक्स',
        Ta: 'QR குறியீடு பெட்டி',
        Ja: 'QRコードボックス',
        Ge: 'QR-Code-Box',
      },
      AVIAVAML03: {
        En: 'RFID',
        Et: 'RFID',
        Ar: 'RFID',
        Ml: 'RFID',
        Ma: 'RFID',
        Fr: 'RFID',
        Hi: 'आरएफआईडी',
        Ta: 'RFID',
        Ja: 'RFID',
        Ge: 'RFID',
      },
      AVIAVAMTB02: {
        En: 'RFID Box',
        Et: 'RFID kast',
        Ar: 'صندوق RFID',
        Ml: 'RFID ബോക്സ്',
        Ma: 'आरएफआयडी बॉक्स',
        Fr: 'Boîte RFID',
        Hi: 'आरएफआईडी बॉक्स',
        Ta: 'RFID பெட்டி',
        Ja: 'RFID ボックス',
        Ge: 'RFID-Box',
      },
      AVIAVAML04: {
        En: 'Barcode',
        Et: 'Vöötkood',
        Ar: 'الرمز الشريطي',
        Ml: 'ബാർകോഡ്',
        Ma: 'बारकोड',
        Fr: 'code à barre',
        Hi: 'बारकोड',
        Ta: 'பார்கோடு',
        Ja: 'バーコード',
        Ge: 'Strichcode',
      },
      AVIAVAMTB03: {
        En: 'Barcode Box',
        Et: 'Vöötkoodi kast',
        Ar: 'صندوق الباركود',
        Ml: 'ബാർകോഡ് ബോക്സ്',
        Ma: 'बारकोड बॉक्स',
        Fr: 'Boîte à code-barres',
        Hi: 'बारकोड बॉक्स',
        Ta: 'பார்கோடு பெட்டி',
        Ja: 'バーコードボックス',
        Ge: 'Barcode-Box',
      },
      AVIAVAMDD01: {
        En: 'Select Shelf',
        Et: 'Valige Riiul',
        Ar: 'حدد الرف',
        Ml: 'ഷെൽഫ് തിരഞ്ഞെടുക്കുക',
        Ma: 'शेल्फ निवडा',
        Fr: "Sélectionnez l'étagère",
        Hi: 'शेल्फ का चयन करें',
        Ta: 'அலமாரியைத் தேர்ந்தெடுக்கவும்',
        Ja: '棚を選択',
        Ge: 'Regal auswählen',
      },
      AVIAVAMDD02: {
        En: 'Select Vault Name',
        Et: 'Valige Vault Name',
        Ar: 'حدد اسم Vault',
        Ml: 'നിലവറയുടെ പേര് തിരഞ്ഞെടുക്കുക',
        Ma: 'Vault नाव निवडा',
        Fr: 'Sélectionnez le nom du coffre-fort',
        Hi: 'तिजोरी का नाम चुनें',
        Ta: 'வால்ட் பெயரைத் தேர்ந்தெடுக்கவும்',
        Ja: 'ボールト名を選択',
        Ge: 'Wählen Sie Tresorname aus',
      },
      AVIAVAML05: {
        En: 'Comments',
        Et: 'Kommentaarid',
        Ar: 'تعليقات',
        Ml: 'അഭിപ്രായങ്ങൾ',
        Ma: 'टिप्पण्या',
        Fr: 'commentaires',
        Hi: 'टिप्पणियाँ',
        Ta: 'கருத்துகள்',
        Ja: 'コメント',
        Ge: 'Kommentare',
      },
      AVIAVAMTB04: {
        En: 'Comments Box',
        Et: 'Kommentaaride kast',
        Ar: 'مربع التعليقات',
        Ml: 'കമന്റ് ബോക്സ്',
        Ma: 'टिप्पण्या बॉक्स',
        Fr: 'Boîte de commentaires',
        Hi: 'कमेंट बॉक्स',
        Ta: 'கருத்துப் பெட்டி',
        Ja: 'コメントボックス',
        Ge: 'Kommentarfeld',
      },
      AVIAVAMI01: {
        En: 'User Profile Image',
        Et: 'Kasutaja profiili pilt',
        Ar: 'صورة الملف الشخصي للمستخدم',
        Ml: 'ഉപയോക്തൃ പ്രൊഫൈൽ ചിത്രം',
        Ma: 'वापरकर्ता प्रोफाइल प्रतिमा',
        Fr: 'Image de profil utilisateur',
        Hi: 'उपयोगकर्ता प्रोफ़ाइल छवि',
        Ta: 'பயனர் சுயவிவரப் படம்',
        Ja: 'ユーザープロフィール画像',
        Ge: 'Benutzerprofilbild',
      },
      AVIAVAMB01: {
        En: 'Start',
        Et: 'Alusta',
        Ar: 'بداية',
        Ml: 'ആരംഭിക്കുക',
        Ma: 'सुरू करा',
        Fr: 'Commencer',
        Hi: 'शुरू',
        Ta: 'தொடங்கு',
        Ja: '始める',
        Ge: 'Anfang',
      },
      AVIAVAMB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      AVIAVAMB03: {
        En: 'Accept',
        Et: 'Nõustu',
        Ar: 'قبول',
        Ml: 'സ്വീകരിക്കുക',
        Ma: 'स्वीकारा',
        Fr: 'Accepter',
        Hi: 'स्वीकार करना',
        Ta: 'ஏற்றுக்கொள்',
        Ja: '承認',
        Ge: 'Annehmen',
      },
    },

    AssetViewItemLevelAllAssetsViewAccess: {
      AVLAAB01: {
        En: 'Assign Picker',
        Et: 'Määra valija',
        Ar: 'منتقي التعيين',
        Ml: 'പിക്കർ അസൈൻ ചെയ്യുക',
        Ma: 'पिकर नियुक्त करा',
        Fr: 'Attribuer un sélecteur',
        Hi: 'पिकर असाइन करें',
        Ta: 'பிக்கரை ஒதுக்கவும்',
        Ja: 'ピッカーの割り当て',
        Ge: 'Picker zuweisen',
      },
      AVLAAB02: {
        En: 'Move to Climatisation',
        Et: 'Liikuge kliimaseadmete juurde',
        Ar: 'انتقل إلى Climatisation',
        Ml: 'കാലാവസ്ഥാ വ്യതിയാനത്തിലേക്ക് നീങ്ങുക',
        Ma: 'हवामानीकरणाकडे जा',
        Fr: 'Move to Climatisation',
        Hi: 'जलवायुकरण की ओर बढ़ें',
        Ta: 'காலநிலைக்கு நகர்த்தவும்',
        Ja: '気候変動への移行',
        Ge: 'Wechseln Sie zu Klimatisierung',
      },
      AVLAAB04: {
        En: 'Ready for outward deliver',
        Et: 'Väliseks tarnimiseks valmis',
        Ar: 'جاهز للتسليم الخارجي',
        Ml: 'പുറത്തേക്കുള്ള ഡെലിവറിക്ക് തയ്യാറാണ്',
        Ma: 'बाह्य वितरणासाठी सज्ज',
        Fr: "Prêt pour la livraison vers l'extérieur",
        Hi: 'जावक वितरण के लिए तैयार',
        Ta: 'வெளிப்புற விநியோகத்திற்கு தயாராக உள்ளது',
        Ja: '発送準備完了',
        Ge: 'Bereit für die Auslieferung',
      },
      AVLAAB05: {
        En: 'Delivered',
        Et: 'Kohale toimetatud',
        Ar: 'تم التوصيل',
        Ml: 'എത്തിച്ചു',
        Ma: 'वितरित केले',
        Fr: 'Livré',
        Hi: 'पहुंचा दिया',
        Ta: 'வழங்கப்பட்டது',
        Ja: '配達済み',
        Ge: 'Geliefert',
      },
      AVLAAB06: {
        En: 'Returned',
        Et: 'Tagastatud',
        Ar: 'عاد',
        Ml: 'മടങ്ങി',
        Ma: 'परतले',
        Fr: 'Revenu',
        Hi: 'लौटाया हुआ',
        Ta: 'திரும்பினார்',
        Ja: '戻ってきた',
        Ge: 'Ist zurückgekommen',
      },
    },

    AssetViewItemLevelAllAssetsViewAccessAssignPicker: {
      AVIAVAAL01: {
        En: 'Assign Picker',
        Et: 'Määra valija',
        Ar: 'منتقي التعيين',
        Ml: 'പിക്കർ അസൈൻ ചെയ്യുക',
        Ma: 'पिकर नियुक्त करा',
        Fr: 'Attribuer un sélecteur',
        Hi: 'पिकर असाइन करें',
        Ta: 'பிக்கரை ஒதுக்கவும்',
        Ja: 'ピッカーの割り当て',
        Ge: 'Picker zuweisen',
      },
      AVIAVAADD01: {
        En: 'Names',
        Et: 'Nimed',
        Ar: 'الأسماء',
        Ml: 'പേരുകൾ',
        Ma: 'नावे',
        Fr: 'Des noms',
        Hi: 'नाम',
        Ta: 'பெயர்கள்',
        Ja: '名前',
        Ge: 'Namen',
      },
      AVIAVAAL02: {
        En: 'Comments',
        Et: 'Kommentaarid',
        Ar: 'تعليقات',
        Ml: 'അഭിപ്രായങ്ങൾ',
        Ma: 'टिप्पण्या',
        Fr: 'commentaires',
        Hi: 'टिप्पणियाँ',
        Ta: 'கருத்துகள்',
        Ja: 'コメント',
        Ge: 'Kommentare',
      },
      AVIAVAATB01: {
        En: 'Comments Box',
        Et: 'Kommentaaride kast',
        Ar: 'مربع التعليقات',
        Ml: 'കമന്റ് ബോക്സ്',
        Ma: 'टिप्पण्या बॉक्स',
        Fr: 'Boîte de commentaires',
        Hi: 'कमेंट बॉक्स',
        Ta: 'கருத்துப் பெட்டி',
        Ja: 'コメントボックス',
        Ge: 'Kommentarfeld',
      },
      AVIAVAAI01: {
        En: 'User Profile Image',
        Et: 'Kasutaja profiili pilt',
        Ar: 'صورة الملف الشخصي للمستخدم',
        Ml: 'ഉപയോക്തൃ പ്രൊഫൈൽ ചിത്രം',
        Ma: 'वापरकर्ता प्रोफाइल प्रतिमा',
        Fr: 'Image de profil utilisateur',
        Hi: 'उपयोगकर्ता प्रोफ़ाइल छवि',
        Ta: 'பயனர் சுயவிவரப் படம்',
        Ja: 'ユーザープロフィール画像',
        Ge: 'Benutzerprofilbild',
      },
      AVIAVAAB01: {
        En: 'Start',
        Et: 'Alusta',
        Ar: 'بداية',
        Ml: 'ആരംഭിക്കുക',
        Ma: 'सुरू करा',
        Fr: 'Commencer',
        Hi: 'शुरू',
        Ta: 'தொடங்கு',
        Ja: '始める',
        Ge: 'Anfang',
      },
      AVIAVAAB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      AVIAVAAB03: {
        En: 'Accept',
        Et: 'Nõustu',
        Ar: 'قبول',
        Ml: 'സ്വീകരിക്കുക',
        Ma: 'स्वीकारा',
        Fr: 'Accepter',
        Hi: 'स्वीकार करना',
        Ta: 'ஏற்றுக்கொள்',
        Ja: '承認',
        Ge: 'Annehmen',
      },
    },

    AssetViewItemLevelAllAssetsViewAccessMovetoClimatisation: {},

    AssetViewItemLevelAllAssetsViewAccessReadyforoutwarddeliver: {},

    AssetViewItemLevelAllAssetsViewAccessDelivered: {},

    AssetViewItemLevelAllAssetsViewAccessReturned: {},

    AssetViewItemLevelAllAssetsViewDigital: {
      AVIAVDL1: {
        En: 'Catalog',
        Et: 'Kataloog',
        Ar: 'فهرس',
        Ml: 'കാറ്റലോഗ്',
        Ma: 'कॅटलॉग',
        Fr: 'Catalogue',
        Hi: 'सूची',
        Ta: 'அட்டவணை',
        Ja: 'カタログ',
        Ge: 'Katalog',
      },
      AVIAVDB1: {
        En: 'Physical Inspection Report',
        Et: 'Füüsilise kontrolli aruanne',
        Ar: 'تقرير التفتيش المادي',
        Ml: 'ഫിസിക്കൽ ഇൻസ്പെക്ഷൻ റിപ്പോർട്ട്',
        Ma: 'शारीरिक तपासणी अहवाल',
        Fr: "Rapport d'inspection physique",
        Hi: 'भौतिक निरीक्षण रिपोर्ट',
        Ta: 'உடல் பரிசோதனை அறிக்கை',
        Ja: '物理的検査レポート',
        Ge: 'Physischer Inspektionsbericht',
      },
      AVIAVDB2: {
        En: 'Inventory Report',
        Et: 'Varude aruanne',
        Ar: 'تقرير المخزونات',
        Ml: 'ഇൻവെന്ററി റിപ്പോർട്ട്',
        Ma: 'इन्व्हेंटरी अहवाल',
        Fr: "Rapport d'inventaire",
        Hi: 'वस्तुसूची विवरण',
        Ta: 'சரக்கு அறிக்கை',
        Ja: '在庫レポート',
        Ge: 'Inventarbericht',
      },
      AVIAVDB3: {
        En: 'Plus',
        Et: 'Pluss',
        Ar: 'زائد',
        Ml: 'പ്ലസ്',
        Ma: 'प्लस',
        Fr: 'Plus',
        Hi: 'प्लस',
        Ta: 'மேலும்',
        Ja: 'プラス',
        Ge: 'Plus',
      },
      AVIAVDL2: {
        En: 'Select a File',
        Et: 'Valige fail',
        Ar: 'حدد ملف',
        Ml: 'ഒരു ഫയൽ തിരഞ്ഞെടുക്കുക',
        Ma: 'एक फाइल निवडा',
        Fr: 'Sélectionner un fichier',
        Hi: 'किसी फाइल का चयन करें',
        Ta: 'ஒரு கோப்பைத் தேர்ந்தெடுக்கவும்',
        Ja: 'ファイルを選択',
        Ge: 'Wählen Sie eine Datei aus',
      },
      AVIAVDB4: {
        En: 'Close',
        Et: 'Sulge',
        Ar: 'قريب',
        Ml: 'അടയ്ക്കുക',
        Ma: 'बंद',
        Fr: 'proche',
        Hi: 'बंद करना',
        Ta: 'நெருக்கமான',
        Ja: '近い',
        Ge: 'Nah dran',
      },
    },

    AssetViewItemLevelAllAssetsViewPhysical: {
      AVIAVPB1: {
        En: 'Plus',
        Et: 'Pluss',
        Ar: 'زائد',
        Ml: 'പ്ലസ്',
        Ma: 'प्लस',
        Fr: 'Plus',
        Hi: 'प्लस',
        Ta: 'மேலும்',
        Ja: 'プラス',
        Ge: 'Plus',
      },
      AVIAVPB2: {
        En: 'Minus',
        Et: 'Miinus',
        Ar: 'ناقص',
        Ml: 'മൈനസ്',
        Ma: 'उणे',
        Fr: 'Moins',
        Hi: 'ऋण',
        Ta: 'கழித்தல்',
        Ja: 'マイナス',
        Ge: 'Minus',
      },
    },

    Reports: {
      RTH01: {
        En: 'Film Title',
        Et: 'Filmi pealkiri',
        Ar: 'عنوان الفيلم',
        Ml: 'സിനിമയുടെ പേര്',
        Ma: 'चित्रपटाचे शीर्षक',
        Fr: 'Titre de film',
        Hi: 'फिल्म का शीर्षक',
        Ta: 'படத்தின் தலைப்பு',
        Ja: '映画のタイトル',
        Ge: 'Filmtitel',
      },
      RTH02: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      RTH03: {
        En: 'WorkFlow',
        Et: 'WorkFlow',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      RTH04: {
        En: 'Language',
        Et: 'Keel',
        Ar: 'لغة',
        Ml: 'ഭാഷ',
        Ma: 'इंग्रजी',
        Fr: 'Langue',
        Hi: 'भाषा',
        Ta: 'மொழி',
        Ja: '言語',
        Ge: 'Sprache',
      },
      RTH05: {
        En: 'Country of Production',
        Et: 'Tootmisriik',
        Ar: 'بلد الإنتاج',
        Ml: 'ഉൽപ്പാദന രാജ്യം',
        Ma: 'उत्पादन देश',
        Fr: 'Pays de production',
        Hi: 'उत्पादन का देश',
        Ta: 'உற்பத்தி நாடு',
        Ja: '生産国',
        Ge: 'Produktionsland',
      },
      RTH06: {
        En: 'Original Language',
        Et: 'Algkeel',
        Ar: 'اللغة الأصلية',
        Ml: 'യഥാർത്ഥ ഭാഷ',
        Ma: 'मूळ भाषा',
        Fr: 'Langue originale',
        Hi: 'वास्तविक भाषा',
        Ta: 'அசல் மொழி',
        Ja: '元の言語',
        Ge: 'Ursprache',
      },
      RTH07: {
        En: 'Description',
        Et: 'Kirjeldus',
        Ar: 'وصف',
        Ml: 'വിവരണം',
        Ma: 'वर्णन',
        Fr: 'La description',
        Hi: 'विवरण',
        Ta: 'விளக்கம்',
        Ja: '説明',
        Ge: 'Beschreibung',
      },
      RTH08: {
        En: 'Duration',
        Et: 'Kestus',
        Ar: 'مدة',
        Ml: 'ദൈർഘ്യം',
        Ma: 'कालावधी',
        Fr: 'Durée',
        Hi: 'अवधि',
        Ta: 'கால அளவு',
        Ja: '間隔',
        Ge: 'Dauer',
      },
      RTH09: {
        En: 'Total Can Count',
        Et: 'Kokku saab lugeda',
        Ar: 'مجموع يمكن أن يحسب',
        Ml: 'ആകെ കണക്കാക്കാം',
        Ma: 'एकूण मोजू शकता',
        Fr: 'Le total peut compter',
        Hi: 'कुल गिनती कर सकते हैं',
        Ta: 'மொத்தமாக எண்ணலாம்',
        Ja: '総缶数',
        Ge: 'Gesamt kann zählen',
      },
      RTH10: {
        En: 'Producer',
        Et: 'Tootja',
        Ar: 'منتج',
        Ml: 'നിർമ്മാതാവ്',
        Ma: 'निर्माता',
        Fr: 'Producteur',
        Hi: 'निर्माता',
        Ta: 'தயாரிப்பாளர்',
        Ja: 'プロデューサー',
        Ge: 'Hersteller',
      },
      RTH11: {
        En: 'Director',
        Et: 'Direktor',
        Ar: 'مخرج',
        Ml: 'ഡയറക്ടർ',
        Ma: 'दिग्दर्शक',
        Fr: 'Directeur',
        Hi: 'निर्देशक',
        Ta: 'இயக்குனர்',
        Ja: '監督',
        Ge: 'Direktor',
      },
      RTH12: {
        En: 'Editing',
        Et: 'Redigeerimine',
        Ar: 'التحرير',
        Ml: 'എഡിറ്റിംഗ്',
        Ma: 'संपादन',
        Fr: 'Édition',
        Hi: 'संपादन',
        Ta: 'எடிட்டிங்',
        Ja: '編集',
        Ge: 'Bearbeitung',
      },
      RTH13: {
        En: 'Music',
        Et: 'Muusika',
        Ar: 'موسيقى',
        Ml: 'സംഗീതം',
        Ma: 'संगीत',
        Fr: 'Musique',
        Hi: 'संगीत',
        Ta: 'இசை',
        Ja: '音楽',
        Ge: 'Musik',
      },
      RTH14: {
        En: 'Production Manager',
        Et: 'Tootmisjuht',
        Ar: 'مدير الانتاج',
        Ml: 'പ്രൊഡക്ഷൻ മാനേജർ',
        Ma: 'उत्पादन व्यवस्थापक',
        Fr: 'Directeur de production',
        Hi: 'उत्पादन प्रबंधक',
        Ta: 'தயாரிப்பு மேலாளர்',
        Ja: 'プロダクションマネージャー',
        Ge: 'Produktionsleiter',
      },
      RTH15: {
        En: 'Physical Sensor Barcode',
        Et: 'Füüsilise anduri vöötkood',
        Ar: 'الباركود المستشعر المادي',
        Ml: 'ഫിസിക്കൽ സെൻസർ ബാർകോഡ്',
        Ma: 'भौतिक सेन्सर बारकोड',
        Fr: 'Code-barres du capteur physique',
        Hi: 'भौतिक सेंसर बारकोड',
        Ta: 'இயற்பியல் சென்சார் பார்கோடு',
        Ja: '物理センサー バーコード',
        Ge: 'Physischer Sensor-Barcode',
      },
      RB01: {
        En: 'Page Number',
        Et: 'Lehekülje number',
        Ar: 'رقم الصفحة',
        Ml: 'പേജ് നമ്പർ',
        Ma: 'पृष्ठ क्रमांक',
        Fr: 'Numéro de page',
        Hi: 'पृष्ठ संख्या',
        Ta: 'பக்க எண்',
        Ja: 'ページ番号',
        Ge: 'Seitennummer',
      },
      RB02: {
        En: 'Setting',
        Et: 'Seadistamine',
        Ar: 'ضبط',
        Ml: 'ക്രമീകരണം',
        Ma: 'सेटिंग',
        Fr: 'Paramètre',
        Hi: 'स्थापना',
        Ta: 'அமைத்தல்',
        Ja: '設定',
        Ge: 'Einstellung',
      },
      RL01: {
        En: 'Reports',
        Et: 'Aruanded',
        Ar: 'التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ',
        Ma: 'अहवाल',
        Fr: 'Rapports',
        Hi: 'रिपोर्टों',
        Ta: 'அறிக்கைகள்',
        Ja: 'レポート',
        Ge: 'Berichte',
      },
      RCL01: {
        En: 'Reports Customization',
        Et: 'Aruannete kohandamine',
        Ar: 'تخصيص التقارير',
        Ml: 'റിപ്പോർട്ടുകൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'रिपोर्ट कस्टमायझेशन',
        Fr: 'Personnalisation des rapports',
        Hi: 'रिपोर्ट अनुकूलन',
        Ta: 'அறிக்கைகள் தனிப்பயனாக்கம்',
        Ja: 'レポートのカスタマイズ',
        Ge: 'Anpassung von Berichten',
      },
      RB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      RB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
    },

    SBPivotTableMain: {
      SBPTM01: {
        En: 'Choose From and To Date',
        Et: 'Vali alates Tänaseks',
        Ar: 'اختر من وحتى التاريخ',
        Ml: 'തീയതി തിരഞ്ഞെടുക്കുക തുടങ്ങി',
        Ma: 'पासून ते तारीख निवडा',
        Fr: 'Choisissez la date de début et de fin',
        Hi: 'चुनें तारीख से लेकर तक',
        Ta: 'தேதியைத் தேர்ந்தெடுக்கவும் தொடக்கம் முதல் இறுதி வரை',
        Ja: '開始日と終了日を選択してください',
        Ge: 'Wählen Sie das Datum von bis'
      },
      SBPTM02: {
        En: 'From',
        Et: 'Alates',
        Ar: 'من',
        Ml: 'മുതൽ',
        Ma: 'पासून',
        Fr: 'de',
        Hi: 'से',
        Ta: 'தொடக்கம்',
        Ja: 'から',
        Ge: 'von'
      },
      SBPTM03: {
        En: 'To',
        Et: 'Kuni',
        Ar: 'إلى',
        Ml: 'ക്ക്',
        Ma: 'ला',
        Fr: 'à',
        Hi: 'को',
        Ta: 'இறுதி',
        Ja: 'に',
        Ge: 'zu'
      },
      SBPTM04:{
        En: 'Loading your Data...',
        Et: 'Laadin teie andmeid...',
        Ar: 'جاري تحميل بياناتك...',
        Ml: 'നിങ്ങളുടെ ഡാറ്റ ലോഡ് ചെയ്യുന്നു...',
        Ma: 'तुमचे डेटा लोड होत आहे...',
        Fr: 'Chargement de vos données...',
        Hi: 'आपका डेटा लोड हो रहा है...',
        Ta: 'உங்கள் தரவு ஏற்றப்படுகிறது...',
        Ja: 'データを読み込んでいます...',
        Ge: 'Ihre Daten werden geladen...'
      },
      SBPTM05:{
        En: 'Generate Report',
        Et: 'Loo aruanne',
        Ar: 'توليد تقرير',
        Ml: 'റിപ്പോർട്ട് ജനറേറ്റ് ചെയ്യുക',
        Ma: 'अहवाल तयार करा',
        Fr: 'Générer un rapport',
        Hi: 'रिपोर्ट तैयार करें',
        Ta: 'அறிக்கை உருவாக்கு',
        Ja: 'レポートを生成する',
        Ge: 'Bericht erstellen'
      },
      SBPTM06:{
        En: 'Save As Pivot',
        Et: 'Salvesta pööratabelina',
        Ar: 'حفظ كجدول محوري',
        Ml: 'പിവറ്റ് ടേബിളായി സംരക്ഷിക്കുക',
        Ma: 'पिव्हॉट टेबल म्हणून वाचवा',
        Fr: 'Sauvegarder en tant que tableau croisé dynamique',
        Hi: 'पिवोट तालिका के रूप में सहेजें',
        Ta: 'சுழல் அட்டவணை என சேமி',
        Ja: 'ピボットテーブルとして保存',
        Ge: ' Als Pivot-Tabelle speichern'
      }
    },

    AssetTable: {
      AT01:{
        En: {
          "Title": "Title",
          "Asset Tracking Status": "Asset Tracking Status",
          "Movementdate": "Movementdate",
          "Item Created At": "Item Created At",
          "Physical Sensor Barcode": "Physical Sensor Barcode",
          "Asset In Vault": "Asset In Vault",
          "Physical Location Vault": "Physical Location Vault",
          "Physical Location Shelf": "Physical Location Shelf"
        },
        
        Et: {
          "Title": "Pealkiri",
          "Asset Tracking Status": "Vara jälgimise staatus",
          "Movementdate": "Liikumise kuupäev",
          "Item Created At": "Eseme loomise kuupäev",
          "Physical Sensor Barcode": "Füüsilise anduri vöötkood",
          "Asset In Vault": "Vara on seifis",
          "Physical Location Vault": "Füüsiline asukoht - seif",
          "Physical Location Shelf": "Füüsiline asukoht - riiul"
        },
        
        Ar: {
          "Title": "عنوان",
          "Asset Tracking Status": "حالة تتبع الأصول",
          "Movementdate": "تاريخ الحركة",
          "Item Created At": "تاريخ إنشاء العنصر",
          "Physical Sensor Barcode": "باركود المستشعر المادي",
          "Asset In Vault": "الأصل في الخزنة",
          "Physical Location Vault": "الموقع المادي للخزنة",
          "Physical Location Shelf": "الموقع المادي للرف"
        },
        
        Ml: {
          "Title": "ശീർഷകം",
          "Asset Tracking Status": "ആസ്തി ട്രാക്കിംഗ് സ്ഥിതി",
          "Movementdate": "ചലന തീയതി",
          "Item Created At": "ഇനം സൃഷ്ടിച്ച തീയതി",
          "Physical Sensor Barcode": "ഭൗതിക സെൻസർ ബാർകോഡ്",
          "Asset In Vault": "വോൾട്ടിൽ ആസ്തി",
          "Physical Location Vault": "ഭൗതിക സ്ഥാനം വോൾട്ട്",
          "Physical Location Shelf": "ഭൗതിക സ്ഥാനം ഷെൽഫ്"
        },
        
        Ma: {
          "Title": "शीर्षक",
          "Asset Tracking Status": "संपत्ती ट्रॅकिंग स्थिती",
          "Movementdate": "हालचाल तारीख",
          "Item Created At": "वस्तू निर्माण तारीख",
          "Physical Sensor Barcode": "भौतिक संवेदक बारकोड",
          "Asset In Vault": "तिजोरीत संपत्ती",
          "Physical Location Vault": "भौतिक स्थान तिजोरी",
          "Physical Location Shelf": "भौतिक स्थान शेल्फ"
        },
        
        Fr: {
          "Title": "Titre",
          "Asset Tracking Status": "Statut de suivi d'actif",
          "Movementdate": "Date de mouvement",
          "Item Created At": "Date de création de l'élément",
          "Physical Sensor Barcode": "Code-barres du capteur physique",
          "Asset In Vault": "Actif dans le coffre-fort",
          "Physical Location Vault": "Emplacement physique du coffre-fort",
          "Physical Location Shelf": "Emplacement physique de l'étagère"
        },
        
        Hi: {
          "Title": "शीर्षक",
          "Asset Tracking Status": "संपत्ति ट्रैकिंग स्थिति",
          "Movementdate": "आंदोलन की तारीख",
          "Item Created At": "आइटम बनाया गया",
          "Physical Sensor Barcode": "भौतिक सेंसर बारकोड",
          "Asset In Vault": "तहखाने में संपत्ति",
          "Physical Location Vault": "भौतिक स्थान तहखाना",
          "Physical Location Shelf": "भौतिक स्थान शेल्फ"
        },
        
        Ta: {
          "Title": "தலைப்பு",
          "Asset Tracking Status": "சொத்து கண்காணிப்பு நிலை",
          "Movementdate": "இயக்க தேதி",
          "Item Created At": "பொருள் உருவாக்கப்பட்ட தேதி",
          "Physical Sensor Barcode": "உடல் சென்சார் பார் கோட்",
          "Asset In Vault": "கருவூலத்தில் சொத்து",
          "Physical Location Vault": "உடல் இருப்பிடம் கருவூலம்",
          "Physical Location Shelf": "உடல் இருப்பிடம் அலமாரி"
        },
        
        Ja: {
          "Title": "タイトル",
          "Asset Tracking Status": "アセット追跡ステータス",
          "Movementdate": "移動日",
          "Item Created At": "アイテム作成日",
          "Physical Sensor Barcode": "物理センサーバーコード",
          "Asset In Vault": "金庫内の資産",
          "Physical Location Vault": "物理的な場所金庫",
          "Physical Location Shelf": "物理的な場所棚"
        },
        
        Ge: {
          "Title": "Titel",
          "Asset Tracking Status": "Asset-Tracking-Status",
          "Movementdate": "Bewegungsdatum",
          "Item Created At": "Artikel erstellt am",
          "Physical Sensor Barcode": "physischer Sensor-Barcode",
          "Asset In Vault": "Asset im Tresor",
          "Physical Location Vault": "physischer Standort Tresor",
          "Physical Location Shelf": "physischer Standort Regal"
        }
      },
    },
    ReceivingTable: {
      R001: {
      En: {
      "Receiving Title" : 'Receiving Title',
      "Type": 'Type',
      "Date": 'Date',
      "Verify Status": 'Verify Status'
      },
      Et: {
      "Receiving Title": 'vastuvõetud pealkiri',
      "Type": 'tüüp',
      "Date": 'kuupäev',
      "Verify Status" : 'kinnitusstaatus'
      },
      Ar: {
        "Receiving Title": 'عنوان المستلم',
        "Type": 'نوع',
        "Date": 'تاريخ',
        "Verify Status": 'حالة التحقق'
      },
      Ml: {
        "Receiving Title": 'ലഭിച്ച തലക്കെട്ട്',
        "Type": 'തരം',
        "Date": 'തീയതി',
        "Verify Status": 'സ്ഥിരീകരണ സ്ഥിതി'
      },
      Ma: {
        "Receiving Title": 'प्राप्त झालेला शीर्षक',
        "Type": 'प्रकार',
        "Date": 'तारीख',
        "Verify Status": 'सत्यापित स्थिती'
      },
      Fr: {
        "Receiving Title": 'titre reçu',
        "Type": 'type',
        "Date": 'date',
        "Verify Status": 'statut de vérification'
      },
      Hi: {
        "Receiving Title": 'प्राप्त शीर्षक',
        "Type": 'प्रकार',
        "Date": 'तारीख',
        "Verify Status": 'सत्यापन स्थिति'
      },
      Ta: {
        "Receiving Title": 'பெறப்பட்ட தலைப்பு',
        "Type": 'வகை',
        "Date": 'தேதி',
        "Verify Status": 'சரிபார்ப்பு நிலை'
      },
      Ja: {
        "Receiving Title": '受信タイトル',
        "Type": 'タイプ',
        "Date": '日付',
        "Verify Status": '検証ステータス'
      },
      Ge: {
        "Receiving Title": 'empfangener Titel',
        "Type": 'Typ',
        "Date": 'Datum',
        "Verify Status": 'Überprüfungsstatus'
      }
      }
      },
      AlertsTable: {
          ALT01: {
            En: {
              "Title": "Title",
              "Task": "Task",
              "Subtask": "Subtask",
              "Reject Date Time": "Reject Date Time",
              "Reject Username": "Reject Username",
              "Reject Message": "Reject Message",
              "Resolve Username": "Resolve Username",
              "Resolve Message": "Resolve Message",
              "Resolve Date Time": "Resolve Date Time"
            },
            Et: {
              "Title": "Pealkiri",
              "Task": "Ülesanne",
              "Subtask": "Alamülesanne",
              "Reject Date Time": "Tagasilükkamise kuupäev ja kellaaeg",
              "Reject Username": "Tagasilükkamise kasutajanimi",
              "Reject Message": "Tagasilükkamise sõnum",
              "Resolve Username": "Lahendamise kasutajanimi",
              "Resolve Message": "Lahendamise sõnum",
              "Resolve Date Time": "Lahendamise kuupäev ja kellaaeg"
            },
            Ar: {
              "Title": "عنوان",
              "Task": "مهمة",
              "Subtask": "مهمة فرعية",
              "Reject Date Time": "تاريخ ووقت الرفض",
              "Reject Username": "اسم المستخدم الذي رفض",
              "Reject Message": "رسالة الرفض",
              "Resolve Username": "اسم المستخدم الذي حل",
              "Resolve Message": "رسالة الحل",
              "Resolve Date Time": "تاريخ ووقت الحل"
            },
            Ml: {
              "Title": "ശീർഷകം",
              "Task": "ടാസ്ക്",
              "Subtask": "സബ്‌ടാസ്ക്",
              "Reject Date Time": "പ്രതിസന്ധി തീയതി സമയം",
              "Reject Username": "പ്രതിസന്ധി ഉപയോക്താവ്",
              "Reject Message": "പ്രതിസന്ധി സന്ദേശം",
              "Resolve Username": "പരിഹാര ഉപയോക്താവ്",
              "Resolve Message": "പരിഹാര സന്ദേശം",
              "Resolve Date Time": "പരിഹാര തീയതി സമയം"
            },
            Ma: {
              "Title": "शीर्षक",
              "Task": "कार्य",
              "Subtask": "उपकार्य",
              "Reject Date Time": "अस्वीकार तारीख वेळ",
              "Reject Username": "अस्वीकार वापरकर्तानाव",
              "Reject Message": "अस्वीकार संदेश",
              "Resolve Username": "सोडवण वापरकर्तानाव",
              "Resolve Message": "सोडवण संदेश",
              "Resolve Date Time": "सोडवण तारीख वेळ"
            },
            Fr: {
              "Title": "Titre",
              "Task": "Tâche",
              "Subtask": "Sous-tâche",
              "Reject Date Time": "Date et heure de rejet",
              "Reject Username": "Nom d'utilisateur de rejet",
              "Reject Message": "Message de rejet",
              "Resolve Username": "Nom d'utilisateur de résolution",
              "Resolve Message": "Message de résolution",
              "Resolve Date Time": "Date et heure de résolution"
            },
            Hi: {
              "Title": "शीर्षक",
              "Task": "कार्य",
              "Subtask": "उप कार्य",
              "Reject Date Time": "अस्वीकार दिनांक समय",
              "Reject Username": "अस्वीकार उपयोगकर्ता नाम",
              "Reject Message": "अस्वीकार संदेश",
              "Resolve Username": "समाधान उपयोगकर्ता नाम",
              "Resolve Message": "समाधान संदेश",
              "Resolve Date Time": "समाधान दिनांक समय"
            },
            Ta: {
              "Title": "தலைப்பு",
              "Task": "பணி",
              "Subtask": "துணை பணி",
              "Reject Date Time": "நிராகரிக்க தேதி நேரம்",
              "Reject Username": "நிராகரிக்க பயனர் பெயர்",
              "Reject Message": "நிராகரிக்க செய்தி",
              "Resolve Username": "தீர்க்க பயனர் பெயர்",
              "Resolve Message": "தீர்க்க செய்தி",
              "Resolve Date Time": "தீர்க்க தேதி நேரம்"
            },
            Ja: {
              "Title": "タイトル",
              "Task": "タスク",
              "Subtask": "サブタスク",
              "Reject Date Time": "拒否日時",
              "Reject Username": "拒否したユーザー名",
              "Reject Message": "拒否メッセージ",
              "Resolve Username": "解決したユーザー名",
              "Resolve Message": "解決メッセージ",
              "Resolve Date Time": "解決日時"
            },
            Ge: {
              "Title": "Titel",
              "Task": "Aufgabe",
              "Subtask": "Unteraufgabe",
              "Reject Date Time": "Ablehnungsdatum Zeit",
              "Reject Username": "Ablehnender Benutzername",
              "Reject Message": "Ablehnungsnachricht",
              "Resolve Username": "Auflösender Benutzername",
              "Resolve Message": "Auflösungsnachricht",
              "Resolve Date Time": "Auflösungsdatum Zeit"
            }
          }
        },      
      TagTable: {
        TT01: {
          En: {
            "Title": "Title",
            "Element": "Element",
            "Type": "Type",
            "Asset Tracking Status": "Asset Tracking Status"
          },
          Et: {
            "Title": "Pealkiri",
            "Element": "Element",
            "Type": "Tüüp",
            "Asset Tracking Status": "Vara jälgimise staatus"
          },
          Ar: {
            "Title": "عنوان",
            "Element": "عنصر",
            "Type": "نوع",
            "Asset Tracking Status": "حالة تتبع الأصول"
          },
          Ml: {
            "Title": "ശീർഷകം",
            "Element": "ഘടകം",
            "Type": "തരം",
            "Asset Tracking Status": "ആസ്തി ട്രാക്കിംഗ് സ്ഥിതി"
          },
          Ma: {
            "Title": "शीर्षक",
            "Element": "घटक",
            "Type": "प्रकार",
            "Asset Tracking Status": "संपत्ती ट्रॅकिंग स्थिती"
          },
          Fr: {
            "Title": "Titre",
            "Element": "Élément",
            "Type": "Type",
            "AssetTrackingStatus": "Statut de suivi d'actif"
          },
          Hi: {
            "Title": "शीर्षक",
            "Element": "तत्व",
            "Type": "प्रकार",
            "Asset Tracking Status": "संपत्ति ट्रैकिंग स्थिति"
          },
          Ta: {
            "Title": "தலைப்பு",
            "Element": "உறுப்பு",
            "Type": "வகை",
            "Asset Tracking Status": "சொத்து கண்காணிப்பு நிலை"
          },
          Ja: {
            "Title": "タイトル",
            "Element": "要素",
            "Type": "タイプ",
            "Asset Tracking Status": "アセット追跡ステータス"
          },
          Ge: {
            "Title": "Titel",
            "Element": "Element",
            "Type": "Typ",
            "Asset Tracking Status": "Asset-Tracking-Status"
          }
        }
      },

      CreateOrderTable: {
        COT01: {
          En: {
            "Title": "Title",
            "Element": "Element",
            "Type": "Type",
            "Asset In Vault": "Asset In Vault"
          },
          Et: {
            "Title": "Pealkiri",
            "Element": "Element",
            "Type": "Tüüp",
            "Asset In Vault": "Vara on seifis"
          },
          Ar: {
            "Title": "عنوان",
            "Element": "عنصر",
            "Type": "نوع",
            "Asset In Vault": "الأصل في الخزنة"
          },
          Ml: {
            "Title": "ശീർഷകം",
            "Element": "ഘടകം",
            "Type": "തരം",
            "Asset In Vault": "വോൾട്ടിൽ ആസ്തി"
          },
          Ma: {
            "Title": "शीर्षक",
            "Element": "घटक",
            "Type": "प्रकार",
            "Asset In Vault": "तिजोरीत संपत्ती"
          },
          Fr: {
            "Title": "Titre",
            "Element": "Élément",
            "Type": "Type",
            "Asset In Vault": "Actif dans le coffre-fort"
          },
          Hi: {
            "Title": "शीर्षक",
            "Element": "तत्व",
            "Type": "प्रकार",
            "Asset In Vault": "तहखाने में संपत्ति"
          },
          Ta: {
            "Title": "தலைப்பு",
            "Element": "உறுப்பு",
            "Type": "வகை",
            "Asset In Vault": "கருவூலத்தில் சொத்து"
          },
          Ja: {
            "Title": "タイトル",
            "Element": "要素",
            "Type": "タイプ",
            "Asset In Vault": "金庫内の資産"
          },
          Ge: {
            "Title": "Titel",
            "Element": "Element",
            "Type": "Typ",
            "Asset In Vault": "Asset im Tresor"
          }
        }
      },

      UpdateTable: {
        UT01:{
          En: 'To',
          Et: 'Kuni',
          Ar: 'إلى',
          Ml: 'വരെ',
          Ma: 'पर्यंत',
          Fr: 'Jusque',
          Hi: 'तक',
          Ta: 'வரை',
          Ja: 'まで',
          Ge: 'Bis'
        },
        UT02:{
          En: 'Date/Time',
          Et: 'Kuupäev/Aeg',
          Ar: 'تاريخ/وقت',
          Ml: 'തീയതി/സമയം',
          Ma: 'दिनांक/वेळ',
          Fr: 'Date/Heure',
          Hi: 'दिनांक/समय',
          Ta: 'தேதி/நேரம்',
          Ja: '日付/時間',
          Ge: 'Datum/Zeit'
        },
        UT03:{
          En: 'Updates',
          Et: 'Uuendused',
          Ar: 'تحديثات',
          Ml: 'അപ്‌ഡേറ്റുകൾ',
          Ma: 'अपडेट्स',
          Fr: 'Mises à jour',
          Hi: 'अपडेट्स',
          Ta: 'புதுப்பிப்புகள்',
          Ja: 'アップデート',
          Ge: 'Updates'
        },
        UT04:{
          En: 'Status',
          Et: 'Staatus',
          Ar: 'حالة',
          Ml: 'സ്ഥിതി',
          Ma: 'स्थिती',
          Fr: 'Statut',
          Hi: 'स्थिति',
          Ta: 'நிலை',
          Ja: 'ステータス',
          Ge: 'Status'
        },
        UT05:{
          En: 'Read Receipt',
          Et: 'Loetud kinnitus',
          Ar: 'إشعار القراءة',
          Ml: 'വായന സ്വീകാരം',
          Ma: 'वाचन पावती',
          Fr: 'Accusé de réception',
          Hi: 'रीड रसीद',
          Ta: 'வாசிப்பு உறுதி',
          Ja: '開封確認',
          Ge: 'Lesebestätigung'
        },
      },

      MessagesTable:{
        MT01: {
          En: {
            'Email' : 'Email',
            'Date Time' : 'Date Time',
            'Body' : 'Body',
            'Subject' : 'Subject'
          },
          Et: {
            'Email' : 'E-post',
            'Date Time' : 'Kuupäev ja kellaaeg',
            'Body' : 'Sisukiri',
            'Subject' : 'Teema'
          },
          Ar: {
            'Email' : 'البريد الإلكتروني',
            'Date Time' : 'التاريخ والوقت',
            'Body' : 'المحتوى',
            'Subject' : 'الموضوع'
          },
          Ml: {
            'Email' : 'ഇമെയിൽ',
            'Date Time' : 'ദിനവും സമയവും',
            'Body' : 'ശരീരം',
            'Subject' : 'വിഷയം'
          },
          Ma: {
            'Email' : 'इमेल',
            'Date Time' : 'दिनांक आणि वेळ',
            'Body' : 'शरीर',
            'Subject' : 'विषय'
          },
          Fr: {
            'Email' : 'Courriel',
            'Date Time' : 'Date et heure',
            'Body' : 'Corps',
            'Subject' : 'Objet'
          },
          Hi: {
            'Email' : 'ईमेल',
            'Date Time' : 'तारीख और समय',
            'Body' : 'शरीर',
            'Subject' : 'विषय'
          },
          Ta: {
            'Email' : 'மின்னஞ்சல்',
            'Date Time' : 'நாள் மற்றும் நேரம்',
            'Body' : 'உடல்',
            'Subject' : 'விஷயம்'
          },
          Ja: {
            'Email' : '電子メール',
            'Date Time' : '日時',
            'Body' : '本文',
            'Subject' : '件名'
          },
          Ge: {
            'Email' : 'E-Mail',
            'Date Time' : 'Datum und Uhrzeit',
            'Body' : 'Inhalt',
            'Subject' : 'Betreff'
          }
        },
        MT02: {
         En: 'Mark as Read', 
         Et: 'Märgi loetud',
         Ar: 'علامة كقراءة',
         Ml: 'വായിച്ചതായി അടയാളപ്പെടുത്തുക',
         Ma: 'वाचलेले म्हणून चिन्हांकित करा',
         Fr: 'Marquer comme lu',
         Hi: 'पढ़ा हुआ चिह्नित करें',
         Ta: 'படிக்கப்பட்டது எனக் குறிக்கவும்',
         Ja: '既読にする',
         Ge: 'Als gelesen markieren',
        }
      },

    OrdersModal:{
      OM01: {
        En: 'No Orders Assets Found',
        Et: 'Ei leitud ühtegi tellimust ega vara',
        Ar: 'لم يتم العثور على أي أوامر أو أصول',
        Ml: 'യാതൊരു ഓർഡറുകളും ആസ്തികളും കണ്ടെത്തിയില്ല',
        Ma: 'कोणतेही ऑर्डर किंवा संपत्ती सापडली नाही',
        Fr: 'Aucun ordre ou actif trouvé',
        Hi: 'कोई आदेश या संपत्ति नहीं मिली',
        Ta: 'எந்த ஆர்டர்கள் அல்லது சொத்துக்களும் காணப்படவில்லை',
        Ja: '注文または資産は見つかりませんでした',
        Ge: 'Keine Bestellungen oder Vermögenswerte gefunden'
      },
    },

    SectionsModal: {
      SM01: {
        En: 'Sections Single',
        Et: 'Üksikud lõigud',
        Ar: 'أقسام مفردة',
        Ml: 'ഒറ്റ സെക്ഷനുകൾ',
        Ma: 'एकल विभाग',
        Fr: 'Sections uniques',
        Hi: 'एकल खंड',
        Ta: 'தனிப் பிரிவுகள்',
        Ja: '単一のセクション',
        Ge: 'Einzelne Abschnitte'
      },
      SM02: {
        En: 'Sections Multiple',
        Et: 'Mitmikosad',
        Ar: 'أقسام متعددة',
        Ml: 'വിഭാഗങ്ങൾ ഒന്നിലധികം',
        Ma: 'विभाग बहुविध',
        Fr: 'Sections Multiples',
        Hi: 'खंड बहु',
        Ta: 'பிரிவுகள் பல',
        Ja: 'セクション複数',
        Ge: 'Mehrfache Abschnitte'
      },
    },

    RPModal: {
      RP01:{
        En: 'Clone', 
        Et: 'Kloon',
        Ar: 'نسخ',
        Ml: 'ക്ലോൺ',
        Ma: 'क्लोन',
        Fr: 'Clone',
        Hi: 'क्लोन',
        Ta: 'குளோன்',
        Ja: 'クローン',
        Ge: 'Klon',
      },
      RP02:{
        En: 'Add New', 
        Et: 'Lisa uus',
        Ar: 'إضافة جديد',
        Ml: 'പുതിയത് ചേർക്കുക',
        Ma: 'नवीन जोडा',
        Fr: 'Ajouter nouveau',
        Hi: 'नया जोड़ें',
        Ta: 'புதியதைச் சேர்க்கவும்',
        Ja: '新規追加',
        Ge: 'Neu hinzufügen',
      },
      RP03:{
        En: 'Create New', 
        Et: 'Loo uus',
        Ar: 'إنشاء جديد',
        Ml: 'പുതിയത് സൃഷ്ടിക്കുക',
        Ma: 'नवीन तयार करा',
        Fr: 'Créer nouveau',
        Hi: 'नया बनाएँ',
        Ta: 'புதியதை உருவாக்கவும்',
        Ja: '新規作成',
        Ge: 'Neu erstellen',
      },

    },

    ReportsPendingApprover: {},

    ReportsMonthTillDateReport: {},

    ReportsYearTillDateReport: {},

    ReportsFIAFReport: {},

    ReportsCustomizedReport: {},

    ReportsAuditTrail: {},

    UserViewUser: {
      UVUL01: {
        En: 'USER MANAGEMEnT',
        Et: 'KASUTAJA HALDAMINE',
        Ar: 'إدارةالمستخدم',
        Ml: 'ഉപയോക്താവ് മാനേജ്മെന്റ്',
        Ma: 'वापरकर्ता व्यवस्थापन',
        Fr: 'GESTION DES UTILISATEURS',
        Hi: 'उपयोगकर्ता प्रबंधन',
        Ta: 'பயனர் மேலாண்மை',
        Ja: 'ユーザー管理',
        Ge: 'Benutzerverwaltung',
      },
      UVUB01: {
        En: 'Create user',
        Et: 'Loo kasutaja',
        Ar: 'إنشاء مستخدم',
        Ml: 'ഉപയോക്താവിനെ സൃഷ്ടിക്കുക',
        Ma: 'वापरकर्ता तयार करा',
        Fr: 'Créer un utilisateur',
        Hi: 'उपयोगकर्ता बनाइये',
        Ta: 'பயனரை உருவாக்கவும்',
        Ja: 'ユーザーを作成',
        Ge: 'Benutzer erstellen',
      },
      UVUI01: {
        En: 'User Image',
        Et: 'Kasutaja pilt',
        Ar: 'صورة المستخدم',
        Ml: 'ഉപയോക്തൃ ചിത്രം',
        Ma: 'वापरकर्ता प्रतिमा',
        Fr: 'Image utilisateur',
        Hi: 'उपयोगकर्ता छवि',
        Ta: 'பயனர் படம்',
        Ja: 'ユーザー画像',
        Ge: 'Benutzerbild',
      },
      UVUL02: {
        En: 'Display name',
        Et: 'Kuvatav nimi',
        Ar: 'اسم العرض',
        Ml: 'പ്രദർശന നാമം',
        Ma: 'नाव प्रदर्शित करा',
        Fr: 'Afficher un nom',
        Hi: 'प्रदर्शित होने वाला नाम',
        Ta: 'காட்சி பெயர்',
        Ja: '表示名',
        Ge: 'Anzeigename',
      },
      UVUL03: {
        En: 'User name',
        Et: 'Kasutajanimi',
        Ar: 'اسم المستخدم',
        Ml: 'ഉപയോക്തൃ നാമം',
        Ma: 'वापरकर्ता नाव',
        Fr: "Nom d'utilisateur",
        Hi: 'उपयोगकर्ता नाम',
        Ta: 'பயனர் பெயர்',
        Ja: 'ユーザー名',
        Ge: 'Nutzername',
      },
      UVUB02: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      UVUB03: {
        En: 'Delete',
        Et: 'Kustuta',
        Ar: 'حذف',
        Ml: 'ഇല്ലാതാക്കുക',
        Ma: 'हटवा',
        Fr: 'Effacer',
        Hi: 'मिटाना',
        Ta: 'அழி',
        Ja: '消去',
        Ge: 'Löschen',
      },
      UVUS01:{
        En: 'displayname',
        Et: 'Ekraaninimi',
        Ar: 'اسم العرض',
        Ml: 'പ്രദർശന നാമം',
        Ma: 'प्रदर्शन नाव',
        Fr: 'Nom d`affichage',
        Hi: 'प्रदर्शन नाम',
        Ta: 'காட்சி பெயர்',
        Ja: '表示名',
        Ge: 'Anzeigename'
      },
      UVUS02:{
        En: 'email',
        Et: 'E-kiri',
        Ar: 'بريد إلكتروني',
        Ml: 'ഇമെയിൽ',
        Ma: 'ईमेल',
        Fr: 'courriel',
        Hi: 'ईमेल',
        Ta: 'மின்னஞ்சல்',
        Ja: 'メール',
        Ge: 'E-Mail'
      },
      UVUS03:{
        En: 'username',
        Et: 'Kasutajanimi',
        Ar: 'اسم المستخدم',
        Ml: 'ഉപയോക്തൃനാമം',
        Ma: 'वापरकर्तानाव',
        Fr: 'Nom d`utilisateur',
        Hi: 'उपयोगकर्ता नाम',
        Ta: 'பயனர் பெயர்',
        Ja: 'ユーザー名',
        Ge: 'Benutzername'
      }
    },

    UserViewUserEdit: {
      UVUEML01: {
        En: 'Edit',
        Et: 'Muuda',
        Ar: 'يحرر',
        Ml: 'എഡിറ്റ് ചെയ്യുക',
        Ma: 'सुधारणे',
        Fr: 'Éditer',
        Hi: 'संपादन करना',
        Ta: 'தொகு',
        Ja: '編集',
        Ge: 'Bearbeiten',
      },
      UVUEL01: {
        En: 'Display Name',
        Et: 'Kuvatav nimi',
        Ar: 'اسم العرض',
        Ml: 'പ്രദർശന നാമം',
        Ma: 'डिस्प्ले नाव',
        Fr: 'Afficher un nom',
        Hi: 'प्रदर्शित होने वाला नाम',
        Ta: 'காட்சி பெயர்',
        Ja: '表示名',
        Ge: 'Anzeigename',
      },
      UVUETB01: {
        En: 'Display Name',
        Et: 'Kuvatav nimi',
        Ar: 'اسم العرض',
        Ml: 'പ്രദർശന നാമം',
        Ma: 'डिस्प्ले नाव',
        Fr: 'Afficher un nom',
        Hi: 'प्रदर्शित होने वाला नाम',
        Ta: 'காட்சி பெயர்',
        Ja: '表示名',
        Ge: 'Anzeigename',
      },
      UVUEL02: {
        En: 'Username',
        Et: 'Kasutajanimi',
        Ar: 'اسم المستخدم',
        Ml: 'ഉപയോക്തൃനാമം',
        Ma: 'वापरकर्तानाव',
        Fr: "Nom d'utilisateur",
        Hi: 'उपयोगकर्ता नाम',
        Ta: 'பயனர் பெயர்',
        Ja: 'ユーザー名',
        Ge: 'Nutzername',
      },
      UVUETB02: {
        En: 'Username',
        Et: 'Kasutajanimi',
        Ar: 'اسم المستخدم',
        Ml: 'ഉപയോക്തൃനാമം',
        Ma: 'वापरकर्तानाव',
        Fr: "Nom d'utilisateur",
        Hi: 'उपयोगकर्ता नाम',
        Ta: 'பயனர் பெயர்',
        Ja: 'ユーザー名',
        Ge: 'Nutzername',
      },
      UVUEL03: {
        En: 'Department Name',
        Et: 'Osakonna nimi',
        Ar: 'اسم القسم',
        Ml: 'വകുപ്പിന്റെ പേര്',
        Ma: 'विभागाचे नाव',
        Fr: 'Nom du département',
        Hi: 'विभाग का नाम',
        Ta: 'துறை பெயர்',
        Ja: '部署名',
        Ge: 'Abteilungsname',
      },
      UVUETB03: {
        En: 'Department Name',
        Et: 'Osakonna nimi',
        Ar: 'اسم القسم',
        Ml: 'വകുപ്പിന്റെ പേര്',
        Ma: 'विभागाचे नाव',
        Fr: 'Nom du département',
        Hi: 'विभाग का नाम',
        Ta: 'துறை பெயர்',
        Ja: '部署名',
        Ge: 'Abteilungsname',
      },
      UVUEL04: {
        En: 'Customer Name',
        Et: 'Kliendi nimi',
        Ar: 'اسم الزبون',
        Ml: 'ഉപഭോക്താവിന്റെ പേര്',
        Ma: 'ग्राहकाचे नाव',
        Fr: 'Nom du client',
        Hi: 'ग्राहक का नाम',
        Ta: 'வாடிக்கையாளர் பெயர்',
        Ja: '顧客名',
        Ge: 'Kundenname',
      },
      UVUETB04: {
        En: 'Customer Name',
        Et: 'Kliendi nimi',
        Ar: 'اسم الزبون',
        Ml: 'ഉപഭോക്താവിന്റെ പേര്',
        Ma: 'ग्राहकाचे नाव',
        Fr: 'Nom du client',
        Hi: 'ग्राहक का नाम',
        Ta: 'வாடிக்கையாளர் பெயர்',
        Ja: '顧客名',
        Ge: 'Kundenname',
      },
      UVUEL05: {
        En: 'Address Line1',
        Et: 'Aadressi rida 1',
        Ar: 'العنوان الأول',
        Ml: 'വിലാസ ലൈൻ 1',
        Ma: 'पत्ता ओळ 1',
        Fr: 'Adresse 1',
        Hi: 'पता पंक्ति 1',
        Ta: 'முகவரி வரி 1',
        Ja: '住所1',
        Ge: 'Anschrift Zeile 1',
      },
      UVUETB05: {
        En: 'Address Line1',
        Et: 'Aadressi rida 1',
        Ar: 'العنوان الأول',
        Ml: 'വിലാസ ലൈൻ 1',
        Ma: 'पत्ता ओळ 1',
        Fr: 'Adresse 1',
        Hi: 'पता पंक्ति 1',
        Ta: 'முகவரி வரி 1',
        Ja: '住所1',
        Ge: 'Anschrift Zeile 1',
      },
      UVUEL06: {
        En: 'Address Line2',
        Et: 'Aadressi rida 2',
        Ar: 'سطر العنوان 2',
        Ml: 'വിലാസം വരി 2',
        Ma: 'पत्ता ओळ 2',
        Fr: 'Adresse Ligne 2',
        Hi: 'पता पंक्ति नं। 2',
        Ta: 'முகவரி வரி 2',
        Ja: '住所2',
        Ge: 'Adresszeile 2',
      },
      UVUETB06: {
        En: 'Address Line2',
        Et: 'Aadressi rida 2',
        Ar: 'سطر العنوان 2',
        Ml: 'വിലാസം വരി 2',
        Ma: 'पत्ता ओळ 2',
        Fr: 'Adresse Ligne 2',
        Hi: 'पता पंक्ति नं। 2',
        Ta: 'முகவரி வரி 2',
        Ja: '住所2',
        Ge: 'Adresszeile 2',
      },
      UVUEL07: {
        En: 'Phone Number',
        Et: 'Telefoninumber',
        Ar: 'رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ',
        Ma: 'फोन नंबर',
        Fr: 'Numéro de téléphone',
        Hi: 'फ़ोन नंबर',
        Ta: 'தொலைபேசி எண்',
        Ja: '電話番号',
        Ge: 'Telefonnummer',
      },
      UVUETB07: {
        En: 'Phone Number',
        Et: 'Telefoninumber',
        Ar: 'رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ',
        Ma: 'फोन नंबर',
        Fr: 'Numéro de téléphone',
        Hi: 'फ़ोन नंबर',
        Ta: 'தொலைபேசி எண்',
        Ja: '電話番号',
        Ge: 'Telefonnummer',
      },
      UVUEL08: {
        En: 'Alternate Phone Number',
        Et: 'Alternatiivne telefoninumber',
        Ar: 'رقم هاتف بديل',
        Ml: 'ഇതര ഫോൺ നമ്പർ',
        Ma: 'पर्यायी फोन नंबर',
        Fr: 'Autre numéro de téléphone',
        Hi: 'वैकल्पिक फ़ोन नंबर',
        Ta: 'மாற்று தொலைபேசி எண்',
        Ja: '代替電話番号',
        Ge: 'Alternative Telefonnummer',
      },
      UVUETB08: {
        En: 'Alternate Phone Number',
        Et: 'Alternatiivne telefoninumber',
        Ar: 'رقم هاتف بديل',
        Ml: 'ഇതര ഫോൺ നമ്പർ',
        Ma: 'पर्यायी फोन नंबर',
        Fr: 'Autre numéro de téléphone',
        Hi: 'वैकल्पिक फ़ोन नंबर',
        Ta: 'மாற்று தொலைபேசி எண்',
        Ja: '代替電話番号',
        Ge: 'Alternative Telefonnummer',
      },
      UVUEL09: {
        En: 'Role',
        Et: 'Roll',
        Ar: 'دور',
        Ml: 'പങ്ക്',
        Ma: 'भूमिका',
        Fr: 'Rôle',
        Hi: 'भूमिका',
        Ta: 'பங்கு',
        Ja: '役割',
        Ge: 'Rolle',
      },
      UVUEDD01: {
        En: 'Role',
        Et: 'Roll',
        Ar: 'دور',
        Ml: 'പങ്ക്',
        Ma: 'भूमिका',
        Fr: 'Rôle',
        Hi: 'भूमिका',
        Ta: 'பங்கு',
        Ja: '役割',
        Ge: 'Rolle',
      },
      UVUEB01: {
        En: 'Set Default Password',
        Et: 'Määra vaikeparool',
        Ar: 'تعيين كلمة المرور الافتراضية',
        Ml: 'സ്ഥിരസ്ഥിതി പാസ്‌വേഡ് സജ്ജമാക്കുക',
        Ma: 'डीफॉल्ट पासवर्ड सेट करा',
        Fr: 'Définir le mot de passe par défaut',
        Hi: 'डिफ़ॉल्ट पासवर्ड सेट करें',
        Ta: 'இயல்பு கடவுச்சொல்லை அமைக்கவும்',
        Ja: 'デフォルトのパスワードを設定',
        Ge: 'Standard-Passwort festlegen',
      },
      UVUEB02: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      UVUEB03: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      UVUEB04: {
        En: 'Submit',
        Et: 'Esita',
        Ar: 'يُقدِّم',
        Ml: 'സമർപ്പിക്കുക',
        Ma: 'प्रस्तुत करणे',
        Fr: 'Soumettre',
        Hi: 'प्रस्तुत करना',
        Ta: 'சமர்ப்பிக்கவும்',
        Ja: '送信',
        Ge: 'Einreichen',
      },
    },

    UserViewUserDelete: {
      UVUDL01: {
        En: 'Delete Confirmation',
        Et: 'Kustutamise kinnitus',
        Ar: 'تأكيد الحذف',
        Ml: 'സ്ഥിരീകരണം ഇല്ലാതാക്കുക',
        Ma: 'पुष्टीकरण हटवा',
        Fr: 'Supprimer la confirmation',
        Hi: 'पुष्टि हटाएं',
        Ta: 'உறுதிப்படுத்தலை நீக்கு',
        Ja: '削除の確認',
        Ge: 'Bestätigung löschen',
      },
      UVUDL02: {
        En: 'Are you sure, you want to delete this User',
        Et: 'Kas olete kindel, et soovite selle kasutaja kustutada',
        Ar: 'هل أنت متأكد أنك تريد حذف هذا المستخدم',
        Ml: 'നിങ്ങൾക്ക് ഉറപ്പാണോ, ഈ ഉപയോക്താവിനെ ഇല്ലാതാക്കണമെന്ന്',
        Ma: 'तुमची खात्री आहे, तुम्ही हा वापरकर्ता हटवू इच्छिता',
        Fr: 'Êtes-vous sûr de vouloir supprimer cet utilisateur',
        Hi: 'क्या आप सुनिश्चित हैं, आप इस उपयोगकर्ता को हटाना चाहते हैं',
        Ta: 'நிச்சயமாக, இந்தப் பயனரை நீக்க விரும்புகிறீர்களா',
        Ja: 'このユーザーを削除しますか?',
        Ge: 'Sind Sie sicher, dass Sie diesen Benutzer löschen möchten',
      },
      UVUDB01: {
        En: 'No',
        Et: 'Ei',
        Ar: 'رقم',
        Ml: 'ഇല്ല',
        Ma: 'नाही',
        Fr: 'Non',
        Hi: 'नहीं',
        Ta: 'இல்லை',
        Ja: 'いいえ',
        Ge: 'Nein',
      },
      UVUDB02: {
        En: 'Yes',
        Et: 'Jah',
        Ar: 'نعم',
        Ml: 'അതെ',
        Ma: 'होय',
        Fr: 'Oui',
        Hi: 'हाँ',
        Ta: 'ஆம்',
        Ja: 'はい',
        Ge: 'Ja',
      },
    },

    UserCreateUser: {
      UCUML01: {
        En: 'Create User',
        Et: 'Loo kasutaja',
        Ar: 'إنشاء مستخدم',
        Ml: 'ഉപയോക്താവിനെ സൃഷ്ടിക്കുക',
        Ma: 'वापरकर्ता तयार करा',
        Fr: 'Créer un utilisateur',
        Hi: 'उपयोगकर्ता बनाइये',
        Ta: 'பயனரை உருவாக்கவும்',
        Ja: 'ユーザーを作成',
        Ge: 'Benutzer erstellen',
      },
      UCUL01: {
        En: 'Display Name',
        Et: 'Kuvatav nimi',
        Ar: 'اسم العرض',
        Ml: 'പ്രദർശന നാമം',
        Ma: 'डिस्प्ले नाव',
        Fr: 'Afficher un nom',
        Hi: 'प्रदर्शित होने वाला नाम',
        Ta: 'காட்சி பெயர்',
        Ja: '表示名',
        Ge: 'Anzeigename',
      },
      UCUTB01: {
        En: 'Display Name',
        Et: 'Kuvatav nimi',
        Ar: 'اسم العرض',
        Ml: 'പ്രദർശന നാമം',
        Ma: 'डिस्प्ले नाव',
        Fr: 'Afficher un nom',
        Hi: 'प्रदर्शित होने वाला नाम',
        Ta: 'காட்சி பெயர்',
        Ja: '表示名',
        Ge: 'Anzeigename',
      },
      UCUL02: {
        En: 'Username',
        Et: 'Kasutajanimi',
        Ar: 'اسم المستخدم',
        Ml: 'ഉപയോക്തൃനാമം',
        Ma: 'वापरकर्तानाव',
        Fr: "Nom d'utilisateur",
        Hi: 'उपयोगकर्ता नाम',
        Ta: 'பயனர் பெயர்',
        Ja: 'ユーザー名',
        Ge: 'Nutzername',
      },
      UCUTB02: {
        En: 'Username',
        Et: 'Kasutajanimi',
        Ar: 'اسم المستخدم',
        Ml: 'ഉപയോക്തൃനാമം',
        Ma: 'वापरकर्तानाव',
        Fr: "Nom d'utilisateur",
        Hi: 'उपयोगकर्ता नाम',
        Ta: 'பயனர் பெயர்',
        Ja: 'ユーザー名',
        Ge: 'Nutzername',
      },
      UCUL03: {
        En: 'Email',
        Et: 'Meil',
        Ar: 'البريد الإلكتروني',
        Ml: 'ഇമെയിൽ',
        Ma: 'ईमेल',
        Fr: 'E-mail',
        Hi: 'ईमेल',
        Ta: 'மின்னஞ்சல்',
        Ja: 'Eメール',
        Ge: 'Email',
      },
      UCUTB03: {
        En: 'Email',
        Et: 'Meil',
        Ar: 'البريد الإلكتروني',
        Ml: 'ഇമെയിൽ',
        Ma: 'ईमेल',
        Fr: 'E-mail',
        Hi: 'ईमेल',
        Ta: 'மின்னஞ்சல்',
        Ja: 'Eメール',
        Ge: 'Email',
      },
      UCUL04: {
        En: 'Password',
        Et: 'Parool',
        Ar: 'كلمة المرور',
        Ml: 'Password',
        Ma: 'पासवर्ड',
        Fr: 'Mot de passe',
        Hi: 'पासवर्ड',
        Ta: 'கடவுச்சொல்',
        Ja: 'パスワード',
        Ge: 'Passwort',
      },
      UCUTB04: {
        En: 'Password',
        Et: 'Parool',
        Ar: 'كلمة المرور',
        Ml: 'Password',
        Ma: 'पासवर्ड',
        Fr: 'Mot de passe',
        Hi: 'पासवर्ड',
        Ta: 'கடவுச்சொல்',
        Ja: 'パスワード',
        Ge: 'Passwort',
      },
      UCUL05: {
        En: 'Department Name',
        Et: 'Osakonna nimi',
        Ar: 'اسم القسم',
        Ml: 'വകുപ്പിന്റെ പേര്',
        Ma: 'विभागाचे नाव',
        Fr: 'Nom du département',
        Hi: 'विभाग का नाम',
        Ta: 'துறை பெயர்',
        Ja: '部署名',
        Ge: 'Abteilungsname',
      },
      UCUTB05: {
        En: 'Department Name',
        Et: 'Osakonna nimi',
        Ar: 'اسم القسم',
        Ml: 'വകുപ്പിന്റെ പേര്',
        Ma: 'विभागाचे नाव',
        Fr: 'Nom du département',
        Hi: 'विभाग का नाम',
        Ta: 'துறை பெயர்',
        Ja: '部署名',
        Ge: 'Abteilungsname',
      },
      UCUL06: {
        En: 'Customer Name',
        Et: 'Kliendi nimi',
        Ar: 'اسم الزبون',
        Ml: 'ഉപഭോക്താവിന്റെ പേര്',
        Ma: 'ग्राहकाचे नाव',
        Fr: 'Nom du client',
        Hi: 'ग्राहक का नाम',
        Ta: 'வாடிக்கையாளர் பெயர்',
        Ja: '顧客名',
        Ge: 'Kundenname',
      },
      UCUTB06: {
        En: 'Customer Name',
        Et: 'Kliendi nimi',
        Ar: 'اسم الزبون',
        Ml: 'ഉപഭോക്താവിന്റെ പേര്',
        Ma: 'ग्राहकाचे नाव',
        Fr: 'Nom du client',
        Hi: 'ग्राहक का नाम',
        Ta: 'வாடிக்கையாளர் பெயர்',
        Ja: '顧客名',
        Ge: 'Kundenname',
      },

      UCUL07: {
        En: 'Address Line1',
        Et: 'Aadressi rida 1',
        Ar: 'العنوان الأول',
        Ml: 'വിലാസ ലൈൻ 1',
        Ma: 'पत्ता ओळ 1',
        Fr: 'Adresse 1',
        Hi: 'पता पंक्ति 1',
        Ta: 'முகவரி வரி 1',
        Ja: '住所1',
        Ge: 'Anschrift Zeile 1',
      },
      UCUTB07: {
        En: 'Address Line1',
        Et: 'Aadressi rida 1',
        Ar: 'العنوان الأول',
        Ml: 'വിലാസ ലൈൻ 1',
        Ma: 'पत्ता ओळ 1',
        Fr: 'Adresse 1',
        Hi: 'पता पंक्ति 1',
        Ta: 'முகவரி வரி 1',
        Ja: '住所1',
        Ge: 'Anschrift Zeile 1',
      },
      UCUL08: {
        En: 'Address Line2',
        Et: 'Aadressi rida 2',
        Ar: 'سطر العنوان 2',
        Ml: 'വിലാസം വരി 2',
        Ma: 'पत्ता ओळ 2',
        Fr: 'Adresse Ligne 2',
        Hi: 'पता पंक्ति नं। 2',
        Ta: 'முகவரி வரி 2',
        Ja: '住所2',
        Ge: 'Adresszeile 2',
      },
      UCUTB08: {
        En: 'Address Line2',
        Et: 'Aadressi rida 2',
        Ar: 'سطر العنوان 2',
        Ml: 'വിലാസം വരി 2',
        Ma: 'पत्ता ओळ 2',
        Fr: 'Adresse Ligne 2',
        Hi: 'पता पंक्ति नं। 2',
        Ta: 'முகவரி வரி 2',
        Ja: '住所2',
        Ge: 'Adresszeile 2',
      },
      UCUL09: {
        En: 'Phone Number',
        Et: 'Telefoninumber',
        Ar: 'رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ',
        Ma: 'फोन नंबर',
        Fr: 'Numéro de téléphone',
        Hi: 'फ़ोन नंबर',
        Ta: 'தொலைபேசி எண்',
        Ja: '電話番号',
        Ge: 'Telefonnummer',
      },
      UCUTB09: {
        En: 'Phone Number',
        Et: 'Telefoninumber',
        Ar: 'رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ',
        Ma: 'फोन नंबर',
        Fr: 'Numéro de téléphone',
        Hi: 'फ़ोन नंबर',
        Ta: 'தொலைபேசி எண்',
        Ja: '電話番号',
        Ge: 'Telefonnummer',
      },
      UCUL10: {
        En: 'Alternate Phone Number',
        Et: 'Alternatiivne telefoninumber',
        Ar: 'رقم هاتف بديل',
        Ml: 'ഇതര ഫോൺ നമ്പർ',
        Ma: 'पर्यायी फोन नंबर',
        Fr: 'Autre numéro de téléphone',
        Hi: 'वैकल्पिक फ़ोन नंबर',
        Ta: 'மாற்று தொலைபேசி எண்',
        Ja: '代替電話番号',
        Ge: 'Alternative Telefonnummer',
      },
      UCUTB10: {
        En: 'Alternate Phone Number',
        Et: 'Alternatiivne telefoninumber',
        Ar: 'رقم هاتف بديل',
        Ml: 'ഇതര ഫോൺ നമ്പർ',
        Ma: 'पर्यायी फोन नंबर',
        Fr: 'Autre numéro de téléphone',
        Hi: 'वैकल्पिक फ़ोन नंबर',
        Ta: 'மாற்று தொலைபேசி எண்',
        Ja: '代替電話番号',
        Ge: 'Alternative Telefonnummer',
      },
      UCUL11: {
        En: 'Role',
        Et: 'Roll',
        Ar: 'دور',
        Ml: 'പങ്ക്',
        Ma: 'भूमिका',
        Fr: 'Rôle',
        Hi: 'भूमिका',
        Ta: 'பங்கு',
        Ja: '役割',
        Ge: 'Rolle',
      },
      UCUDD01: {
        En: 'Role',
        Et: 'Roll',
        Ar: 'دور',
        Ml: 'പങ്ക്',
        Ma: 'भूमिका',
        Fr: 'Rôle',
        Hi: 'भूमिका',
        Ta: 'பங்கு',
        Ja: '役割',
        Ge: 'Rolle',
      },

      UCUB01: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      UCUB02: {
        En: 'Or',
        Et: 'Või',
        Ar: 'أو',
        Ml: 'അഥവാ',
        Ma: 'किंवा',
        Fr: 'Ou',
        Hi: 'या',
        Ta: 'அல்லது',
        Ja: 'または',
        Ge: 'Oder',
      },
      UCUB03: {
        En: 'Register',
        Et: 'Registreeri',
        Ar: 'يسجل',
        Ml: 'രജിസ്റ്റർ ചെയ്യുക',
        Ma: 'नोंदणी करा',
        Fr: "S'inscrire",
        Hi: 'पंजीकरण करवाना',
        Ta: 'பதிவு',
        Ja: '登録',
        Ge: 'Registrieren',
      },
    },

    UserBorrowerRegistration: {
      UBRL01: {
        En: 'Register Borrower',
        Et: 'Registreeri laenuvõtja',
        Ar: 'تسجيل المقترض',
        Ml: 'വായ്പക്കാരനെ രജിസ്റ്റർ ചെയ്യുക',
        Ma: 'कर्जदाराची नोंदणी करा',
        Fr: "Enregistrer l'emprunteur",
        Hi: 'उधारकर्ता पंजीकृत करें',
        Ta: 'பதிவு கடன் வாங்குபவர்',
        Ja: '借入人登録',
        Ge: 'Kreditnehmer registrieren',
      },
      UBRTB01: {
        En: 'Display Name',
        Et: 'Kuvatav nimi',
        Ar: 'اسم العرض',
        Ml: 'പ്രദർശന നാമം',
        Ma: 'डिस्प्ले नाव',
        Fr: 'Afficher un nom',
        Hi: 'प्रदर्शित होने वाला नाम',
        Ta: 'காட்சி பெயர்',
        Ja: '表示名',
        Ge: 'Anzeigename',
      },
      UBRTB02: {
        En: 'Username',
        Et: 'Kasutajanimi',
        Ar: 'اسم المستخدم',
        Ml: 'ഉപയോക്തൃനാമം',
        Ma: 'वापरकर्तानाव',
        Fr: "Nom d'utilisateur",
        Hi: 'उपयोगकर्ता नाम',
        Ta: 'பயனர் பெயர்',
        Ja: 'ユーザー名',
        Ge: 'Nutzername',
      },
      UBRTB03: {
        En: 'Email',
        Et: 'Meil',
        Ar: 'البريد الإلكتروني',
        Ml: 'ഇമെയിൽ',
        Ma: 'ईमेल',
        Fr: 'E-mail',
        Hi: 'ईमेल',
        Ta: 'மின்னஞ்சல்',
        Ja: 'Eメール',
        Ge: 'Email',
      },
      UBRTB04: {
        En: 'Password',
        Et: 'Parool',
        Ar: 'كلمة المرور',
        Ml: 'Password',
        Ma: 'पासवर्ड',
        Fr: 'Mot de passe',
        Hi: 'पासवर्ड',
        Ta: 'கடவுச்சொல்',
        Ja: 'パスワード',
        Ge: 'Passwort',
      },
      UBRTB05: {
        En: 'Customer Name',
        Et: 'Kliendi nimi',
        Ar: 'اسم الزبون',
        Ml: 'ഉപഭോക്താവിന്റെ പേര്',
        Ma: 'ग्राहकाचे नाव',
        Fr: 'Nom du client',
        Hi: 'ग्राहक का नाम',
        Ta: 'வாடிக்கையாளர் பெயர்',
        Ja: '顧客名',
        Ge: 'Kundenname',
      },
      UBRTB06: {
        En: 'Company Name',
        Et: 'Ettevõtte nimi',
        Ar: 'اسم الشركة',
        Ml: 'കമ്പനി പേര്',
        Ma: 'कंपनीचे नाव',
        Fr: "Nom de l'entreprise",
        Hi: 'कंपनी का नाम',
        Ta: 'நிறுவனத்தின் பெயர்',
        Ja: '会社名',
        Ge: 'Name der Firma',
      },
      UBRTB07: {
        En: 'Address',
        Et: 'Aadress',
        Ar: 'تبوك',
        Ml: 'വിലാസം',
        Ma: 'पत्ता',
        Fr: 'Adresse',
        Hi: 'पता',
        Ta: 'முகவரி',
        Ja: '住所',
        Ge: 'Adresse',
      },
      UBRTB08: {
        En: 'Address Line 2',
        Et: 'aadressi rida 2',
        Ar: 'سطر العنوان 2',
        Ml: 'വിലാസം വരി 2',
        Ma: 'पत्ता ओळ 2',
        Fr: 'Adresse Ligne 2',
        Hi: 'पता पंक्ति नं। 2',
        Ta: 'முகவரி வரி 2',
        Ja: '住所2',
        Ge: 'Adresszeile 2',
      },
      UBRDD01: {
        En: 'Country',
        Et: 'Riik',
        Ar: 'دولة',
        Ml: 'രാജ്യം',
        Ma: 'देश',
        Fr: 'Pays',
        Hi: 'देश',
        Ta: 'நாடு',
        Ja: '国',
        Ge: 'Land',
      },
      UBRDD02: {
        En: 'State',
        Et: 'osariik',
        Ar: 'حالة',
        Ml: 'സംസ്ഥാനം',
        Ma: 'राज्य',
        Fr: 'État',
        Hi: 'राज्य',
        Ta: 'நிலை',
        Ja: '州',
        Ge: 'Bundesland',
      },
      UBRDD03: {
        En: 'City',
        Et: 'Linn',
        Ar: 'مدينة',
        Ml: 'നഗരം',
        Ma: 'शहर',
        Fr: 'Ville',
        Hi: 'शहर',
        Ta: 'நகரம்',
        Ja: '街',
        Ge: 'Stadt',
      },
      UBRTB09: {
        En: 'Postal Code',
        Et: 'Postiindeks',
        Ar: 'رمز بريدي',
        Ml: 'തപാൽ കോഡ്',
        Ma: 'पिनकोड',
        Fr: 'code postal',
        Hi: 'डाक कोड',
        Ta: 'குறியீடு',
        Ja: '郵便番号',
        Ge: 'Postleitzahl',
      },
      UBRTB10: {
        En: 'Phone Number',
        Et: 'Telefoninumber',
        Ar: 'رقم الهاتف',
        Ml: 'ഫോൺ നമ്പർ',
        Ma: 'फोन नंबर',
        Fr: 'Numéro de téléphone',
        Hi: 'फ़ोन नंबर',
        Ta: 'தொலைபேசி எண்',
        Ja: '電話番号',
        Ge: 'Telefonnummer',
      },
      UBRTB11: {
        En: 'Alternate Phone Number',
        Et: 'Alternatiivne telefoninumber',
        Ar: 'رقم هاتف بديل',
        Ml: 'ഇതര ഫോൺ നമ്പർ',
        Ma: 'पर्यायी फोन नंबर',
        Fr: 'Autre numéro de téléphone',
        Hi: 'वैकल्पिक फ़ोन नंबर',
        Ta: 'மாற்று தொலைபேசி எண்',
        Ja: '代替電話番号',
        Ge: 'Alternative Telefonnummer',
      },
      UBRTB12: {
        En: 'Remarks',
        Et: 'Märkused',
        Ar: 'ملاحظات',
        Ml: 'പരാമർശത്തെ',
        Ma: 'शेरा',
        Fr: 'Remarques',
        Hi: 'टिप्पणियां',
        Ta: 'கருத்துக்கள்',
        Ja: '備考',
        Ge: 'Bemerkungen',
      },
      UBRB01: {
        En: 'Register',
        Et: 'Registreeri',
        Ar: 'يسجل',
        Ml: 'രജിസ്റ്റർ ചെയ്യുക',
        Ma: 'नोंदणी करा',
        Fr: "S'inscrire",
        Hi: 'पंजीकरण करवाना',
        Ta: 'பதிவு',
        Ja: '登録',
        Ge: 'Registrieren',
      },
    },

    Messages: {
      SL01: {
        En: 'MESSAGES',
        Et: 'SÕNUMID',
        Ar: 'رسائل',
        Ml: 'സന്ദേശങ്ങൾ',
        Ma: 'संदेश',
        Fr: 'MESSAGES',
        Hi: 'संदेशों',
        Ta: 'செய்திகள்',
        Ja: 'メッセージ',
        Ge: 'MITTEILUNGEN',
      },
      SB01: {
        En: 'Alerts',
        Et: 'Märguanded',
        Ar: 'تنبيهات',
        Ml: 'അലേർട്ടുകൾ',
        Ma: 'इशारे',
        Fr: 'Alertes',
        Hi: 'अलर्ट',
        Ta: 'எச்சரிக்கைகள்',
        Ja: 'アラート',
        Ge: 'Warnungen',
      },
      SB02: {
        En: 'Messages',
        Et: 'Sõnumid',
        Ar: 'رسائل',
        Ml: 'സന്ദേശങ്ങൾ',
        Ma: 'संदेश',
        Fr: 'messages',
        Hi: 'संदेशों',
        Ta: 'செய்திகள்',
        Ja: 'メッセージ',
        Ge: 'Mitteilungen',
      },
      SB03: {
        En: 'Updates',
        Et: 'Värskendused',
        Ar: 'التحديثات',
        Ml: 'അപ്ഡേറ്റുകൾ',
        Ma: 'अपडेट्स',
        Fr: 'Mises à jour',
        Hi: 'अपडेट',
        Ta: 'புதுப்பிப்புகள்',
        Ja: 'アップデート',
        Ge: 'Aktualisierung',
      },
    },

    MessagesAlerts: {
      MATL01: {
        En: 'View Alerts',
        Et: 'Kuva märguanded',
        Ar: 'عرض التنبيهات',
        Ml: 'അലേർട്ടുകൾ കാണുക',
        Ma: 'सूचना पहा',
        Fr: 'Afficher les alertes',
        Hi: 'अलर्ट देखें',
        Ta: 'விழிப்பூட்டல்களைப் பார்க்கவும்',
        Ja: 'アラートを表示',
        Ge: 'Warnungen anzeigen',
      },
      MATH01: {
        En: 'Title',
        Et: 'Pealkiri',
        Ar: 'عنوان',
        Ml: 'തലക്കെട്ട്',
        Ma: 'शीर्षक',
        Fr: 'Titre',
        Hi: 'शीर्षक',
        Ta: 'தலைப்பு',
        Ja: '題名',
        Ge: 'Titel',
      },
      SATH02: {
        En: 'Date/Time',
        Et: 'Kuupäev Kellaaeg',
        Ar: 'التاريخ / الوقت',
        Ml: 'തീയതി സമയം',
        Ma: 'तारीख वेळ',
        Fr: 'Date/Heure',
        Hi: 'दिनांक समय',
        Ta: 'தேதி நேரம்',
        Ja: '日付時刻',
        Ge: 'Terminzeit',
      },
      SATH03: {
        En: 'Task',
        Et: 'Ülesanne',
        Ar: 'مهمة',
        Ml: 'ടാസ്ക്',
        Ma: 'कार्य',
        Fr: 'Tâche',
        Hi: 'काम',
        Ta: 'பணி',
        Ja: '仕事',
        Ge: 'Aufgabe',
      },
      SATH04: {
        En: 'Sub Task',
        Et: 'Alamülesanne',
        Ar: 'مهمة فرعية',
        Ml: 'ഉപ ടാസ്ക്',
        Ma: 'उप कार्य',
        Fr: 'Sous-tâche',
        Hi: 'उप कार्य',
        Ta: 'துணை பணி',
        Ja: 'サブタスク',
        Ge: 'Unteraufgabe',
      },
      SATH05: {
        En: 'Messages',
        Et: 'Sõnumid',
        Ar: 'رسائل',
        Ml: 'സന്ദേശങ്ങൾ',
        Ma: 'संदेश',
        Fr: 'messages',
        Hi: 'संदेशों',
        Ta: 'செய்திகள்',
        Ja: 'メッセージ',
        Ge: 'Mitteilungen',
      },
      SATH06: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      SATH07: {
        En: 'View Resolved',
        Et: 'Vaade Lahendatud',
        Ar: 'مشاهدة ملف Resolved',
        Ml: 'പരിഹരിച്ചു കാണുക',
        Ma: 'निराकरण केलेले पहा',
        Fr: 'Voir Résolu',
        Hi: 'हल देखें',
        Ta: 'காண்க தீர்க்கப்பட்டது',
        Ja: '解決済みを表示',
        Ge: 'Gelöst anzeigen',
      },
      SAB01: {
        En: 'Thumps up',
        Et: 'Pöidlad üles',
        Ar: 'ممتاز',
        Ml: 'വിജയചിഹ്നം',
        Ma: 'उत्तम',
        Fr: 'Pouces vers le haut',
        Hi: 'थम्स अप',
        Ta: 'தம்ஸ் அப்',
        Ja: 'いいぞ',
        Ge: 'Daumen hoch',
      },
      SAB02: {
        En: 'Alert',
        Et: 'Hoiatus',
        Ar: 'انذار',
        Ml: 'മുന്നറിയിപ്പ്',
        Ma: 'अलर्ट',
        Fr: 'Alerte',
        Hi: 'चेतावनी',
        Ta: 'எச்சரிக்கை',
        Ja: 'アラート',
        Ge: 'Alarm',
      },
      SAB03: {
        En: 'Read',
        Et: 'Loen',
        Ar: 'أقرأ',
        Ml: 'വായിക്കുക',
        Ma: 'वाचणे',
        Fr: 'Lire',
        Hi: 'पढ़ना',
        Ta: 'படிக்க',
        Ja: '読む',
        Ge: 'Lesen',
      },
      SAB04: {
        En: 'Unread',
        Et: 'Lugemata',
        Ar: 'غير مقروء',
        Ml: 'വായിക്കാത്ത',
        Ma: 'वाचलेला नाही',
        Fr: 'Non lu',
        Hi: 'अनपढ़',
        Ta: 'படிக்காத',
        Ja: '読まない',
        Ge: 'Ungelesen'
      },

    },

    SettingsAlerts: {
      SATH01: {
        En: 'Title',
        Et: 'Pealkiri',
        Ar: 'عنوان',
        Ml: 'തലക്കെട്ട്',
        Ma: 'शीर्षक',
        Fr: 'Titre',
        Hi: 'शीर्षक',
        Ta: 'தலைப்பு',
        Ja: '題名',
        Ge: 'Titel',
      },
      SATH02: {
        En: 'Date/Time',
        Et: 'Kuupäev Kellaaeg',
        Ar: 'التاريخ / الوقت',
        Ml: 'തീയതി സമയം',
        Ma: 'तारीख वेळ',
        Fr: 'Date/Heure',
        Hi: 'दिनांक समय',
        Ta: 'தேதி நேரம்',
        Ja: '日付時刻',
        Ge: 'Terminzeit',
      },
      SATH03: {
        En: 'Task',
        Et: 'Ülesanne',
        Ar: 'مهمة',
        Ml: 'ടാസ്ക്',
        Ma: 'कार्य',
        Fr: 'Tâche',
        Hi: 'काम',
        Ta: 'பணி',
        Ja: '仕事',
        Ge: 'Aufgabe',
      },
      SATH04: {
        En: 'Sub Task',
        Et: 'Alamülesanne',
        Ar: 'مهمة فرعية',
        Ml: 'ഉപ ടാസ്ക്',
        Ma: 'उप कार्य',
        Fr: 'Sous-tâche',
        Hi: 'उप कार्य',
        Ta: 'துணை பணி',
        Ja: 'サブタスク',
        Ge: 'Unteraufgabe',
      },
      SATH05: {
        En: 'Messages',
        Et: 'Sõnumid',
        Ar: 'رسائل',
        Ml: 'സന്ദേശങ്ങൾ',
        Ma: 'संदेश',
        Fr: 'messages',
        Hi: 'संदेशों',
        Ta: 'செய்திகள்',
        Ja: 'メッセージ',
        Ge: 'Mitteilungen',
      },
      SATH06: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      SATH07: {
        En: 'View Resolved',
        Et: 'Vaade Lahendatud',
        Ar: 'مشاهدة ملف Resolved',
        Ml: 'പരിഹരിച്ചു കാണുക',
        Ma: 'निराकरण केलेले पहा',
        Fr: 'Voir Résolu',
        Hi: 'हल देखें',
        Ta: 'காண்க தீர்க்கப்பட்டது',
        Ja: '解決済みを表示',
        Ge: 'Gelöst anzeigen',
      },
      SAB01: {
        En: 'Thumps up',
        Et: 'Pöidlad üles',
        Ar: 'ممتاز',
        Ml: 'വിജയചിഹ്നം',
        Ma: 'उत्तम',
        Fr: 'Pouces vers le haut',
        Hi: 'थम्स अप',
        Ta: 'தம்ஸ் அப்',
        Ja: 'いいぞ',
        Ge: 'Daumen hoch',
      },
      SAB02: {
        En: 'Alert',
        Et: 'Hoiatus',
        Ar: 'انذار',
        Ml: 'മുന്നറിയിപ്പ്',
        Ma: 'अलर्ट',
        Fr: 'Alerte',
        Hi: 'चेतावनी',
        Ta: 'எச்சரிக்கை',
        Ja: 'アラート',
        Ge: 'Alarm',
      },
    },

    SettingsMessages: {
      SMTH01: {
        En: 'To',
        Et: 'To',
        Ar: 'إلى',
        Ml: 'ലേക്ക്',
        Ma: 'ला',
        Fr: 'À',
        Hi: 'प्रति',
        Ta: 'செய்ய',
        Ja: 'に',
        Ge: 'Zu',
      },
      SMTH02: {
        En: 'Date/Time',
        Et: 'Kuupäev Kellaaeg',
        Ar: 'التاريخ / الوقت',
        Ml: 'തീയതി സമയം',
        Ma: 'तारीख वेळ',
        Fr: 'Date/Heure',
        Hi: 'दिनांक समय',
        Ta: 'தேதி நேரம்',
        Ja: '日付時刻',
        Ge: 'Terminzeit',
      },
      SMTH03: {
        En: 'Messages',
        Et: 'Sõnumid',
        Ar: 'رسائل',
        Ml: 'സന്ദേശങ്ങൾ',
        Ma: 'संदेश',
        Fr: 'messages',
        Hi: 'संदेशों',
        Ta: 'செய்திகள்',
        Ja: 'メッセージ',
        Ge: 'Mitteilungen',
      },
      SMTH04: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      SMTH05: {
        En: 'Read Receipt',
        Et: 'Lugege kviitungit',
        Ar: 'اشعار قراءة',
        Ml: 'രസീത് വായിക്കുക',
        Ma: 'पावती वाचा',
        Fr: 'Lire reçu',
        Hi: 'रसीद पढ़ें',
        Ta: 'ரசீதைப் படிக்கவும்',
        Ja: '領収書を読む',
        Ge: 'Quittung lesen',
      },
    },

    SettingsUpdates: {
      SMTH01: {
        En: 'To',
        Et: 'To',
        Ar: 'إلى',
        Ml: 'ലേക്ക്',
        Ma: 'ला',
        Fr: 'À',
        Hi: 'प्रति',
        Ta: 'செய்ய',
        Ja: 'に',
        Ge: 'Zu',
      },
      SMTH02: {
        En: 'Date/Time',
        Et: 'Kuupäev Kellaaeg',
        Ar: 'التاريخ / الوقت',
        Ml: 'തീയതി സമയം',
        Ma: 'तारीख वेळ',
        Fr: 'Date/Heure',
        Hi: 'दिनांक समय',
        Ta: 'தேதி நேரம்',
        Ja: '日付時刻',
        Ge: 'Terminzeit',
      },
      SMTH03: {
        En: 'Updates',
        Et: 'Värskendused',
        Ar: 'التحديثات',
        Ml: 'അപ്ഡേറ്റുകൾ',
        Ma: 'अपडेट्स',
        Fr: 'Mises à jour',
        Hi: 'अपडेट',
        Ta: 'புதுப்பிப்புகள்',
        Ja: 'アップデート',
        Ge: 'Aktualisierung',
      },
      SMTH04: {
        En: 'Status',
        Et: 'Olek',
        Ar: 'حالة',
        Ml: 'പദവി',
        Ma: 'स्थिती',
        Fr: 'Statut',
        Hi: 'दर्जा',
        Ta: 'நிலை',
        Ja: '状態',
        Ge: 'Status',
      },
      SMTH05: {
        En: 'Read Receipt',
        Et: 'Lugege kviitungit',
        Ar: 'اشعار قراءة',
        Ml: 'രസീത് വായിക്കുക',
        Ma: 'पावती वाचा',
        Fr: 'Lire reçu',
        Hi: 'रसीद पढ़ें',
        Ta: 'ரசீதைப் படிக்கவும்',
        Ja: '領収書を読む',
        Ge: 'Quittung lesen',
      },
    },

    SettingsROLESANDPERMISSIONS: {
      SRPL01: {
        En: 'ROLES AND PERMISSIONS',
        Et: 'ROLLID JA LOAD',
        Ar: 'الأدوار والأذونات',
        Ml: 'റോളുകളും അനുമതികളും',
        Ma: 'भूमिका आणि परवानग्या',
        Fr: 'RÔLES ET PERMISSIONS',
        Hi: 'भूमिकाएं और अनुमतियां',
        Ta: 'பாத்திரங்கள் மற்றும் அனுமதிகள்',
        Ja: '役割と権限',
        Ge: 'ROLLEN UND BERECHTIGUNGEN',
      },
      SRPL02: {
        En: 'Roles and Permissions',
        Et: 'Rollid ja load',
        Ar: 'الأدوار والتصاريح',
        Ml: 'റോളുകളും അനുമതികളും',
        Ma: 'भूमिका आणि परवानग्या',
        Fr: 'Rôles et autorisations',
        Hi: 'भूमिकाएं और अनुमतियां',
        Ta: 'பாத்திரங்கள் மற்றும் அனுமதிகள்',
        Ja: '役割と権限',
        Ge: 'Rollen und Berechtigungen',
      },
      SRPB01: {
        En: 'Basic User',
        Et: 'Põhikasutaja',
        Ar: 'مستخدم أساسي',
        Ml: 'അടിസ്ഥാന ഉപയോക്താവ്',
        Ma: 'मूलभूत वापरकर्ता',
        Fr: 'Utilisateur de base',
        Hi: 'सामान्य उपयोगकर्ता',
        Ta: 'அடிப்படை பயனர்',
        Ja: '基本的なユーザー',
        Ge: 'Einfacher Benutzer',
      },
      SRPB02: {
        En: 'User',
        Et: 'Kasutaja',
        Ar: 'المستعمل',
        Ml: 'ഉപയോക്താവ്',
        Ma: 'वापरकर्ता',
        Fr: 'Utilisateur',
        Hi: 'उपयोगकर्ता',
        Ta: 'பயனர்',
        Ja: 'ユーザー',
        Ge: 'Benutzer',
      },
      SRPB03: {
        En: 'Medium User',
        Et: 'Keskmine kasutaja',
        Ar: 'مستخدم متوسط',
        Ml: 'ഇടത്തരം ഉപയോക്താവ്',
        Ma: 'मध्यम वापरकर्ता',
        Fr: 'Utilisateur moyen',
        Hi: 'मध्यम उपयोगकर्ता',
        Ta: 'நடுத்தர பயனர்',
        Ja: 'ミディアムユーザー',
        Ge: 'Mittlerer Benutzer',
      },
      SRPB04: {
        En: 'Super User',
        Et: 'Superkasutaja',
        Ar: 'مستخدم ممتاز',
        Ml: 'സൂപ്പർ യൂസർ',
        Ma: 'सुपर वापरकर्ता',
        Fr: 'Super utilisateur',
        Hi: 'सुपर उपयोगकर्ता',
        Ta: 'சூப்பர் யூசர்',
        Ja: 'スーパーユーザー',
        Ge: 'Super-Benutzer',
      },
      SRPB05: {
        En: 'Intermediate User',
        Et: 'Vahekasutaja',
        Ar: 'المستخدم المتوسط',
        Ml: 'ഇന്റർമീഡിയറ്റ് ഉപയോക്താവ്',
        Ma: 'मध्यवर्ती वापरकर्ता',
        Fr: 'Utilisateur intermédiaire',
        Hi: 'मध्यवर्ती उपयोगकर्ता',
        Ta: 'இடைநிலை பயனர்',
        Ja: '中級ユーザー',
        Ge: 'Fortgeschrittener Benutzer',
      },
      SRPB06: {
        En: 'Admin',
        Et: 'Admin',
        Ar: 'مسؤل',
        Ml: 'അഡ്മിൻ',
        Ma: 'अॅडमिन',
        Fr: 'Administrateur',
        Hi: 'व्यवस्थापक',
        Ta: 'நிர்வாகம்',
        Ja: '管理者',
        Ge: 'Administrator',
      },
      SRPB07: {
        En: 'Super Admin',
        Et: 'Superadministraator',
        Ar: 'مشرف فائق',
        Ml: 'സൂപ്പർ അഡ്മിൻ',
        Ma: 'सुपर अॅडमिन',
        Fr: 'Super administrateur',
        Hi: 'सुपर एडमिन',
        Ta: 'சூப்பர் அட்மின்',
        Ja: 'スーパー管理者',
        Ge: 'höchster Vorgesetzter',
      },
      SRPB08: {
        En: 'Archivist',
        Et: 'Arhivaar',
        Ar: 'أرشيفية',
        Ml: 'ആർക്കൈവിസ്റ്റ്',
        Ma: 'आर्किव्हिस्ट',
        Fr: 'Archiviste',
        Hi: 'पुरालेखपाल',
        Ta: 'காப்பாளர்',
        Ja: 'アーキビスト',
        Ge: 'Archivar',
      },
      SRPB09: {
        En: 'Junior Archivist',
        Et: 'Nooremarhivaar',
        Ar: 'أرشيفي مبتدئ',
        Ml: 'ജൂനിയർ ആർക്കൈവിസ്റ്റ്',
        Ma: 'कनिष्ठ आर्किव्हिस्ट',
        Fr: 'Archiviste junior',
        Hi: 'कनिष्ठ पुरालेखपाल',
        Ta: 'ஜூனியர் காப்பாளர்',
        Ja: 'ジュニアアーキビスト',
        Ge: 'Junior-Archivar',
      },
      SRPB10: {
        En: 'Manager',
        Et: 'Juht',
        Ar: 'مدير',
        Ml: 'മാനേജർ',
        Ma: 'व्यवस्थापक',
        Fr: 'Gestionnaire',
        Hi: 'प्रबंधक',
        Ta: 'மேலாளர்',
        Ja: 'マネジャー',
        Ge: 'Manager',
      },
      SRPB11: {
        En: 'Project Manager',
        Et: 'Projektijuht',
        Ar: 'مدير المشروع',
        Ml: 'പ്രോജക്റ്റ് മാനേജർ',
        Ma: 'प्रकल्प व्यवस्थापक',
        Fr: 'Chef de projet',
        Hi: 'प्रोजेक्ट मैनेजर',
        Ta: 'திட்ட மேலாளர்',
        Ja: 'プロジェクトマネージャ',
        Ge: 'Projektmanager',
      },
      SRPB12: {
        En: 'Editor',
        Et: 'Toimetaja',
        Ar: 'محرر',
        Ml: 'എഡിറ്റർ',
        Ma: 'संपादक',
        Fr: 'Éditeur',
        Hi: 'संपादक',
        Ta: 'ஆசிரியர்',
        Ja: '編集者',
        Ge: 'Editor',
      },
      SRPB13: {
        En: 'Picker',
        Et: 'Valija',
        Ar: 'منقار',
        Ml: 'പിക്കർ',
        Ma: 'पिकर',
        Fr: 'Cueilleur',
        Hi: 'कुदाल',
        Ta: 'பிக்கர்',
        Ja: 'ピッカー',
        Ge: 'Pflücker',
      },
      SRPB14: {
        En: 'New Role',
        Et: 'Uus roll',
        Ar: 'دور جديد',
        Ml: 'പുതിയ റോൾ',
        Ma: 'नवीन भूमिका',
        Fr: 'Nouveau rôle',
        Hi: 'नयी भूमिका',
        Ta: 'புதிய பாத்திரம்',
        Ja: '新しい役割',
        Ge: 'Neue Rolle',
      },
      SRPB15: {
        En: 'Plus',
        Et: 'Pluss',
        Ar: 'زائد',
        Ml: 'പ്ലസ്',
        Ma: 'प्लस',
        Fr: 'Plus',
        Hi: 'प्लस',
        Ta: 'மேலும்',
        Ja: 'プラス',
        Ge: 'Plus',
      },
      SRPB16: {
        En: 'Clone',
        Et: 'Klooni',
        Ar: 'استنساخ',
        Ml: 'ക്ലോൺ',
        Ma: 'क्लोन',
        Fr: 'Cloner',
        Hi: 'क्लोन',
        Ta: 'குளோன்',
        Ja: 'クローン',
        Ge: 'Klon',
      },
      SRPB17: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
      SRPL03: {
        En: 'PAGES',
        Et: 'LEHEKÜLGID',
        Ar: 'الصفحات',
        Ml: 'പേജുകൾ',
        Ma: 'पृष्ठे',
        Fr: 'PAGES',
        Hi: 'पृष्ठों',
        Ta: 'பக்கங்கள்',
        Ja: 'ページ',
        Ge: 'SEITEN',
      },
      SRPCL01: {
        En: 'Pages customization',
        Et: 'Lehtede kohandamine',
        Ar: 'تخصيص الصفحات',
        Ml: 'പേജുകൾ ഇഷ്‌ടാനുസൃതമാക്കൽ',
        Ma: 'पृष्ठे सानुकूलन',
        Fr: 'Personnalisation des pages',
        Hi: 'पृष्ठ अनुकूलन',
        Ta: 'பக்கங்களின் தனிப்பயனாக்கம்',
        Ja: 'ページのカスタマイズ',
        Ge: 'Seitenanpassung',
      },
      SRPL04: {
        En: 'COMPONEnTS',
        Et: 'KOMPONENDID',
        Ar: 'عناصر',
        Ml: 'ഘടകങ്ങൾ',
        Ma: 'घटक',
        Fr: 'Composants',
        Hi: 'अवयव',
        Ta: 'கூறுகள்',
        Ja: 'コンポーネント',
        Ge: 'KOMPONENTEN',
      },
      SRPCL02: {
        En: 'Components customization',
        Et: 'Komponentide kohandamine',
        Ar: 'تخصيص المكونات',
        Ml: 'ഘടകങ്ങൾ ഇഷ്ടാനുസൃതമാക്കൽ',
        Ma: 'घटक सानुकूलन',
        Fr: 'Personnalisation des composants',
        Hi: 'घटक अनुकूलन',
        Ta: 'கூறுகள் தனிப்பயனாக்கம்',
        Ja: 'コンポーネントのカスタマイズ',
        Ge: 'Anpassung der Komponenten',
      },
      SRPL05: {
        En: 'FEATURES',
        Et: 'FUNKTSIOONID',
        Ar: 'الميزات',
        Ml: 'ഫീച്ചറുകൾ',
        Ma: 'वैशिष्ट्ये',
        Fr: 'CARACTÉRISTIQUES',
        Hi: 'विशेषताएँ',
        Ta: 'அம்சங்கள்',
        Ja: '特徴',
        Ge: 'MERKMALE',
      },
      SRPCL03: {
        En: 'FEATURES customization',
        Et: 'FUNKTSIOONIDE kohandamine',
        Ar: 'ميزات التخصيص',
        Ml: 'സവിശേഷതകൾ ഇഷ്‌ടാനുസൃതമാക്കൽ',
        Ma: 'फीचर्स कस्टमायझेशन',
        Fr: 'personnalisation des CARACTÉRISTIQUES',
        Hi: 'विशेषताएं अनुकूलन',
        Ta: 'அம்சங்கள் தனிப்பயனாக்கம்',
        Ja: '機能のカスタマイズ',
        Ge: 'EIGENSCHAFTEN Anpassung',
      },
    },

    SettingsCOMMUNICATION: {
      SCL01: {
        En: 'COMMUNICATION SETTING',
        Et: 'SIDE SEADISTUS',
        Ar: 'إعداد الاتصال',
        Ml: 'ആശയവിനിമയ ക്രമീകരണം',
        Ma: 'संप्रेषण सेटिंग',
        Fr: 'RÉGLAGE DES COMMUNICATIONS',
        Hi: 'संचार सेटिंग',
        Ta: 'தொடர்பு அமைப்பு',
        Ja: '通信設定',
        Ge: 'KOMMUNIKATIONSEINSTELLUNG',
      },
      SCDD01: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      SCDD02: {
        En: 'Milestone',
        Et: 'Verstapost',
        Ar: 'معلما',
        Ml: 'നാഴികക്കല്ല്',
        Ma: 'मैलाचा दगड',
        Fr: 'Jalon',
        Hi: 'मील का पत्थर',
        Ta: 'மைல்கல்',
        Ja: 'マイルストーン',
        Ge: 'Meilenstein',
      },
      SCDD03: {
        En: 'Task',
        Et: 'Ülesanne',
        Ar: 'مهمة',
        Ml: 'ടാസ്ക്',
        Ma: 'कार्य',
        Fr: 'Tâche',
        Hi: 'काम',
        Ta: 'பணி',
        Ja: '仕事',
        Ge: 'Aufgabe',
      },
      SCDD04: {
        En: 'Subtask',
        Et: 'Alamülesanne',
        Ar: 'المهمة الفرعية',
        Ml: 'ഉപടാസ്ക്',
        Ma: 'उपकार्य',
        Fr: 'Sous-tâche',
        Hi: 'उपकार्य',
        Ta: 'துணைப் பணி',
        Ja: 'サブタスク',
        Ge: 'Teilaufgabe',
      },
      SCB01: {
        En: 'Subtask List',
        Et: 'Alamülesannete loend',
        Ar: 'قائمة المهام الفرعية',
        Ml: 'ഉപടാസ്ക് ലിസ്റ്റ്',
        Ma: 'उपकार्य सूची',
        Fr: 'Liste des sous-tâches',
        Hi: 'उपकार्य सूची',
        Ta: 'துணைப் பணி பட்டியல்',
        Ja: 'サブタスク一覧',
        Ge: 'Liste der Teilaufgaben',
      },
      SCTB01: {
        En: 'Dear Name This is a reminder for returning the Asset as the due date Due Date has passed. Thanks Admin Name',
      },
      SCL02: {
        En: 'User Name',
        Et: 'Kasutajanimi',
        Ar: 'اسم االمستخدم',
        Ml: 'ഉപയോക്തൃ നാമം',
        Ma: 'वापरकर्ता नाव',
        Fr: "Nom d'utilisateur",
        Hi: 'उपयोगकर्ता नाम',
        Ta: 'பயனர் பெயர்',
        Ja: 'ユーザー名',
        Ge: 'Nutzername',
      },
      SCDD05: {
        En: 'Role',
        Et: 'Roll',
        Ar: 'دور',
        Ml: 'പങ്ക്',
        Ma: 'भूमिका',
        Fr: 'Rôle',
        Hi: 'भूमिका',
        Ta: 'பங்கு',
        Ja: '役割',
        Ge: 'Rolle',
      },
      SCL03: {
        En: 'Attachment',
        Et: 'Manus',
        Ar: 'المرفق',
        Ml: 'ബന്ധം',
        Ma: 'संलग्नक',
        Fr: 'Attachement',
        Hi: 'अनुरक्ति',
        Ta: 'இணைப்பு',
        Ja: '付属品',
        Ge: 'Anhang',
      },
      SCDD06: {
        En: 'PI Report',
        Et: 'PI aruanne',
        Ar: 'تقرير PI',
        Ml: 'പിഐ റിപ്പോർട്ട്',
        Ma: 'PI अहवाल',
        Fr: 'PI Report',
        Hi: 'पीआई रिपोर्ट',
        Ta: 'PI அறிக்கை',
        Ja: 'PIレポート',
        Ge: 'PI-Bericht',
      },
      SCB02: {
        En: 'CurrentDate',
        Et: 'Tänane kuupäev',
        Ar: 'التاريخ الحالي',
        Ml: 'നിലവിലെ തീയതി',
        Ma: 'चालू दिनांक',
        Fr: 'Date actuelle',
        Hi: 'आज की तारीख',
        Ta: 'இன்றைய தேதி',
        Ja: '現在の日付',
        Ge: 'Aktuelles Datum',
      },
      SCB03: {
        En: 'Task Date Start',
        Et: 'Ülesande alguskuupäev',
        Ar: 'تاريخ بدء المهمة',
        Ml: 'ടാസ്ക് തീയതി ആരംഭം',
        Ma: 'कार्य तारीख सुरू',
        Fr: 'Date de début de la tâche',
        Hi: 'कार्य दिनांक प्रारंभ',
        Ta: 'பணி தொடங்கும் தேதி',
        Ja: 'タスク開始日',
        Ge: 'Startdatum der Aufgabe',
      },
      SCB04: {
        En: 'Title',
        Et: 'Pealkiri',
        Ar: 'عنوان',
        Ml: 'തലക്കെട്ട്',
        Ma: 'शीर्षक',
        Fr: 'Titre',
        Hi: 'शीर्षक',
        Ta: 'தலைப்பு',
        Ja: '題名',
        Ge: 'Titel',
      },
      SCB05: {
        En: 'Task Date End',
        Et: 'Ülesande kuupäev Lõpp',
        Ar: 'تاريخ انتهاء المهمة',
        Ml: 'ടാസ്ക് തീയതി അവസാനം',
        Ma: 'कार्य तारीख समाप्त',
        Fr: 'Date de fin de la tâche',
        Hi: 'कार्य दिनांक समाप्ति',
        Ta: 'பணி தேதி முடிவு',
        Ja: 'タスクの終了日',
        Ge: 'Aufgabenende',
      },
      SCB06: {
        En: 'API',
        Et: 'API',
        Ar: 'API',
        Ml: 'API',
        Ma: 'API',
        Fr: 'API',
        Hi: 'एपीआई',
        Ta: 'API',
        Ja: 'API',
        Ge: 'API',
      },
      SCB07: {
        En: 'Workflow',
        Et: 'Töövoog',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'कार्यप्रवाह',
        Fr: 'Flux de travail',
        Hi: 'कार्यप्रवाह',
        Ta: 'பணிப்பாய்வு',
        Ja: 'ワークフロー',
        Ge: 'Arbeitsablauf',
      },
      SCB08: {
        En: 'Movement',
        Et: 'Liikumine',
        Ar: 'حركة',
        Ml: 'പ്രസ്ഥാനം',
        Ma: 'हालचाल',
        Fr: 'Mouvement',
        Hi: 'गति',
        Ta: 'இயக்கம்',
        Ja: '動き',
        Ge: 'Bewegung',
      },
    },

    SettingsWORKFLOW: {
      SWL01: {
        En: 'WORKFLOW',
        Et: 'TÖÖVOOD',
        Ar: 'سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ',
        Ma: 'वर्कफ्लो',
        Fr: 'FLUX DE TRAVAIL',
        Hi: 'कार्यप्रवाह',
        Ta: 'வொர்க்ஃப்ளோ',
        Ja: 'ワークフロー',
        Ge: 'ARBEITSABLAUF',
      },
      SWL02: {
        En: 'ASSET TYPE',
        Et: 'VARA TÜÜP',
        Ar: 'نوع الأصول',
        Ml: 'അസറ്റ് തരം',
        Ma: 'मालमत्ता प्रकार',
        Fr: "TYPE D'ACTIF",
        Hi: 'संपदा प्रकार',
        Ta: 'சொத்து வகை',
        Ja: '資産の種類',
        Ge: 'ANLAGENTYP',
      },
      SWB01: {
        En: 'Tape',
        Et: 'Lint',
        Ar: 'الشريط',
        Ml: 'ടേപ്പ്',
        Ma: 'टेप',
        Fr: 'Ruban',
        Hi: 'फीता',
        Ta: 'டேப்',
        Ja: 'テープ',
        Ge: 'Band',
      },
      SWB02: {
        En: 'Film/Audio',
        Et: 'Film/Audio',
        Ar: 'فيلم / صوت',
        Ml: 'ഫിലിം/ഓഡിയോ',
        Ma: 'चित्रपट/ऑडिओ',
        Fr: 'Film/Audio',
        Hi: 'फिल्म/ऑडियो',
        Ta: 'திரைப்படம்/ஆடியோ',
        Ja: '映画/オーディオ',
        Ge: 'Film/Audio',
      },
      SWB03: {
        En: 'Film/Picture',
        Et: 'Film/Pilt',
        Ar: 'فيلم / صورة',
        Ml: 'സിനിമ/ചിത്രം',
        Ma: 'चित्रपट/चित्र',
        Fr: 'Film/Image',
        Hi: 'फिल्म/चित्र',
        Ta: 'திரைப்படம்/படம்',
        Ja: '映画・写真',
        Ge: 'Film/Bild',
      },
      SWB04: {
        En: 'Photo',
        Et: 'Foto',
        Ar: 'صورة',
        Ml: 'ഫോട്ടോ',
        Ma: 'छायाचित्र',
        Fr: 'Photo',
        Hi: 'फ़ोटो',
        Ta: 'புகைப்படம்',
        Ja: '写真',
        Ge: 'Foto',
      },
      SWB05: {
        En: 'Document',
        Et: 'Dokument',
        Ar: 'وثيقة',
        Ml: 'പ്രമാണം',
        Ma: 'दस्तऐवज',
        Fr: 'Document',
        Hi: 'दस्तावेज़',
        Ta: 'ஆவணம்',
        Ja: '書類',
        Ge: 'Dokumentieren',
      },
      SWTB01: {
        En: 'Create New',
        Et: 'Loo uus',
        Ar: 'خلق جديد إبداع جديد',
        Ml: 'പുതിയത് സൃഷ്ടിക്കുക',
        Ma: 'नवीन तयार करा',
        Fr: 'Créer un nouveau',
        Hi: 'नया बनाओ',
        Ta: 'புதிதாக உருவாக்கு',
        Ja: '新しく作る',
        Ge: 'Erstelle neu',
      },
      SWB06: {
        En: 'Plus',
        Et: 'Pluss',
        Ar: 'زائد',
        Ml: 'പ്ലസ്',
        Ma: 'प्लस',
        Fr: 'Plus',
        Hi: 'प्लस',
        Ta: 'மேலும்',
        Ja: 'プラス',
        Ge: 'Plus',
      },
      SWL03: {
        En: 'TEMPLATE/PRESET',
        Et: 'MALL/EELMISEADISTUS',
        Ar: 'النموذج / الإعداد المسبق',
        Ml: 'ടെംപ്ലേറ്റ്/പ്രീസെറ്റ്',
        Ma: 'टेम्प्लेट/प्रीसेट',
        Fr: 'MODÈLE/PRÉRÉGLAGE',
        Hi: 'टेम्प्लेट / प्रीसेट',
        Ta: 'டெம்ப்ளேட்/முன்னமைவு',
        Ja: 'テンプレート/プリセット',
        Ge: 'VORLAGE/VOREINSTELLUNG',
      },
      SWL04: {
        En: 'TASK',
        Et: 'ÜLESANNE',
        Ar: 'مهمة',
        Ml: 'ചുമതല',
        Ma: 'टास्क',
        Fr: 'TÂCHE',
        Hi: 'काम',
        Ta: 'பணி',
        Ja: '仕事',
        Ge: 'AUFGABE',
      },
      SWL05: {
        En: 'SUBTASK',
        Et: 'ALAÜLESANNE',
        Ar: 'سبتاسك',
        Ml: 'ഉപ ടാസ്ക്',
        Ma: 'सबटास्क',
        Fr: 'SOUS-TÂCHE',
        Hi: 'उपकार्य',
        Ta: 'துணைப் பணி',
        Ja: 'サブタスク',
        Ge: 'UNTERAUFGABE',
      },
      SWL06: {
        En: 'REPORT COMPONEnTS',
        Et: 'ARUANNE KOMPONENDID',
        Ar: 'تقرير المكونات',
        Ml: 'ഘടകങ്ങൾ റിപ്പോർട്ട് ചെയ്യുക',
        Ma: 'अहवाल घटक',
        Fr: 'ÉLÉMENTS DU RAPPORT',
        Hi: 'रिपोर्ट घटक',
        Ta: 'கூறுகள் அறிக்கை',
        Ja: 'レポート コンポーネント',
        Ge: 'BERICHTSKOMPONENTEN',
      },
      SWB07: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      SWB08: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    SettingsWORKFLOWTEMPLATEPRESET: {
      SWTPL01: {
        En: 'TEMPLATE/PRESET List',
        Et: 'MALL/EELMISEADISTUS Loend',
        Ar: 'نموذج / قائمة الإعداد المسبق',
        Ml: 'ടെംപ്ലേറ്റ്/പ്രീസെറ്റ് ലിസ്റ്റ്',
        Ma: 'टेम्प्लेट/प्रीसेट सूची',
        Fr: 'Liste TEMPLATE/PRESET',
        Hi: 'टेम्पलेट/पूर्व निर्धारित सूची',
        Ta: 'டெம்ப்ளேட்/முன்னமைக்கப்பட்ட பட்டியல்',
        Ja: 'テンプレート/プリセット一覧',
        Ge: 'VORLAGEN/PRESET-Liste',
      },
      SWTPTB01: {
        En: 'Create New',
        Et: 'Loo uus',
        Ar: 'خلق جديد إبداع جديد',
        Ml: 'പുതിയത് സൃഷ്ടിക്കുക',
        Ma: 'नवीन तयार करा',
        Fr: 'Créer un nouveau',
        Hi: 'नया बनाओ',
        Ta: 'புதிதாக உருவாக்கு',
        Ja: '新しく作る',
        Ge: 'Erstelle neu',
      },
      SWTPB01: {
        En: 'Plus',
        Et: 'Pluss',
        Ar: 'زائد',
        Ml: 'പ്ലസ്',
        Ma: 'प्लस',
        Fr: 'Plus',
        Hi: 'प्लस',
        Ta: 'மேலும்',
        Ja: 'プラス',
        Ge: 'Plus',
      },
    },

    SettingsWORKFLOWTASK: {
      SWTL01: {
        En: 'Task customization',
        Et: 'Ülesande kohandamine',
        Ar: 'تخصيص المهمة',
        Ml: 'ടാസ്ക് ഇഷ്‌ടാനുസൃതമാക്കൽ',
        Ma: 'कार्य सानुकूलन',
        Fr: 'Personnalisation des tâches',
        Hi: 'कार्य अनुकूलन',
        Ta: 'பணி தனிப்பயனாக்கம்',
        Ja: 'タスクのカスタマイズ',
        Ge: 'Aufgabenanpassung',
      },
      SWTTB01: {
        En: 'Create New',
        Et: 'Loo uus',
        Ar: 'خلق جديد إبداع جديد',
        Ml: 'പുതിയത് സൃഷ്ടിക്കുക',
        Ma: 'नवीन तयार करा',
        Fr: 'Créer un nouveau',
        Hi: 'नया बनाओ',
        Ta: 'புதிதாக உருவாக்கு',
        Ja: '新しく作る',
        Ge: 'Erstelle neu',
      },
      SWTB01: {
        En: 'Plus',
        Et: 'Pluss',
        Ar: 'زائد',
        Ml: 'പ്ലസ്',
        Ma: 'प्लस',
        Fr: 'Plus',
        Hi: 'प्लस',
        Ta: 'மேலும்',
        Ja: 'プラス',
        Ge: 'Plus',
      },
    },

    SettingsWORKFLOWSUBTASK: {
      SWSTL01: {
        En: 'Subtask customization',
        Et: 'Alamülesannete kohandamine',
        Ar: 'تخصيص المهام الفرعية',
        Ml: 'ഉപടാസ്ക് ഇഷ്‌ടാനുസൃതമാക്കൽ',
        Ma: 'सबटास्क कस्टमायझेशन',
        Fr: 'Personnalisation des sous-tâches',
        Hi: 'उपकार्य अनुकूलन',
        Ta: 'துணைப் பணி தனிப்பயனாக்கம்',
        Ja: 'サブタスクのカスタマイズ',
        Ge: 'Anpassung von Teilaufgaben',
      },
      SWSTTB01: {
        En: 'Create New',
        Et: 'Loo uus',
        Ar: 'خلق جديد إبداع جديد',
        Ml: 'പുതിയത് സൃഷ്ടിക്കുക',
        Ma: 'नवीन तयार करा',
        Fr: 'Créer un nouveau',
        Hi: 'नया बनाओ',
        Ta: 'புதிதாக உருவாக்கு',
        Ja: '新しく作る',
        Ge: 'Erstelle neu',
      },
      SWSTB01: {
        En: 'Plus',
        Et: 'Pluss',
        Ar: 'زائد',
        Ml: 'പ്ലസ്',
        Ma: 'प्लस',
        Fr: 'Plus',
        Hi: 'प्लस',
        Ta: 'மேலும்',
        Ja: 'プラス',
        Ge: 'Plus',
      },
    },

    SettingsWORKFLOWREPORTCOMPONEnTS: {
      SWRCL01: {
        En: 'Report Component customization',
        Et: 'Teata komponendi kohandamisest',
        Ar: 'تقرير مكون التخصيص',
        Ml: 'ഘടക കസ്റ്റമൈസേഷൻ റിപ്പോർട്ട് ചെയ്യുക',
        Ma: 'घटक सानुकूलित अहवाल',
        Fr: 'Personnalisation des composants du rapport',
        Hi: 'रिपोर्ट घटक अनुकूलन',
        Ta: 'அறிக்கை கூறு தனிப்பயனாக்கம்',
        Ja: 'レポート コンポーネントのカスタマイズ',
        Ge: 'Anpassung der Berichtskomponente',
      },
      SWRCTB01: {
        En: 'Create New',
        Et: 'Loo uus',
        Ar: 'خلق جديد إبداع جديد',
        Ml: 'പുതിയത് സൃഷ്ടിക്കുക',
        Ma: 'नवीन तयार करा',
        Fr: 'Créer un nouveau',
        Hi: 'नया बनाओ',
        Ta: 'புதிதாக உருவாக்கு',
        Ja: '新しく作る',
        Ge: 'Erstelle neu',
      },
      SWRCB01: {
        En: 'Plus',
        Et: 'Pluss',
        Ar: 'زائد',
        Ml: 'പ്ലസ്',
        Ma: 'प्लस',
        Fr: 'Plus',
        Hi: 'प्लस',
        Ta: 'மேலும்',
        Ja: 'プラス',
        Ge: 'Plus',
      },
      SWRCB02: {
        En: 'Settings',
        Et: 'Seaded',
        Ar: 'إعدادات',
        Ml: 'ക്രമീകരണങ്ങൾ',
        Ma: 'सेटिंग्ज',
        Fr: 'Réglages',
        Hi: 'समायोजन',
        Ta: 'அமைப்புகள்',
        Ja: '設定',
        Ge: 'Einstellungen',
      },
      SWRCL02: {
        En: 'Settings Modal',
        Et: 'Seaded Modal',
        Ar: 'مشروط الإعدادات',
        Ml: 'ക്രമീകരണ മോഡൽ',
        Ma: 'सेटिंग्ज मॉडेल',
        Fr: 'Paramètres Modaux',
        Hi: 'सेटिंग्स मोडल',
        Ta: 'அமைப்புகள் மாதிரி',
        Ja: '設定モーダル',
        Ge: 'Einstellungen Modal',
      },
      SWRCDD01: {
        En: 'Text Box',
        Et: 'Tekstikast',
        Ar: 'مربع الكتابة',
        Ml: 'ടെക്സ്റ്റ് ബോക്സ്',
        Ma: 'मजकूर बॉक्स',
        Fr: 'Zone de texte',
        Hi: 'पाठ बॉक्स',
        Ta: 'உரை பெட்டி',
        Ja: 'テキストボックス',
        Ge: 'Textfeld',
      },
      SWRCDD02: {
        En: 'Text Area',
        Et: 'Tekstiala',
        Ar: 'منطقة النص',
        Ml: 'ടെക്സ്റ്റ് ഏരിയ',
        Ma: 'मजकूर क्षेत्र',
        Fr: 'Zone de texte',
        Hi: 'पाठ क्षेत्र',
        Ta: 'உரை பகுதி',
        Ja: 'テキストエリア',
        Ge: 'Textbereich',
      },
      SWRCDD03: {
        En: 'Dropdown',
        Et: 'Rippmenüü',
        Ar: 'اسقاط',
        Ml: 'ഡ്രോപ്പ് ഡൗൺ',
        Ma: 'ड्रॉपडाउन',
        Fr: 'Menu déroulant',
        Hi: 'ड्रॉप डाउन',
        Ta: 'கீழே போடு',
        Ja: '落ちる',
        Ge: 'Dropdown-Liste',
      },
      SWRCDD04: {
        En: 'Counter Increment',
        Et: 'Loenduri juurdekasv',
        Ar: 'زيادة العداد',
        Ml: 'കൗണ്ടർ ഇൻക്രിമെന്റ്',
        Ma: 'काउंटर वाढ',
        Fr: 'Incrément du compteur',
        Hi: 'काउंटर वेतन वृद्धि',
        Ta: 'எதிர் அதிகரிப்பு',
        Ja: 'カウンターインクリメント',
        Ge: 'Zählererhöhung',
      },
      SWRCDD05: {
        En: 'Add Photograph',
        Et: 'Lisa foto',
        Ar: 'أضف صورة',
        Ml: 'ഫോട്ടോ ചേർക്കുക',
        Ma: 'छायाचित्र जोडा',
        Fr: 'Ajouter une photo',
        Hi: 'फोटो जोड़ें',
        Ta: 'புகைப்படத்தைச் சேர்க்கவும்',
        Ja: '写真を追加',
        Ge: 'Foto hinzufügen',
      },
      SWRCB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      SWRCB04: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },

    SettingsWORKFLOWREPORTCOMPONEnTSDropdown: {
      SWRCDDB01: {
        En: 'Enable by default',
        Et: 'Luba vaikimisi',
        Ar: 'تمكين افتراضيًا',
        Ml: 'സ്ഥിരസ്ഥിതിയായി പ്രവർത്തനക്ഷമമാക്കുക',
        Ma: 'डीफॉल्टनुसार सक्षम करा',
        Fr: 'Activer par défaut',
        Hi: 'डिफ़ॉल्ट रूप से सक्षम करें',
        Ta: 'முன்னிருப்பாக இயக்கு',
        Ja: 'デフォルトで有効',
        Ge: 'Standardmäßig aktivieren',
      },
      SWRCDDL01: {
        En: 'Title',
        Et: 'Pealkiri',
        Ar: 'عنوان',
        Ml: 'തലക്കെട്ട്',
        Ma: 'शीर्षक',
        Fr: 'Titre',
        Hi: 'शीर्षक',
        Ta: 'தலைப்பு',
        Ja: '題名',
        Ge: 'Titel',
      },
      SWRCDDTB01: {
        En: 'Add Title',
        Et: 'Lisa pealkiri',
        Ar: 'أضف عنوانا',
        Ml: 'തലക്കെട്ട് ചേര്ക്കുക',
        Ma: 'शीर्षक द्या',
        Fr: 'Ajouter un titre',
        Hi: 'शीर्षक जोडें',
        Ta: 'தலைப்பை சேர்க்கவும்',
        Ja: '表題を加える',
        Ge: 'Titel hinzufügen',
      },
      SWRCDDB02: {
        En: 'Add option',
        Et: 'Lisa valik',
        Ar: 'إضافة خيار',
        Ml: 'ഓപ്ഷൻ ചേർക്കുക',
        Ma: 'पर्याय जोडा',
        Fr: 'Ajouter une option',
        Hi: 'विकल्प जोड़ें',
        Ta: 'விருப்பத்தைச் சேர்க்கவும்',
        Ja: 'オプションを追加',
        Ge: 'Option hinzufügen',
      },
      SWRCDDB03: {
        En: 'Cancel',
        Et: 'Tühista',
        Ar: 'يلغي',
        Ml: 'റദ്ദാക്കുക',
        Ma: 'रद्द करा',
        Fr: 'Annuler',
        Hi: 'रद्द करना',
        Ta: 'ரத்து செய்',
        Ja: 'キャンセル',
        Ge: 'Absagen',
      },
      SWRCDDB04: {
        En: 'Save',
        Et: 'Salvesta',
        Ar: 'يحفظ',
        Ml: 'രക്ഷിക്കും',
        Ma: 'जतन करा',
        Fr: 'sauvegarder',
        Hi: 'सहेजें',
        Ta: 'சேமிக்கவும்',
        Ja: '保存',
        Ge: 'Speichern',
      },
    },
    HistoryHeader: {
      HH01: {
        En: 'Element Type',
        Et: 'Elemendi tüüp',
        Ar: 'نوع العنصر',
        Ml: 'ഘടക തരം',
        Ma: 'घटक प्रकार',
        Fr: 'Type d\'élément',
        Hi: 'तत्व प्रकार',
        Ta: 'உறுப்பு வகை',
        Ja: '要素タイプ',
        Ge: 'Elementtyp'
      },
      HH02: {
        En: 'Asset Type',
        Et: 'Vara tüüp',
        Ar: 'نوع الأصل',
        Ml: 'ആസ്തി തരം',
        Ma: 'संपत्ती प्रकार',
        Fr: 'Type d\'actif',
        Hi: 'संपत्ति प्रकार',
        Ta: 'சொத்து வகை',
        Ja: '資産タイプ',
        Ge: 'Assettyp'
      },
      HH03: {
        En: 'Asset In Vault',
        Et: 'Vara Vault',
        Ar: 'الأصول في الخزنة',
        Ml: 'വോൾട്ടിലെ അസറ്റ്',
        Ma: 'व्हॉल्टमध्ये मालमत्ता',
        Fr: 'Actif dans le coffre-fort',
        Hi: 'तिजोरी में संपत्ति',
        Ta: 'வால்ட்டில் உள்ள சொத்து',
        Ja: 'ボールト内のアセット',
        Ge: 'Asset im Tresor',
      },
      HH04: {
        En: 'Parent',
        Et: 'Vanema',
        Ar: 'ولي',
        Ml: 'അച്ഛൻ/അമ്മ',
        Ma: 'आई/बाबा',
        Fr: 'Parent',
        Hi: 'माता-पिता',
        Ta: 'பெற்றோர்',
        Ja: '親',
        Ge: 'Eltern'
      },
      HH05: {
        En: 'Current Task',
        Et: 'Praegune ülesanne',
        Ar: 'المهمة الحالية',
        Ml: 'നിലവിലുള്ള ജോലി',
        Ma: 'सध्याचे कार्य',
        Fr: 'Tâche actuelle',
        Hi: 'वर्तमान कार्य',
        Ta: 'தற்போதைய பணி',
        Ja: '現在のタスク',
        Ge: 'Aktuelle Aufgabe'
      },
      HH06:{
        En: 'Current Subtask',
        Et: 'Praegune alamülesanne',
        Ar: 'المهمة الفرعية الحالية',
        Ml: 'നിലവിലുള്ള ഉപജോലി',
        Ma: 'सध्याचे उपकार्य',
        Fr: 'Sous-tâche actuelle',
        Hi: 'वर्तमान उपकार्य',
        Ta: 'தற்போதைய துணைப்பணி',
        Ja: '現在のサブタスク',
        Ge: 'Aktuelle Unteraufgabe'
      },
      HH07:{
        En: 'Workflow Status',
        Et: 'Töövoo staatus',
        Ar: 'حالة سير العمل',
        Ml: 'വർക്ക്ഫ്ലോ സ്ഥിതി',
        Ma: 'वर्कफ्लो स्थिती',
        Fr: 'État du flux de travail',
        Hi: 'वर्कफ़्लो स्थिति',
        Ta: 'பணிப்பாய்வு நிலை',
        Ja: 'ワークフローの状態',
        Ge: 'Workflow-Status'
      },
      HH08:{
        En: 'Current User',
        Et: 'Praegune kasutaja',
        Ar: 'المستخدم الحالي',
        Ml: 'നിലവിലുള്ള ഉപയോക്താവ്',
        Ma: 'सध्याचा वापरकर्ता',
        Fr: 'Utilisateur actuel',
        Hi: 'वर्तमान उपयोगकर्ता',
        Ta: 'தற்போதைய பயனர்',
        Ja: '現在のユーザー',
        Ge: 'Aktueller Benutzer'
      },
    },
  },
];
